import React, {
  useMemo,
  useCallback,
  useState,
  useEffect,
  useRef,
  useReducer,
} from "react";
import {
  Archive,
  BarChart,
  Activity,
  Copy,
  GitBranch,
  Phone,
  Droplets,
  Dumbbell,
  Tag,
  Bed,
  UserMinus,
  Globe,
  Printer,
  Child,
  Baby,
  UserCheck,
  Navigation,
  Zap,
  loadingHotels,
  User,
  Filter,
  Ticket,
  Home,
  AlertCircle,
  LogIn,
  AlertTriangle,
  Info,
  ChevronLeft,
  Calendar,
  Plane,
  Hotel,
  CreditCard,
  FileText,
  Users,
  ShoppingCart,
  BarChart3,
  Settings,
  LogOut,
  Menu,
  X,
  Clock,
  MapPin,
  CheckCircle,
  MessageCircle,
  Send,
  Search,
  Loader,
  Building2,
  UserPlus,
  Shield,
  Edit,
  Trash2,
  Eye,
  Plus,
  Save,
  Wifi,
  Coffee,
  Car,
  Star,
  PlusCircle,
  ChevronRight,
  ChevronDown,
  DollarSign,
  Download,
  FileCheck,
  Mail,
  Percent,
  Package,
  Minus,
  RefreshCw,
  ChevronUp,
} from "lucide-react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {MultiFlightCartWorkflow} from "./components/DemandeBillet"
import {FlightRequestsList} from "./components/ListeDeBillet"
// import 'toastify-pro/dist/ToastifyPro.css';
// import { toast } from "toastify-pro";

import Swal from "sweetalert2";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "jspdf-autotable";
const API_BASE_URL = "https://abmtravel.sag.ci/api/amadeus";

// "https://hums4a4lwgk6go7q6slve7ce2e.apigateway.us-ashburn-1.oci.customer-oci.com/amadeus/api/amadeus";
const API_BASE_URL2 = "https://abmtravel.sag.ci/api";
const API_BASE_URL3 = "https://abmtravel.sag.ci/api/amadeus2";
// "https://hums4a4lwgk6go7q6slve7ce2e.apigateway.us-ashburn-1.oci.customer-oci.com/amadeus/api"; // Utilisez votre URL de base

// Fonction utilitaire pour formater les montants en toute sécurité
const formatAmount = (amount, defaultValue = 0) => {
  const num = parseFloat(amount);
  return isNaN(num) ? defaultValue.toFixed(2) : num.toFixed(2);
};
const getAirlineName = (code) => {
  const airlines = {
    AF: "Air France",
    LH: "Lufthansa",
    BA: "British Airways",
    KL: "KLM",
    SN: "Brussels Airlines",
    LX: "Swiss International Air Lines",
    IB: "Iberia",
    AZ: "Alitalia",
    TP: "TAP Air Portugal",
    AY: "Finnair",
    SK: "SAS Scandinavian Airlines",
    LO: "LOT Polish Airlines",
    OS: "Austrian Airlines",
    SU: "Aeroflot",
    TK: "Turkish Airlines",
    A3: "Aegean Airlines",
    DY: "Norwegian Air Shuttle",
    FR: "Ryanair",
    U2: "easyJet",
    VY: "Vueling",
    EW: "Eurowings",
    BT: "Air Baltic",
    JU: "Air Serbia",
    OU: "Croatia Airlines",
    KM: "Air Malta",
    FI: "Icelandair",
    EK: "Emirates",
    EY: "Etihad Airways",
    QR: "Qatar Airways",
    SV: "Saudia",
    RJ: "Royal Jordanian",
    WY: "Oman Air",
    GF: "Gulf Air",
    KU: "Kuwait Airways",
    ME: "Middle East Airlines",
    ET: "Ethiopian Airlines",
    MS: "EgyptAir",
    AT: "Royal Air Maroc",
    TU: "Tunisair",
    KQ: "Kenya Airways",
    SA: "South African Airways",
    MK: "Air Mauritius",
    UL: "SriLankan Airlines",
    WB: "RwandAir",
    P4: "Air Peace",
    "9U": "Air Moldova",
    AA: "American Airlines",
    DL: "Delta Air Lines",
    UA: "United Airlines",
    AC: "Air Canada",
    WN: "Southwest Airlines",
    B6: "JetBlue Airways",
    AS: "Alaska Airlines",
    WS: "WestJet",
    F9: "Frontier Airlines",
    LA: "LATAM Airlines",
    AV: "Avianca",
    CM: "Copa Airlines",
    AR: "Aerolíneas Argentinas",
    G3: "Gol Transportes Aéreos",
    AD: "Azul Brazilian Airlines",
    JJ: "LATAM Brasil",
    SQ: "Singapore Airlines",
    CX: "Cathay Pacific",
    NH: "ANA All Nippon Airways",
    JL: "Japan Airlines",
    KE: "Korean Air",
    OZ: "Asiana Airlines",
    CI: "China Airlines",
    BR: "EVA Air",
    TG: "Thai Airways",
    MH: "Malaysia Airlines",
    GA: "Garuda Indonesia",
    PR: "Philippine Airlines",
    VN: "Vietnam Airlines",
    CZ: "China Southern Airlines",
    MU: "China Eastern Airlines",
    CA: "Air China",
    HU: "Hainan Airlines",
    FM: "Shanghai Airlines",
    "3U": "Sichuan Airlines",
    "9C": "Spring Airlines",
    QF: "Qantas",
    VA: "Virgin Australia",
    NZ: "Air New Zealand",
    FJ: "Fiji Airways",
    NK: "Spirit Airlines",
    SY: "Sun Country Airlines",
    G4: "Allegiant Air",
    Y4: "Volaris",
    Y9: "Air Arabia",
    FD: "Thai AirAsia",
    AK: "AirAsia",
    D7: "AirAsia X",
    TR: "Scoot",
    Z2: "Philippines AirAsia",
    "5Y": "Atlas Air",
    K4: "Kalitta Air",
    W8: "Cargojet Airways",
    YX: "Republic Airways",
    OO: "SkyWest Airlines",
    "9E": "Endeavor Air",
    MQ: "Envoy Air",
    OH: "PSA Airlines",
    "2J": 'Air Burkina',
    AI: "Air India",
    PK: "Pakistan International Airlines",
    BG: "Biman Bangladesh Airlines",
    BI: "Royal Brunei Airlines",
    OM: "MIAT Mongolian Airlines",
    RGN: "Regional Express",
    J2: "Azerbaijan Airlines",
    KC: "Air Astana",
    HY: "Uzbekistan Airways",
    FV: "Rossiya Airlines",
    S7: "S7 Airlines",
    U6: "Ural Airlines",
    "5N": "Nordavia",
    D2: "Severstal Air Company",
    N4: "Nordwind Airlines",
    ZF: "Azur Air",
    Y7: "NordStar Airlines",
    DP: "Pobeda",
    "6W": "Saratov Airlines",
    B2: "Belavia",
    "7J": "Tajik Air",
    NQ: "Air Japan",
    JW: "Vanilla Air",
    MM: "Peach Aviation",
    GK: "Jetstar Japan",
    BC: "Skymark Airlines",
    LJ: "Jin Air",
    ZE: "Eastar Jet",
    TW: "Tway Air",
    BX: "Air Busan",
    RS: "Air Seoul",
    VZ: "Thai Vietjet Air",
    SL: "Thai Lion Air",
    DD: "Nok Air",
    XJ: "Thai AirAsia X",
    Z8: "Amaszonas",
    "8L": "Lucky Air",
    GJ: "Loong Air",
    DR: "Ruili Airlines",
    A6: "Air Travel",
    GT: "Air Guilin",
    QW: "Qingdao Airlines",
    CN: "West Air",
    PN: "China West Air",
    RY: "Jiangxi Air",
    VD: "Henan Airlines",
    G5: "China Express Air",
    "9H": "Air Changan",
    NS: "Hebei Airlines",
    KN: "China United",
    JD: "Capital Airlines",
    DZ: "Donghai Airlines",
    Y8: "Yangtze River Express",
    OQ: "Chongqing Airlines",
    GX: "GX Airlines",
    AQ: "9 Air",
    EU: "Chengdu Airlines",
    UQ: "Urumqi Air",
  };

  return airlines[code] || code;
};


const dateIntl = (iso) =>{
  const date = new Date(iso);

const dateFormatee = new Intl.DateTimeFormat("fr-FR", {
  day: "numeric",
  weekday: "long",
                          year: "numeric",
                          month: "long",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(date);

return dateFormatee;
}
// Fonction pour obtenir un montant numérique sûr
const getSafeAmount = (amount, defaultValue = 0) => {
  const num = parseFloat(amount);
  return isNaN(num) ? defaultValue : num;
};
const amadeusService = {
  searchFlights: async (searchParams) => {
    try {
      const params = {
        originLocationCode: searchParams.originLocationCode,
        destinationLocationCode: searchParams.destinationLocationCode,
        departureDate: searchParams.departureDate,
        adults: searchParams.adults,
        max: searchParams.max || 10,
        travelClass: searchParams.travelClass || "ECONOMY",
      };

      // Ajouter la date de retour si c'est un aller-retour
      if (searchParams.tripType === "round-trip" && searchParams.returnDate) {
        params.returnDate = searchParams.returnDate;
      }

      const queryParams = new URLSearchParams(params).toString();
      const response = await fetch(`${API_BASE_URL}/flights?${queryParams}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        console.error("Erreur HTTP:", response.status);
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const data = await response.json();
      console.log("Données reçues:", data); // Pour déboguer
      return data;
    } catch (error) {
      console.error("Erreur recherche vols:", error);
      throw error;
    }
  },

  searchHotels: async (searchParams) => {
    try {
      const queryParams = new URLSearchParams(searchParams).toString();
      const response = await fetch(`${API_BASE_URL3}/hotels?${queryParams}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Erreur recherche hôtels:", error);
      throw error;
    }
  },

  getHotelOffers1: async (hotelId, params) => {
    try {
      // Créer un nouvel objet params sans la propriété hotelIds si elle existe
      const { hotelIds, ...otherParams } = params;

      const queryParams = new URLSearchParams({
        ...otherParams,
        hotelIds: hotelId, // Utiliser le hotelId passé en premier argument
        roomQuantity: params.rooms || params.roomQuantity, // S'assurer d'utiliser roomQuantity
      }).toString();

      console.log("DONNEES RECHRECHE HOTEL", queryParams);
      const response = await fetch(
        `${API_BASE_URL3}/hotel-offers?${queryParams}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log("apres ICI", response.json());
      if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Erreur offres hôtel:", error);
      throw error;
    }
  },
  getHotelOffers: async (hotelId, params) => {
    try {
      // Préparer les données pour le body (format JSON)
      const requestBody = {
        hotelIds: hotelId, // Utiliser le hotelId passé en premier argument
        checkInDate: params.checkInDate,
        checkOutDate: params.checkOutDate,
        adults: params.adults,
        roomQuantity: params.rooms || params.roomQuantity || "1",
        // Ajouter d'autres paramètres si nécessaires
        children: params.children || "0",
        infants: params.infants || "0",
        currency: params.currency || "EUR",
      };

      // Nettoyer l'objet (supprimer les propriétés undefined)
      Object.keys(requestBody).forEach((key) => {
        if (requestBody[key] === undefined) {
          delete requestBody[key];
        }
      });

      console.log("DONNEES RECHERCHE HOTEL", requestBody);

      const response = await fetch(`${API_BASE_URL3}/hotel-offers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody), // Envoyer dans le body
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erreur HTTP: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      console.log("Réponse offres hôtel:", data);
      return data;
    } catch (error) {
      console.error("Erreur offres hôtel:", error);
      throw error;
    }
  },
  /// A UTILISER http://149.202.45.76:1820/amadeus2/flights/orders
  ///http://149.202.45.76:1820/amadeus2/flights/pricing
  //http://149.202.45.76:1820/amadeus2/flights/orders
  /// http://149.202.45.76:1820/amadeus2/flights/orders/1/ticket (Pas de route)
  ///http://149.202.45.76:1820/amadeus2/flights/complete-booking
  getSeatmap: async (flightOfferId) => {
    try {
      // D'abord, faire le pricing pour obtenir les détails
      const pricingResponse = await fetch(
        `${API_BASE_URL}/flight-offers/pricing`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data: {
              type: "flight-offers-pricing",
              flightOffers: [flightOfferId],
            },
          }),
        }
      );

      if (!pricingResponse.ok) throw new Error("Erreur pricing");
      const pricingData = await pricingResponse.json();

      // Ensuite récupérer la seatmap
      const seatmapResponse = await fetch(`${API_BASE_URL}/seatmaps`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          data: pricingData.data,
        }),
      });

      if (!seatmapResponse.ok) throw new Error("Erreur récupération seatmap");
      return await seatmapResponse.json();
    } catch (error) {
      console.error("Erreur seatmap:", error);
      throw error;
    }
  },
  getFlightPricingWithSeats: async (flightOffer) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/flight-offers/pricing?include=seats`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data: {
              type: "flight-offers-pricing",
              flightOffers: [flightOffer],
            },
          }),
        }
      );

      if (!response.ok) throw new Error("Erreur pricing avec sièges");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },
};
// ==================== SERVICE DE FACTURATION ====================

const billingService = {
  getConfig: async () => {
    const response = await fetch(`${API_BASE_URL2}/billing/config`);
    if (!response.ok) throw new Error("Erreur récupération config");
    return await response.json();
  },

  updateConfig: async (config) => {
    const response = await fetch(`${API_BASE_URL2}/billing/config`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(config),
    });
    if (!response.ok) throw new Error("Erreur mise à jour config");
    return await response.json();
  },

  getUnbilledItems: async () => {
    const response = await fetch(`${API_BASE_URL2}/billing/unbilled`);
    if (!response.ok) throw new Error("Erreur récupération items non facturés");
    return await response.json();
  },

  createInvoice: async (data) => {
    const requestData = {
      ...data,
      id: generateUUID(),
      numeroFacture: `REQ-${Date.now()}`,
      dateEmission: Date.now(),
      dateEcheance: Date.now() + 30,
      createdAt: Date.now(),
    };
    console.log("Données passées", requestData);
    const response = await fetch(`${API_BASE_URL2}/billing/invoices`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    if (!response.ok) throw new Error("Erreur création facture");
    return await response.json();
  },

  getInvoices: async () => {
    const response = await fetch(`${API_BASE_URL2}/billing/invoices`);
    if (!response.ok) throw new Error("Erreur récupération factures");
    return await response.json();
  },

  getInvoiceById: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/billing/invoices/${id}`);
    if (!response.ok) throw new Error("Erreur récupération facture");
    return await response.json();
  },

  updateInvoiceStatus: async (id, status) => {
    const response = await fetch(
      `${API_BASE_URL2}/billing/invoices/${id}/status`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status }),
      }
    );
    if (!response.ok) throw new Error("Erreur mise à jour statut");
    return await response.json();
  },

  sendInvoiceEmail: async (invoiceId, emailData) => {
    const response = await fetch(
      `${API_BASE_URL2}/billing/invoices/${invoiceId}/send`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(emailData),
      }
    );
    if (!response.ok) throw new Error("Erreur envoi email");
    return await response.json();
  },

  downloadInvoicePDF: async (invoiceId) => {
    const response = await fetch(
      `${API_BASE_URL2}/billing/invoices/${invoiceId}/pdf`
    );
    if (!response.ok) throw new Error("Erreur téléchargement PDF");
    return await response.blob();
  },

  getStatistics: async () => {
    const response = await fetch(`${API_BASE_URL2}/billing/statistics`);
    if (!response.ok) throw new Error("Erreur récupération statistiques");
    return await response.json();
  },
};

// ==================== GÉNÉRATION PDF FACTURE ====================

const generateInvoicePDF = (invoice) => {
  const doc = new jsPDF();

  // En-tête avec logo
  doc.setFillColor(37, 99, 235);
  doc.rect(0, 0, 210, 50, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(28);
  doc.text("FACTURE", 105, 25, { align: "center" });
  doc.setFontSize(14);
  doc.text(invoice.numeroFacture, 105, 35, { align: "center" });

  // Informations entreprise
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  let yPos = 60;
  doc.setFont(undefined, "bold");
  doc.text("ABM Travel Agency", 20, yPos);
  doc.setFont(undefined, "normal");
  yPos += 5;
  doc.text("Abidjan, Côte d ivoire", 20, yPos);
  yPos += 5;
  doc.text("contact@abmtravel.com", 20, yPos);
  yPos += 5;
  doc.text("+225 07 08 83 76 60", 20, yPos);
  yPos += 5;
  doc.text("RC-GN-2024-XXX", 20, yPos);

  // Dates et statut
  yPos = 60;
  doc.text(
    `Date: ${new Date(invoice.dateEmission).toLocaleDateString("fr-FR")}`,
    190,
    yPos,
    { align: "right" }
  );
  yPos += 5;
  doc.text(
    `Échéance: ${new Date(invoice.dateEcheance).toLocaleDateString("fr-FR")}`,
    190,
    yPos,
    { align: "right" }
  );
  yPos += 5;
  doc.setFont(undefined, "bold");
  doc.text(`Statut: ${invoice.statut}`, 190, yPos, { align: "right" });

  yPos = 95;

  // Client
  doc.setFont(undefined, "bold");
  doc.setFontSize(12);
  doc.text("FACTURÉ À", 20, yPos);
  doc.setFont(undefined, "normal");
  doc.setFontSize(10);
  yPos += 7;
  invoice.clients.forEach((client) => {
    doc.text(client, 20, yPos);
    yPos += 5;
  });

  yPos += 10;

  // Tableau des services
  const tableData = [];

  // Billets d'avion
  if (invoice.items.flights && invoice.items.flights.length > 0) {
    invoice.items.flights.forEach((flight) => {
      const flightAmount = getSafeAmount(flight.montant);
      const serviceFeePercent = getSafeAmount(
        invoice.config.flightServiceFeePercent,
        10
      );
      const serviceFee = (flightAmount * serviceFeePercent) / 100;
      const devise = flight.devise || "EUR";

      tableData.push([
        "Billet d'avion",
        `${flight.prenom || ""} ${flight.nom || ""}`.trim(),
        `${flight.searchParams?.originLocationCode || "N/A"} → ${
          flight.searchParams?.destinationLocationCode || "N/A"
        }`,
        `${formatAmount(flightAmount)} ${devise}`,
        `${formatAmount(serviceFee)} ${devise}`,
        `${formatAmount(flightAmount + serviceFee)} ${devise}`,
      ]);
    });
  }

  // Réservations d'hôtel
  if (invoice.items.hotels && invoice.items.hotels.length > 0) {
    invoice.items.hotels.forEach((hotel) => {
      const numberOfNights = getSafeAmount(hotel.nombreNuits, 1);
      const amount = numberOfNights * 150;
      const serviceFeePercent = getSafeAmount(
        invoice.config.hotelServiceFeePercent,
        5
      );
      const serviceFee = (amount * serviceFeePercent) / 100;

      tableData.push([
        "Réservation hôtel",
        `${hotel.prenom || ""} ${hotel.nom || ""}`.trim(),
        `${hotel.hotel?.name || "Hôtel"} (${numberOfNights} nuit${
          numberOfNights > 1 ? "s" : ""
        })`,
        `${formatAmount(amount)} EUR`,
        `${formatAmount(serviceFee)} EUR`,
        `${formatAmount(amount + serviceFee)} EUR`,
      ]);
    });
  }

  doc.autoTable({
    startY: yPos,
    head: [
      ["Service", "Voyageur", "Détails", "Montant", "Frais service", "Total"],
    ],
    body: tableData,
    theme: "striped",
    headStyles: { fillColor: [37, 99, 235] },
    styles: { fontSize: 9 },
  });

  yPos = doc.lastAutoTable.finalY + 15;

  // Récapitulatif financier
  const totalsData = [
    ["Sous-total services", `${formatAmount(invoice.totals.subtotal)} EUR`],
    [
      "Total frais de service",
      `${formatAmount(invoice.totals.serviceFees)} EUR`,
    ],
    ["Sous-total HT", `${formatAmount(invoice.totals.subtotalWithFees)} EUR`],
    [
      `TVA (${invoice.config.taxRate}%)`,
      `${formatAmount(invoice.totals.tax)} EUR`,
    ],
    ["TOTAL TTC", `${formatAmount(invoice.totals.total)} EUR`],
  ];

  doc.autoTable({
    startY: yPos,
    body: totalsData,
    theme: "plain",
    columnStyles: {
      0: { fontStyle: "bold", halign: "right", fontSize: 10 },
      1: { fontStyle: "bold", halign: "right", fontSize: 10 },
    },
    margin: { left: 110 },
    styles: { cellPadding: 3 },
  });

  // Note de paiement
  yPos = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(9);
  doc.setFont(undefined, "italic");
  doc.text(
    "Paiement à effectuer sous 30 jours à réception de la facture.",
    20,
    yPos
  );
  yPos += 5;
  doc.text("Coordonnées bancaires disponibles sur demande.", 20, yPos);

  // Pied de page
  doc.setFillColor(37, 99, 235);
  doc.rect(0, 270, 210, 27, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(8);
  doc.setFont(undefined, "normal");
  doc.text("ABM Travel Agency - Conakry, Guinée", 105, 280, {
    align: "center",
  });
  doc.text(
    "contact@abmtravel.com | +225 XXX XXX XXX | RC-GN-2024-XXX",
    105,
    285,
    { align: "center" }
  );

  return doc;
};

// ==================== COMPOSANTS FACTURATION ====================

const UnbilledItemsComponent = ({ flights, hotels, onGenerateInvoice }) => {
  const [selectedFlights, setSelectedFlights] = useState([]);
  const [selectedHotels, setSelectedHotels] = useState([]);
  const [config, setConfig] = useState({
    flightServiceFeePercent: 10,
    hotelServiceFeePercent: 5,
    taxRate: 18,
  });
  const [totals, setTotals] = useState({
    subtotal: 0,
    serviceFees: 0,
    subtotalWithFees: 0,
    tax: 0,
    total: 0,
  });

  useEffect(() => {
    loadConfig();
  }, []);

  // Recalculer les totaux quand la sélection ou la config change
  useEffect(() => {
    calculateTotal();
  }, [selectedFlights, selectedHotels, config, flights, hotels]);

  const loadConfig = async () => {
    try {
      const data = await billingService.getConfig();
      setConfig(data);
    } catch (error) {
      console.error("Erreur chargement config:", error);
    }
  };

  const toggleFlightSelection = (id) => {
    setSelectedFlights((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleHotelSelection = (id) => {
    setSelectedHotels((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleAllFlights = () => {
    if (selectedFlights.length === flights.length) {
      setSelectedFlights([]);
    } else {
      setSelectedFlights(flights.map((flight) => flight.id));
    }
  };

  const toggleAllHotels = () => {
    if (selectedHotels.length === hotels.length) {
      setSelectedHotels([]);
    } else {
      setSelectedHotels(hotels.map((hotel) => hotel.id));
    }
  };

  const calculateTotal = () => {
    let total = 0;
    let serviceFees = 0;

    selectedFlights.forEach((id) => {
      const flight = flights.find((f) => f.id === id);
      if (flight) {
        const amount = getSafeAmount(flight.montant);
        total += amount;
        serviceFees +=
          (amount * getSafeAmount(config.flightServiceFeePercent, 10)) / 100;
      }
    });

    selectedHotels.forEach((id) => {
      const hotel = hotels.find((h) => h.id === id);
      if (hotel) {
        const numberOfNights = getSafeAmount(hotel.nombreNuits, 1);
        const amount = numberOfNights * 150;
        total += amount;
        serviceFees +=
          (amount * getSafeAmount(config.hotelServiceFeePercent, 5)) / 100;
      }
    });

    const subtotalWithFees = total + serviceFees;
    const tax = (subtotalWithFees * getSafeAmount(config.taxRate, 18)) / 100;
    const totalTTC = subtotalWithFees + tax;

    setTotals({
      subtotal: total,
      serviceFees,
      subtotalWithFees,
      tax,
      total: totalTTC,
    });
  };
  const totalSelected = selectedFlights.length + selectedHotels.length;

  const handleGenerateInvoice = () => {
    if (totalSelected === 0) return;
    onGenerateInvoice(selectedFlights, selectedHotels, totals);
  };

  return (
    <div className="space-y-6 p-6 bg-gray-50 min-h-screen">
      {/* En-tête avec statistiques */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-blue-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">Billets non facturés</p>
              <p className="text-3xl font-bold mt-1">{flights.length}</p>
            </div>
            <Plane className="w-12 h-12 text-blue-500 opacity-20" />
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-purple-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">Hôtels non facturés</p>
              <p className="text-3xl font-bold mt-1">{hotels.length}</p>
            </div>
            <Hotel className="w-12 h-12 text-purple-500 opacity-20" />
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">Éléments sélectionnés</p>
              <p className="text-3xl font-bold mt-1">{totalSelected}</p>
            </div>
            <CheckCircle className="w-12 h-12 text-green-500 opacity-20" />
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-orange-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">Total TTC</p>
              <p className="text-2xl font-bold mt-1">
                {formatAmount(totals.total)} EUR
              </p>
            </div>
            <DollarSign className="w-12 h-12 text-orange-500 opacity-20" />
          </div>
        </div>
      </div>

      {/* Bouton de génération de facture */}
      {totalSelected > 0 && (
        <div className="bg-gradient-to-r from-green-600 to-emerald-600 rounded-xl shadow-md p-6 text-white">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
            <div className="flex-1">
              <h3 className="text-xl font-bold mb-2">Générer une facture</h3>
              <p className="text-green-100 mb-3">
                {totalSelected} élément{totalSelected > 1 ? "s" : ""}{" "}
                sélectionné{totalSelected > 1 ? "s" : ""}
              </p>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 text-sm">
                <div className="space-y-1">
                  <p className="text-green-200">
                    Sous-total: {formatAmount(totals.subtotal)} EUR
                  </p>
                  <p className="text-green-200">
                    Frais service: +{formatAmount(totals.serviceFees)} EUR
                  </p>
                </div>
                <div className="space-y-1">
                  <p className="text-green-200">
                    TVA ({config.taxRate}%): +{formatAmount(totals.tax)} EUR
                  </p>
                  <p className="font-bold text-lg">
                    Total TTC: {formatAmount(totals.total)} EUR
                  </p>
                </div>
              </div>
            </div>
            <button
              onClick={handleGenerateInvoice}
              className="bg-white text-green-600 px-6 py-3 rounded-lg font-semibold hover:bg-green-50 transition-colors duration-200 flex items-center shadow-lg hover:shadow-xl"
            >
              <FileCheck className="w-5 h-5 mr-2" />
              Créer la facture
            </button>
          </div>
        </div>
      )}

      {/* Liste des billets d'avion */}
      {flights.length > 0 && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-bold flex items-center">
              <Plane className="w-6 h-6 mr-2 text-blue-600" />
              Billets d'avion non facturés ({flights.length})
            </h3>
            <button
              onClick={toggleAllFlights}
              className="text-sm text-blue-600 hover:text-blue-800 font-medium"
            >
              {selectedFlights.length === flights.length
                ? "Tout désélectionner"
                : "Tout sélectionner"}
            </button>
          </div>

          <div className="space-y-3">
            {flights.map((flight) => {
              //To do paramètre frais
              const serviceFee = (parseFloat(flight.montant) * 10) / 100;
              const isSelected = selectedFlights.includes(flight.id);

              return (
                <div
                  key={flight.id}
                  className={`border-2 rounded-lg p-4 cursor-pointer transition-all duration-200 ${
                    isSelected
                      ? "border-blue-600 bg-blue-50 shadow-md"
                      : "border-gray-200 hover:border-blue-300 hover:bg-gray-50"
                  }`}
                  onClick={() => toggleFlightSelection(flight.id)}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex items-start space-x-3 flex-1">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => {}}
                        className="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500"
                      />
                      <div className="flex-1">
                        <div className="flex items-center space-x-3 mb-2">
                          <h4 className="font-bold text-gray-900">
                            {flight.numeroRequete}
                          </h4>
                          <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-sm font-medium">
                            {flight.statut}
                          </span>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
                          <div>
                            <p className="text-gray-500 text-xs uppercase font-medium">
                              Voyageur
                            </p>
                            <p className="font-semibold text-gray-900">
                              {flight.prenom} {flight.nom}
                            </p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs uppercase font-medium">
                              Trajet
                            </p>
                            <p className="font-semibold text-gray-900">
                              {flight.searchParams.originLocationCode} →{" "}
                              {flight.searchParams.destinationLocationCode}
                            </p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs uppercase font-medium">
                              Date
                            </p>
                            <p className="font-semibold text-gray-900">
                              {new Date(
                                flight.searchParams.departureDate
                              ).toLocaleDateString("fr-FR")}
                            </p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs uppercase font-medium">
                              Émis le
                            </p>
                            <p className="font-semibold text-gray-900">
                              {new Date(flight.createdAt).toLocaleDateString(
                                "fr-FR"
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-right ml-4 min-w-[180px]">
                      <p className="text-sm text-gray-500">Montant</p>
                      <p className="text-lg font-bold text-blue-600">
                        {formatAmount(flight.montant) || 0} {flight.devise}
                      </p>
                      <p className="text-xs text-gray-500 mt-1 flex items-center justify-end">
                        <Percent className="w-3 h-3 mr-1" />
                        Frais ({config.flightServiceFeePercent}%):{" "}
                        {formatAmount(serviceFee)} {flight.devise}
                      </p>
                      <p className="text-sm font-semibold text-green-600 mt-1">
                        Total:{" "}
                        {formatAmount(
                          (formatAmount(flight.montant) || 0) + serviceFee
                        )}{" "}
                        {flight.devise}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Liste des réservations d'hôtel */}
      {hotels.length > 0 && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-bold flex items-center">
              <Hotel className="w-6 h-6 mr-2 text-purple-600" />
              Réservations d'hôtel non facturées ({hotels.length})
            </h3>
            <button
              onClick={toggleAllHotels}
              className="text-sm text-purple-600 hover:text-purple-800 font-medium"
            >
              {selectedHotels.length === hotels.length
                ? "Tout désélectionner"
                : "Tout sélectionner"}
            </button>
          </div>

          <div className="space-y-3">
            {hotels.map((hotel) => {
              const amount = hotel.nombreNuits * 150;
              const serviceFee = (amount * 5) / 100;
              const isSelected = selectedHotels.includes(hotel.id);

              return (
                <div
                  key={hotel.id}
                  className={`border-2 rounded-lg p-4 cursor-pointer transition-all duration-200 ${
                    isSelected
                      ? "border-purple-600 bg-purple-50 shadow-md"
                      : "border-gray-200 hover:border-purple-300 hover:bg-gray-50"
                  }`}
                  onClick={() => toggleHotelSelection(hotel.id)}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex items-start space-x-3 flex-1">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => {}}
                        className="mt-1 w-5 h-5 text-purple-600 rounded focus:ring-purple-500"
                      />
                      <div className="flex-1">
                        <div className="flex items-center space-x-3 mb-2">
                          <h4 className="font-bold text-gray-900">
                            {hotel.numeroRequete}
                          </h4>
                          <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-sm font-medium">
                            {hotel.statut}
                          </span>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
                          <div>
                            <p className="text-gray-500 text-xs uppercase font-medium">
                              Voyageur
                            </p>
                            <p className="font-semibold text-gray-900">
                              {hotel.prenom} {hotel.nom}
                            </p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs uppercase font-medium">
                              Hôtel
                            </p>
                            <p className="font-semibold text-gray-900">
                              {hotel.hotel.name}
                            </p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs uppercase font-medium">
                              Nuits
                            </p>
                            <p className="font-semibold text-gray-900">
                              {hotel.nombreNuits}
                            </p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs uppercase font-medium">
                              Réservé le
                            </p>
                            <p className="font-semibold text-gray-900">
                              {new Date(hotel.createdAt).toLocaleDateString(
                                "fr-FR"
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-right ml-4 min-w-[180px]">
                      <p className="text-sm text-gray-500">Montant estimé</p>
                      <p className="text-lg font-bold text-purple-600">
                        {formatAmount(amount)} EUR
                      </p>
                      <p className="text-xs text-gray-500 mt-1 flex items-center justify-end">
                        <Percent className="w-3 h-3 mr-1" />
                        Frais ({config.hotelServiceFeePercent}%):{" "}
                        {formatAmount(serviceFee)} EUR
                      </p>
                      <p className="text-sm font-semibold text-green-600 mt-1">
                        Total: {formatAmount(amount + serviceFee)} EUR
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Message si aucun élément */}
      {flights.length === 0 && hotels.length === 0 && (
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <CheckCircle className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-xl font-bold text-gray-700 mb-2">
            Aucun élément à facturer
          </h3>
          <p className="text-gray-500">
            Tous les billets et réservations ont été facturés
          </p>
        </div>
      )}
    </div>
  );
};
const InvoicesListComponent = ({
  invoices,
  onUpdateStatus,
  onSendEmail,
  onRefresh,
}) => {
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailForm, setEmailForm] = useState({
    to: "",
    cc: "",
    subject: "",
    message: "",
  });
  const [sending, setSending] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const doc = new jsPDF();
  const getStatusColor = (status) =>
    ({
      Impayée: "bg-yellow-100 text-yellow-700",
      Payée: "bg-green-100 text-green-700",
      Annulée: "bg-red-100 text-red-700",
      "En attente": "bg-blue-100 text-blue-700",
    }[status] || "bg-gray-100 text-gray-700");

  const handleDownloadPDFFallback = async (invoice) => {
    setDownloading(true);
    try {
      const blob = await billingService.downloadInvoicePDF(invoice.id);

      // Créer un URL pour le blob et déclencher le téléchargement
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Facture_${invoice.numeroFacture}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      alert("Facture téléchargée avec succès !");
    } catch (error) {
      console.error("Erreur téléchargement PDF:", error);
      alert(`Erreur lors du téléchargement: ${error.message}`);
    } finally {
      setDownloading(false);
    }
  };

  // Fonction de secours pour générer le PDF côté client si l'API n'est pas disponible
  const handleDownloadPDF = (invoice) => {
    const doc = new jsPDF();

    // ==================== EN-TÊTE ====================
    doc.setFillColor(37, 99, 235);
    doc.rect(0, 0, 210, 50, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(28);
    doc.text("FACTURE", 105, 25, { align: "center" });
    doc.setFontSize(14);
    doc.text(invoice.numeroFacture, 105, 35, { align: "center" });

    // ==================== INFORMATIONS ENTREPRISE ====================
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    let yPos = 60;
    doc.setFont(undefined, "bold");
    doc.text("ABM Travel Agency", 20, yPos);
    doc.setFont(undefined, "normal");
    yPos += 5;
    doc.text("Conakry, Guinée", 20, yPos);
    yPos += 5;
    doc.text("contact@abmtravel.com", 20, yPos);
    yPos += 5;
    doc.text("+225 07 08 83 76 60", 20, yPos);
    yPos += 5;
    doc.text("RC-GN-2024-XXX", 20, yPos);

    // ==================== DATES ET STATUT ====================
    yPos = 60;
    doc.text(
      `Date: ${new Date(invoice.dateEmission).toLocaleDateString("fr-FR")}`,
      190,
      yPos,
      { align: "right" }
    );
    yPos += 5;
    doc.text(
      `Échéance: ${new Date(invoice.dateEcheance).toLocaleDateString("fr-FR")}`,
      190,
      yPos,
      { align: "right" }
    );
    yPos += 5;
    doc.setFont(undefined, "bold");
    doc.text(`Statut: ${invoice.statut}`, 190, yPos, { align: "right" });

    yPos = 95;

    // ==================== INFORMATIONS CLIENT ====================
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("FACTURÉ À", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    yPos += 7;

    if (invoice.clients && invoice.clients.length > 0) {
      invoice.clients.forEach((client) => {
        doc.text(client, 20, yPos);
        yPos += 5;
      });
    } else {
      doc.text("Client non spécifié", 20, yPos);
      yPos += 5;
    }

    yPos += 10;

    // ==================== TABLEAU DES SERVICES (MANUEL) ====================

    // En-tête du tableau
    doc.setFillColor(37, 99, 235);
    doc.rect(15, yPos, 180, 8, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont(undefined, "bold");
    doc.setFontSize(9);
    doc.text("Service", 20, yPos + 6);
    doc.text("Voyageur", 50, yPos + 6);
    doc.text("Détails", 90, yPos + 6);
    doc.text("Montant", 140, yPos + 6);
    doc.text("Frais service", 160, yPos + 6);
    doc.text("Total", 185, yPos + 6);

    yPos += 8;
    doc.setTextColor(0, 0, 0);
    doc.setFont(undefined, "normal");

    // Lignes du tableau
    let rowHeight = 8;
    let currentY = yPos;

    // Billets d'avion
    if (invoice.items.flights && invoice.items.flights.length > 0) {
      invoice.items.flights.forEach((flight) => {
        const flightAmount = getSafeAmount(flight.montant);
        const serviceFeePercent = getSafeAmount(
          invoice.config.flightServiceFeePercent,
          10
        );
        const serviceFee = (flightAmount * serviceFeePercent) / 100;
        const devise = flight.devise || "EUR";

        // Fond alterné pour les lignes
        if (currentY % 16 === yPos % 16) {
          doc.setFillColor(245, 245, 245);
          doc.rect(15, currentY, 180, rowHeight, "F");
        }

        doc.setFontSize(8);
        doc.text("Billet d'avion", 20, currentY + 6);
        doc.text(
          `${flight.prenom || ""} ${flight.nom || ""}`.trim(),
          50,
          currentY + 6
        );
        doc.text(
          `${flight.searchParams?.originLocationCode || "N/A"} → ${
            flight.searchParams?.destinationLocationCode || "N/A"
          }`,
          90,
          currentY + 6
        );
        doc.text(`${formatAmount(flightAmount)} ${devise}`, 140, currentY + 6);
        doc.text(`${formatAmount(serviceFee)} ${devise}`, 160, currentY + 6);
        doc.text(
          `${formatAmount(flightAmount + serviceFee)} ${devise}`,
          185,
          currentY + 6
        );

        currentY += rowHeight;
      });
    }

    // Réservations d'hôtel
    if (invoice.items.hotels && invoice.items.hotels.length > 0) {
      invoice.items.hotels.forEach((hotel) => {
        const numberOfNights = getSafeAmount(hotel.nombreNuits, 1);
        const amount = numberOfNights * 150;
        const serviceFeePercent = getSafeAmount(
          invoice.config.hotelServiceFeePercent,
          5
        );
        const serviceFee = (amount * serviceFeePercent) / 100;

        // Fond alterné pour les lignes
        if (currentY % 16 === yPos % 16) {
          doc.setFillColor(245, 245, 245);
          doc.rect(15, currentY, 180, rowHeight, "F");
        }

        doc.setFontSize(8);
        doc.text("Réservation hôtel", 20, currentY + 6);
        doc.text(
          `${hotel.prenom || ""} ${hotel.nom || ""}`.trim(),
          50,
          currentY + 6
        );
        doc.text(
          `${hotel.hotel?.name || "Hôtel"} (${numberOfNights} nuit${
            numberOfNights > 1 ? "s" : ""
          })`,
          90,
          currentY + 6
        );
        doc.text(`${formatAmount(amount)} EUR`, 140, currentY + 6);
        doc.text(`${formatAmount(serviceFee)} EUR`, 160, currentY + 6);
        doc.text(`${formatAmount(amount + serviceFee)} EUR`, 185, currentY + 6);

        currentY += rowHeight;
      });
    }

    // Ligne de séparation
    doc.setDrawColor(200, 200, 200);
    doc.line(15, currentY, 195, currentY);
    currentY += 10;

    // ==================== RÉCAPITULATIF FINANCIER ====================
    doc.setFont(undefined, "bold");
    doc.setFontSize(10);

    const totals = [
      {
        label: "Sous-total services",
        value: `${formatAmount(invoice.totals.subtotal)} EUR`,
      },
      {
        label: "Total frais de service",
        value: `${formatAmount(invoice.totals.serviceFees)} EUR`,
      },
      {
        label: "Sous-total HT",
        value: `${formatAmount(invoice.totals.subtotalWithFees)} EUR`,
      },
      {
        label: `TVA (${invoice.config.taxRate}%)`,
        value: `${formatAmount(invoice.totals.tax)} EUR`,
      },
      {
        label: "TOTAL TTC",
        value: `${formatAmount(invoice.totals.total)} EUR`,
      },
    ];

    totals.forEach((item, index) => {
      const isTotal = index === totals.length - 1;

      if (isTotal) {
        doc.setFontSize(12);
        doc.setFillColor(230, 240, 255);
        doc.rect(100, currentY, 95, 10, "F");
      }

      doc.text(item.label, 105, currentY + 7, { align: "right" });
      doc.text(item.value, 195, currentY + 7, { align: "right" });

      currentY += isTotal ? 12 : 8;

      if (isTotal) {
        doc.setFontSize(10);
      }
    });

    // ==================== NOTE DE PAIEMENT ====================
    currentY += 5;
    doc.setFontSize(9);
    doc.setFont(undefined, "italic");
    doc.text(
      "Paiement à effectuer sous 30 jours à réception de la facture.",
      20,
      currentY
    );
    currentY += 5;
    doc.text("Coordonnées bancaires disponibles sur demande.", 20, currentY);

    // ==================== INFORMATIONS IMPORTANTES ====================
    currentY += 10;
    doc.setFont(undefined, "bold");
    doc.setFontSize(10);
    doc.text("INFORMATIONS IMPORTANTES", 20, currentY);
    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    currentY += 6;

    const informations = [
      "• Cette facture est établie en conformité avec la législation en vigueur.",
      "• Tout retard de paiement entraînera des pénalités de retard.",
      "• En cas de litige, privilégier le contact amiable.",
      "• Facture électronique - Valeur probante équivalente à la version papier.",
    ];

    informations.forEach((info) => {
      doc.text(info, 20, currentY);
      currentY += 5;
    });

    // ==================== CODE-BARRES FACTURE ====================
    currentY += 10;
    doc.setFillColor(0, 0, 0);
    doc.rect(50, currentY, 110, 15, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(10);
    doc.text(invoice.numeroFacture || "FACTURE-2024", 105, currentY + 10, {
      align: "center",
    });

    // ==================== PIED DE PAGE ====================
    doc.setTextColor(0, 0, 0);
    doc.setFillColor(37, 99, 235);
    doc.rect(0, 270, 210, 27, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(8);
    doc.setFont(undefined, "normal");
    doc.text("ABM Travel Agency - Conakry, Guinée", 105, 278, {
      align: "center",
    });
    doc.text(
      "contact@abmtravel.com | +225 07 08 83 76 60 | RC-GN-2024-XXX",
      105,
      283,
      { align: "center" }
    );
    doc.setFont(undefined, "italic");
    doc.text(
      "Document généré électroniquement - Valide sans signature",
      105,
      288,
      { align: "center" }
    );

    // ==================== TÉLÉCHARGEMENT ====================
    doc.save(`Facture_${invoice.numeroFacture || "FACTURE"}.pdf`);
  };

  // const handleDownloadPDF = (invoice) => {
  //   const doc = generateInvoicePDF(invoice);
  //   doc.save(`Facture_${invoice.numeroFacture}.pdf`);
  // };

  const handleSendEmail = async () => {
    if (!emailForm.to || !selectedInvoice) {
      alert("Veuillez renseigner au moins l'email du destinataire");
      return;
    }

    setSending(true);
    try {
      await billingService.sendInvoiceEmail(selectedInvoice.id, emailForm);
      alert("Facture envoyée par email avec succès !");
      setShowEmailModal(false);
      setEmailForm({ to: "", cc: "", subject: "", message: "" });
      onRefresh && (await onRefresh());
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setSending(false);
    }
  };

  const openEmailModal = (invoice) => {
    setSelectedInvoice(invoice);
    setEmailForm({
      to:
        invoice.items.flights[0]?.email || invoice.items.hotels[0]?.email || "",
      cc: "",
      subject: `Facture ${invoice.numeroFacture} - ABM Travel Agency`,
      message: `Bonjour,

Veuillez trouver ci-joint la facture ${
        invoice.numeroFacture
      } d'un montant de ${formatAmount(invoice.totals.total)} EUR.

Date d'émission : ${new Date(invoice.dateEmission).toLocaleDateString("fr-FR")}
Date d'échéance : ${new Date(invoice.dateEcheance).toLocaleDateString("fr-FR")}

Merci de procéder au règlement avant la date d'échéance.

Cordialement,
L'équipe ABM Travel Agency`,
    });
    setShowEmailModal(true);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-bold">Factures émises</h3>
          <button
            onClick={onRefresh}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
          >
            <Download className="w-4 h-4 mr-2" />
            Actualiser
          </button>
        </div>

        {invoices.length === 0 ? (
          <div className="text-center py-12">
            <FileCheck className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">Aucune facture émise</p>
          </div>
        ) : (
          <div className="space-y-4">
            {invoices.map((invoice) => (
              <div
                key={invoice.id}
                className="border rounded-lg p-6 hover:shadow-lg transition"
              >
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <div className="flex items-center space-x-3 mb-2">
                      <h4 className="text-xl font-bold">
                        {invoice.numeroFacture}
                      </h4>
                      <span
                        className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(
                          invoice.statut
                        )}`}
                      >
                        {invoice.statut}
                      </span>
                    </div>
                    <div className="text-sm text-gray-600 space-y-1">
                      <p>
                        Émise le:{" "}
                        {new Date(invoice.dateEmission).toLocaleDateString(
                          "fr-FR"
                        )}
                      </p>
                      <p>
                        Échéance:{" "}
                        {new Date(invoice.dateEcheance).toLocaleDateString(
                          "fr-FR"
                        )}
                      </p>
                      <p>Clients: {invoice.clients.join(", ")}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-500">Montant total</p>
                    <p className="text-3xl font-bold text-blue-600">
                      {formatAmount(invoice.totals.total)} EUR
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 mb-4">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <div>
                      <p className="text-gray-500">Vols</p>{" "}
                      <p className="font-semibold">
                        {invoice.items.flights?.length || 0}
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-500">Hôtels</p>
                      <p className="font-semibold">
                        {invoice.items.hotels?.length || 0}
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-500">Frais de service</p>
                      <p className="font-semibold">
                        {formatAmount(invoice.totals.serviceFees)} EUR
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-500">
                        TVA ({invoice.config.taxRate}%)
                      </p>
                      <p className="font-semibold">
                        {formatAmount(invoice.totals.tax)} EUR
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap gap-3">
                  <button
                    onClick={() => handleDownloadPDF(invoice)}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
                  >
                    <Download className="w-4 h-4 mr-2" />
                    Télécharger PDF
                  </button>
                  <button
                    onClick={() => openEmailModal(invoice)}
                    className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center"
                  >
                    <Mail className="w-4 h-4 mr-2" />
                    Envoyer par email
                  </button>
                  {invoice.statut === "Impayée" && (
                    <button
                      onClick={() => onUpdateStatus(invoice.id, "Payée")}
                      className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 flex items-center"
                    >
                      <CheckCircle className="w-4 h-4 mr-2" />
                      Marquer comme payée
                    </button>
                  )}
                  <button
                    onClick={() =>
                      setSelectedInvoice(
                        selectedInvoice === invoice.id ? null : invoice.id
                      )
                    }
                    className="px-4 py-2 border rounded-lg hover:bg-gray-50 flex items-center"
                  >
                    <Eye className="w-4 h-4 mr-2" />
                    {selectedInvoice === invoice.id ? "Masquer" : "Détails"}
                  </button>
                </div>

                {selectedInvoice === invoice.id && (
                  <div className="mt-4 border-t pt-4">
                    <h5 className="font-bold mb-3">Détails de la facture</h5>

                    {invoice.items.flights &&
                      invoice.items.flights.length > 0 && (
                        <div className="mb-4">
                          <p className="font-semibold text-sm text-gray-700 mb-2">
                            Billets d'avion
                          </p>
                          <div className="space-y-2">
                            {invoice.items.flights.map((flight, idx) => (
                              <div
                                key={idx}
                                className="bg-blue-50 p-3 rounded text-sm"
                              >
                                <div className="flex justify-between">
                                  <span>
                                    {flight.prenom} {flight.nom} -{" "}
                                    {flight.searchParams.originLocationCode} →{" "}
                                    {
                                      flight.searchParams
                                        .destinationLocationCode
                                    }
                                  </span>
                                  <span className="font-semibold">
                                    {flight.montant} {flight.devise}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                    {invoice.items.hotels &&
                      invoice.items.hotels.length > 0 && (
                        <div>
                          <p className="font-semibold text-sm text-gray-700 mb-2">
                            Réservations d'hôtel
                          </p>
                          <div className="space-y-2">
                            {invoice.items.hotels.map((hotel, idx) => {
                              const amount = hotel.nombreNuits * 150;
                              return (
                                <div
                                  key={idx}
                                  className="bg-purple-50 p-3 rounded text-sm"
                                >
                                  <div className="flex justify-between">
                                    <span>
                                      {hotel.prenom} {hotel.nom} -{" "}
                                      {hotel.hotel.name} ({hotel.nombreNuits}{" "}
                                      nuit{hotel.nombreNuits > 1 ? "s" : ""})
                                    </span>
                                    <span className="font-semibold">
                                      {formatAmount(amount)} EUR
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                    <div className="mt-4 pt-4 border-t space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span>Sous-total</span>
                        <span className="font-semibold">
                          {formatAmount(invoice.totals.subtotal)} EUR
                        </span>
                      </div>
                      <div className="flex justify-between text-blue-600">
                        <span>Frais de service</span>
                        <span className="font-semibold">
                          + {formatAmount(invoice.totals.serviceFees)} EUR
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Sous-total avec frais</span>
                        <span className="font-semibold">
                          {formatAmount(invoice.totals.subtotalWithFees)} EUR
                        </span>
                      </div>
                      <div className="flex justify-between text-gray-600">
                        <span>TVA ({invoice.config.taxRate}%)</span>
                        <span className="font-semibold">
                          + {formatAmount(invoice.totals.tax)} EUR
                        </span>
                      </div>
                      <div className="flex justify-between text-lg font-bold pt-2 border-t">
                        <span>TOTAL TTC</span>
                        <span className="text-green-600">
                          {formatAmount(invoice.totals.total)} EUR
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal d'envoi d'email */}
      {showEmailModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold flex items-center">
                  <Mail className="w-6 h-6 mr-2 text-blue-600" />
                  Envoyer la facture par email
                </h3>
                <button
                  onClick={() => setShowEmailModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                <p className="text-sm text-blue-900">
                  <span className="font-semibold">Facture:</span>{" "}
                  {selectedInvoice?.numeroFacture}
                </p>
                <p className="text-sm text-blue-900">
                  <span className="font-semibold">Montant:</span>{" "}
                  {formatAmount(selectedInvoice?.totals.total)} EUR
                </p>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold mb-2">
                    Destinataire *
                  </label>
                  <input
                    type="email"
                    value={emailForm.to}
                    onChange={(e) =>
                      setEmailForm({ ...emailForm, to: e.target.value })
                    }
                    placeholder="email@exemple.com"
                    className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-2">
                    CC (Copie)
                  </label>
                  <input
                    type="email"
                    value={emailForm.cc}
                    onChange={(e) =>
                      setEmailForm({ ...emailForm, cc: e.target.value })
                    }
                    placeholder="email@exemple.com"
                    className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-2">
                    Sujet *
                  </label>
                  <input
                    type="text"
                    value={emailForm.subject}
                    onChange={(e) =>
                      setEmailForm({ ...emailForm, subject: e.target.value })
                    }
                    className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-2">
                    Message *
                  </label>
                  <textarea
                    value={emailForm.message}
                    onChange={(e) =>
                      setEmailForm({ ...emailForm, message: e.target.value })
                    }
                    rows="8"
                    className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                  <p className="text-sm text-yellow-800">
                    <span className="font-semibold">Note:</span> La facture PDF
                    sera automatiquement jointe à cet email.
                  </p>
                </div>
              </div>

              <div className="flex space-x-3 mt-6">
                <button
                  onClick={handleSendEmail}
                  disabled={sending}
                  className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 text-white py-3 rounded-lg font-semibold hover:from-green-700 hover:to-emerald-700 disabled:opacity-50 flex items-center justify-center"
                >
                  {sending ? (
                    <>
                      <Loader className="w-5 h-5 mr-2 animate-spin" />
                      Envoi en cours...
                    </>
                  ) : (
                    <>
                      <Mail className="w-5 h-5 mr-2" />
                      Envoyer la facture
                    </>
                  )}
                </button>
                <button
                  onClick={() => setShowEmailModal(false)}
                  disabled={sending}
                  className="px-6 py-3 border rounded-lg hover:bg-gray-50 disabled:opacity-50"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const BillingConfigComponent = ({ config, onUpdate }) => {
  const [formData, setFormData] = useState(config);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await billingService.updateConfig(formData);
      alert("Configuration enregistrée avec succès !");
      onUpdate && onUpdate(formData);
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h2 className="text-2xl font-bold mb-6 flex items-center">
        <Settings className="w-6 h-6 mr-2 text-blue-600" />
        Configuration de la facturation
      </h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="border rounded-lg p-6 bg-blue-50">
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <Plane className="w-5 h-5 mr-2 text-blue-600" />
            Frais de service - Billets d'avion
          </h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Pourcentage (%)
              </label>
              <input
                type="number"
                step="0.01"
                value={formData.flightServiceFeePercent}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    flightServiceFeePercent: parseFloat(e.target.value),
                  })
                }
                className="w-full px-4 py-2 border rounded-lg"
                required
              />
            </div>
          </div>
          <div className="mt-3 p-3 bg-blue-100 rounded text-sm">
            <p className="font-semibold text-blue-900">
              Exemple: Pour un billet de 500 EUR, les frais seront de{" "}
              {formatAmount((500 * formData.flightServiceFeePercent) / 100)} EUR
              ({formData.flightServiceFeePercent}%)
            </p>
          </div>
        </div>

        <div className="border rounded-lg p-6 bg-purple-50">
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <Hotel className="w-5 h-5 mr-2 text-purple-600" />
            Frais de service - Réservations d'hôtel
          </h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Pourcentage (%)
              </label>
              <input
                type="number"
                step="0.01"
                value={formData.hotelServiceFeePercent}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    hotelServiceFeePercent: parseFloat(e.target.value),
                  })
                }
                className="w-full px-4 py-2 border rounded-lg"
                required
              />
            </div>
          </div>
          <div className="mt-3 p-3 bg-purple-100 rounded text-sm">
            <p className="font-semibold text-purple-900">
              Exemple: Pour une réservation de 300 EUR, les frais seront de{" "}
              {formatAmount((300 * formData.hotelServiceFeePercent) / 100)} EUR
              ({formData.hotelServiceFeePercent}%)
            </p>
          </div>
        </div>

        <div className="border rounded-lg p-6 bg-green-50">
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <DollarSign className="w-5 h-5 mr-2 text-green-600" />
            Taxe sur la Valeur Ajoutée (TVA)
          </h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Taux de TVA (%)
              </label>
              <input
                type="number"
                step="0.01"
                value={formData.taxRate}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    taxRate: parseFloat(e.target.value),
                  })
                }
                className="w-full px-4 py-2 border rounded-lg"
                required
              />
            </div>
          </div>
          <div className="mt-3 p-3 bg-green-100 rounded text-sm">
            <p className="font-semibold text-green-900">
              La TVA de {formData.taxRate}% est appliquée sur le montant total
              incluant les frais de service
            </p>
          </div>
        </div>

        <div className="border rounded-lg p-6 bg-gradient-to-r from-blue-50 to-purple-50">
          <h3 className="text-lg font-bold mb-4">Simulation de facture</h3>
          <div className="space-y-3">
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-white p-4 rounded-lg">
                <p className="text-sm text-gray-600 mb-2">Vol de 500 EUR</p>
                <div className="space-y-1 text-sm">
                  <div className="flex justify-between">
                    <span>Montant billet:</span>
                    <span className="font-semibold">500.00 EUR</span>
                  </div>
                  <div className="flex justify-between text-blue-600">
                    <span>Frais de service:</span>
                    <span className="font-semibold">
                      +{" "}
                      {formatAmount(
                        (500 * formData.flightServiceFeePercent) / 100
                      )}{" "}
                      EUR
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span>Sous-total:</span>
                    <span className="font-semibold">
                      {formatAmount(
                        500 + (500 * formData.flightServiceFeePercent) / 100
                      )}{" "}
                      EUR
                    </span>
                  </div>
                  <div className="flex justify-between text-green-600">
                    <span>TVA ({formData.taxRate}%):</span>
                    <span className="font-semibold">
                      +{" "}
                      {formatAmount(
                        ((500 +
                          (500 * formData.flightServiceFeePercent) / 100) *
                          formData.taxRate) /
                          100
                      )}{" "}
                      EUR
                    </span>
                  </div>
                  <div className="flex justify-between font-bold text-lg pt-2 border-t">
                    <span>Total TTC:</span>
                    <span className="text-blue-600">
                      {formatAmount(
                        (500 + (500 * formData.flightServiceFeePercent) / 100) *
                          (1 + formData.taxRate / 100)
                      )}{" "}
                      EUR
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-white p-4 rounded-lg">
                <p className="text-sm text-gray-600 mb-2">
                  Hôtel 3 nuits (450 EUR)
                </p>
                <div className="space-y-1 text-sm">
                  <div className="flex justify-between">
                    <span>Montant réservation:</span>
                    <span className="font-semibold">450.00 EUR</span>
                  </div>
                  <div className="flex justify-between text-purple-600">
                    <span>Frais de service:</span>
                    <span className="font-semibold">
                      +{" "}
                      {formatAmount(
                        (450 * formData.hotelServiceFeePercent) / 100
                      )}{" "}
                      EUR
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span>Sous-total:</span>
                    <span className="font-semibold">
                      {formatAmount(
                        450 + (450 * formData.hotelServiceFeePercent) / 100
                      )}{" "}
                      EUR
                    </span>
                  </div>
                  <div className="flex justify-between text-green-600">
                    <span>TVA ({formData.taxRate}%):</span>
                    <span className="font-semibold">
                      +{" "}
                      {formatAmount(
                        ((450 + (450 * formData.hotelServiceFeePercent) / 100) *
                          formData.taxRate) /
                          100
                      )}{" "}
                      EUR
                    </span>
                  </div>
                  <div className="flex justify-between font-bold text-lg pt-2 border-t">
                    <span>Total TTC:</span>
                    <span className="text-purple-600">
                      {formatAmount(
                        (450 + (450 * formData.hotelServiceFeePercent) / 100) *
                          (1 + formData.taxRate / 100)
                      )}{" "}
                      EUR
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex space-x-4">
          <button
            type="submit"
            disabled={saving}
            className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center"
          >
            {saving ? (
              <>
                <Loader className="w-5 h-5 mr-2 animate-spin" />
                Enregistrement...
              </>
            ) : (
              <>
                <Save className="w-5 h-5 mr-2" />
                Enregistrer la configuration
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

// ==================== MODULE PRINCIPAL DE FACTURATION ====================

const BillingModule = () => {
  const [activeTab, setActiveTab] = useState("unbilled");
  const [unbilledFlights, setUnbilledFlights] = useState([]);
  const [unbilledHotels, setUnbilledHotels] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [config, setConfig] = useState({
    flightServiceFeePercent: 10,
    hotelServiceFeePercent: 15,
    taxRate: 18,
  });
  const [loading, setLoading] = useState(false);
  const [statistics, setStatistics] = useState(null);

  useEffect(() => {
    loadAllData();
  }, []);

  const loadAllData = async () => {
    setLoading(true);
    try {
      const [configData, unbilledData, invoicesData, statsData] =
        await Promise.all([
          billingService.getConfig(),
          billingService.getUnbilledItems(),
          billingService.getInvoices(),
          // billingService.getStatistics()
        ]);

      setConfig(configData);
      setUnbilledFlights(unbilledData.flights || []);
      setUnbilledHotels(unbilledData.hotels || []);
      setInvoices(invoicesData);
      //setStatistics(statsData);
    } catch (error) {
      console.error("Erreur chargement données:", error);
      alert("Erreur lors du chargement des données de facturation");
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateInvoice = async (
    selectedFlights,
    selectedHotels,
    totals
  ) => {
    if (selectedFlights.length === 0 && selectedHotels.length === 0) {
      alert("Veuillez sélectionner au moins un élément");
      return;
    }
    // Validation des données
    const flights = unbilledFlights.filter((f) =>
      selectedFlights.includes(f.id)
    );
    const hotels = unbilledHotels.filter((h) => selectedHotels.includes(h.id));

    // S'assurer que tous les montants sont valides
    const invalidFlights = flights.filter((f) => isNaN(parseFloat(f.montant)));
    if (invalidFlights.length > 0) {
      alert("Certains vols ont des montants invalides");
      return;
    }

    setLoading(true);
    try {
      const flights = unbilledFlights.filter((f) =>
        selectedFlights.includes(f.id)
      );
      const hotels = unbilledHotels.filter((h) =>
        selectedHotels.includes(h.id)
      );

      const invoiceData = {
        flightIds: selectedFlights,
        hotelIds: selectedHotels,
        items: { flights, hotels },
        config,
        totals,
        clients: [
          ...new Set([
            ...flights.map((f) => `${f.prenom} ${f.nom}`),
            ...hotels.map((h) => `${h.prenom} ${h.nom}`),
          ]),
        ],
      };
      console.log("les données", invoiceData);
      await billingService.createInvoice(invoiceData);
      alert("Facture créée avec succès !");
      await loadAllData();
      setActiveTab("invoices");
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateInvoiceStatus = async (id, status) => {
    try {
      await billingService.updateInvoiceStatus(id, status);
      await loadAllData();
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    }
  };

  const tabs = [
    { id: "unbilled", label: "Non facturées", icon: Clock },
    { id: "invoices", label: "Factures émises", icon: FileCheck },
    { id: "config", label: "Configuration", icon: Settings },
  ];

  if (loading && !unbilledFlights.length && !invoices.length) {
    return (
      <div className="bg-white rounded-xl shadow-md p-12 text-center">
        <Loader className="w-12 h-12 text-blue-600 mx-auto mb-4 animate-spin" />
        <p className="text-gray-600">Chargement du module de facturation...</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h1 className="text-3xl font-bold mb-6 flex items-center">
          <CreditCard className="w-8 h-8 mr-3 text-blue-600" />
          Module de Facturation
        </h1>

        {statistics && (
          <div className="grid md:grid-cols-4 gap-4 mb-6">
            <div className="bg-green-50 rounded-lg p-4">
              <p className="text-sm text-gray-600">Total facturé</p>
              <p className="text-2xl font-bold text-green-600">
                {formatAmount(statistics.totalFacture) || "0.00"} EUR
              </p>
            </div>
            <div className="bg-yellow-50 rounded-lg p-4">
              <p className="text-sm text-gray-600">Factures impayées</p>
              <p className="text-2xl font-bold text-yellow-600">
                {statistics.impayees || 0}
              </p>
            </div>
            <div className="bg-blue-50 rounded-lg p-4">
              <p className="text-sm text-gray-600">Factures payées</p>
              <p className="text-2xl font-bold text-blue-600">
                {statistics.payees || 0}
              </p>
            </div>
            <div className="bg-purple-50 rounded-lg p-4">
              <p className="text-sm text-gray-600">Frais perçus</p>
              <p className="text-2xl font-bold text-purple-600">
                {formatAmount(statistics.totalServiceFees) || "0.00"} EUR
              </p>
            </div>
          </div>
        )}

        <div className="flex space-x-2 border-b overflow-x-auto">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 font-semibold flex items-center space-x-2 border-b-2 transition whitespace-nowrap ${
                  activeTab === tab.id
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-gray-600 hover:text-blue-600"
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {activeTab === "unbilled" && (
        <UnbilledItemsComponent
          flights={unbilledFlights}
          hotels={unbilledHotels}
          onGenerateInvoice={handleGenerateInvoice}
        />
      )}

      {activeTab === "invoices" && (
        <InvoicesListComponent
          invoices={invoices}
          onUpdateStatus={handleUpdateInvoiceStatus}
          onRefresh={loadAllData}
        />
      )}

      {activeTab === "config" && (
        <BillingConfigComponent config={config} onUpdate={loadAllData} />
      )}
    </div>
  );
};
// ==================== MODULES HÔTELS ====================

// ==================== SERVICES API DEMANDES D'HÔTELS ====================

const HotelSearch = ({ onSelectHotel }) => {
  // Configuration des limites API
  const API_CONFIG = {
    MAX_HOTELS: 1000,
    DELAY_BETWEEN_REQUESTS: 1200,
    BATCH_SIZE: 3,
    BATCH_DELAY: 3000,
    MAX_RETRIES: 2,
    INITIAL_DELAY: 1000,
  };

  // États de recherche
  const [searchParams, setSearchParams] = useState({
    cityCode: "",
    checkInDate: "",
    checkOutDate: "",
    adults: "1",
    children: "0",
    infants: "0",
    rooms: "1",
    radius: "5",
    radiusUnit: "KM",
    ratings: "",
  });
  // Nouvel état pour l'offre sélectionnée
  const [selectedOffer, setSelectedOffer] = useState(null);
  // États des données
  const [hotels, setHotels] = useState([]);
  const [hotelOffers, setHotelOffers] = useState({});

  // États de chargement
  const [loading, setLoading] = useState(false);
  const [loadingOffers, setLoadingOffers] = useState({});
  const [allOffersLoaded, setAllOffersLoaded] = useState(false);

  // États d'erreur et gestion des requêtes
  const [error, setError] = useState(null);
  const [failedRequests, setFailedRequests] = useState(new Set());
  const [successfulRequests, setSuccessfulRequests] = useState(new Set());
  const [currentBatch, setCurrentBatch] = useState(0);
  const [totalBatches, setTotalBatches] = useState(0);
  const [apiDelay, setApiDelay] = useState(API_CONFIG.INITIAL_DELAY);
  const [searchStrategy, setSearchStrategy] = useState("balanced"); // 'conservative' | 'balanced' | 'aggressive'

  // Statistiques en temps réel
  const [stats, setStats] = useState({
    total: 0,
    withOffers: 0,
    noOffers: 0,
    errors: 0,
    loading: 0,
    completed: 0,
  });

  // Mettre à jour les statistiques
  useEffect(() => {
    const total = hotels.length;
    const withOffers = hotels.filter(
      (hotel) =>
        hotelOffers[hotel.hotelId] && hotelOffers[hotel.hotelId].length > 0
    ).length;
    const errors = failedRequests.size;
    const loading = hotels.filter(
      (hotel) =>
        hotel.hotelId &&
        loadingOffers[hotel.hotelId] &&
        !failedRequests.has(hotel.hotelId)
    ).length;
    const completed = successfulRequests.size;
    const noOffers = total - withOffers - errors - loading;

    setStats({ total, withOffers, noOffers, errors, loading, completed });
  }, [hotels, hotelOffers, failedRequests, loadingOffers, successfulRequests]);

  // Adapter la stratégie basée sur les erreurs
  useEffect(() => {
    if (failedRequests.size > stats.total * 0.3) {
      // Plus de 30% d'erreurs
      setSearchStrategy("conservative");
      setApiDelay(2000);
    } else if (failedRequests.size > stats.total * 0.1) {
      // Plus de 10% d'erreurs
      setSearchStrategy("balanced");
      setApiDelay(1200);
    } else {
      setSearchStrategy("aggressive");
      setApiDelay(800);
    }
  }, [failedRequests.size, stats.total]);

  // Recherche principale des hôtels
  const handleSearch = async (e) => {
    if (e) e.preventDefault();

    // Réinitialiser tous les états
    setLoading(true);
    setError(null);
    setHotels([]);
    setHotelOffers({});
    setFailedRequests(new Set());
    setSuccessfulRequests(new Set());
    setCurrentBatch(0);
    setAllOffersLoaded(false);
    setApiDelay(API_CONFIG.INITIAL_DELAY);
    setSelectedOffer(null);
    try {
      console.log("🔍 Lancement de la recherche hôtels...");
      const results = await amadeusService.searchHotels(searchParams);
      const hotelsData = results.data || [];

      // Limiter le nombre d'hôtels pour respecter les limites API
      const limitedHotels = hotelsData.slice(0, API_CONFIG.MAX_HOTELS);
      setHotels(limitedHotels);

      if (limitedHotels.length === 0) {
        setError("Aucun hôtel trouvé pour ces critères de recherche.");
        return;
      }

      console.log(
        `🏨 ${limitedHotels.length} hôtels trouvés, démarrage du chargement des offres...`
      );

      // Démarrer le chargement des offres par lots
      processHotelsInBatches(limitedHotels);
    } catch (err) {
      console.error("❌ Erreur recherche hôtels:", err);
      setError(
        err.message ||
          "Erreur lors de la recherche d'hôtels. Veuillez réessayer."
      );
    } finally {
      setLoading(false);
    }
  };

  // Traitement des hôtels par lots avec délais
  const processHotelsInBatches = async (hotelsList) => {
    const batches = [];
    for (let i = 0; i < hotelsList.length; i += API_CONFIG.BATCH_SIZE) {
      batches.push(hotelsList.slice(i, i + API_CONFIG.BATCH_SIZE));
    }

    setTotalBatches(batches.length);
    console.log(
      `📦 Traitement en ${batches.length} lots de ${API_CONFIG.BATCH_SIZE} hôtels`
    );

    for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
      setCurrentBatch(batchIndex + 1);

      const batch = batches[batchIndex];
      console.log(`🔄 Traitement du lot ${batchIndex + 1}/${batches.length}`);

      // Traiter chaque hôtel du lot actuel
      await Promise.allSettled(
        batch.map((hotel) =>
          hotel.hotelId
            ? fetchHotelOffersWithRetry(hotel.hotelId)
            : Promise.resolve()
        )
      );

      // Attendre entre les lots sauf pour le dernier
      if (batchIndex < batches.length - 1) {
        console.log(
          `⏳ Attente de ${API_CONFIG.BATCH_DELAY}ms avant le prochain lot...`
        );
        await new Promise((resolve) =>
          setTimeout(resolve, API_CONFIG.BATCH_DELAY)
        );
      }
    }

    // Marquer comme terminé
    setAllOffersLoaded(true);
    console.log("✅ Tous les lots traités");
  };

  // Récupération des offres avec système de retry intelligent
  const fetchHotelOffersWithRetry1 = async (hotelId, retryCount = 0) => {
    if (hotelOffers[hotelId] !== undefined || loadingOffers[hotelId]) {
      return;
    }

    setLoadingOffers((prev) => ({ ...prev, [hotelId]: true }));

    try {
      // Attendre le délai configuré entre les requêtes
      await new Promise((resolve) => setTimeout(resolve, apiDelay));

      const offerParams = {
        checkInDate: searchParams.checkInDate,
        checkOutDate: searchParams.checkOutDate,
        adults: searchParams.adults,
        children: searchParams.children,
        infants: searchParams.infants,
        rooms: searchParams.rooms,
      };

      console.log(
        `📡 Requête offre pour ${hotelId} (tentative ${retryCount + 1})`
      );
      const response = await amadeusService.getHotelOffers(
        hotelId,
        offerParams
      );
      const offers = response.data || [];

      setHotelOffers((prev) => ({ ...prev, [hotelId]: offers }));
      setSuccessfulRequests((prev) => new Set([...prev, hotelId]));

      // Retirer des échecs si présent
      setFailedRequests((prev) => {
        const newSet = new Set(prev);
        newSet.delete(hotelId);
        return newSet;
      });

      if (offers.length > 0) {
        console.log(
          `✅ Offres reçues pour ${hotelId}: ${offers.length} offre(s)`
        );
      } else {
        console.log(`ℹ️  Aucune offre pour ${hotelId}`);
      }
    } catch (err) {
      console.error(`❌ Erreur pour ${hotelId}:`, err);

      const errorCode = err.errors?.[0]?.code;
      const shouldRetry = shouldRetryRequest(errorCode, retryCount);

      if (shouldRetry) {
        const nextRetryCount = retryCount + 1;
        const retryDelay = calculateRetryDelay(errorCode, nextRetryCount);

        console.log(
          `🔄 Retry ${nextRetryCount} pour ${hotelId} dans ${retryDelay}ms`
        );

        setTimeout(() => {
          fetchHotelOffersWithRetry(hotelId, nextRetryCount);
        }, retryDelay);

        return;
      }

      // Échec définitif - marquer comme sans offre
      setFailedRequests((prev) => new Set([...prev, hotelId]));
      setHotelOffers((prev) => ({ ...prev, [hotelId]: [] }));
    } finally {
      setLoadingOffers((prev) => ({ ...prev, [hotelId]: false }));
    }
  };
  // Récupération des offres avec système de retry intelligent - VERSION CORRIGÉE
  const fetchHotelOffersWithRetry = async (hotelId, retryCount = 0) => {
    if (hotelOffers[hotelId] !== undefined || loadingOffers[hotelId]) {
      return;
    }

    setLoadingOffers((prev) => ({ ...prev, [hotelId]: true }));

    try {
      // Attendre le délai configuré entre les requêtes
      await new Promise((resolve) => setTimeout(resolve, apiDelay));

      const offerParams = {
        checkInDate: searchParams.checkInDate,
        checkOutDate: searchParams.checkOutDate,
        adults: searchParams.adults,
        children: searchParams.children,
        infants: searchParams.infants,
        rooms: searchParams.rooms,
      };

      console.log(
        `📡 Requête offre pour ${hotelId} (tentative ${retryCount + 1})`
      );
      const response = await amadeusService.getHotelOffers(
        hotelId,
        offerParams
      );

      // DEBUG: Vérifier la structure complète de la réponse
      console.log("📦 Réponse API complète:", response);
      console.log("🏨 Structure data:", response.data);

      // CORRECTION: Extraire correctement les offres de la réponse
      let offers = [];

      if (response.data && Array.isArray(response.data)) {
        // La réponse contient un tableau d'objets "hotel-offers"
        const hotelOffersData = response.data;

        // Pour chaque hôtel dans la réponse, extraire ses offres
        hotelOffersData.forEach((hotelOffer) => {
          if (hotelOffer.offers && Array.isArray(hotelOffer.offers)) {
            console.log(
              `✅ ${hotelOffer.offers.length} offre(s) trouvée(s) pour ${hotelId}`
            );

            // Ajouter les informations de l'hôtel à chaque offre pour référence
            const offersWithHotelInfo = hotelOffer.offers.map((offer) => ({
              ...offer,
              hotelInfo: {
                hotelId: hotelOffer.hotel?.hotelId,
                name: hotelOffer.hotel?.name,
                chainCode: hotelOffer.hotel?.chainCode,
                cityCode: hotelOffer.hotel?.cityCode,
              },
            }));

            offers = offers.concat(offersWithHotelInfo);
          }
        });

        // Si aucune offre n'a été trouvée dans le format attendu, essayer d'autres formats
        if (offers.length === 0) {
          console.log(
            "🔍 Aucune offre trouvée dans hotelOffer.offers, recherche alternative..."
          );

          // Essayer de trouver des offres directement dans la réponse
          if (response.data[0] && response.data[0].offers) {
            offers = response.data[0].offers;
          } else if (response.offers) {
            offers = response.offers;
          } else if (Array.isArray(response.data) && response.data.length > 0) {
            // Si data est un tableau d'offres directement
            offers = response.data;
          }
        }
      } else if (response.offers && Array.isArray(response.offers)) {
        // Format alternatif: les offres sont directement dans response.offers
        offers = response.offers;
        console.log(
          `✅ ${offers.length} offre(s) trouvée(s) dans response.offers`
        );
      } else if (response.data && response.data.offers) {
        // Format alternatif: les offres sont dans response.data.offers
        offers = response.data.offers;
        console.log(
          `✅ ${offers.length} offre(s) trouvée(s) dans response.data.offers`
        );
      }

      // DEBUG: Vérifier la structure finale des offres
      console.log(`🎯 Offres finales pour ${hotelId}:`, offers);
      if (offers.length > 0) {
        console.log("💰 Structure de la première offre:", offers[0]);
        console.log("💵 Prix de la première offre:", offers[0].price);
      }

      // Stocker les offres dans l'état
      setHotelOffers((prev) => ({ ...prev, [hotelId]: offers }));
      setSuccessfulRequests((prev) => new Set([...prev, hotelId]));

      // Retirer des échecs si présent
      setFailedRequests((prev) => {
        const newSet = new Set(prev);
        newSet.delete(hotelId);
        return newSet;
      });

      if (offers.length > 0) {
        console.log(
          `✅ ${offers.length} offre(s) enregistrée(s) pour ${hotelId}`
        );
      } else {
        console.log(`ℹ️  Aucune offre pour ${hotelId}`);
      }
    } catch (err) {
      console.error(`❌ Erreur pour ${hotelId}:`, err);
      console.error(
        "📊 Détails de l'erreur:",
        err.response?.data || err.message
      );

      const errorCode = err.errors?.[0]?.code;
      const shouldRetry = shouldRetryRequest(errorCode, retryCount);

      if (shouldRetry) {
        const nextRetryCount = retryCount + 1;
        const retryDelay = calculateRetryDelay(errorCode, nextRetryCount);

        console.log(
          `🔄 Retry ${nextRetryCount} pour ${hotelId} dans ${retryDelay}ms`
        );

        setTimeout(() => {
          fetchHotelOffersWithRetry(hotelId, nextRetryCount);
        }, retryDelay);

        return;
      }

      // Échec définitif - marquer comme sans offre
      setFailedRequests((prev) => new Set([...prev, hotelId]));
      setHotelOffers((prev) => ({ ...prev, [hotelId]: [] }));
    } finally {
      setLoadingOffers((prev) => ({ ...prev, [hotelId]: false }));
    }
  };
  // Logique de décision pour les retry
  const shouldRetryRequest = (errorCode, retryCount) => {
    if (retryCount >= API_CONFIG.MAX_RETRIES) return false;

    const retryableErrors = [38194, 11, 429]; // Too many requests, Unable to process, Rate limit
    return retryableErrors.includes(errorCode);
  };

  // Calcul du délai de retry adaptatif
  const calculateRetryDelay = (errorCode, retryCount) => {
    const baseDelays = {
      38194: 2000, // Too many requests
      11: 1500, // Unable to process
      429: 3000, // Rate limit
    };

    const baseDelay = baseDelays[errorCode] || 1000;
    return baseDelay * Math.pow(2, retryCount - 1); // Backoff exponentiel
  };

  // Recharger les offres échouées
  const retryFailedRequests = () => {
    console.log("🔄 Relance des requêtes échouées");
    const failedArray = Array.from(failedRequests);
    setFailedRequests(new Set());

    failedArray.forEach((hotelId) => {
      if (hotels.some((hotel) => hotel.hotelId === hotelId)) {
        fetchHotelOffersWithRetry(hotelId);
      }
    });
  };

  // Fonctions utilitaires d'affichage
  const getRatingStars = useCallback((rating) => {
    const numericRating = Math.floor(rating || 0);
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${
          i < numericRating
            ? "text-yellow-400 fill-yellow-400"
            : "text-gray-300"
        }`}
      />
    ));
  }, []);

  const formatPrice = useCallback((price) => {
    console.log("🔍 formatPrice reçoit:", price);

    if (!price) {
      return "Prix non disponible";
    }

    // Vérifier si price est un string (cas où on recevrait directement le total)
    if (typeof price === "string") {
      const amount = parseFloat(price);
      return isNaN(amount)
        ? "Prix non disponible"
        : new Intl.NumberFormat("fr-FR", {
            style: "currency",
            currency: "EUR",
          }).format(amount);
    }

    // Vérifier si price est un objet avec total
    if (typeof price === "object" && price !== null) {
      const total = price.total || price.base;
      const currency = price.currency || "EUR";

      if (total) {
        const amount = typeof total === "string" ? parseFloat(total) : total;
        if (!isNaN(amount)) {
          return new Intl.NumberFormat("fr-FR", {
            style: "currency",
            currency: currency,
          }).format(amount);
        }
      }
    }

    return "Prix non disponible";
  }, []);
  // Vérifier si un hôtel a des offres
  // Vérifier si un hôtel a des offres - VERSION CORRIGÉE
  const hasOffers = (hotel) => {
    const offers = hotelOffers[hotel.hotelId];
    const hasOffers = offers && offers.length > 0;

    console.log(`🔍 hasOffers pour ${hotel.hotelId}:`, hasOffers);
    if (hasOffers) {
      console.log("💰 Prix de la première offre:", offers[0].price);
    }

    return hasOffers;
  };

  // Obtenir toutes les offres d'un hôtel
  // Obtenir toutes les offres d'un hôtel - VERSION CORRIGÉE
  const getAllOffers = (hotel) => {
    const offers = hotelOffers[hotel.hotelId] || [];

    // DEBUG: Vérifier ce qui est stocké
    console.log(`🔍 getAllOffers pour ${hotel.hotelId}:`, offers);
    if (offers.length > 0) {
      console.log("📊 Structure de la première offre:", offers[0]);
      console.log("💵 Prix disponible:", offers[0].price);
    }

    return offers;
  };

  // Obtenir la stratégie d'affichage
  const getStrategyConfig = () => {
    switch (searchStrategy) {
      case "conservative":
        return { color: "text-orange-500", label: "Prudent", icon: Shield };
      case "balanced":
        return { color: "text-blue-500", label: "Équilibré", icon: Zap };
      case "aggressive":
        return { color: "text-green-500", label: "Rapide", icon: Clock };
      default:
        return { color: "text-gray-500", label: "Standard", icon: Zap };
    }
  };

  const strategyConfig = getStrategyConfig();
  const StrategyIcon = strategyConfig.icon;

  return (
    <div className="space-y-6">
      {/* Formulaire de recherche */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-gray-800 flex items-center">
            <Hotel className="w-6 h-6 mr-2 text-blue-600" />
            Rechercher un hôtel
          </h2>
          <div className={`flex items-center text-sm ${strategyConfig.color}`}>
            <StrategyIcon className="w-4 h-4 mr-1" />
            Mode {strategyConfig.label}
          </div>
        </div>

        <form onSubmit={handleSearch} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* Ville */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <MapPin className="w-4 h-4 inline mr-1" />
                Ville (Code IATA) *
              </label>
              <select
                name="cityCode"
                value={searchParams.cityCode}
                onChange={(e) =>
                  setSearchParams((prev) => ({
                    ...prev,
                    cityCode: e.target.value,
                  }))
                }
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Sélectionnez un aéroport de départ</option>

                {/* Afrique */}
                <optgroup label="Afrique">
                  <option value="ABJ">Abidjan, Côte d'Ivoire (ABJ)</option>
                  <option value="ACC">Accra, Ghana (ACC)</option>
                  <option value="ADD">Addis-Abeba, Éthiopie (ADD)</option>
                  <option value="ALG">Alger, Algérie (ALG)</option>
                  <option value="CMN">Casablanca, Maroc (CMN)</option>
                  <option value="COO">Cotonou, Bénin (COO)</option>
                  <option value="DKR">Dakar, Sénégal (DKR)</option>
                  <option value="DAR">Dar es Salaam, Tanzanie (DAR)</option>
                  <option value="EBB">Entebbe, Ouganda (EBB)</option>
                  <option value="FIH">Kinshasa, RDC (FIH)</option>
                  <option value="JNB">
                    Johannesburg, Afrique du Sud (JNB)
                  </option>
                  <option value="KGL">Kigali, Rwanda (KGL)</option>
                  <option value="LAD">Luanda, Angola (LAD)</option>
                  <option value="LOS">Lagos, Nigeria (LOS)</option>
                  <option value="NBO">Nairobi, Kenya (NBO)</option>
                  <option value="RAI">Praia, Cap-Vert (RAI)</option>
                  <option value="TUN">Tunis, Tunisie (TUN)</option>
                </optgroup>

                {/* Europe */}
                <optgroup label="Europe">
                  <option value="AMS">Amsterdam, Pays-Bas (AMS)</option>
                  <option value="BCN">Barcelone, Espagne (BCN)</option>
                  <option value="BER">Berlin, Allemagne (BER)</option>
                  <option value="BRU">Bruxelles, Belgique (BRU)</option>
                  <option value="CDG">
                    Paris Charles de Gaulle, France (CDG)
                  </option>
                  <option value="FCO">Rome Fiumicino, Italie (FCO)</option>
                  <option value="FRA">Francfort, Allemagne (FRA)</option>
                  <option value="GVA">Genève, Suisse (GVA)</option>
                  <option value="IST">Istanbul, Turquie (IST)</option>
                  <option value="LHR">
                    Londres Heathrow, Royaume-Uni (LHR)
                  </option>
                  <option value="LIS">Lisbonne, Portugal (LIS)</option>
                  <option value="MAD">Madrid, Espagne (MAD)</option>
                  <option value="MUC">Munich, Allemagne (MUC)</option>
                  <option value="ORY">Paris Orly, France (ORY)</option>
                  <option value="VIE">Vienne, Autriche (VIE)</option>
                  <option value="ZRH">Zurich, Suisse (ZRH)</option>
                </optgroup>

                {/* Amérique du Nord */}
                <optgroup label="Amérique du Nord">
                  <option value="ATL">Atlanta, USA (ATL)</option>
                  <option value="DFW">Dallas, USA (DFW)</option>
                  <option value="DTW">Detroit, USA (DTW)</option>
                  <option value="JFK">New York JFK, USA (JFK)</option>
                  <option value="LAX">Los Angeles, USA (LAX)</option>
                  <option value="MIA">Miami, USA (MIA)</option>
                  <option value="ORD">Chicago, USA (ORD)</option>
                  <option value="SFO">San Francisco, USA (SFO)</option>
                  <option value="YYZ">Toronto, Canada (YYZ)</option>
                  <option value="YUL">Montréal, Canada (YUL)</option>
                </optgroup>

                {/* Amérique du Sud */}
                <optgroup label="Amérique du Sud">
                  <option value="BOG">Bogota, Colombie (BOG)</option>
                  <option value="EZE">Buenos Aires, Argentine (EZE)</option>
                  <option value="GRU">São Paulo, Brésil (GRU)</option>
                  <option value="LIM">Lima, Pérou (LIM)</option>
                  <option value="SCL">Santiago, Chili (SCL)</option>
                </optgroup>

                {/* Asie */}
                <optgroup label="Asie">
                  <option value="BKK">Bangkok, Thaïlande (BKK)</option>
                  <option value="CAN">Guangzhou, Chine (CAN)</option>
                  <option value="DEL">Delhi, Inde (DEL)</option>
                  <option value="DXB">Dubaï, Émirats Arabes Unis (DXB)</option>
                  <option value="HKG">Hong Kong (HKG)</option>
                  <option value="ICN">Séoul, Corée du Sud (ICN)</option>
                  <option value="KUL">Kuala Lumpur, Malaisie (KUL)</option>
                  <option value="NRT">Tokyo Narita, Japon (NRT)</option>
                  <option value="PEK">Pékin, Chine (PEK)</option>
                  <option value="PVG">Shanghai Pudong, Chine (PVG)</option>
                  <option value="SIN">Singapour (SIN)</option>
                </optgroup>

                {/* Océanie */}
                <optgroup label="Océanie">
                  <option value="AKL">Auckland, Nouvelle-Zélande (AKL)</option>
                  <option value="BNE">Brisbane, Australie (BNE)</option>
                  <option value="MEL">Melbourne, Australie (MEL)</option>
                  <option value="SYD">Sydney, Australie (SYD)</option>
                </optgroup>

                {/* Moyen-Orient */}
                <optgroup label="Moyen-Orient">
                  <option value="AUH">
                    Abu Dhabi, Émirats Arabes Unis (AUH)
                  </option>
                  <option value="BAH">Bahreïn (BAH)</option>
                  <option value="DOH">Doha, Qatar (DOH)</option>
                  <option value="JED">Jeddah, Arabie Saoudite (JED)</option>
                  <option value="RUH">Riyad, Arabie Saoudite (RUH)</option>
                  <option value="TLV">Tel Aviv, Israël (TLV)</option>
                </optgroup>
              </select>
            </div>

            {/* Date d'arrivée */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Calendar className="w-4 h-4 inline mr-1" />
                Date d'arrivée *
              </label>
              <input
                type="date"
                value={searchParams.checkInDate}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    checkInDate: e.target.value,
                  })
                }
                min={new Date().toISOString().split("T")[0]}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>

            {/* Date de départ */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Calendar className="w-4 h-4 inline mr-1" />
                Date de départ *
              </label>
              <input
                type="date"
                value={searchParams.checkOutDate}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    checkOutDate: e.target.value,
                  })
                }
                min={
                  searchParams.checkInDate ||
                  new Date().toISOString().split("T")[0]
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>

            {/* Adultes */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Users className="w-4 h-4 inline mr-1" />
                Adultes
              </label>
              <select
                value={searchParams.adults}
                onChange={(e) =>
                  setSearchParams({ ...searchParams, adults: e.target.value })
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                {[1, 2, 3, 4, 5, 6].map((n) => (
                  <option key={n} value={n}>
                    {n} adulte{n > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>

            {/* Enfants */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Users className="w-4 h-4 inline mr-1" />
                Enfants
              </label>
              <select
                value={searchParams.children}
                onChange={(e) =>
                  setSearchParams({ ...searchParams, children: e.target.value })
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                {[0, 1, 2, 3, 4, 5, 6].map((n) => (
                  <option key={n} value={n}>
                    {n} enfant{n > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>

            {/* Bébés */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Users className="w-4 h-4 inline mr-1" />
                Bébés
              </label>
              <select
                value={searchParams.infants}
                onChange={(e) =>
                  setSearchParams({ ...searchParams, infants: e.target.value })
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                {[0, 1, 2, 3].map((n) => (
                  <option key={n} value={n}>
                    {n} bébé{n > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>

            {/* Chambres */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Hotel className="w-4 h-4 inline mr-1" />
                Chambres
              </label>
              <select
                value={searchParams.rooms}
                onChange={(e) =>
                  setSearchParams({ ...searchParams, rooms: e.target.value })
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                {[1, 2, 3, 4].map((n) => (
                  <option key={n} value={n}>
                    {n} chambre{n > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>

            {/* Étoiles minimum */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Star className="w-4 h-4 inline mr-1" />
                Étoiles minimum
              </label>
              <select
                value={searchParams.ratings}
                onChange={(e) =>
                  setSearchParams({ ...searchParams, ratings: e.target.value })
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">Toutes</option>
                <option value="1">1 étoile</option>
                <option value="2">2 étoiles</option>
                <option value="3">3 étoiles</option>
                <option value="4">4 étoiles</option>
                <option value="5">5 étoiles</option>
              </select>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 transition-all duration-200 flex items-center justify-center shadow-lg"
          >
            {loading ? (
              <>
                <Loader className="w-5 h-5 mr-2 animate-spin" />
                Recherche en cours...
              </>
            ) : (
              <>
                <Search className="w-5 h-5 mr-2" />
                Rechercher des hôtels
              </>
            )}
          </button>
        </form>
      </div>

      {/* Messages d'erreur */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 animate-fadeIn">
          <div className="flex items-center">
            <AlertCircle className="w-5 h-5 text-red-600 mr-2" />
            <p className="text-red-600 font-semibold">{error}</p>
          </div>
        </div>
      )}

      {/* Avertissement limitations API */}
      {stats.errors > 0 && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 animate-fadeIn">
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-yellow-600 mr-2 mt-0.5" />
            <div className="flex-1">
              <p className="text-yellow-800 font-semibold">
                Optimisation automatique activée
              </p>
              <p className="text-yellow-700 text-sm mt-1">
                {stats.errors} requête{stats.errors > 1 ? "s" : ""} sur{" "}
                {stats.total} ont rencontré des limitations d'API. Le système a
                adapté sa stratégie pour améliorer les résultats.
              </p>
              <button
                onClick={retryFailedRequests}
                disabled={stats.errors === 0}
                className="mt-2 px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 disabled:opacity-50 transition flex items-center text-sm"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Réessayer les échecs ({stats.errors})
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Indicateur de chargement des offres */}
      {hotels.length > 0 && !allOffersLoaded && (
        <div className="bg-white rounded-xl shadow-md p-6 animate-fadeIn">
          <div className="text-center">
            <Loader className="w-8 h-8 animate-spin mx-auto text-blue-600 mb-4" />
            <p className="text-gray-600 font-semibold">
              Chargement des offres en cours...
            </p>

            {/* Barre de progression */}
            <div className="mt-4 bg-gray-200 rounded-full h-2">
              <div
                className="bg-blue-600 h-2 rounded-full transition-all duration-500"
                style={{ width: `${(stats.completed / stats.total) * 100}%` }}
              ></div>
            </div>

            {/* Statistiques détaillées */}
            <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-600">
                  {stats.loading}
                </div>
                <div className="text-gray-500">En cours</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-green-600">
                  {stats.withOffers}
                </div>
                <div className="text-gray-500">Avec offres</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-gray-400">
                  {stats.noOffers}
                </div>
                <div className="text-gray-500">Sans offres</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-yellow-600">
                  {stats.errors}
                </div>
                <div className="text-gray-500">En erreur</div>
              </div>
            </div>

            {/* Informations du lot actuel */}
            {totalBatches > 0 && (
              <div className="mt-4 text-xs text-gray-500">
                Lot {currentBatch} sur {totalBatches} • Délai entre requêtes:{" "}
                {apiDelay}ms • Stratégie: {strategyConfig.label}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Résultats avec TOUS les hôtels et TOUTES les offres */}
      {allOffersLoaded && hotels.length > 0 && (
        <div className="bg-white rounded-xl shadow-md p-6 animate-fadeIn">
          {/* En-tête avec statistiques */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
            <div>
              <h3 className="text-xl font-bold text-gray-800">
                {stats.total} hôtel{stats.total > 1 ? "s" : ""} trouvé
                {stats.total > 1 ? "s" : ""}
              </h3>
              <p className="text-gray-600 text-sm mt-1">
                {stats.withOffers} avec offres • {stats.noOffers} sans offres
                {stats.errors > 0 && ` • ${stats.errors} non chargés`}
              </p>
            </div>

            {stats.errors > 0 && (
              <button
                onClick={retryFailedRequests}
                className="mt-2 md:mt-0 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition flex items-center text-sm shadow-md"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Réessayer ({stats.errors})
              </button>
            )}
          </div>

          {/* Liste de TOUS les hôtels avec TOUTES leurs offres */}
          <div className="space-y-8">
            {hotels.map((hotel, index) => {
              const offers = getAllOffers(hotel);
              const hotelHasOffers = hasOffers(hotel);

              return (
                <div
                  key={`${hotel.hotelId}-${index}`}
                  className={`border rounded-xl p-6 transition-all duration-300 ${
                    hotelHasOffers
                      ? "border-green-200 hover:shadow-lg hover:border-green-300"
                      : "border-gray-200 hover:shadow-md hover:border-gray-300"
                  }`}
                >
                  {/* En-tête de l'hôtel */}
                  <div className="flex justify-between items-start mb-6">
                    <div className="flex items-start space-x-4 flex-1">
                      <div
                        className={`p-3 rounded-lg ${
                          hotelHasOffers ? "bg-green-100" : "bg-gray-100"
                        }`}
                      >
                        <Hotel
                          className={`w-6 h-6 ${
                            hotelHasOffers ? "text-green-600" : "text-gray-600"
                          }`}
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="font-bold text-xl text-gray-900 mb-2">
                          {hotel.name}
                        </h4>
                        <div className="flex items-center space-x-1 mb-2">
                          {getRatingStars(hotel.rating)}
                          <span className="text-sm text-gray-500 ml-2">
                            ({hotel.rating || "N/A"})
                          </span>
                        </div>

                        {/* Localisation */}
                        <div className="flex items-center text-gray-600 mb-1">
                          <MapPin className="w-4 h-4 mr-2" />
                          <span className="text-sm">
                            {hotel.address?.lines?.[0] ||
                              hotel.address?.cityName ||
                              "Adresse non disponible"}
                          </span>
                        </div>
                        {hotel.distance && (
                          <p className="text-xs text-gray-500 ml-6">
                            À {hotel.distance.value} {hotel.distance.unit} du
                            centre-ville
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Équipements */}
                  {hotel.amenities && hotel.amenities.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-6">
                      {hotel.amenities.slice(0, 6).map((amenity, idx) => (
                        <span
                          key={idx}
                          className="px-3 py-1 bg-gray-100 text-gray-700 rounded-lg text-sm flex items-center"
                        >
                          {amenity === "WIFI" && (
                            <Wifi className="w-3 h-3 mr-1" />
                          )}
                          {amenity === "PARKING" && (
                            <Car className="w-3 h-3 mr-1" />
                          )}
                          {amenity === "RESTAURANT" && (
                            <Coffee className="w-3 h-3 mr-1" />
                          )}
                          {amenity === "SWIMMING_POOL" && (
                            <Droplets className="w-3 h-3 mr-1" />
                          )}
                          {amenity === "FITNESS_CENTER" && (
                            <Dumbbell className="w-3 h-3 mr-1" />
                          )}
                          {amenity.replace(/_/g, " ").toLowerCase()}
                        </span>
                      ))}
                      {hotel.amenities.length > 6 && (
                        <span className="px-3 py-1 bg-gray-100 text-gray-500 rounded-lg text-sm">
                          +{hotel.amenities.length - 6}
                        </span>
                      )}
                    </div>
                  )}

                  {/* Dans la section d'affichage des offres - CORRECTION COMPLÈTE */}
                  <div className="border-t pt-6">
                    <h5 className="font-semibold text-lg text-gray-800 mb-4 flex items-center">
                      <Tag className="w-5 h-5 mr-2 text-blue-600" />
                      Offres disponibles ({offers.length})
                    </h5>

                    {hotelHasOffers ? (
                      <div className="space-y-4">
                        {offers.map((offer, offerIndex) => {
                          // DEBUG CRITIQUE - Vérifions la structure réelle
                          console.log("🔍 OFFRE COMPLÈTE:", offer);
                          console.log("💰 offer.price:", offer?.price);
                          console.log("📊 Type de offer:", typeof offer);
                          console.log(
                            "🎯 Clés de offer:",
                            offer ? Object.keys(offer) : "offer is undefined"
                          );

                          // Solution robuste pour récupérer le prix
                          const getPriceData = (offer) => {
                            if (!offer) return null;

                            // Essayer différents chemins d'accès
                            if (offer.price) return offer.price;
                            if (offer.pricing) return offer.pricing;
                            if (offer.ratePlan) return offer.ratePlan?.price;

                            // Chercher récursivement dans l'objet
                            for (let key in offer) {
                              if (
                                offer[key] &&
                                typeof offer[key] === "object"
                              ) {
                                if (offer[key].total || offer[key].base) {
                                  return offer[key];
                                }
                              }
                            }

                            return null;
                          };

                          const priceData = getPriceData(offer);
                          console.log("💰 priceData trouvé:", priceData);

                          return (
                            <div
                              key={offerIndex}
                              className="border border-gray-200 rounded-lg p-4 hover:border-blue-300 hover:shadow-md transition-all duration-200"
                            >
                              <div className="flex justify-between items-start">
                                <div className="flex-1">
                                  <h6 className="font-semibold text-gray-900 text-lg mb-2">
                                    {offer.room?.typeEstimated?.category ||
                                      offer.roomInformation?.typeEstimated
                                        ?.category ||
                                      "Chambre Standard"}
                                  </h6>

                                  {/* Description de la chambre */}
                                  {(offer.room?.description?.text ||
                                    offer.roomInformation?.description) && (
                                    <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                                      {offer.room?.description?.text ||
                                        offer.roomInformation?.description}
                                    </p>
                                  )}

                                  {/* Détails de l'offre */}
                                  <div className="flex flex-wrap gap-4 text-sm text-gray-500 mb-3">
                                    {offer.boardType && (
                                      <span className="flex items-center">
                                        <Coffee className="w-4 h-4 mr-1" />
                                        {offer.boardType}
                                      </span>
                                    )}
                                    {(offer.room?.typeEstimated?.beds ||
                                      offer.roomInformation?.typeEstimated
                                        ?.beds) && (
                                      <span className="flex items-center">
                                        <Bed className="w-4 h-4 mr-1" />
                                        {offer.room?.typeEstimated?.beds ||
                                          offer.roomInformation?.typeEstimated
                                            ?.beds}{" "}
                                        lit(s)
                                      </span>
                                    )}
                                    {(offer.room?.typeEstimated?.bedType ||
                                      offer.roomInformation?.typeEstimated
                                        ?.bedType) && (
                                      <span className="flex items-center">
                                        <Bed className="w-4 h-4 mr-1" />
                                        {offer.room?.typeEstimated?.bedType ||
                                          offer.roomInformation?.typeEstimated
                                            ?.bedType}
                                      </span>
                                    )}
                                  </div>

                                  {/* Politiques d'annulation */}
                                  {offer.policies?.cancellation && (
                                    <div className="flex items-center text-sm text-green-600 mb-2">
                                      <CheckCircle className="w-4 h-4 mr-1" />
                                      {offer.policies.cancellation.description
                                        ?.text ||
                                        offer.policies.cancellation[0]
                                          ?.description?.text ||
                                        "Annulation gratuite"}
                                    </div>
                                  )}
                                </div>

                                {/* Prix et sélection - VERSION CORRIGÉE */}
                                <div className="text-right ml-4 min-w-[120px]">
                                  <div className="text-2xl font-bold text-green-600 mb-2">
                                    {priceData ? (
                                      formatPrice(priceData)
                                    ) : (
                                      <span className="text-red-500 text-sm">
                                        ❌ Prix manquant
                                        <div className="text-xs text-gray-400">
                                          Structure:{" "}
                                          {JSON.stringify(offer).substring(
                                            0,
                                            100
                                          )}
                                          ...
                                        </div>
                                      </span>
                                    )}
                                  </div>

                                  <div className="text-xs text-gray-500 mb-3">
                                    {searchParams.rooms} chambre
                                    {searchParams.rooms > 1 ? "s" : ""}
                                  </div>

                                  <button
                                    onClick={() => {
                                      setSelectedOffer(offer);
                                      onSelectHotel &&
                                        onSelectHotel(
                                          hotel,
                                          searchParams,
                                          offer
                                        );
                                    }}
                                    className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2 px-4 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 transition flex items-center justify-center text-sm shadow-md"
                                  >
                                    <CheckCircle className="w-4 h-4 mr-2" />
                                    Sélectionner
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg">
                        <Hotel className="w-12 h-12 text-gray-400 mx-auto mb-3" />
                        <p className="text-gray-500 font-semibold">
                          Aucune offre disponible
                        </p>
                        <p className="text-gray-400 text-sm mt-1">
                          Aucune offre trouvée pour cet hôtel avec les critères
                          sélectionnés
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
const hotelRequestsService = {
  // Récupérer toutes les demandes
  getAll: async () => {
    const response = await fetch(`${API_BASE_URL2}/hotel-requests`);
    if (!response.ok) throw new Error("Erreur récupération demandes");
    return await response.json();
  },

  // Récupérer une demande par ID
  getById: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/hotel-requests/${id}`);
    if (!response.ok) throw new Error("Erreur récupération demande");
    return await response.json();
  },

  // Créer une nouvelle demande
  create: async (data) => {
    const response = await fetch(`${API_BASE_URL2}/hotel-requests`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur création demande");
    }
    return await response.json();
  },

  // Mettre à jour une demande
  update: async (id, data) => {
    const response = await fetch(`${API_BASE_URL2}/hotel-requests/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur mise à jour demande");
    }
    return await response.json();
  },

  // Supprimer une demande
  delete: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/hotel-requests/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur suppression demande");
    }
    return await response.json();
  },

  // Approuver une demande
  approve: async (id) => {
    const response = await fetch(
      `${API_BASE_URL2}/hotel-requests/${id}/approve`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur approbation demande");
    }
    return await response.json();
  },

  // Rejeter une demande
  reject: async (id) => {
    const response = await fetch(
      `${API_BASE_URL2}/hotel-requests/${id}/reject`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur rejet demande");
    }
    return await response.json();
  },

  // Confirmer une réservation
  confirmBooking1: async (id, paymentData) => {
    // 1. Appel Amadeus pour la réservation réelle
    const amadeusResponse = await fetch(
      `${API_BASE_URL3}/hotel-requests/${id}/complete-booking`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          payment: paymentData,
        }),
      }
    );

    if (!amadeusResponse.ok) {
      const error = await amadeusResponse.json();
      throw new Error(error.message || "Erreur lors de la réservation Amadeus");
    }

    const amadeusResult = await amadeusResponse.json();

    // 2. Appel local pour mettre à jour le statut dans la base de données
    const localResponse = await fetch(
      `${API_BASE_URL2}/hotel-requests/${id}/book`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!localResponse.ok) {
      const error = await localResponse.json();
      throw new Error(
        error.message || "Erreur confirmation réservation locale"
      );
    }

    const localResult = await localResponse.json();

    // 3. Appeler la synchronisation des voyages après la confirmation de réservation
    try {
      await fetch(`${API_BASE_URL2}/travelers/sync`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      console.log(
        "Synchronisation des voyages déclenchée après confirmation hôtel"
      );
    } catch (syncError) {
      console.error("Erreur synchronisation voyages:", syncError);
      // Ne pas bloquer l'opération principale si la synchro échoue
    }

    // Retourner les résultats combinés
    return {
      ...localResult,
      amadeus: amadeusResult,
    };
  },

  confirmBooking: async (request, paymentData) => {
    try {
      // Définir les fonctions utilitaires
      const extractFirstName = (fullName) => {
        if (!fullName) return "JEAN";
        const names = fullName.trim().split(/\s+/);
        return names[0] || "JEAN";
      };

      const extractLastName = (fullName) => {
        if (!fullName) return "DUPONT";
        const names = fullName.trim().split(/\s+/);
        return names.slice(1).join(" ") || "DUPONT";
      };

      const formatExpiryDate = (expiryDate) => {
        if (!expiryDate) return "12-28";
        const cleaned = expiryDate.replace(/\D/g, "");
        if (cleaned.length >= 4) {
          const month = cleaned.substring(0, 2);
          const year = cleaned.substring(2, 4);
          return `${month}-${year}`;
        }
        return "12-28";
      };

      const formatPhoneNumber = (phone) => {
        if (!phone) return "+33123456789";
        const cleaned = phone.replace(/\D/g, "");
        if (cleaned.startsWith("0")) {
          return "+33" + cleaned.substring(1);
        }
        if (!cleaned.startsWith("+")) {
          return "+33" + cleaned;
        }
        return phone;
      };

      const getVendorCode = (cardNumber) => {
        const cleanedNumber = cardNumber.replace(/\s/g, "");
        const firstDigit = cleanedNumber[0];
        const firstTwoDigits = cleanedNumber.substring(0, 2);

        if (firstDigit === "4") return "VI";
        if (
          firstDigit === "5" &&
          cleanedNumber >= "5100000000000000" &&
          cleanedNumber <= "5599999999999999"
        )
          return "MC";
        if (firstTwoDigits === "34" || firstTwoDigits === "37") return "AX";
        if (
          cleanedNumber.startsWith("6011") ||
          (cleanedNumber >= "6221260000000000" &&
            cleanedNumber <= "6229259999999999") ||
          (cleanedNumber >= "6440000000000000" &&
            cleanedNumber <= "6499999999999999") ||
          cleanedNumber.startsWith("65")
        )
          return "CA";
        return "CA";
      };

      // Validation des données requises
      if (!request?.id) {
        throw new Error("ID de demande manquant");
      }

      const offerId = request.offerId || request.hotel?.offers?.[0]?.id;
      if (!offerId) {
        throw new Error("Offer ID manquant pour la réservation");
      }

      // 1. Préparer les données pour l'API Amadeus
      const bookingData = {
        offerId: offerId,
        guests: [
          {
            name: {
              title: "MR",
              firstName:
                extractFirstName(paymentData.cardHolder) ||
                request.prenom ||
                "JEAN",
              lastName:
                extractLastName(paymentData.cardHolder) ||
                request.nom ||
                "DUPONT",
            },
            contact: {
              phone: formatPhoneNumber(paymentData.phone),
              email: paymentData.email,
            },
          },
        ],
        payments: [
          {
            method: "CREDIT_CARD",
            card: {
              vendorCode: getVendorCode(paymentData.cardNumber),
              cardNumber: paymentData.cardNumber.replace(/\s/g, ""),
              expiryDate: formatExpiryDate(paymentData.expiryDate),
            },
          },
        ],
      };

      console.log(
        "📤 Données de réservation envoyées:",
        JSON.stringify(bookingData, null, 2)
      );

      // 2. Appel Amadeus pour la réservation réelle
      const amadeusResponse = await fetch(
        `${API_BASE_URL3}/hotel-booking/complete-booking`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bookingData),
        }
      );

      const responseText = await amadeusResponse.text();
      console.log("📥 Réponse brute Amadeus:", responseText);

      let amadeusResult;
      try {
        amadeusResult = JSON.parse(responseText);
      } catch (parseError) {
        console.error("❌ Erreur parsing réponse Amadeus:", parseError);
        throw new Error("Format de réponse invalide de l'API Amadeus");
      }

      if (!amadeusResponse.ok) {
        console.error("❌ Erreur Amadeus détaillée:", amadeusResult);
        throw new Error(
          amadeusResult.message || `Erreur Amadeus: ${amadeusResponse.status}`
        );
      }

      console.log("✅ Réservation Amadeus réussie:", amadeusResult);

      // 3. Appel local pour mettre à jour le statut dans la base de données
      const localResponse = await fetch(
        `${API_BASE_URL2}/hotel-requests/${request.id}/book`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!localResponse.ok) {
        const error = await localResponse.json();
        throw new Error(
          error.message || "Erreur confirmation réservation locale"
        );
      }

      const localResult = await localResponse.json();

      // 4. Appeler la synchronisation des voyages après la confirmation de réservation
      try {
        await fetch(`${API_BASE_URL2}/travelers/sync`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });
        console.log(
          "✅ Synchronisation des voyages déclenchée après confirmation hôtel"
        );
      } catch (syncError) {
        console.error("⚠️ Erreur synchronisation voyages:", syncError);
        // Ne pas bloquer l'opération principale si la synchro échoue
      }

      // Retourner les résultats combinés
      return {
        ...localResult,
        amadeus: amadeusResult,
      };
    } catch (error) {
      console.error("❌ Erreur complète lors de la réservation:", error);
      throw error;
    }
  },

  //////////////NOUVEAU///////////////
  // Récupérer les demandes par statut
  getByStatus: async (status) => {
    const response = await fetch(
      `${API_BASE_URL2}/hotel-requests/status/${status}`
    );
    if (!response.ok)
      throw new Error("Erreur récupération demandes par statut");
    return await response.json();
  },

  // Récupérer les demandes par agent
  getByAgent: async (agentId) => {
    const response = await fetch(
      `${API_BASE_URL2}/hotel-requests/agent/${agentId}`
    );
    if (!response.ok) throw new Error("Erreur récupération demandes par agent");
    return await response.json();
  },
};

// ==================== COMPOSANT FORMULAIRE DE DEMANDE D'HÔTEL AVEC API ====================

const HotelBookingRequestForm1 = ({
  selectedHotel,
  selectedOffer,
  searchParams,
  user,
  submitting,
  onSubmit,
  onCancel,
}) => {
  const [agents, setAgents] = useState([]);
  const [loadingAgents, setLoadingAgents] = useState(false);

  console.log("ICI BUG");

  const [formData, setFormData] = useState({
    matricule: "",
    nom: "",
    prenom: "",
    categorie: "",
    fonction: "",
    objetVoyage: "",
    motifDeplacement: "",
    projet: "",
    centreCoût: "",
    preferencesSpeciales: "",
    agentId: "",
  });

  const calculateNights = () => {
    if (searchParams.checkInDate && searchParams.checkOutDate) {
      const checkIn = new Date(searchParams.checkInDate);
      const checkOut = new Date(searchParams.checkOutDate);
      const diffTime = Math.abs(checkOut - checkIn);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    }
    return 0;
  };

  // Service d'administration pour récupérer les agents
  const administrationService = {
    getAgents: async () => {
      const response = await fetch(`${API_BASE_URL2}/travel-agents`);
      if (!response.ok) throw new Error("Erreur récupération agents");
      return await response.json();
    },
  };

  // Chargement des agents au montage du composant
  useEffect(() => {
    loadAgents();
  }, []);

  const loadAgents = async () => {
    setLoadingAgents(true);
    try {
      // Chargement des agents depuis la base de données
      const agentsData = await administrationService.getAgents();
      setAgents(agentsData);
    } catch (error) {
      console.error("Erreur lors du chargement des agents:", error);
      alert("Impossible de charger la liste des agents. Veuillez réessayer.");
    } finally {
      setLoadingAgents(false);
    }
  };

  // Fonction pour générer un UUID
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.agentId) {
      alert("Veuillez sélectionner un agent");
      return;
    }

    const selectedAgent = agents.find((a) => a.id === formData.agentId);
    if (!selectedAgent) {
      alert("Agent sélectionné introuvable");
      return;
    }

    const requestData = {
      id: generateUUID(),
      numeroRequete: `REQ-${Date.now()}`,
      matricule: selectedAgent.matricule,
      nom: selectedAgent.nom,
      prenom: selectedAgent.prenom,
      categorie: selectedAgent.categorie,
      fonction: selectedAgent.fonction,
      objetVoyage: formData.objetVoyage,
      motifDeplacement: formData.motifDeplacement,
      projet: formData.projet,
      centreCoût: formData.centreCoût,
      createdById: user.id,
      createdAt: new Date(),
      statut: "En attente",
      numeroRequete: `HTL-${Date.now()}`,
      hotel: selectedHotel,
      offer: selectedOffer, // Ajouter l'offre sélectionnée aux données
      searchParams,
      dateRequete: new Date().toISOString(),
      nombreNuits: calculateNights(),
      agentId: formData.agentId,
    };

    onSubmit(requestData);
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex justify-between mb-6">
        <h2 className="text-2xl font-bold flex items-center">
          <FileText className="w-6 h-6 mr-2 text-blue-600" />
          Demande de réservation d'hôtel
        </h2>
        <button onClick={onCancel} disabled={submitting}>
          <X className="w-6 h-6 text-gray-500 hover:text-gray-700" />
        </button>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <h3 className="font-bold text-blue-900 mb-3 flex items-center">
          <Hotel className="w-5 h-5 mr-2" />
          Hôtel sélectionné
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm mb-4">
          <div>
            <p className="text-gray-600">Établissement</p>
            <p className="font-semibold">{selectedHotel.name}</p>
          </div>
          <div>
            <p className="text-gray-600">Ville</p>
            <p className="font-semibold">{searchParams.cityCode}</p>
          </div>
          <div>
            <p className="text-gray-600">Arrivée</p>
            <p className="font-semibold">
              {new Date(searchParams.checkInDate).toLocaleDateString("fr-FR")}
            </p>
          </div>
          <div>
            <p className="text-gray-600">Départ</p>
            <p className="font-semibold">
              {new Date(searchParams.checkOutDate).toLocaleDateString("fr-FR")}
            </p>
          </div>
          <div>
            <p className="text-gray-600">Nuits</p>
            <p className="font-semibold">
              {calculateNights()} nuit{calculateNights() > 1 ? "s" : ""}
            </p>
          </div>
          <div>
            <p className="text-gray-600">Occupants</p>
            <p className="font-semibold">
              {searchParams.adults} adulte(s) - {searchParams.rooms} chambre(s)
            </p>
          </div>
        </div>

        {/* Détails de l'offre sélectionnée */}
        {selectedOffer && (
          <div className="mt-4 pt-4 border-t border-blue-300">
            <h4 className="font-bold text-blue-800 mb-3 flex items-center">
              <Tag className="w-4 h-4 mr-2" />
              Détails de l'offre sélectionnée
            </h4>

            <div className="bg-white rounded-lg p-4 border border-blue-100">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Informations de la chambre */}
                <div>
                  <h5 className="font-semibold text-gray-800 mb-2">Chambre</h5>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Type de chambre:</span>
                      <span className="font-semibold">
                        {selectedOffer.room?.typeEstimated?.category ||
                          selectedOffer.roomInformation?.typeEstimated
                            ?.category ||
                          "Chambre Standard"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Type de lit:</span>
                      <span className="font-semibold">
                        {selectedOffer.room?.typeEstimated?.bedType ||
                          selectedOffer.roomInformation?.typeEstimated
                            ?.bedType ||
                          "Non spécifié"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Nombre de lits:</span>
                      <span className="font-semibold">
                        {selectedOffer.room?.typeEstimated?.beds ||
                          selectedOffer.roomInformation?.typeEstimated?.beds ||
                          "1"}
                      </span>
                    </div>
                    {(selectedOffer.room?.description?.text ||
                      selectedOffer.roomInformation?.description) && (
                      <div className="mt-2 p-2 bg-gray-50 rounded">
                        <p className="text-xs text-gray-600">
                          {selectedOffer.room?.description?.text ||
                            selectedOffer.roomInformation?.description}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Informations tarifaires */}
                <div>
                  <h5 className="font-semibold text-gray-800 mb-2">Tarifs</h5>
                  <div className="space-y-2 text-sm">
                    {/* Prix par nuit */}
                    {selectedOffer.price?.total && (
                      <div className="flex justify-between">
                        <span className="text-gray-600">Prix par nuit:</span>
                        <span className="font-semibold">
                          {new Intl.NumberFormat("fr-FR", {
                            style: "currency",
                            currency: selectedOffer.price?.currency || "EUR",
                          }).format(parseFloat(selectedOffer.price.total))}
                        </span>
                      </div>
                    )}

                    {/* Taxes et frais */}
                    {selectedOffer.price?.taxes &&
                      selectedOffer.price.taxes.length > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Taxes et frais:</span>
                          <span className="font-semibold">
                            {new Intl.NumberFormat("fr-FR", {
                              style: "currency",
                              currency: selectedOffer.price?.currency || "EUR",
                            }).format(
                              selectedOffer.price.taxes.reduce(
                                (sum, tax) => sum + parseFloat(tax.amount || 0),
                                0
                              )
                            )}
                          </span>
                        </div>
                      )}

                    {/* Prix total pour le séjour */}
                    <div className="flex justify-between border-t pt-2 mt-2">
                      <span className="text-gray-800 font-semibold">
                        Total pour {calculateNights()} nuit
                        {calculateNights() > 1 ? "s" : ""}:
                      </span>
                      <span className="text-lg font-bold text-green-600">
                        {selectedOffer.price?.total
                          ? new Intl.NumberFormat("fr-FR", {
                              style: "currency",
                              currency: selectedOffer.price.currency || "EUR",
                            }).format(parseFloat(selectedOffer.price.total))
                          : "Prix non disponible"}
                      </span>
                    </div>

                    {/* Calcul détaillé (optionnel) */}
                    {selectedOffer.price?.base && (
                      <div className="text-xs text-gray-500 text-right mt-1">
                        {parseFloat(selectedOffer.price.base)} € ×{" "}
                        {calculateNights()} nuit
                        {calculateNights() > 1 ? "s" : ""}
                        {selectedOffer.price?.taxes &&
                        selectedOffer.price.taxes.length > 0
                          ? ` + ${selectedOffer.price.taxes.reduce(
                              (sum, tax) => sum + parseFloat(tax.amount || 0),
                              0
                            )} € de taxes`
                          : ""}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Politiques et conditions */}
              <div className="mt-4 pt-3 border-t border-gray-200">
                <h5 className="font-semibold text-gray-800 mb-2">Conditions</h5>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                  <div>
                    <div className="flex justify-between mb-1">
                      <span className="text-gray-600">Type de paiement:</span>
                      <span className="font-semibold">
                        {selectedOffer.policies?.paymentType === "guarantee"
                          ? "Garantie requise"
                          : selectedOffer.policies?.paymentType === "deposit"
                          ? "Acompte requis"
                          : "Paiement à l'arrivée"}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-gray-600">Annulation:</span>
                      <span
                        className={`font-semibold ${
                          selectedOffer.policies?.refundable
                            ?.cancellationRefund === "NON_REFUNDABLE"
                            ? "text-red-600"
                            : "text-green-600"
                        }`}
                      >
                        {selectedOffer.policies?.refundable
                          ?.cancellationRefund === "NON_REFUNDABLE"
                          ? "Non remboursable"
                          : selectedOffer.policies?.refundable
                              ?.cancellationRefund ===
                            "REFUNDABLE_UP_TO_DEADLINE"
                          ? "Remboursable avant limite"
                          : "Remboursable"}
                      </span>
                    </div>
                  </div>

                  <div>
                    {selectedOffer.policies?.cancellation && (
                      <div className="text-xs text-gray-600 bg-yellow-50 p-2 rounded border border-yellow-200">
                        <strong>Politique d'annulation:</strong>
                        <br />
                        {selectedOffer.policies.cancellation[0]?.description
                          ?.text ||
                          selectedOffer.policies.cancellation?.description
                            ?.text ||
                          "Voir conditions spécifiques"}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Numéro de confirmation de l'offre */}
              {selectedOffer.id && (
                <div className="mt-3 text-xs text-gray-500">
                  Référence offre: {selectedOffer.id}
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <Users className="w-5 h-5 mr-2 text-blue-600" />
            Agent voyageur
          </h3>
          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Sélectionner un agent *
              </label>
              <select
                value={formData.agentId}
                onChange={(e) =>
                  setFormData({ ...formData, agentId: e.target.value })
                }
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                disabled={submitting || loadingAgents}
              >
                <option value="">-- Choisir un agent --</option>
                {agents.map((agent) => (
                  <option key={agent.id} value={agent.id}>
                    {agent.prenom} {agent.nom} - {agent.fonction} (Mat:{" "}
                    {agent.matricule})
                  </option>
                ))}
              </select>
              {loadingAgents && (
                <p className="text-sm text-gray-500 mt-1">
                  Chargement des agents...
                </p>
              )}
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <MapPin className="w-5 h-5 mr-2 text-blue-600" />
            Détails du séjour
          </h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Objet du voyage *
              </label>
              <input
                type="text"
                value={formData.objetVoyage}
                onChange={(e) =>
                  setFormData({ ...formData, objetVoyage: e.target.value })
                }
                placeholder="Réunion, Formation, Conférence..."
                className="w-full px-4 py-2 border rounded-lg"
                required
                disabled={submitting}
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Motif du déplacement *
              </label>
              <textarea
                value={formData.motifDeplacement}
                onChange={(e) =>
                  setFormData({ ...formData, motifDeplacement: e.target.value })
                }
                rows="3"
                className="w-full px-4 py-2 border rounded-lg"
                required
                disabled={submitting}
              />
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Projet
                </label>
                <input
                  type="text"
                  value={formData.projet}
                  onChange={(e) =>
                    setFormData({ ...formData, projet: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={submitting}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Centre de coût
                </label>
                <input
                  type="text"
                  value={formData.centreCoût}
                  onChange={(e) =>
                    setFormData({ ...formData, centreCoût: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={submitting}
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Préférences spéciales
              </label>
              <textarea
                value={formData.preferencesSpeciales}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    preferencesSpeciales: e.target.value,
                  })
                }
                placeholder="Étage élevé, chambre calme, lit king size..."
                rows="2"
                className="w-full px-4 py-2 border rounded-lg"
                disabled={submitting}
              />
            </div>
          </div>
        </div>

        <div className="flex space-x-4">
          <button
            type="submit"
            disabled={submitting}
            className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center"
          >
            {submitting ? (
              <>
                <Loader className="w-5 h-5 mr-2 animate-spin" />
                Envoi en cours...
              </>
            ) : (
              <>
                <Save className="w-5 h-5 mr-2" />
                Soumettre la demande
              </>
            )}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={submitting}
            className="px-6 py-3 border rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
};
// ==================== COMPOSANT WORKFLOW RÉSERVATION HÔTEL AVEC API ====================

const HotelBookingRequestForm = ({
  selectedHotel,
  selectedOffer,
  searchParams,
  user,
  submitting,
  onSubmit,
  onCancel,
}) => {
  const [agents, setAgents] = useState([]);
  const [loadingAgents, setLoadingAgents] = useState(false);

  console.log("ICI BUG - selectedOffer:", selectedOffer); // Debug

  const [formData, setFormData] = useState({
    matricule: "",
    nom: "",
    prenom: "",
    categorie: "",
    fonction: "",
    objetVoyage: "",
    motifDeplacement: "",
    projet: "",
    centreCoût: "",
    preferencesSpeciales: "",
    agentId: "",
  });

  const calculateNights = () => {
    if (searchParams.checkInDate && searchParams.checkOutDate) {
      const checkIn = new Date(searchParams.checkInDate);
      const checkOut = new Date(searchParams.checkOutDate);
      const diffTime = Math.abs(checkOut - checkIn);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    }
    return 0;
  };

  // Fonction pour formater le prix
  const formatPrice = (price) => {
    if (!price || (!price.total && price.total !== 0))
      return "Prix non disponible";

    const totalAmount =
      typeof price.total === "string" ? parseFloat(price.total) : price.total;
    const currency = price.currency || "EUR";

    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: currency,
    }).format(totalAmount);
  };

  // Fonction pour calculer le prix total pour toutes les nuits
  const calculateTotalPrice = () => {
    if (!selectedOffer?.price?.total) return null;

    const nights = calculateNights();
    const rooms = parseInt(searchParams.rooms) || 1;

    // Récupérer le prix de base ou total
    const pricePerNightPerRoom = parseFloat(
      selectedOffer.price.base || selectedOffer.price.total
    );

    // Calculer le prix total : prix par nuit × nombre de nuits × nombre de chambres
    const totalPrice = pricePerNightPerRoom * nights * rooms;

    return {
      total: totalPrice,
      currency: selectedOffer.price.currency || "EUR",
      pricePerNightPerRoom: pricePerNightPerRoom,
      nights: nights,
      rooms: rooms,
    };
  };

  // Service d'administration pour récupérer les agents
  const administrationService = {
    getAgents: async () => {
      const response = await fetch(`${API_BASE_URL2}/travel-agents`);
      if (!response.ok) throw new Error("Erreur récupération agents");
      return await response.json();
    },
  };

  // Chargement des agents au montage du composant
  useEffect(() => {
    loadAgents();
  }, []);

  const loadAgents = async () => {
    setLoadingAgents(true);
    try {
      const agentsData = await administrationService.getAgents();
      setAgents(agentsData);
    } catch (error) {
      console.error("Erreur lors du chargement des agents:", error);
      alert("Impossible de charger la liste des agents. Veuillez réessayer.");
    } finally {
      setLoadingAgents(false);
    }
  };

  // Fonction pour générer un UUID
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.agentId) {
      alert("Veuillez sélectionner un agent");
      return;
    }

    const selectedAgent = agents.find((a) => a.id === formData.agentId);
    if (!selectedAgent) {
      alert("Agent sélectionné introuvable");
      return;
    }

    const totalPriceInfo = calculateTotalPrice();
    const nights = calculateNights();
    const rooms = parseInt(searchParams.rooms) || 1;
    const adults = parseInt(searchParams.adults) || 1;

    // Mettre à jour l'offre avec le total calculé
    const updatedOffer = selectedOffer
      ? {
          ...selectedOffer,
          price: {
            ...selectedOffer.price,
            // Mettre à jour le total avec le calcul qui inclut nuits et chambres
            total: totalPriceInfo
              ? totalPriceInfo.total.toString()
              : selectedOffer.price.total,
            // Garder le prix de base original pour référence
            base: selectedOffer.price.base || selectedOffer.price.total,
          },
        }
      : null;

    // Structure complète
    const requestData = {
      numeroRequete: `HTL-${Date.now()}`,
      matricule: selectedAgent.matricule,
      nom: selectedAgent.nom,
      prenom: selectedAgent.prenom,
      categorie: selectedAgent.categorie,
      fonction: selectedAgent.fonction,
      objetVoyage: formData.objetVoyage,
      motifDeplacement: formData.motifDeplacement,
      projet: formData.projet,
      centreCoût: formData.centreCoût,
      createdById: user.id,

      statut: "En attente",

      // nombreNuits à la racine comme en BD
      nombreNuits: nights,

      // Hôtel avec l'offre mise à jour contenant le total calculé
      hotel: {
        ...selectedHotel,
        // Offre mise à jour avec le bon total calculé
        offers: updatedOffer ? [updatedOffer] : [],
      },

      // Paramètres de recherche
      searchParams: {
        ...searchParams,
        checkInDate: searchParams.checkInDate,
        checkOutDate: searchParams.checkOutDate,
        cityCode: searchParams.cityCode,
        adults: adults,
        rooms: rooms,
      },

      agentId: formData.agentId,
    };

    console.log("💾 Données envoyées à onSubmit:", {
      nombreNuits: nights,
      offerTotal: updatedOffer?.price?.total,
      calcul: totalPriceInfo
        ? `${totalPriceInfo.pricePerNightPerRoom} × ${nights} × ${rooms} = ${totalPriceInfo.total}`
        : "N/A",
    });

    onSubmit(requestData);
  };
  const totalPriceInfo = calculateTotalPrice();
  const nights = calculateNights();

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex justify-between mb-6">
        <h2 className="text-2xl font-bold flex items-center">
          <FileText className="w-6 h-6 mr-2 text-blue-600" />
          Demande de réservation d'hôtel
        </h2>
        <button onClick={onCancel} disabled={submitting}>
          <X className="w-6 h-6 text-gray-500 hover:text-gray-700" />
        </button>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <h3 className="font-bold text-blue-900 mb-3 flex items-center">
          <Hotel className="w-5 h-5 mr-2" />
          Hôtel sélectionné
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm mb-4">
          <div>
            <p className="text-gray-600">Établissement</p>
            <p className="font-semibold">{selectedHotel.name}</p>
          </div>
          <div>
            <p className="text-gray-600">Ville</p>
            <p className="font-semibold">{searchParams.cityCode}</p>
          </div>
          <div>
            <p className="text-gray-600">Arrivée</p>
            <p className="font-semibold">
              {new Date(searchParams.checkInDate).toLocaleDateString("fr-FR")}
            </p>
          </div>
          <div>
            <p className="text-gray-600">Départ</p>
            <p className="font-semibold">
              {new Date(searchParams.checkOutDate).toLocaleDateString("fr-FR")}
            </p>
          </div>
          <div>
            <p className="text-gray-600">Nuits</p>
            <p className="font-semibold">
              {nights} nuit{nights > 1 ? "s" : ""}
            </p>
          </div>
          <div>
            <p className="text-gray-600">Occupants</p>
            <p className="font-semibold">
              {searchParams.adults} adulte(s) - {searchParams.rooms} chambre(s)
            </p>
          </div>
        </div>

        {/* Détails de l'offre sélectionnée */}
        {selectedOffer && (
          <div className="mt-4 pt-4 border-t border-blue-300">
            <h4 className="font-bold text-blue-800 mb-3 flex items-center">
              <Tag className="w-4 h-4 mr-2" />
              Détails de l'offre sélectionnée
            </h4>

            <div className="bg-white rounded-lg p-4 border border-blue-100">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Informations de la chambre */}
                <div>
                  <h5 className="font-semibold text-gray-800 mb-2">Chambre</h5>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Type de chambre:</span>
                      <span className="font-semibold">
                        {selectedOffer.room?.typeEstimated?.category ||
                          selectedOffer.roomInformation?.typeEstimated
                            ?.category ||
                          "Chambre Standard"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Type de lit:</span>
                      <span className="font-semibold">
                        {selectedOffer.room?.typeEstimated?.bedType ||
                          selectedOffer.roomInformation?.typeEstimated
                            ?.bedType ||
                          "Non spécifié"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Nombre de lits:</span>
                      <span className="font-semibold">
                        {selectedOffer.room?.typeEstimated?.beds ||
                          selectedOffer.roomInformation?.typeEstimated?.beds ||
                          "1"}
                      </span>
                    </div>
                    {(selectedOffer.room?.description?.text ||
                      selectedOffer.roomInformation?.description) && (
                      <div className="mt-2 p-2 bg-gray-50 rounded">
                        <p className="text-xs text-gray-600">
                          {selectedOffer.room?.description?.text ||
                            selectedOffer.roomInformation?.description}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Informations tarifaires CORRIGÉES */}
                <div>
                  <h5 className="font-semibold text-gray-800 mb-2">Tarifs</h5>
                  <div className="space-y-2 text-sm">
                    {/* Prix par nuit par chambre */}
                    {selectedOffer.price?.base && (
                      <div className="flex justify-between">
                        <span className="text-gray-600">
                          Prix par nuit (par chambre):
                        </span>
                        <span className="font-semibold">
                          {new Intl.NumberFormat("fr-FR", {
                            style: "currency",
                            currency: selectedOffer.price?.currency || "EUR",
                          }).format(parseFloat(selectedOffer.price.base))}
                        </span>
                      </div>
                    )}

                    {/* Nombre de chambres */}
                    <div className="flex justify-between">
                      <span className="text-gray-600">Nombre de chambres:</span>
                      <span className="font-semibold">
                        {searchParams.rooms} chambre
                        {searchParams.rooms > 1 ? "s" : ""}
                      </span>
                    </div>

                    {/* Nombre de nuits */}
                    <div className="flex justify-between">
                      <span className="text-gray-600">Nombre de nuits:</span>
                      <span className="font-semibold">
                        {nights} nuit{nights > 1 ? "s" : ""}
                      </span>
                    </div>

                    {/* Taxes et frais */}
                    {selectedOffer.price?.taxes &&
                      selectedOffer.price.taxes.length > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Taxes et frais:</span>
                          <span className="font-semibold">
                            {new Intl.NumberFormat("fr-FR", {
                              style: "currency",
                              currency: selectedOffer.price?.currency || "EUR",
                            }).format(
                              selectedOffer.price.taxes.reduce(
                                (sum, tax) => sum + parseFloat(tax.amount || 0),
                                0
                              )
                            )}
                          </span>
                        </div>
                      )}

                    {/* Prix total CORRIGÉ */}
                    <div className="flex justify-between border-t pt-2 mt-2">
                      <span className="text-gray-800 font-semibold">
                        Total pour {nights} nuit{nights > 1 ? "s" : ""} ×{" "}
                        {searchParams.rooms} chambre
                        {searchParams.rooms > 1 ? "s" : ""}:
                      </span>
                      <span className="text-lg font-bold text-green-600">
                        {totalPriceInfo
                          ? new Intl.NumberFormat("fr-FR", {
                              style: "currency",
                              currency: totalPriceInfo.currency,
                            }).format(totalPriceInfo.total)
                          : selectedOffer.price?.total
                          ? formatPrice(selectedOffer.price)
                          : "Prix non disponible"}
                      </span>
                    </div>

                    {/* Calcul détaillé CORRIGÉ */}
                    {selectedOffer.price?.base && totalPriceInfo && (
                      <div className="text-xs text-gray-500 text-right mt-1">
                        {parseFloat(selectedOffer.price.base).toFixed(2)} € ×{" "}
                        {nights} nuit{nights > 1 ? "s" : ""} ×{" "}
                        {searchParams.rooms} chambre
                        {searchParams.rooms > 1 ? "s" : ""} ={" "}
                        {totalPriceInfo.total.toFixed(2)} €
                        {selectedOffer.price?.taxes &&
                          selectedOffer.price.taxes.length > 0 && (
                            <div>
                              +{" "}
                              {selectedOffer.price.taxes
                                .reduce(
                                  (sum, tax) =>
                                    sum + parseFloat(tax.amount || 0),
                                  0
                                )
                                .toFixed(2)}{" "}
                              € de taxes
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Politiques et conditions */}
              <div className="mt-4 pt-3 border-t border-gray-200">
                <h5 className="font-semibold text-gray-800 mb-2">Conditions</h5>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                  <div>
                    <div className="flex justify-between mb-1">
                      <span className="text-gray-600">Type de paiement:</span>
                      <span className="font-semibold">
                        {selectedOffer.policies?.paymentType === "guarantee"
                          ? "Garantie requise"
                          : selectedOffer.policies?.paymentType === "deposit"
                          ? "Acompte requis"
                          : "Paiement à l'arrivée"}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-gray-600">Annulation:</span>
                      <span
                        className={`font-semibold ${
                          selectedOffer.policies?.refundable
                            ?.cancellationRefund === "NON_REFUNDABLE"
                            ? "text-red-600"
                            : "text-green-600"
                        }`}
                      >
                        {selectedOffer.policies?.refundable
                          ?.cancellationRefund === "NON_REFUNDABLE"
                          ? "Non remboursable"
                          : selectedOffer.policies?.refundable
                              ?.cancellationRefund ===
                            "REFUNDABLE_UP_TO_DEADLINE"
                          ? "Remboursable avant limite"
                          : "Remboursable"}
                      </span>
                    </div>
                  </div>

                  <div>
                    {selectedOffer.policies?.cancellation && (
                      <div className="text-xs text-gray-600 bg-yellow-50 p-2 rounded border border-yellow-200">
                        <strong>Politique d'annulation:</strong>
                        <br />
                        {selectedOffer.policies.cancellation[0]?.description
                          ?.text ||
                          selectedOffer.policies.cancellation?.description
                            ?.text ||
                          "Voir conditions spécifiques"}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Numéro de confirmation de l'offre */}
              {selectedOffer.id && (
                <div className="mt-3 text-xs text-gray-500">
                  Référence offre: {selectedOffer.id}
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Le reste du formulaire reste inchangé */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <Users className="w-5 h-5 mr-2 text-blue-600" />
            Agent voyageur
          </h3>
          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Sélectionner un agent *
              </label>
              <select
                value={formData.agentId}
                onChange={(e) =>
                  setFormData({ ...formData, agentId: e.target.value })
                }
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                disabled={submitting || loadingAgents}
              >
                <option value="">-- Choisir un agent --</option>
                {agents.map((agent) => (
                  <option key={agent.id} value={agent.id}>
                    {agent.prenom} {agent.nom} - {agent.fonction} (Mat:{" "}
                    {agent.matricule})
                  </option>
                ))}
              </select>
              {loadingAgents && (
                <p className="text-sm text-gray-500 mt-1">
                  Chargement des agents...
                </p>
              )}
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <MapPin className="w-5 h-5 mr-2 text-blue-600" />
            Détails du séjour
          </h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Objet du voyage *
              </label>
              <input
                type="text"
                value={formData.objetVoyage}
                onChange={(e) =>
                  setFormData({ ...formData, objetVoyage: e.target.value })
                }
                placeholder="Réunion, Formation, Conférence..."
                className="w-full px-4 py-2 border rounded-lg"
                required
                disabled={submitting}
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Motif du déplacement *
              </label>
              <textarea
                value={formData.motifDeplacement}
                onChange={(e) =>
                  setFormData({ ...formData, motifDeplacement: e.target.value })
                }
                rows="3"
                className="w-full px-4 py-2 border rounded-lg"
                required
                disabled={submitting}
              />
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Projet
                </label>
                <input
                  type="text"
                  value={formData.projet}
                  onChange={(e) =>
                    setFormData({ ...formData, projet: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={submitting}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Centre de coût
                </label>
                <input
                  type="text"
                  value={formData.centreCoût}
                  onChange={(e) =>
                    setFormData({ ...formData, centreCoût: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={submitting}
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Préférences spéciales
              </label>
              <textarea
                value={formData.preferencesSpeciales}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    preferencesSpeciales: e.target.value,
                  })
                }
                placeholder="Étage élevé, chambre calme, lit king size..."
                rows="2"
                className="w-full px-4 py-2 border rounded-lg"
                disabled={submitting}
              />
            </div>
          </div>
        </div>

        <div className="flex space-x-4">
          <button
            type="submit"
            disabled={submitting}
            className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center"
          >
            {submitting ? (
              <>
                <Loader className="w-5 h-5 mr-2 animate-spin" />
                Envoi en cours...
              </>
            ) : (
              <>
                <Save className="w-5 h-5 mr-2" />
                Soumettre la demande
              </>
            )}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={submitting}
            className="px-6 py-3 border rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
};
const HotelBookingWorkflow = ({ user, onRequestSubmitted }) => {
  const [step, setStep] = useState(1);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [selectedOffer, setSelectedOffer] = useState(null); // Ajoutez cette ligne
  const [searchParams, setSearchParams] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [safeSearchParams, setSafeSearchParams] = useState({
    originLocationCode: "",
    destinationLocationCode: "",
    departureDate: "",
    returnDate: "",
    adults: "1",
    children: "0",
    infants: "0",
    tripType: "one-way",
    travelClass: "ECONOMY",
  });

  const handleRequestSubmit = async (requestData) => {
    setSubmitting(true);
    try {
      const createdRequest = await hotelRequestsService.create(requestData);
      toast.success("Demande de réservation créée avec succès !");
      onRequestSubmitted && onRequestSubmitted(createdRequest);
      setStep(1);
      setSelectedHotel(null);
      setSelectedOffer(null); // Réinitialiser l'offre aussi
      setSearchParams(null);
    } catch (error) {
      toast.error(`Erreur lors de la création: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center ${
                step >= 1 ? "bg-blue-600 text-white" : "bg-gray-200"
              }`}
            >
              1
            </div>
            <div>
              <p className="font-semibold">Recherche</p>
              <p className="text-sm text-gray-500">Trouvez votre hôtel</p>
            </div>
          </div>
          <div className="flex-1 h-1 bg-gray-200 mx-4">
            <div
              className={`h-full bg-blue-600 transition-all`}
              style={{ width: step >= 2 ? "100%" : "0%" }}
            ></div>
          </div>
          <div className="flex items-center space-x-4">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center ${
                step >= 2 ? "bg-blue-600 text-white" : "bg-gray-200"
              }`}
            >
              2
            </div>
            <div>
              <p className="font-semibold">Demande</p>
              <p className="text-sm text-gray-500">Complétez</p>
            </div>
          </div>
        </div>
      </div>

      {step === 1 && (
        <HotelSearch
          onSelectHotel={(hotel, params, offer) => {
            // Ajoutez le paramètre offer
            console.log("🏨 Hôtel sélectionné dans workflow:", hotel);
            console.log("💰 Offre sélectionnée dans workflow:", offer);
            setSelectedHotel(hotel);
            setSearchParams(params);
            setSelectedOffer(offer); // Stockez l'offre sélectionnée
            setStep(2);
          }}
        />
      )}

      {step === 2 && (
        <HotelBookingRequestForm
          selectedHotel={selectedHotel}
          searchParams={searchParams}
          selectedOffer={selectedOffer} // Passez l'offre sélectionnée
          user={user}
          submitting={submitting}
          onSubmit={handleRequestSubmit}
          onCancel={() => {
            setStep(1);
            setSelectedHotel(null);
            setSelectedOffer(null); // Réinitialiser l'offre
            setSearchParams(null);
          }}
        />
      )}
    </div>
  );
};

// ==================== COMPOSANT LISTE DES DEMANDES D'HÔTELS AVEC API ====================

const HotelRequestsList2 = ({ onRefresh }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    loadRequests();
  }, [filterStatus]);

  const loadRequests = async () => {
    setLoading(true);
    setError(null);
    try {
      let data;
      if (filterStatus === "all") {
        data = await hotelRequestsService.getAll();
      } else {
        data = await hotelRequestsService.getByStatus(filterStatus);
      }
      setRequests(data);
    } catch (error) {
      console.error("Erreur chargement demandes:", error);
      setError("Erreur lors du chargement des demandes: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    confirmToast(
      "Êtes-vous sûr de vouloir approuver cette demande ?",
      () => {},
      () => {
        toast.info("Action annulée.");
        return;
      }
    );

    try {
      await hotelRequestsService.approve(id);
      toast.success("Demande approuvée avec succès !");
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
      toast.error(`Erreur: ${error.message}`);
    }
  };

  const handleReject = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir rejeter cette demande ?"))
      return;

    try {
      await hotelRequestsService.reject(id);
      alert("Demande rejetée");
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    }
  };

  const handleBook = async (request) => {
confirmToast(
        "Confirmer la réservation de cet hôtel ?",
        async () => {
          setSelectedRequest(request);
    setShowPaymentModal(true);
        },
        () => {
          toast.info("Action annulée.");
          return;
        }
      );
    
  };

  const handlePaymentConfirm = async (paymentData) => {
    setIsProcessing(true);

    
    try {
      await hotelRequestsService.confirmBooking(
        selectedRequest.id,
        paymentData
      );
      toast.success("Réservation confirmée avec succès !");
      setShowPaymentModal(false);
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
      toast.error(`Erreur: ${error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleDelete = async (id) => {
   

    confirmToast(
        "Êtes-vous sûr de vouloir supprimer cette demande ?",
        async () => {
          try {
      await hotelRequestsService.delete(id);
      toast.success("Demande supprimée avec succès !");
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
      toast.error(`Erreur: ${error.message}`);
    }
        },
        () => {
          toast.info("Action annulée.");
          return;
        }
      );

    
  };

  // Fonction pour calculer le prix total depuis la structure hotel.offers
  const calculateTotalPrice = (request) => {
    try {
      // Vérifier si la structure existe et a le prix
      if (request?.hotel?.offers?.[0]?.price?.total) {
        return request.hotel.offers[0].price.total + " €";
      }

      // Fallback: si le prix total est directement dans la requête
      if (request.totalPrice) {
        return request.totalPrice + " €";
      }

      // Fallback: calcul basé sur le prix de base et le nombre de nuits
      if (request?.hotel?.offers?.[0]?.price?.base && request.nombreNuits) {
        const basePrice = parseFloat(request.hotel.offers[0].price.base);
        const total = basePrice * parseInt(request.nombreNuits);
        return total.toFixed(2) + " €";
      }

      return "N/A";
    } catch (error) {
      console.error("Erreur calcul prix:", error);
      return "N/A";
    }
  };

  // Fonction pour obtenir juste la valeur numérique du prix (sans le symbole €)
  const getNumericPrice = (request) => {
    try {
      if (request?.vol?.offers?.[0]?.price?.total) {
        return request.vol.offers[0].price.total;
      }
      return null;
    } catch (error) {
      return null;
    }
  };

  // Fonction pour générer et télécharger le PDF de confirmation de réservation
  const handleDownloadConfirmation = (request) => {
    const doc = new jsPDF();

    // En-tête avec design moderne
    doc.setFillColor(147, 51, 234); // Couleur violet pour les hôtels
    doc.rect(0, 0, 210, 45, "F");

    // Titre principal
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(24);
    doc.text("CONFIRMATION DE RÉSERVATION", 105, 20, { align: "center" });
    doc.setFontSize(14);
    doc.text("HÔTEL", 105, 30, { align: "center" });
    doc.setFontSize(11);
    doc.text(`N° ${request.numeroRequete}`, 105, 38, { align: "center" });

    // Logo et informations de l'agence
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    let yPos = 55;
    doc.setFont(undefined, "bold");
    doc.text("ABM Travel Agency", 20, yPos);
    doc.setFont(undefined, "normal");
    yPos += 5;
    doc.text("Abidjan, Côte d'Ivoire", 20, yPos);
    yPos += 5;
    doc.text("contact@abmtravel.com", 20, yPos);
    yPos += 5;
    doc.text("+225 07 08 83 60", 20, yPos);

    // Date de confirmation
    yPos = 55;
    doc.setFont(undefined, "bold");
    doc.text("Date de confirmation:", 190, yPos, { align: "right" });
    doc.setFont(undefined, "normal");
    yPos += 5;
    doc.text(new Date().toLocaleDateString("fr-FR"), 190, yPos, {
      align: "right",
    });

    yPos = 85;

    // Informations du voyageur
    doc.setFillColor(245, 245, 250); // Fond gris clair
    doc.rect(15, yPos - 5, 180, 35, "F");
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("INFORMATIONS DU VOYAGEUR", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    yPos += 8;
    doc.text(
      `Nom complet: ${request.prenom || "N/A"} ${
        request.nom?.toUpperCase() || "N/A"
      }`,
      20,
      yPos
    );
    yPos += 7;
    doc.text(`Matricule: ${request.matricule || "N/A"}`, 20, yPos);
    doc.text(`Fonction: ${request.fonction || "N/A"}`, 100, yPos);
    yPos += 7;
    doc.text(`Email: ${request.email || "contact@abmtravel.com"}`, 20, yPos);
    doc.text(
      `Téléphone: ${request.telephone || "+225 07 08 83 76 60"}`,
      100,
      yPos
    );

    yPos += 15;

    // Détails de l'hôtel
    doc.setFillColor(245, 245, 250);
    doc.rect(15, yPos - 5, 180, 50, "F");
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("DÉTAILS DE LA RÉSERVATION", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    yPos += 8;

    // Nom de l'hôtel en grand
    doc.setFont(undefined, "bold");
    doc.setFontSize(14);
    doc.setTextColor(147, 51, 234); // Violet
    doc.text(request.hotel?.name || "Hôtel réservé", 20, yPos);
    doc.setTextColor(0, 0, 0);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    yPos += 8;

    // Détails de la réservation
    doc.text(`Ville: ${request.searchParams?.cityCode || "N/A"}`, 20, yPos);
    if (request.hotel?.address?.cityName) {
      doc.text(` - ${request.hotel.address.cityName}`, 50, yPos);
    }
    yPos += 7;

    // Dates avec mise en forme améliorée
    const checkInDate = request.searchParams?.checkInDate
      ? new Date(request.searchParams.checkInDate).toLocaleDateString("fr-FR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      : "N/A";

    const checkOutDate = request.searchParams?.checkOutDate
      ? new Date(request.searchParams.checkOutDate).toLocaleDateString(
          "fr-FR",
          {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          }
        )
      : "N/A";

    doc.setFont(undefined, "bold");
    doc.text("Check-in:", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.text(checkInDate, 45, yPos);
    yPos += 7;

    doc.setFont(undefined, "bold");
    doc.text("Check-out:", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.text(checkOutDate, 45, yPos);
    yPos += 7;

    // Nombre de nuits et chambres
    doc.text(
      `Durée du séjour: ${request.nombreNuits || "N/A"} nuit(s)`,
      20,
      yPos
    );
    doc.text(`Chambres: ${request.searchParams?.rooms || "1"}`, 100, yPos);
    doc.text(`Adultes: ${request.searchParams?.adults || "1"}`, 150, yPos);

    // Prix total
    yPos += 7;
    doc.setFont(undefined, "bold");
    doc.text("Prix total:", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.text(`${calculateTotalPrice(request)}`, 50, yPos);

    yPos += 15;

    // Détails de la mission
    doc.setFillColor(245, 245, 250);
    doc.rect(15, yPos - 5, 180, 40, "F");
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("DÉTAILS DE LA MISSION", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    yPos += 8;
    doc.text(`Objet du voyage: ${request.objetVoyage || "N/A"}`, 20, yPos);
    yPos += 7;

    // Motif du déplacement (peut être long, donc on le divise en lignes)
    const motifLines = doc.splitTextToSize(
      `Motif: ${request.motifDeplacement || "N/A"}`,
      160
    );
    motifLines.forEach((line) => {
      doc.text(line, 20, yPos);
      yPos += 6;
    });

    yPos += 5;

    if (request.projet) {
      doc.text(`Projet: ${request.projet}`, 20, yPos);
      yPos += 7;
    }

    if (request.centreCoût) {
      doc.text(`Centre de coût: ${request.centreCoût}`, 20, yPos);
      yPos += 7;
    }

    // Informations de paiement si disponibles
    if (request.bookingId) {
      yPos += 10;
      doc.setFillColor(245, 245, 250);
      doc.rect(15, yPos - 5, 180, 25, "F");
      doc.setFont(undefined, "bold");
      doc.setFontSize(12);
      doc.text("INFORMATIONS DE RÉSERVATION", 20, yPos);
      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      yPos += 8;
      doc.text(`ID Réservation: ${request.bookingId}`, 20, yPos);
      yPos += 6;
      doc.text(
        `N° Confirmation: ${request.confirmationNumber || "N/A"}`,
        20,
        yPos
      );
    }

    yPos += 10;

    // Informations importantes
    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.text("INFORMATIONS IMPORTANTES", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(9);
    yPos += 7;

    const infos = [
      "• Cette confirmation doit être présentée à l'hôtel lors du check-in.",
      "• Toute modification est soumise à disponibilité et peut entraîner des frais.",
      "• En cas d'annulation, veuillez contacter ABM Travel Agency immédiatement.",
      "• Les heures de check-in et check-out doivent être respectées selon les règles de l'hôtel.",
      "• Une pièce d'identité valide sera demandée à l'arrivée.",
    ];

    infos.forEach((info) => {
      doc.text(info, 20, yPos);
      yPos += 6;
    });

    // Code de confirmation (code-barres simulé)
    yPos += 10;
    doc.setFillColor(0, 0, 0);
    doc.rect(50, yPos, 110, 15, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(10);
    doc.text(`CONF-${request.numeroRequete || "HOTEL-2024"}`, 105, yPos + 10, {
      align: "center",
    });

    // Pied de page
    doc.setTextColor(0, 0, 0);
    doc.setFillColor(147, 51, 234);
    doc.rect(0, 270, 210, 27, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(8);
    doc.setFont(undefined, "normal");
    doc.text("ABM Travel Agency - Votre partenaire de voyage", 105, 278, {
      align: "center",
    });
    doc.text("Conakry, Guinée", 105, 283, { align: "center" });
    doc.text(
      "contact@abmtravel.com | +225 07 08 83 76 60 | www.abmtravel.com",
      105,
      288,
      { align: "center" }
    );
    doc.text(
      "Document généré électroniquement - Valide sans signature",
      105,
      293,
      { align: "center" }
    );

    // Télécharger le PDF
    doc.save(`Confirmation_Hotel_${request.numeroRequete || "HOTEL"}.pdf`);
  };

  const PaymentModal = ({ isOpen, onClose, onConfirm, request, isLoading }) => {
    const [paymentData, setPaymentData] = useState({
      cardNumber: "",
      expiryDate: "",
      cvv: "",
      cardHolder: "",
      email: "",
      phone: "",
    });

    const handleSubmit = (e) => {
      e.preventDefault();
      onConfirm(paymentData);
    };

    const formatCardNumber = (value) => {
      return value
        .replace(/\s/g, "")
        .replace(/(.{4})/g, "$1 ")
        .trim();
    };

    const handleCardNumberChange = (e) => {
      const value = e.target.value.replace(/\s/g, "");
      if (value.length <= 16) {
        setPaymentData({
          ...paymentData,
          cardNumber: formatCardNumber(value),
        });
      }
    };

    const handleExpiryDateChange = (e) => {
      let value = e.target.value.replace(/\D/g, "");
      if (value.length >= 2) {
        value = value.slice(0, 2) + "/" + value.slice(2, 4);
      }
      setPaymentData({
        ...paymentData,
        expiryDate: value,
      });
    };

    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
          <div className="p-6 border-b flex justify-between items-center">
            <h2 className="text-xl font-semibold">
              Paiement de la réservation
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
              disabled={isLoading}
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            {/* Informations de l'hôtel */}
            <div className="bg-blue-50 p-4 rounded-lg">
              <h3 className="font-semibold text-blue-800 mb-2">
                Détails de l'hôtel
              </h3>
              <p className="text-sm text-blue-700">{request?.hotel?.name}</p>
              <p className="text-sm text-blue-600">
                {request?.searchParams?.checkInDate &&
                  new Date(request.searchParams.checkInDate).toLocaleDateString(
                    "fr-FR"
                  )}{" "}
                -{" "}
                {request?.searchParams?.checkOutDate &&
                  new Date(
                    request.searchParams.checkOutDate
                  ).toLocaleDateString("fr-FR")}
              </p>
              <p className="text-sm text-blue-600">
                {request?.nombreNuits} nuit(s)
              </p>
            </div>

            {/* Informations de la carte */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Numéro de carte
              </label>
              <div className="relative">
                <CreditCard className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <input
                  type="text"
                  placeholder="1234 5678 9012 3456"
                  className="pl-10 w-full p-2 border border-gray-300 rounded-md"
                  value={paymentData.cardNumber}
                  onChange={handleCardNumberChange}
                  maxLength={19}
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Date d'expiration
                </label>
                <div className="relative">
                  <Calendar className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                  <input
                    type="text"
                    placeholder="MM/AA"
                    className="pl-10 w-full p-2 border border-gray-300 rounded-md"
                    value={paymentData.expiryDate}
                    onChange={handleExpiryDateChange}
                    maxLength={5}
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  CVV
                </label>
                <input
                  type="text"
                  placeholder="123"
                  className="w-full p-2 border border-gray-300 rounded-md"
                  value={paymentData.cvv}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      cvv: e.target.value.replace(/\D/g, ""),
                    })
                  }
                  maxLength={4}
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Titulaire de la carte
              </label>
              <div className="relative">
                <User className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <input
                  type="text"
                  placeholder="JEAN DUPONT"
                  className="pl-10 w-full p-2 border border-gray-300 rounded-md uppercase"
                  value={paymentData.cardHolder}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      cardHolder: e.target.value.toUpperCase(),
                    })
                  }
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <input
                  type="email"
                  placeholder="jean.dupont@example.com"
                  className="pl-10 w-full p-2 border border-gray-300 rounded-md"
                  value={paymentData.email}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      email: e.target.value,
                    })
                  }
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Téléphone
              </label>
              <div className="relative">
                <Phone className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <input
                  type="tel"
                  placeholder="+33123456789"
                  className="pl-10 w-full p-2 border border-gray-300 rounded-md"
                  value={paymentData.phone}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      phone: e.target.value,
                    })
                  }
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            {/* Récapitulatif avec prix total */}
            <div className="bg-gray-50 p-4 rounded-md">
              <h3 className="font-semibold mb-2">Récapitulatif</h3>
              <div className="flex justify-between text-sm mb-1">
                <span>Hôtel:</span>
                <span className="font-semibold">{request?.hotel?.name}</span>
              </div>
              <div className="flex justify-between text-sm mb-1">
                <span>Durée:</span>
                <span>{request?.nombreNuits} nuit(s)</span>
              </div>
              <div className="flex justify-between text-sm mb-1">
                <span>Chambres:</span>
                <span>{request?.searchParams?.rooms || "1"}</span>
              </div>
              <div className="flex justify-between text-sm mb-1">
                <span>Adultes:</span>
                <span>{request?.searchParams?.adults || "1"}</span>
              </div>
              <div className="flex justify-between text-sm font-semibold mt-2 pt-2 border-t">
                <span>Total à payer:</span>
                <span className="text-blue-600 text-lg">
                  {calculateTotalPrice(request)}
                </span>
              </div>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 py-2 px-4 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                disabled={isLoading}
              >
                Annuler
              </button>
              <button
                type="submit"
                className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300 flex items-center justify-center"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Traitement...
                  </>
                ) : (
                  `Payer ${calculateTotalPrice(request)}`
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  const getStatusColor = (status) =>
    ({
      "En attente": "bg-yellow-100 text-yellow-700",
      Approuvée: "bg-green-100 text-green-700",
      Rejetée: "bg-red-100 text-red-700",
      Confirmée: "bg-blue-100 text-blue-700",
      Réservée: "bg-purple-100 text-purple-700",
    }[status] || "bg-gray-100 text-gray-700");

  if (loading && requests.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-md p-12 text-center">
        <Loader className="w-12 h-12 text-blue-600 mx-auto mb-4 animate-spin" />
        <p className="text-gray-600">Chargement des demandes...</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold flex items-center">
          <Hotel className="w-6 h-6 mr-2 text-blue-600" />
          Demandes de réservation d'hôtel
        </h2>
        <div className="flex space-x-3">
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-4 py-2 border rounded-lg"
          >
            <option value="all">Tous les statuts</option>
            <option value="En attente">En attente</option>
            <option value="Approuvée">Approuvée</option>
            <option value="Rejetée">Rejetée</option>
            <option value="Confirmée">Confirmée</option>
            <option value="Réservée">Réservée</option>
          </select>
          <button
            onClick={loadRequests}
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
          >
            {loading ? (
              <>
                <Loader className="w-4 h-4 mr-2 animate-spin" />
                Actualisation...
              </>
            ) : (
              <>
                <Download className="w-4 h-4 mr-2" />
                Actualiser
              </>
            )}
          </button>
        </div>
      </div>

      {error && (
        <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-600 font-semibold">{error}</p>
          <button
            onClick={loadRequests}
            className="mt-2 text-sm text-red-700 underline"
          >
            Réessayer
          </button>
        </div>
      )}

      {requests.length === 0 ? (
        <div className="text-center py-12">
          <Hotel className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500 text-lg">
            {filterStatus === "all"
              ? "Aucune demande de réservation d'hôtel"
              : `Aucune demande avec le statut "${filterStatus}"`}
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {requests.map((request) => (
            <div
              key={request.id}
              className="border rounded-lg p-6 hover:shadow-lg transition"
            >
              <div className="flex justify-between mb-4">
                <div>
                  <div className="flex items-center space-x-3 mb-2">
                    <h3 className="text-lg font-bold">
                      N° {request.numeroRequete}
                    </h3>
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(
                        request.statut
                      )}`}
                    >
                      {request.statut}
                    </span>
                  </div>
                  <p className="text-sm text-gray-500">
                    Créée le{" "}
                    {new Date(request.createdAt).toLocaleDateString("fr-FR")}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-600">Nombre de nuits</p>
                  <p className="text-2xl font-bold text-blue-600">
                    {request.nombreNuits}
                  </p>
                  <p className="text-lg font-semibold text-green-600 mt-1">
                    {calculateTotalPrice(request)}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4 text-sm">
                <div>
                  <p className="text-gray-500 font-semibold">Demandeur</p>
                  <p>
                    {request.prenom} {request.nom}
                  </p>
                  <p className="text-xs text-gray-600">{request.matricule}</p>
                </div>
                <div>
                  <p className="text-gray-500 font-semibold">Hôtel</p>
                  <p>{request.hotel?.name}</p>
                  <p className="text-xs text-gray-600">
                    {request.searchParams?.cityCode}
                  </p>
                </div>
                <div>
                  <p className="text-gray-500 font-semibold">Dates</p>
                  <p>
                    {request.searchParams?.checkInDate &&
                      new Date(
                        request.searchParams.checkInDate
                      ).toLocaleDateString("fr-FR")}
                  </p>
                  <p className="text-xs text-gray-600">
                    →{" "}
                    {request.searchParams?.checkOutDate &&
                      new Date(
                        request.searchParams.checkOutDate
                      ).toLocaleDateString("fr-FR")}
                  </p>
                </div>
                <div>
                  <p className="text-gray-500 font-semibold">Prix total</p>
                  <p className="font-semibold text-green-600">
                    {calculateTotalPrice(request)}
                  </p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-3 mb-4">
                <p className="text-sm">
                  <span className="font-semibold">Motif:</span>{" "}
                  {request.motifDeplacement}
                </p>
                {request.preferencesSpeciales && (
                  <p className="text-sm mt-2">
                    <span className="font-semibold">Préférences:</span>{" "}
                    {request.preferencesSpeciales}
                  </p>
                )}
                {request.bookingId && (
                  <p className="text-sm mt-2">
                    <span className="font-semibold">ID Réservation:</span>{" "}
                    {request.bookingId}
                  </p>
                )}
                {request.confirmationNumber && (
                  <p className="text-sm mt-2">
                    <span className="font-semibold">N° Confirmation:</span>{" "}
                    {request.confirmationNumber}
                  </p>
                )}
              </div>

              <div className="flex flex-wrap gap-3">
                {request.statut === "En attente" && (
                  <>
                    <button
                      onClick={() => handleApprove(request.id)}
                      className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center"
                    >
                      <CheckCircle className="w-4 h-4 mr-2" />
                      Approuver
                    </button>
                    <button
                      onClick={() => handleReject(request.id)}
                      className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center"
                    >
                      <X className="w-4 h-4 mr-2" />
                      Rejeter
                    </button>
                  </>
                )}
                {request.statut === "Approuvée" && (
                  <button
                    onClick={() => handleBook(request)}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
                  >
                    <CreditCard className="w-4 h-4 mr-2" />
                    Payer {calculateTotalPrice(request)}
                  </button>
                )}
                {(request.statut === "Confirmée" ||
                  request.statut === "Réservée") && (
                  <button
                    onClick={() => handleDownloadConfirmation(request)}
                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                  >
                    <Eye className="w-4 h-4 mr-2" />
                    Voir confirmation
                  </button>
                )}
                <button
                  onClick={() => handleDelete(request.id)}
                  className="px-4 py-2 border border-red-300 text-red-600 rounded-lg hover:bg-red-50 flex items-center"
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Supprimer
                </button>
                <button className="px-4 py-2 border rounded-lg hover:bg-gray-50">
                  Détails
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal de paiement */}
      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        onConfirm={handlePaymentConfirm}
        request={selectedRequest}
        isLoading={isProcessing}
      />
    </div>
  );
};

const HotelRequestsList = ({ onRefresh }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedDetailRequest, setSelectedDetailRequest] = useState(null);

  useEffect(() => {
    loadRequests();
  }, [filterStatus]);

  const loadRequests = async () => {
    setLoading(true);
    setError(null);
    try {
      let data;
      if (filterStatus === "all") {
        data = await hotelRequestsService.getAll();
      } else {
        data = await hotelRequestsService.getByStatus(filterStatus);
      }
      setRequests(data);
    } catch (error) {
      console.error("Erreur chargement demandes:", error);
      setError("Erreur lors du chargement des demandes: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    confirmToast(
        "Êtes-vous sûr de vouloir approuver cette demande ?",
        () => {},
        () => {
          toast.info("Action annulée.");
          return;
        }
      );
    
    try {
      await hotelRequestsService.approve(id);
      toast.success("Demande approuvée avec succès !");
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
      toast.error(`Erreur: ${error.message}`);
    }
  };

  const handleReject = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir rejeter cette demande ?"))
      return;

    try {
      await hotelRequestsService.reject(id);
      alert("Demande rejetée");
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    }
  };

  const handleBook = async (request) => {
    
    confirmToast(
        "Confirmer la réservation de cet hôtel ?",
        async () => {
          setSelectedRequest(request);
    setShowPaymentModal(true);
        },
        () => {
          toast.info("Action annulée.");
          return;
        }
      );
    

  };

  const handlePaymentConfirm = async (paymentData) => {
    setIsProcessing(true);
    try {
      // Appeler le service avec la requête complète et les données de paiement
      await hotelRequestsService.confirmBooking(selectedRequest, paymentData);
      alert("Réservation confirmée avec succès !");
      setShowPaymentModal(false);
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
      console.error("❌ Erreur lors de la confirmation:", error);
      alert(`Erreur: ${error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer cette demande ?"))
      return;

    try {
      await hotelRequestsService.delete(id);
      alert("Demande supprimée avec succès !");
      await loadRequests();
      onRefresh && onRefresh();
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    }
  };

  const handleDetails = (request) => {
    setSelectedDetailRequest(request);
    setShowDetailsModal(true);
  };

  // Fonction pour calculer le prix total depuis la structure hotel.offers
  const calculateTotalPrice = (request) => {
    try {
      // Vérifier si la structure existe et a le prix
      if (request?.hotel?.offers?.[0]?.price?.total) {
        return request.hotel.offers[0].price.total + " €";
      }

      // Fallback: si le prix total est directement dans la requête
      if (request.totalPrice) {
        return request.totalPrice + " €";
      }

      // Fallback: calcul basé sur le prix de base et le nombre de nuits
      if (request?.hotel?.offers?.[0]?.price?.base && request.nombreNuits) {
        const basePrice = parseFloat(request.hotel.offers[0].price.base);
        const total = basePrice * parseInt(request.nombreNuits);
        return total.toFixed(2) + " €";
      }

      return "N/A";
    } catch (error) {
      console.error("Erreur calcul prix:", error);
      return "N/A";
    }
  };

  // Fonction pour obtenir juste la valeur numérique du prix (sans le symbole €)
  const getNumericPrice = (request) => {
    try {
      if (request?.hotel?.offers?.[0]?.price?.total) {
        return request.hotel.offers[0].price.total;
      }
      return null;
    } catch (error) {
      return null;
    }
  };

  // Fonction pour générer et télécharger le PDF de confirmation de réservation
  const handleDownloadConfirmation = (request) => {
    const doc = new jsPDF();

    // En-tête avec design moderne
    doc.setFillColor(147, 51, 234); // Couleur violet pour les hôtels
    doc.rect(0, 0, 210, 45, "F");

    // Titre principal
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(24);
    doc.text("CONFIRMATION DE RÉSERVATION", 105, 20, { align: "center" });
    doc.setFontSize(14);
    doc.text("HÔTEL", 105, 30, { align: "center" });
    doc.setFontSize(11);
    doc.text(`N° ${request.numeroRequete}`, 105, 38, { align: "center" });

    // Logo et informations de l'agence
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    let yPos = 55;
    doc.setFont(undefined, "bold");
    doc.text("ABM Travel Agency", 20, yPos);
    doc.setFont(undefined, "normal");
    yPos += 5;
    doc.text("Abidjan, Côte d'Ivoire", 20, yPos);
    yPos += 5;
    doc.text("contact@abmtravel.com", 20, yPos);
    yPos += 5;
    doc.text("+225 07 08 83 60", 20, yPos);

    // Date de confirmation
    yPos = 55;
    doc.setFont(undefined, "bold");
    doc.text("Date de confirmation:", 190, yPos, { align: "right" });
    doc.setFont(undefined, "normal");
    yPos += 5;
    doc.text(new Date().toLocaleDateString("fr-FR"), 190, yPos, {
      align: "right",
    });

    yPos = 85;

    // Informations du voyageur
    doc.setFillColor(245, 245, 250); // Fond gris clair
    doc.rect(15, yPos - 5, 180, 35, "F");
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("INFORMATIONS DU VOYAGEUR", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    yPos += 8;
    doc.text(
      `Nom complet: ${request.prenom || "N/A"} ${
        request.nom?.toUpperCase() || "N/A"
      }`,
      20,
      yPos
    );
    yPos += 7;
    doc.text(`Matricule: ${request.matricule || "N/A"}`, 20, yPos);
    doc.text(`Fonction: ${request.fonction || "N/A"}`, 100, yPos);
    yPos += 7;
    doc.text(`Email: ${request.email || "contact@abmtravel.com"}`, 20, yPos);
    doc.text(
      `Téléphone: ${request.telephone || "+225 07 08 83 76 60"}`,
      100,
      yPos
    );

    yPos += 15;

    // Détails de l'hôtel
    doc.setFillColor(245, 245, 250);
    doc.rect(15, yPos - 5, 180, 50, "F");
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("DÉTAILS DE LA RÉSERVATION", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    yPos += 8;

    // Nom de l'hôtel en grand
    doc.setFont(undefined, "bold");
    doc.setFontSize(14);
    doc.setTextColor(147, 51, 234); // Violet
    doc.text(request.hotel?.name || "Hôtel réservé", 20, yPos);
    doc.setTextColor(0, 0, 0);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    yPos += 8;

    // Détails de la réservation
    doc.text(`Ville: ${request.searchParams?.cityCode || "N/A"}`, 20, yPos);
    if (request.hotel?.address?.cityName) {
      doc.text(` - ${request.hotel.address.cityName}`, 50, yPos);
    }
    yPos += 7;

    // Dates avec mise en forme améliorée
    const checkInDate = request.searchParams?.checkInDate
      ? new Date(request.searchParams.checkInDate).toLocaleDateString("fr-FR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      : "N/A";

    const checkOutDate = request.searchParams?.checkOutDate
      ? new Date(request.searchParams.checkOutDate).toLocaleDateString(
          "fr-FR",
          {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          }
        )
      : "N/A";

    doc.setFont(undefined, "bold");
    doc.text("Check-in:", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.text(checkInDate, 45, yPos);
    yPos += 7;

    doc.setFont(undefined, "bold");
    doc.text("Check-out:", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.text(checkOutDate, 45, yPos);
    yPos += 7;

    // Nombre de nuits et chambres
    doc.text(
      `Durée du séjour: ${request.nombreNuits || "N/A"} nuit(s)`,
      20,
      yPos
    );
    doc.text(`Chambres: ${request.searchParams?.rooms || "1"}`, 100, yPos);
    doc.text(`Adultes: ${request.searchParams?.adults || "1"}`, 150, yPos);

    // Prix total
    yPos += 7;
    doc.setFont(undefined, "bold");
    doc.text("Prix total:", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.text(`${calculateTotalPrice(request)}`, 50, yPos);

    yPos += 15;

    // Détails de la mission
    doc.setFillColor(245, 245, 250);
    doc.rect(15, yPos - 5, 180, 40, "F");
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("DÉTAILS DE LA MISSION", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    yPos += 8;
    doc.text(`Objet du voyage: ${request.objetVoyage || "N/A"}`, 20, yPos);
    yPos += 7;

    // Motif du déplacement (peut être long, donc on le divise en lignes)
    const motifLines = doc.splitTextToSize(
      `Motif: ${request.motifDeplacement || "N/A"}`,
      160
    );
    motifLines.forEach((line) => {
      doc.text(line, 20, yPos);
      yPos += 6;
    });

    yPos += 5;

    if (request.projet) {
      doc.text(`Projet: ${request.projet}`, 20, yPos);
      yPos += 7;
    }

    if (request.centreCoût) {
      doc.text(`Centre de coût: ${request.centreCoût}`, 20, yPos);
      yPos += 7;
    }

    // Informations de paiement si disponibles
    if (request.bookingId) {
      yPos += 10;
      doc.setFillColor(245, 245, 250);
      doc.rect(15, yPos - 5, 180, 25, "F");
      doc.setFont(undefined, "bold");
      doc.setFontSize(12);
      doc.text("INFORMATIONS DE RÉSERVATION", 20, yPos);
      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      yPos += 8;
      doc.text(`ID Réservation: ${request.bookingId}`, 20, yPos);
      yPos += 6;
      doc.text(
        `N° Confirmation: ${request.confirmationNumber || "N/A"}`,
        20,
        yPos
      );
    }

    yPos += 10;

    // Informations importantes
    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.text("INFORMATIONS IMPORTANTES", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(9);
    yPos += 7;

    const infos = [
      "• Cette confirmation doit être présentée à l'hôtel lors du check-in.",
      "• Toute modification est soumise à disponibilité et peut entraîner des frais.",
      "• En cas d'annulation, veuillez contacter ABM Travel Agency immédiatement.",
      "• Les heures de check-in et check-out doivent être respectées selon les règles de l'hôtel.",
      "• Une pièce d'identité valide sera demandée à l'arrivée.",
    ];

    infos.forEach((info) => {
      doc.text(info, 20, yPos);
      yPos += 6;
    });

    // Code de confirmation (code-barres simulé)
    yPos += 10;
    doc.setFillColor(0, 0, 0);
    doc.rect(50, yPos, 110, 15, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(10);
    doc.text(`CONF-${request.numeroRequete || "HOTEL-2024"}`, 105, yPos + 10, {
      align: "center",
    });

    // Pied de page
    doc.setTextColor(0, 0, 0);
    doc.setFillColor(147, 51, 234);
    doc.rect(0, 270, 210, 27, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(8);
    doc.setFont(undefined, "normal");
    doc.text("ABM Travel Agency - Votre partenaire de voyage", 105, 278, {
      align: "center",
    });
    doc.text("Conakry, Guinée", 105, 283, { align: "center" });
    doc.text(
      "contact@abmtravel.com | +225 07 08 83 76 60 | www.abmtravel.com",
      105,
      288,
      { align: "center" }
    );
    doc.text(
      "Document généré électroniquement - Valide sans signature",
      105,
      293,
      { align: "center" }
    );

    // Télécharger le PDF
    doc.save(`Confirmation_Hotel_${request.numeroRequete || "HOTEL"}.pdf`);
  };

  const PaymentModal = ({ isOpen, onClose, onConfirm, request, isLoading }) => {
    const [paymentData, setPaymentData] = useState({
      cardNumber: "",
      expiryDate: "",
      cvv: "",
      cardHolder: "",
      email: "",
      phone: "",
    });

    const handleSubmit = (e) => {
      e.preventDefault();
      onConfirm(paymentData);
    };

    const formatCardNumber = (value) => {
      return value
        .replace(/\s/g, "")
        .replace(/(.{4})/g, "$1 ")
        .trim();
    };

    const handleCardNumberChange = (e) => {
      const value = e.target.value.replace(/\s/g, "");
      if (value.length <= 16) {
        setPaymentData({
          ...paymentData,
          cardNumber: formatCardNumber(value),
        });
      }
    };

    const handleExpiryDateChange = (e) => {
      let value = e.target.value.replace(/\D/g, "");
      if (value.length >= 2) {
        value = value.slice(0, 2) + "/" + value.slice(2, 4);
      }
      setPaymentData({
        ...paymentData,
        expiryDate: value,
      });
    };

    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
          <div className="p-6 border-b flex justify-between items-center">
            <h2 className="text-xl font-semibold">
              Paiement de la réservation
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
              disabled={isLoading}
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            {/* Informations de l'hôtel */}
            <div className="bg-blue-50 p-4 rounded-lg">
              <h3 className="font-semibold text-blue-800 mb-2">
                Détails de l'hôtel
              </h3>
              <p className="text-sm text-blue-700">{request?.hotel?.name}</p>
              <p className="text-sm text-blue-600">
                {request?.searchParams?.checkInDate &&
                  new Date(request.searchParams.checkInDate).toLocaleDateString(
                    "fr-FR"
                  )}{" "}
                -{" "}
                {request?.searchParams?.checkOutDate &&
                  new Date(
                    request.searchParams.checkOutDate
                  ).toLocaleDateString("fr-FR")}
              </p>
              <p className="text-sm text-blue-600">
                {request?.nombreNuits} nuit(s)
              </p>
            </div>

            {/* Informations de la carte */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Numéro de carte
              </label>
              <div className="relative">
                <CreditCard className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <input
                  type="text"
                  placeholder="1234 5678 9012 3456"
                  className="pl-10 w-full p-2 border border-gray-300 rounded-md"
                  value={paymentData.cardNumber}
                  onChange={handleCardNumberChange}
                  maxLength={19}
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Date d'expiration
                </label>
                <div className="relative">
                  <Calendar className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                  <input
                    type="text"
                    placeholder="MM/AA"
                    className="pl-10 w-full p-2 border border-gray-300 rounded-md"
                    value={paymentData.expiryDate}
                    onChange={handleExpiryDateChange}
                    maxLength={5}
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  CVV
                </label>
                <input
                  type="text"
                  placeholder="123"
                  className="w-full p-2 border border-gray-300 rounded-md"
                  value={paymentData.cvv}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      cvv: e.target.value.replace(/\D/g, ""),
                    })
                  }
                  maxLength={4}
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Titulaire de la carte
              </label>
              <div className="relative">
                <User className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <input
                  type="text"
                  placeholder="JEAN DUPONT"
                  className="pl-10 w-full p-2 border border-gray-300 rounded-md uppercase"
                  value={paymentData.cardHolder}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      cardHolder: e.target.value.toUpperCase(),
                    })
                  }
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <input
                  type="email"
                  placeholder="jean.dupont@example.com"
                  className="pl-10 w-full p-2 border border-gray-300 rounded-md"
                  value={paymentData.email}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      email: e.target.value,
                    })
                  }
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Téléphone
              </label>
              <div className="relative">
                <Phone className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <input
                  type="tel"
                  placeholder="+33123456789"
                  className="pl-10 w-full p-2 border border-gray-300 rounded-md"
                  value={paymentData.phone}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      phone: e.target.value,
                    })
                  }
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            {/* Récapitulatif avec prix total */}
            <div className="bg-gray-50 p-4 rounded-md">
              <h3 className="font-semibold mb-2">Récapitulatif</h3>
              <div className="flex justify-between text-sm mb-1">
                <span>Hôtel:</span>
                <span className="font-semibold">{request?.hotel?.name}</span>
              </div>
              <div className="flex justify-between text-sm mb-1">
                <span>Durée:</span>
                <span>{request?.nombreNuits} nuit(s)</span>
              </div>
              <div className="flex justify-between text-sm mb-1">
                <span>Chambres:</span>
                <span>{request?.searchParams?.rooms || "1"}</span>
              </div>
              <div className="flex justify-between text-sm mb-1">
                <span>Adultes:</span>
                <span>{request?.searchParams?.adults || "1"}</span>
              </div>
              <div className="flex justify-between text-sm font-semibold mt-2 pt-2 border-t">
                <span>Total à payer:</span>
                <span className="text-blue-600 text-lg">
                  {calculateTotalPrice(request)}
                </span>
              </div>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 py-2 px-4 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                disabled={isLoading}
              >
                Annuler
              </button>
              <button
                type="submit"
                className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300 flex items-center justify-center"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Traitement...
                  </>
                ) : (
                  `Payer ${calculateTotalPrice(request)}`
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  const DetailsModal = ({ isOpen, onClose, request }) => {
    if (!isOpen || !request) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
          <div className="p-6 border-b flex justify-between items-center">
            <h2 className="text-xl font-semibold">Détails de la demande</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="p-6 space-y-6">
            {/* Informations générales */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <Info className="w-4 h-4 mr-2" />
                  Informations générales
                </h3>
                <div className="space-y-2 text-sm">
                  <p>
                    <span className="font-medium">N° Demande:</span>{" "}
                    {request.numeroRequete}
                  </p>
                  <p>
                    <span className="font-medium">Statut:</span>
                    <span
                      className={`ml-2 px-2 py-1 rounded-full text-xs font-semibold ${getStatusColor(
                        request.statut
                      )}`}
                    >
                      {request.statut}
                    </span>
                  </p>
                  <p>
                    <span className="font-medium">Date création:</span>{" "}
                    {new Date(request.createdAt).toLocaleDateString("fr-FR")}
                  </p>
                  {request.dateConfirmation && (
                    <p>
                      <span className="font-medium">Date confirmation:</span>{" "}
                      {new Date(request.dateConfirmation).toLocaleDateString(
                        "fr-FR"
                      )}
                    </p>
                  )}
                </div>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <User className="w-4 h-4 mr-2" />
                  Informations du voyageur
                </h3>
                <div className="space-y-2 text-sm">
                  <p>
                    <span className="font-medium">Nom complet:</span>{" "}
                    {request.prenom} {request.nom}
                  </p>
                  <p>
                    <span className="font-medium">Matricule:</span>{" "}
                    {request.matricule}
                  </p>
                  <p>
                    <span className="font-medium">Fonction:</span>{" "}
                    {request.fonction}
                  </p>
                  <p>
                    <span className="font-medium">Email:</span> {request.email}
                  </p>
                  <p>
                    <span className="font-medium">Téléphone:</span>{" "}
                    {request.telephone}
                  </p>
                </div>
              </div>
            </div>

            {/* Détails de la mission */}
            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="font-semibold text-gray-800 mb-3 flex items-center">
                <Hotel className="w-4 h-4 mr-2" />
                Détails de la mission
              </h3>
              <div className="space-y-2 text-sm">
                <p>
                  <span className="font-medium">Objet du voyage:</span>{" "}
                  {request.objetVoyage}
                </p>
                <p>
                  <span className="font-medium">Motif du déplacement:</span>{" "}
                  {request.motifDeplacement}
                </p>
                {request.projet && (
                  <p>
                    <span className="font-medium">Projet:</span>{" "}
                    {request.projet}
                  </p>
                )}
                {request.centreCoût && (
                  <p>
                    <span className="font-medium">Centre de coût:</span>{" "}
                    {request.centreCoût}
                  </p>
                )}
                {request.preferencesSpeciales && (
                  <p>
                    <span className="font-medium">Préférences spéciales:</span>{" "}
                    {request.preferencesSpeciales}
                  </p>
                )}
              </div>
            </div>

            {/* Détails de l'hôtel */}
            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="font-semibold text-gray-800 mb-3 flex items-center">
                <Hotel className="w-4 h-4 mr-2" />
                Détails de l'hôtel
              </h3>
              <div className="space-y-2 text-sm">
                <p>
                  <span className="font-medium">Hôtel:</span>{" "}
                  {request.hotel?.name}
                </p>
                <p>
                  <span className="font-medium">Ville:</span>{" "}
                  {request.searchParams?.cityCode}
                </p>
                {request.hotel?.address?.cityName && (
                  <p>
                    <span className="font-medium">Adresse:</span>{" "}
                    {request.hotel.address.cityName}
                  </p>
                )}
                <p>
                  <span className="font-medium">Check-in:</span>{" "}
                  {request.searchParams?.checkInDate &&
                    new Date(
                      request.searchParams.checkInDate
                    ).toLocaleDateString("fr-FR")}
                </p>
                <p>
                  <span className="font-medium">Check-out:</span>{" "}
                  {request.searchParams?.checkOutDate &&
                    new Date(
                      request.searchParams.checkOutDate
                    ).toLocaleDateString("fr-FR")}
                </p>
                <p>
                  <span className="font-medium">Nombre de nuits:</span>{" "}
                  {request.nombreNuits}
                </p>
                <p>
                  <span className="font-medium">Chambres:</span>{" "}
                  {request.searchParams?.rooms || "1"}
                </p>
                <p>
                  <span className="font-medium">Adultes:</span>{" "}
                  {request.searchParams?.adults || "1"}
                </p>
                <p>
                  <span className="font-medium">Prix total:</span>{" "}
                  {calculateTotalPrice(request)}
                </p>
              </div>
            </div>

            {/* Informations de réservation si disponibles */}
            {(request.bookingId || request.confirmationNumber) && (
              <div className="bg-green-50 p-4 rounded-lg">
                <h3 className="font-semibold text-green-800 mb-3 flex items-center">
                  <CheckCircle className="w-4 h-4 mr-2" />
                  Informations de réservation
                </h3>
                <div className="space-y-2 text-sm">
                  {request.bookingId && (
                    <p>
                      <span className="font-medium">ID Réservation:</span>{" "}
                      {request.bookingId}
                    </p>
                  )}
                  {request.confirmationNumber && (
                    <p>
                      <span className="font-medium">N° Confirmation:</span>{" "}
                      {request.confirmationNumber}
                    </p>
                  )}
                </div>
              </div>
            )}

            {/* Boutons d'action */}
            <div className="flex justify-end gap-3 pt-4">
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
              >
                Fermer
              </button>
              {(request.statut === "Confirmée" ||
                request.statut === "Réservée") && (
                <button
                  onClick={() => {
                    handleDownloadConfirmation(request);
                    onClose();
                  }}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                >
                  <Download className="w-4 h-4 mr-2" />
                  Télécharger PDF
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getStatusColor = (status) =>
    ({
      "En attente": "bg-yellow-100 text-yellow-700",
      Approuvée: "bg-green-100 text-green-700",
      Rejetée: "bg-red-100 text-red-700",
      Confirmée: "bg-blue-100 text-blue-700",
      Réservée: "bg-purple-100 text-purple-700",
    }[status] || "bg-gray-100 text-gray-700");

  if (loading && requests.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-md p-12 text-center">
        <Loader className="w-12 h-12 text-blue-600 mx-auto mb-4 animate-spin" />
        <p className="text-gray-600">Chargement des demandes...</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold flex items-center">
          <Hotel className="w-6 h-6 mr-2 text-blue-600" />
          Demandes de réservation d'hôtel
        </h2>
        <div className="flex space-x-3">
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-4 py-2 border rounded-lg"
          >
            <option value="all">Tous les statuts</option>
            <option value="En attente">En attente</option>
            <option value="Approuvée">Approuvée</option>
            <option value="Rejetée">Rejetée</option>
            <option value="Confirmée">Confirmée</option>
            <option value="Réservée">Réservée</option>
          </select>
          <button
            onClick={loadRequests}
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
          >
            {loading ? (
              <>
                <Loader className="w-4 h-4 mr-2 animate-spin" />
                Actualisation...
              </>
            ) : (
              <>
                <Download className="w-4 h-4 mr-2" />
                Actualiser
              </>
            )}
          </button>
        </div>
      </div>

      {error && (
        <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-600 font-semibold">{error}</p>
          <button
            onClick={loadRequests}
            className="mt-2 text-sm text-red-700 underline"
          >
            Réessayer
          </button>
        </div>
      )}

      {requests.length === 0 ? (
        <div className="text-center py-12">
          <Hotel className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500 text-lg">
            {filterStatus === "all"
              ? "Aucune demande de réservation d'hôtel"
              : `Aucune demande avec le statut "${filterStatus}"`}
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {requests.map((request) => (
            <div
              key={request.id}
              className="border rounded-lg p-6 hover:shadow-lg transition"
            >
              <div className="flex justify-between mb-4">
                <div>
                  <div className="flex items-center space-x-3 mb-2">
                    <h3 className="text-lg font-bold">
                      N° {request.numeroRequete}
                    </h3>
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(
                        request.statut
                      )}`}
                    >
                      {request.statut}
                    </span>
                  </div>
                  <p className="text-sm text-gray-500">
                    Créée le{" "}
                    {new Date(request.createdAt).toLocaleDateString("fr-FR")}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-600">Nombre de nuits</p>
                  <p className="text-2xl font-bold text-blue-600">
                    {request.nombreNuits}
                  </p>
                  <p className="text-lg font-semibold text-green-600 mt-1">
                    {calculateTotalPrice(request)}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4 text-sm">
                <div>
                  <p className="text-gray-500 font-semibold">Demandeur</p>
                  <p>
                    {request.prenom} {request.nom}
                  </p>
                  <p className="text-xs text-gray-600">{request.matricule}</p>
                </div>
                <div>
                  <p className="text-gray-500 font-semibold">Hôtel</p>
                  <p>{request.hotel?.name}</p>
                  <p className="text-xs text-gray-600">
                    {request.searchParams?.cityCode}
                  </p>
                </div>
                <div>
                  <p className="text-gray-500 font-semibold">Dates</p>
                  <p>
                    {request.searchParams?.checkInDate &&
                      new Date(
                        request.searchParams.checkInDate
                      ).toLocaleDateString("fr-FR")}
                  </p>
                  <p className="text-xs text-gray-600">
                    →{" "}
                    {request.searchParams?.checkOutDate &&
                      new Date(
                        request.searchParams.checkOutDate
                      ).toLocaleDateString("fr-FR")}
                  </p>
                </div>
                <div>
                  <p className="text-gray-500 font-semibold">Prix total</p>
                  <p className="font-semibold text-green-600">
                    {calculateTotalPrice(request)}
                  </p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-3 mb-4">
                <p className="text-sm">
                  <span className="font-semibold">Motif:</span>{" "}
                  {request.motifDeplacement}
                </p>
                {request.preferencesSpeciales && (
                  <p className="text-sm mt-2">
                    <span className="font-semibold">Préférences:</span>{" "}
                    {request.preferencesSpeciales}
                  </p>
                )}
                {request.bookingId && (
                  <p className="text-sm mt-2">
                    <span className="font-semibold">ID Réservation:</span>{" "}
                    {request.bookingId}
                  </p>
                )}
                {request.confirmationNumber && (
                  <p className="text-sm mt-2">
                    <span className="font-semibold">N° Confirmation:</span>{" "}
                    {request.confirmationNumber}
                  </p>
                )}
              </div>

              <div className="flex flex-wrap gap-3">
                {request.statut === "En attente" && (
                  <>
                    <button
                      onClick={() => handleApprove(request.id)}
                      className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center"
                    >
                      <CheckCircle className="w-4 h-4 mr-2" />
                      Approuver
                    </button>
                    <button
                      onClick={() => handleReject(request.id)}
                      className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center"
                    >
                      <X className="w-4 h-4 mr-2" />
                      Rejeter
                    </button>
                  </>
                )}
                {request.statut === "Approuvée" && (
                  <button
                    onClick={() => handleBook(request)}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
                  >
                    <CreditCard className="w-4 h-4 mr-2" />
                    Payer {calculateTotalPrice(request)}
                  </button>
                )}
                {(request.statut === "Confirmée" ||
                  request.statut === "Réservée") && (
                  <button
                    onClick={() => handleDownloadConfirmation(request)}
                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                  >
                    <Eye className="w-4 h-4 mr-2" />
                    Voir confirmation
                  </button>
                )}
                <button
                  onClick={() => handleDelete(request.id)}
                  className="px-4 py-2 border border-red-300 text-red-600 rounded-lg hover:bg-red-50 flex items-center"
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Supprimer
                </button>
                <button
                  onClick={() => handleDetails(request)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center"
                >
                  <Info className="w-4 h-4 mr-2" />
                  Détails
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal de paiement */}
      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        onConfirm={handlePaymentConfirm}
        request={selectedRequest}
        isLoading={isProcessing}
      />

      {/* Modal de détails */}
      <DetailsModal
        isOpen={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        request={selectedDetailRequest}
      />
    </div>
  );
};

// ==================== SERVICES API STATISTIQUES ====================

const statisticsService = {
  // Statistiques globales
  getGlobalStats: async () => {
    const response = await fetch(`${API_BASE_URL2}/statistics/global`);
    if (!response.ok) throw new Error("Erreur récupération statistiques");
    return await response.json();
  },

  // Statistiques par période
  getStatsByPeriod: async (startDate, endDate) => {
    const response = await fetch(
      `${API_BASE_URL}/statistics/period?start=${startDate}&end=${endDate}`
    );
    if (!response.ok)
      throw new Error("Erreur récupération statistiques par période");
    return await response.json();
  },

  // Statistiques des vols
  getFlightStats: async (filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await fetch(
      `${API_BASE_URL2}/statistics/flights?${queryParams}`
    );
    if (!response.ok) throw new Error("Erreur récupération statistiques vols");
    return await response.json();
  },

  // Statistiques des hôtels
  getHotelStats: async (filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await fetch(
      `${API_BASE_URL2}/statistics/hotels?${queryParams}`
    );
    if (!response.ok)
      throw new Error("Erreur récupération statistiques hôtels");
    return await response.json();
  },

  // Statistiques de facturation
  getBillingStats: async (filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await fetch(
      `${API_BASE_URL2}/statistics/billing?${queryParams}`
    );
    if (!response.ok)
      throw new Error("Erreur récupération statistiques facturation");
    return await response.json();
  },

  // Rapport détaillé
  getDetailedReport: async (type, filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await fetch(
      `${API_BASE_URL2}/statistics/report/${type}?${queryParams}`
    );
    if (!response.ok) throw new Error("Erreur récupération rapport");
    return await response.json();
  },

  // Export Excel
  exportToExcel: async (type, filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await fetch(
      `${API_BASE_URL2}/statistics/export/excel/${type}?${queryParams}`
    );
    if (!response.ok) throw new Error("Erreur export Excel");
    return await response.blob();
  },

  // Export PDF
  exportToPDF: async (type, filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await fetch(
      `${API_BASE_URL2}/statistics/export/pdf/${type}?${queryParams}`
    );
    if (!response.ok) throw new Error("Erreur export PDF");
    return await response.blob();
  },

  // Export CSV
  exportToCSV: async (type, filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await fetch(
      `${API_BASE_URL2}/statistics/export/csv/${type}?${queryParams}`
    );
    if (!response.ok) throw new Error("Erreur export CSV");
    return await response.blob();
  },
};

// ==================== COMPOSANT FILTRES DE RECHERCHE ====================

const StatisticsFilters = ({ onFilter, loading }) => {
  const [filters, setFilters] = useState({
    startDate: new Date(new Date().getFullYear(), 0, 1)
      .toISOString()
      .split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    type: "all",
    statut: "all",
    agentId: "",
    entiteId: "",
    minAmount: "",
    maxAmount: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilter(filters);
  };

  const handleReset = () => {
    const defaultFilters = {
      startDate: new Date(new Date().getFullYear(), 0, 1)
        .toISOString()
        .split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
      type: "all",
      statut: "all",
      agentId: "",
      entiteId: "",
      minAmount: "",
      maxAmount: "",
    };
    setFilters(defaultFilters);
    onFilter(defaultFilters);
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-lg font-bold mb-4 flex items-center">
        <Search className="w-5 h-5 mr-2 text-blue-600" />
        Critères de recherche
      </h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-semibold mb-2">
              Date début
            </label>
            <input
              type="date"
              value={filters.startDate}
              onChange={(e) =>
                setFilters({ ...filters, startDate: e.target.value })
              }
              className="w-full px-4 py-2 border rounded-lg"
              disabled={loading}
            />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2">Date fin</label>
            <input
              type="date"
              value={filters.endDate}
              onChange={(e) =>
                setFilters({ ...filters, endDate: e.target.value })
              }
              className="w-full px-4 py-2 border rounded-lg"
              disabled={loading}
            />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2">Type</label>
            <select
              value={filters.type}
              onChange={(e) => setFilters({ ...filters, type: e.target.value })}
              className="w-full px-4 py-2 border rounded-lg"
              disabled={loading}
            >
              <option value="all">Tous</option>
              <option value="flights">Vols uniquement</option>
              <option value="hotels">Hôtels uniquement</option>
              <option value="billing">Facturation uniquement</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2">Statut</label>
            <select
              value={filters.statut}
              onChange={(e) =>
                setFilters({ ...filters, statut: e.target.value })
              }
              className="w-full px-4 py-2 border rounded-lg"
              disabled={loading}
            >
              <option value="all">Tous</option>
              <option value="En attente">En attente</option>
              <option value="Approuvée">Approuvée</option>
              <option value="Rejetée">Rejetée</option>
              <option value="Billet émis">Billet émis</option>
              <option value="Réservée">Réservée</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2">
              Montant min (EUR)
            </label>
            <input
              type="number"
              value={filters.minAmount}
              onChange={(e) =>
                setFilters({ ...filters, minAmount: e.target.value })
              }
              placeholder="0"
              className="w-full px-4 py-2 border rounded-lg"
              disabled={loading}
            />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2">
              Montant max (EUR)
            </label>
            <input
              type="number"
              value={filters.maxAmount}
              onChange={(e) =>
                setFilters({ ...filters, maxAmount: e.target.value })
              }
              placeholder="99999"
              className="w-full px-4 py-2 border rounded-lg"
              disabled={loading}
            />
          </div>
        </div>
        <div className="flex space-x-3">
          <button
            type="submit"
            disabled={loading}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
          >
            {loading ? (
              <>
                <Loader className="w-4 h-4 mr-2 animate-spin" />
                Recherche...
              </>
            ) : (
              <>
                <Search className="w-4 h-4 mr-2" />
                Rechercher
              </>
            )}
          </button>
          <button
            type="button"
            onClick={handleReset}
            disabled={loading}
            className="px-6 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Réinitialiser
          </button>
        </div>
      </form>
    </div>
  );
};

// ==================== COMPOSANT CARTES STATISTIQUES ====================

const StatisticsCards = ({ stats }) => {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between mb-2">
          <div>
            <p className="text-blue-100 text-sm">Total Demandes Vols</p>
            <p className="text-3xl font-bold">
              {stats.totalFlightRequests || 0}
            </p>
          </div>
          <Plane className="w-12 h-12 opacity-30" />
        </div>
        <p className="text-sm text-blue-100 mt-2">
          {stats.flightRequestsChange > 0 ? "+" : ""}
          {stats.flightRequestsChange || 0}% vs période précédente
        </p>
      </div>

      <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between mb-2">
          <div>
            <p className="text-purple-100 text-sm">Total Réservations Hôtels</p>
            <p className="text-3xl font-bold">
              {stats.totalHotelRequests || 0}
            </p>
          </div>
          <Hotel className="w-12 h-12 opacity-30" />
        </div>
        <p className="text-sm text-purple-100 mt-2">
          {stats.hotelRequestsChange > 0 ? "+" : ""}
          {stats.hotelRequestsChange || 0}% vs période précédente
        </p>
      </div>

      <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between mb-2">
          <div>
            <p className="text-green-100 text-sm">Montant Total</p>
            <p className="text-3xl font-bold">
              {formatAmount(stats.totalAmount || 0)} EUR
            </p>
          </div>
          <DollarSign className="w-12 h-12 opacity-30" />
        </div>
        <p className="text-sm text-green-100 mt-2">
          Frais de service: {formatAmount(stats.totalServiceFees || 0)} EUR
        </p>
      </div>

      <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between mb-2">
          <div>
            <p className="text-orange-100 text-sm">Factures Émises</p>
            <p className="text-3xl font-bold">{stats.totalInvoices || 0}</p>
          </div>
          <FileText className="w-12 h-12 opacity-30" />
        </div>
        <p className="text-sm text-orange-100 mt-2">
          En attente: {stats.pendingInvoices || 0}
        </p>
      </div>
    </div>
  );
};

// ==================== COMPOSANT GRAPHIQUES ====================

const StatisticsCharts = ({ data }) => {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      {/* Graphique des demandes par statut */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-lg font-bold mb-4">Répartition par statut</h3>
        <div className="space-y-3">
          {data.byStatus?.map((item, index) => {
            const colors = [
              "bg-yellow-500",
              "bg-green-500",
              "bg-red-500",
              "bg-blue-500",
            ];
            const percentage = ((item.count / data.total) * 100).toFixed(1);
            return (
              <div key={index}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="font-semibold">{item.status}</span>
                  <span className="text-gray-600">
                    {item.count} ({percentage}%)
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div
                    className={`${
                      colors[index % colors.length]
                    } h-3 rounded-full transition-all`}
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Graphique des demandes par type */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-lg font-bold mb-4">Répartition par type</h3>
        <div className="flex items-center justify-center h-64">
          <div className="grid grid-cols-2 gap-8">
            <div className="text-center">
              <div className="relative inline-block">
                <svg className="w-32 h-32 transform -rotate-90">
                  <circle
                    cx="64"
                    cy="64"
                    r="56"
                    stroke="#E5E7EB"
                    strokeWidth="16"
                    fill="none"
                  />
                  <circle
                    cx="64"
                    cy="64"
                    r="56"
                    stroke="#3B82F6"
                    strokeWidth="16"
                    fill="none"
                    strokeDasharray={`${
                      (data.flightPercentage || 0) * 3.51
                    } 351`}
                    strokeLinecap="round"
                  />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-2xl font-bold text-blue-600">
                    {(data.flightPercentage || 0).toFixed(0)}%
                  </span>
                </div>
              </div>
              <p className="mt-2 font-semibold">Vols</p>
              <p className="text-sm text-gray-600">
                {data.totalFlights || 0} demandes
              </p>
            </div>
            <div className="text-center">
              <div className="relative inline-block">
                <svg className="w-32 h-32 transform -rotate-90">
                  <circle
                    cx="64"
                    cy="64"
                    r="56"
                    stroke="#E5E7EB"
                    strokeWidth="16"
                    fill="none"
                  />
                  <circle
                    cx="64"
                    cy="64"
                    r="56"
                    stroke="#9333EA"
                    strokeWidth="16"
                    fill="none"
                    strokeDasharray={`${
                      (data.hotelPercentage || 0) * 3.51
                    } 351`}
                    strokeLinecap="round"
                  />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-2xl font-bold text-purple-600">
                    {(data.hotelPercentage || 0).toFixed(0)}%
                  </span>
                </div>
              </div>
              <p className="mt-2 font-semibold">Hôtels</p>
              <p className="text-sm text-gray-600">
                {data.totalHotels || 0} demandes
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Graphique de l'évolution mensuelle */}
      <div className="bg-white rounded-xl shadow-md p-6 md:col-span-2">
        <h3 className="text-lg font-bold mb-4">Évolution mensuelle</h3>
        <div className="h-64">
          <div className="flex items-end justify-between h-full space-x-2">
            {data.monthlyData?.map((month, index) => {
              const maxValue = Math.max(
                ...(data.monthlyData?.map((m) => m.value) || [1])
              );
              const heightPercentage = (month.value / maxValue) * 100;
              return (
                <div key={index} className="flex-1 flex flex-col items-center">
                  <div
                    className="w-full bg-gradient-to-t from-blue-600 to-blue-400 rounded-t-lg relative group cursor-pointer hover:from-blue-700 hover:to-blue-500 transition-all"
                    style={{
                      height: `${heightPercentage}%`,
                      minHeight: "20px",
                    }}
                  >
                    <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                      {month.value} demandes
                    </div>
                  </div>
                  <p className="text-xs mt-2 text-gray-600">{month.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

// ==================== COMPOSANT TABLEAU DÉTAILLÉ ====================

const DetailedTable = ({ data, type }) => {
  const [sortField, setSortField] = useState("date");
  const [sortDirection, setSortDirection] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const sortedData = [...(data || [])].sort((a, b) => {
    const aVal = a[sortField];
    const bVal = b[sortField];
    const multiplier = sortDirection === "asc" ? 1 : -1;
    return aVal > bVal ? multiplier : -multiplier;
  });

  const paginatedData = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-lg font-bold mb-4">Liste détaillée</h3>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b-2 border-gray-200">
              <th
                onClick={() => handleSort("numeroRequete")}
                className="text-left p-3 cursor-pointer hover:bg-gray-50"
              >
                <div className="flex items-center">
                  N° Demande
                  {sortField === "numeroRequete" && (
                    <span className="ml-1">
                      {sortDirection === "asc" ? "↑" : "↓"}
                    </span>
                  )}
                </div>
              </th>
              <th
                onClick={() => handleSort("date")}
                className="text-left p-3 cursor-pointer hover:bg-gray-50"
              >
                <div className="flex items-center">
                  Date
                  {sortField === "date" && (
                    <span className="ml-1">
                      {sortDirection === "asc" ? "↑" : "↓"}
                    </span>
                  )}
                </div>
              </th>
              <th className="text-left p-3">Type</th>
              <th className="text-left p-3">Demandeur</th>
              <th className="text-left p-3">Destination</th>
              <th
                onClick={() => handleSort("montant")}
                className="text-left p-3 cursor-pointer hover:bg-gray-50"
              >
                <div className="flex items-center">
                  Montant
                  {sortField === "montant" && (
                    <span className="ml-1">
                      {sortDirection === "asc" ? "↑" : "↓"}
                    </span>
                  )}
                </div>
              </th>
              <th className="text-left p-3">Statut</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((item, index) => (
              <tr key={index} className="border-b hover:bg-gray-50">
                <td className="p-3 font-semibold text-blue-600">
                  {item.numeroRequete}
                </td>
                <td className="p-3">
                  {new Date(item.date).toLocaleDateString("fr-FR")}
                </td>
                <td className="p-3">
                  <span
                    className={`px-2 py-1 rounded text-xs ${
                      item.type === "Vol"
                        ? "bg-blue-100 text-blue-700"
                        : "bg-purple-100 text-purple-700"
                    }`}
                  >
                    {item.type}
                  </span>
                </td>
                <td className="p-3">{item.demandeur}</td>
                <td className="p-3">{item.destination}</td>
                <td className="p-3 font-semibold">
                  {formatAmount(item.montant)} EUR
                </td>
                <td className="p-3">
                  <span
                    className={`px-2 py-1 rounded text-xs ${
                      item.statut === "En attente"
                        ? "bg-yellow-100 text-yellow-700"
                        : item.statut === "Approuvée"
                        ? "bg-green-100 text-green-700"
                        : item.statut === "Rejetée"
                        ? "bg-red-100 text-red-700"
                        : "bg-blue-100 text-blue-700"
                    }`}
                  >
                    {item.statut}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex items-center justify-between mt-4">
          <p className="text-sm text-gray-600">
            Affichage de {(currentPage - 1) * itemsPerPage + 1} à{" "}
            {Math.min(currentPage * itemsPerPage, sortedData.length)} sur{" "}
            {sortedData.length} résultats
          </p>
          <div className="flex space-x-2">
            <button
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              className="px-3 py-1 border rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Précédent
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(
                (p) =>
                  p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1
              )
              .map((page, index, array) => (
                <React.Fragment key={page}>
                  {index > 0 && array[index - 1] !== page - 1 && (
                    <span className="px-3 py-1">...</span>
                  )}
                  <button
                    onClick={() => setCurrentPage(page)}
                    className={`px-3 py-1 border rounded ${
                      currentPage === page
                        ? "bg-blue-600 text-white"
                        : "hover:bg-gray-50"
                    }`}
                  >
                    {page}
                  </button>
                </React.Fragment>
              ))}
            <button
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
              className="px-3 py-1 border rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Suivant
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// ==================== COMPOSANT EXPORTS ====================

const ExportButtons = ({ filters, loading, onExport }) => {
  const [exporting, setExporting] = useState(false);
  const [exportType, setExportType] = useState("");

  const handleExport = async (type, format) => {
    setExporting(true);
    setExportType(`${type}-${format}`);
    try {
      await onExport(type, format, filters);
    } catch (error) {
      alert(`Erreur lors de l'export: ${error.message}`);
    } finally {
      setExporting(false);
      setExportType("");
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-lg font-bold mb-4 flex items-center">
        <Download className="w-5 h-5 mr-2 text-blue-600" />
        Exporter les données
      </h3>
      <div className="grid md:grid-cols-3 gap-4">
        <div className="border rounded-lg p-4">
          <h4 className="font-semibold mb-3 flex items-center">
            <FileText className="w-4 h-4 mr-2 text-green-600" />
            Format Excel
          </h4>
          <div className="space-y-2">
            <button
              onClick={() => handleExport("flights", "excel")}
              disabled={exporting || loading}
              className="w-full px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 text-sm flex items-center justify-center"
            >
              {exporting && exportType === "flights-excel" ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Export...
                </>
              ) : (
                "Exporter Vols"
              )}
            </button>
            <button
              onClick={() => handleExport("hotels", "excel")}
              disabled={exporting || loading}
              className="w-full px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 text-sm flex items-center justify-center"
            >
              {exporting && exportType === "hotels-excel" ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Export...
                </>
              ) : (
                "Exporter Hôtels"
              )}
            </button>
            <button
              onClick={() => handleExport("billing", "excel")}
              disabled={exporting || loading}
              className="w-full px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 text-sm flex items-center justify-center"
            >
              {exporting && exportType === "billing-excel" ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Export...
                </>
              ) : (
                "Exporter Factures"
              )}
            </button>
          </div>
        </div>

        <div className="border rounded-lg p-4">
          <h4 className="font-semibold mb-3 flex items-center">
            <FileText className="w-4 h-4 mr-2 text-red-600" />
            Format PDF
          </h4>
          <div className="space-y-2">
            <button
              onClick={() => handleExport("flights", "pdf")}
              disabled={exporting || loading}
              className="w-full px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50 text-sm flex items-center justify-center"
            >
              {exporting && exportType === "flights-pdf" ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Export...
                </>
              ) : (
                "Exporter Vols"
              )}
            </button>
            <button
              onClick={() => handleExport("hotels", "pdf")}
              disabled={exporting || loading}
              className="w-full px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50 text-sm flex items-center justify-center"
            >
              {exporting && exportType === "hotels-pdf" ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Export...
                </>
              ) : (
                "Exporter Hôtels"
              )}
            </button>
            <button
              onClick={() => handleExport("billing", "pdf")}
              disabled={exporting || loading}
              className="w-full px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50 text-sm flex items-center justify-center"
            >
              {exporting && exportType === "billing-pdf" ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Export...
                </>
              ) : (
                "Exporter Factures"
              )}
            </button>
          </div>
        </div>

        <div className="border rounded-lg p-4">
          <h4 className="font-semibold mb-3 flex items-center">
            <FileText className="w-4 h-4 mr-2 text-blue-600" />
            Format CSV
          </h4>
          <div className="space-y-2">
            <button
              onClick={() => handleExport("flights", "csv")}
              disabled={exporting || loading}
              className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 text-sm flex items-center justify-center"
            >
              {exporting && exportType === "flights-csv" ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Export...
                </>
              ) : (
                "Exporter Vols"
              )}
            </button>
            <button
              onClick={() => handleExport("hotels", "csv")}
              disabled={exporting || loading}
              className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 text-sm flex items-center justify-center"
            >
              {exporting && exportType === "hotels-csv" ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Export...
                </>
              ) : (
                "Exporter Hôtels"
              )}
            </button>
            <button
              onClick={() => handleExport("billing", "csv")}
              disabled={exporting || loading}
              className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 text-sm flex items-center justify-center"
            >
              {exporting && exportType === "billing-csv" ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Export...
                </>
              ) : (
                "Exporter Factures"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ==================== MODULE PRINCIPAL STATISTIQUES ====================

const StatisticsModule = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    startDate: new Date(new Date().getFullYear(), 0, 1)
      .toISOString()
      .split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    type: "all",
    statut: "all",
  });
  const [statistics, setStatistics] = useState({
    global: {},
    charts: {
      byStatus: [],
      monthlyData: [],
      total: 0,
      totalFlights: 0,
      totalHotels: 0,
      flightPercentage: 0,
      hotelPercentage: 0,
    },
    detailedData: [],
  });

  useEffect(() => {
    loadStatistics(filters);
  }, []);

  const loadStatistics = async (currentFilters) => {
    setLoading(true);
    try {
      const [globalStats, flightStats, hotelStats, billingStats] =
        await Promise.all([
          statisticsService.getGlobalStats(),
          statisticsService.getFlightStats(currentFilters),
          statisticsService.getHotelStats(currentFilters),
          statisticsService.getBillingStats(currentFilters),
        ]);

      // Calculer les statistiques combinées
      const totalFlights = flightStats.total || 0;
      const totalHotels = hotelStats.total || 0;
      const total = totalFlights + totalHotels;

      setStatistics({
        global: {
          totalFlightRequests: totalFlights,
          totalHotelRequests: totalHotels,
          totalAmount: billingStats.totalAmount || 0,
          totalServiceFees: billingStats.totalServiceFees || 0,
          totalInvoices: billingStats.totalInvoices || 0,
          pendingInvoices: billingStats.pendingInvoices || 0,
          flightRequestsChange: flightStats.percentageChange || 0,
          hotelRequestsChange: hotelStats.percentageChange || 0,
        },
        charts: {
          byStatus: [
            {
              status: "En attente",
              count:
                (flightStats.byStatus?.pending || 0) +
                (hotelStats.byStatus?.pending || 0),
            },
            {
              status: "Approuvée",
              count:
                (flightStats.byStatus?.approved || 0) +
                (hotelStats.byStatus?.approved || 0),
            },
            {
              status: "Rejetée",
              count:
                (flightStats.byStatus?.rejected || 0) +
                (hotelStats.byStatus?.rejected || 0),
            },
            {
              status: "Émis/Réservé",
              count:
                (flightStats.byStatus?.completed || 0) +
                (hotelStats.byStatus?.completed || 0),
            },
          ],
          monthlyData: generateMonthlyData(
            flightStats.monthly,
            hotelStats.monthly
          ),
          total: total,
          totalFlights: totalFlights,
          totalHotels: totalHotels,
          flightPercentage: total > 0 ? (totalFlights / total) * 100 : 0,
          hotelPercentage: total > 0 ? (totalHotels / total) * 100 : 0,
        },
        detailedData: [
          ...(flightStats.details || []),
          ...(hotelStats.details || []),
        ],
      });
    } catch (error) {
      console.error("Erreur chargement statistiques:", error);
      // alert("Erreur lors du chargement des statistiques");
    } finally {
      setLoading(false);
    }
  };

  const generateMonthlyData = (flightMonthly = [], hotelMonthly = []) => {
    const months = [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Jun",
      "Jul",
      "Aoû",
      "Sep",
      "Oct",
      "Nov",
      "Déc",
    ];
    return months.map((label, index) => {
      const flightValue = flightMonthly[index] || 0;
      const hotelValue = hotelMonthly[index] || 0;
      return {
        label,
        value: flightValue + hotelValue,
      };
    });
  };

  const handleFilter = (newFilters) => {
    setFilters(newFilters);
    loadStatistics(newFilters);
  };

  const handleExport = async (type, format, exportFilters) => {
    try {
      let blob;
      if (format === "excel") {
        blob = await statisticsService.exportToExcel(type, exportFilters);
      } else if (format === "pdf") {
        blob = await statisticsService.exportToPDF(type, exportFilters);
      } else if (format === "csv") {
        blob = await statisticsService.exportToCSV(type, exportFilters);
      }

      // Télécharger le fichier
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${type}_${new Date().toISOString().split("T")[0]}.${
        format === "excel" ? "xlsx" : format
      }`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      alert("Export réussi !");
    } catch (error) {
      throw error;
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h1 className="text-3xl font-bold mb-2 flex items-center">
          <BarChart3 className="w-8 h-8 mr-3 text-blue-600" />
          Statistiques et Rapports
        </h1>
        <p className="text-gray-600">
          Analyse détaillée des demandes, réservations et facturation
        </p>
      </div>

      <StatisticsFilters onFilter={handleFilter} loading={loading} />

      {loading && !statistics.global.totalFlightRequests ? (
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <Loader className="w-12 h-12 text-blue-600 mx-auto mb-4 animate-spin" />
          <p className="text-gray-600">Chargement des statistiques...</p>
        </div>
      ) : (
        <>
          <StatisticsCards stats={statistics.global} />
          <StatisticsCharts data={statistics.charts} />
          <DetailedTable data={statistics.detailedData} />
          <ExportButtons
            filters={filters}
            loading={loading}
            onExport={handleExport}
          />
        </>
      )}
    </div>
  );
};
// ==================== MODULES ADMINISTRATION WORKFLOW ====================
// administrationService.workflow.js
// Extension du service d'administration pour la gestion des workflows

const workflowService = {
  // ============== TEMPLATES DE WORKFLOW ==============

  /**
   * Récupérer tous les templates de workflow
   */
  async getWorkflowTemplates(filters = {}) {
    try {
      const params = new URLSearchParams(filters);
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates?${params}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des templates");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Récupérer un template spécifique
   */
  async getWorkflowTemplate(templateId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération du template");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Créer un nouveau template de workflow
   */
  async createWorkflowTemplate(templateData) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/templates`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(templateData),
      });
      if (!response.ok)
        throw new Error("Erreur lors de la création du template");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Mettre à jour un template de workflow
   */
  async updateWorkflowTemplate(templateId, templateData) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(templateData),
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la mise à jour du template");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Supprimer un template de workflow
   */
  async deleteWorkflowTemplate(templateId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la suppression du template");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Dupliquer un template de workflow
   */
  async duplicateWorkflowTemplate(templateId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}/duplicate`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la duplication du template");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Publier un template
   */
  async publishWorkflowTemplate(templateId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}/publish`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la publication du template");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Archiver un template
   */
  async archiveWorkflowTemplate(templateId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}/archive`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de l'archivage du template");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // ============== ÉTAPES DE WORKFLOW ==============

  /**
   * Récupérer les étapes d'un template
   */
  async getWorkflowSteps(templateId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}/steps`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des étapes");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Récupérer une étape spécifique
   */
  async getWorkflowStep(stepId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/steps/${stepId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération de l'étape");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Créer une étape de workflow
   */
  async createWorkflowStep(stepData) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/steps`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(stepData),
      });
      if (!response.ok)
        throw new Error("Erreur lors de la création de l'étape");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Mettre à jour une étape de workflow
   */
  async updateWorkflowStep(stepId, stepData) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/steps/${stepId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(stepData),
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la mise à jour de l'étape");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Supprimer une étape de workflow
   */
  async deleteWorkflowStep(stepId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/steps/${stepId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la suppression de l'étape");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Réordonner les étapes
   */
  async reorderWorkflowSteps(templateId, stepsOrder) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}/steps/reorder`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(stepsOrder),
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors du réordonnancement des étapes");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // ============== TRANSITIONS ==============

  /**
   * Récupérer les transitions d'un template
   */
  async getWorkflowTransitions(templateId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}/transitions`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des transitions");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Créer une transition
   */
  async createWorkflowTransition(transitionData) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/transitions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(transitionData),
      });
      if (!response.ok)
        throw new Error("Erreur lors de la création de la transition");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Mettre à jour une transition
   */
  async updateWorkflowTransition(transitionId, transitionData) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/transitions/${transitionId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(transitionData),
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la mise à jour de la transition");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Supprimer une transition
   */
  async deleteWorkflowTransition(transitionId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/transitions/${transitionId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la suppression de la transition");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // ============== INSTANCES DE WORKFLOW ==============

  /**
   * Rechercher des instances de workflow
   */
  async searchWorkflowInstances(filters = {}) {
    try {
      const params = new URLSearchParams(filters);
      const response = await fetch(
        `${API_BASE_URL}/workflows/instances?${params}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des instances");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Récupérer une instance spécifique
   */
  async getWorkflowInstance(instanceId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/instances/${instanceId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération de l'instance");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Créer une nouvelle instance de workflow
   */
  async createWorkflowInstance(instanceData) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/instances`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(instanceData),
      });
      if (!response.ok)
        throw new Error("Erreur lors de la création de l'instance");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Mettre à jour une instance
   */
  async updateWorkflowInstance(instanceId, instanceData) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/instances/${instanceId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(instanceData),
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la mise à jour de l'instance");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Annuler une instance
   */
  async cancelWorkflowInstance(instanceId, reason) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/instances/${instanceId}/cancel`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ reason }),
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de l'annulation de l'instance");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Récupérer l'historique d'une instance
   */
  async getWorkflowHistory(instanceId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/instances/${instanceId}/history`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération de l'historique");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Exécuter une action sur une instance de workflow
   */
  async executeWorkflowAction(actionData) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/actions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(actionData),
      });
      if (!response.ok)
        throw new Error("Erreur lors de l'exécution de l'action");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // ============== TÂCHES ==============

  /**
   * Récupérer les tâches de l'utilisateur connecté
   */
  async getMyTasks(status = null) {
    try {
      const params = status ? `?status=${status}` : "";
      const response = await fetch(
        `${API_BASE_URL}/workflows/tasks/my-tasks${params}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des tâches");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Récupérer une tâche spécifique
   */
  async getTask(taskId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/tasks/${taskId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération de la tâche");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Compléter une tâche
   */
  async completeTask(taskId, taskData) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/tasks/${taskId}/complete`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(taskData),
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la complétion de la tâche");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Déléguer une tâche
   */
  async delegateTask(taskId, delegateTo, reason) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/tasks/${taskId}/delegate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ delegate_to: delegateTo, reason }),
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la délégation de la tâche");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Récupérer les tâches d'une instance
   */
  async getInstanceTasks(instanceId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/instances/${instanceId}/tasks`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error(
          "Erreur lors de la récupération des tâches de l'instance"
        );
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // ============== ACL (PERMISSIONS) ==============

  /**
   * Récupérer les ACLs
   */
  async getWorkflowACL(filters = {}) {
    try {
      const params = new URLSearchParams(filters);
      const response = await fetch(`${API_BASE_URL}/workflows/acls?${params}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des ACLs");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Créer une ACL
   */
  async createWorkflowACL(aclData) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/acls`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(aclData),
      });
      if (!response.ok) throw new Error("Erreur lors de la création de l'ACL");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Mettre à jour une ACL
   */
  async updateWorkflowACL(aclId, aclData) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/acls/${aclId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(aclData),
      });
      if (!response.ok)
        throw new Error("Erreur lors de la mise à jour de l'ACL");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Supprimer une ACL
   */
  async deleteWorkflowACL(aclId) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/acls/${aclId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok)
        throw new Error("Erreur lors de la suppression de l'ACL");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Créer plusieurs ACLs en lot
   */
  async createBulkACL(acls) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/acls/bulk`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(acls),
      });
      if (!response.ok)
        throw new Error("Erreur lors de la création en masse des ACLs");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // ============== DÉLÉGATIONS ==============

  /**
   * Récupérer les délégations
   */
  async getDelegations(filters = {}) {
    try {
      const params = new URLSearchParams(filters);
      const response = await fetch(
        `${API_BASE_URL}/workflows/delegations?${params}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des délégations");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Créer une délégation
   */
  async createDelegation(delegationData) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/delegations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(delegationData),
      });
      if (!response.ok)
        throw new Error("Erreur lors de la création de la délégation");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Annuler une délégation
   */
  async cancelDelegation(delegationId, reason) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/delegations/${delegationId}/cancel`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ reason }),
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de l'annulation de la délégation");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // ============== NOTIFICATIONS ==============

  /**
   * Récupérer les notifications
   */
  async getNotifications(filters = {}) {
    try {
      const params = new URLSearchParams(filters);
      const response = await fetch(
        `${API_BASE_URL}/workflows/notifications?${params}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des notifications");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Marquer une notification comme lue
   */
  async markNotificationAsRead(notificationId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/notifications/${notificationId}/read`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors du marquage de la notification");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Créer une notification
   */
  async createNotification(notificationData) {
    try {
      const response = await fetch(`${API_BASE_URL}/workflows/notifications`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(notificationData),
      });
      if (!response.ok)
        throw new Error("Erreur lors de la création de la notification");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // ============== STATISTIQUES ET RAPPORTS ==============

  /**
   * Récupérer les statistiques des workflows
   */
  async getWorkflowStatistics(filters = {}) {
    try {
      const params = new URLSearchParams(filters);
      const response = await fetch(
        `${API_BASE_URL}/workflows/statistics?${params}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des statistiques");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Récupérer les métriques d'un template
   */
  async getWorkflowMetrics(templateId, period = "month") {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}/metrics?period=${period}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des métriques");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // ============== UTILITAIRES ==============

  /**
   * Trouver un workflow applicable
   */
  async findApplicableWorkflow(typeDemande, entiteId, context = {}) {
    try {
      const params = new URLSearchParams({
        type_demande: typeDemande,
        entite_id: entiteId,
      });
      const response = await fetch(
        `${API_BASE_URL}/workflows/find-applicable?${params}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la recherche de workflow applicable");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Vérifier les permissions d'un utilisateur
   */
  async checkACL(userId, templateId, stepId, permission) {
    try {
      const params = new URLSearchParams({
        user_id: userId,
        permission: permission,
        ...(templateId && { template_id: templateId }),
        ...(stepId && { step_id: stepId }),
      });
      const response = await fetch(
        `${API_BASE_URL}/workflows/check-acl?${params}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error("Erreur lors de la vérification des permissions");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Prévisualiser un template
   */
  async previewWorkflowTemplate(templateId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}/preview`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) throw new Error("Erreur lors de la prévisualisation");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Exporter un template
   */
  async exportWorkflowTemplate(templateId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/${templateId}/export`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) throw new Error("Erreur lors de l'export du template");
      return await response.blob();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  /**
   * Importer un template
   */
  async importWorkflowTemplate(importData) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/workflows/templates/import`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(importData),
        }
      );
      if (!response.ok) throw new Error("Erreur lors de l'import du template");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },
};

// Composant principal de gestion des workflows
const WorkflowManagement = ({
  entities = [],
  agents = [],
  profiles = [],
  onRefresh = () => {},
}) => {
  const [activeTab, setActiveTab] = useState("templates");
  const [loading, setLoading] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [instances, setInstances] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showTemplateForm, setShowTemplateForm] = useState(false);
  const [error, setError] = useState(null);

  // Types de demande disponibles
  const typesDemande = [
    { value: "TRAVEL", label: "Voyage" },
    { value: "MISSION", label: "Mission" },
    { value: "EXPENSE", label: "Note de frais" },
    { value: "LEAVE", label: "Congé" },
    { value: "PURCHASE", label: "Achat" },
    { value: "CONTRACT", label: "Contrat" },
    { value: "OTHER", label: "Autre" },
  ];

  // État du formulaire
  const [templateFormData, setTemplateFormData] = useState({
    code: "",
    nom: "",
    description: "",
    type_demande: "",
    entite_id: "",
    conditions: {},
    parametres: {},
    actif: true,
    statut: "draft",
  });

  useEffect(() => {
    loadInitialData();
  }, [activeTab]);

  const loadInitialData = async () => {
    try {
      setLoading(true);
      setError(null);

      switch (activeTab) {
        case "templates":
          const templatesData = await workflowService.getWorkflowTemplates();
          setTemplates(templatesData);
          break;
        case "instances":
          const instancesData = await workflowService.searchWorkflowInstances();
          setInstances(instancesData.data || []);
          break;
        case "tasks":
          const tasksData = await workflowService.getMyTasks();
          setTasks(tasksData);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Erreur lors du chargement:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateTemplate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await workflowService.createWorkflowTemplate(templateFormData);
      await loadInitialData();
      setShowTemplateForm(false);
      resetTemplateForm();
      alert("Template créé avec succès");
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTemplate = async (templateId) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce template ?"))
      return;

    setLoading(true);
    try {
      await workflowService.deleteWorkflowTemplate(templateId);
      await loadInitialData();
      alert("Template supprimé avec succès");
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handlePublishTemplate = async (templateId) => {
    setLoading(true);
    try {
      await workflowService.publishWorkflowTemplate(templateId);
      await loadInitialData();
      alert("Template publié avec succès");
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleArchiveTemplate = async (templateId) => {
    setLoading(true);
    try {
      await workflowService.archiveWorkflowTemplate(templateId);
      await loadInitialData();
      alert("Template archivé avec succès");
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const resetTemplateForm = () => {
    setTemplateFormData({
      code: "",
      nom: "",
      description: "",
      type_demande: "",
      entite_id: "",
      conditions: {},
      parametres: {},
      actif: true,
      statut: "draft",
    });
    setSelectedTemplate(null);
  };

  const renderTemplateCard = (template) => (
    <div
      key={template.id}
      className="border rounded-lg p-4 hover:shadow-md transition bg-white"
    >
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <h3 className="text-lg font-bold text-gray-900">
            {template.name || template.nom}
          </h3>
          <p className="text-sm text-gray-600 mt-1">{template.description}</p>
          <div className="flex items-center space-x-2 mt-2">
            <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium">
              {template.code}
            </span>
            <span
              className={`px-2 py-1 rounded text-xs font-medium ${
                template.status === "published"
                  ? "bg-green-100 text-green-700"
                  : template.status === "draft"
                  ? "bg-yellow-100 text-yellow-700"
                  : "bg-gray-100 text-gray-700"
              }`}
            >
              {template.status || template.statut}
            </span>
            <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs">
              {template.request_type || template.type_demande}
            </span>
            {template.is_active && (
              <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-xs">
                Actif
              </span>
            )}
          </div>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => {
              setSelectedTemplate(template);
              // Navigation vers l'éditeur de workflow
              window.location.hash = `#/workflows/templates/${template.id}`;
            }}
            className="p-2 text-blue-600 hover:bg-blue-50 rounded"
            title="Éditer"
          >
            <Edit className="w-4 h-4" />
          </button>
          {template.status === "draft" && (
            <button
              onClick={() => handlePublishTemplate(template.id)}
              className="p-2 text-green-600 hover:bg-green-50 rounded"
              title="Publier"
            >
              <Send className="w-4 h-4" />
            </button>
          )}
          {template.status === "published" && (
            <button
              onClick={() => handleArchiveTemplate(template.id)}
              className="p-2 text-orange-600 hover:bg-orange-50 rounded"
              title="Archiver"
            >
              <Archive className="w-4 h-4" />
            </button>
          )}
          <button
            onClick={() => handleDeleteTemplate(template.id)}
            className="p-2 text-red-600 hover:bg-red-50 rounded"
            title="Supprimer"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="flex justify-between items-center text-xs text-gray-500">
        <span>
          Créé le {new Date(template.created_at).toLocaleDateString()}
        </span>
        <span>{template.steps_count || 0} étapes</span>
      </div>
    </div>
  );

  const renderInstanceCard = (instance) => (
    <div
      key={instance.id}
      className="border rounded-lg p-4 hover:shadow-md transition bg-white"
    >
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <h3 className="text-lg font-bold text-gray-900">
            {instance.title || instance.titre}
          </h3>
          <p className="text-sm text-gray-600 mt-1">{instance.description}</p>
          <div className="flex items-center space-x-2 mt-2">
            <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium">
              {instance.instance_number || instance.numero_instance}
            </span>
            <span
              className={`px-2 py-1 rounded text-xs font-medium ${
                instance.status === "COMPLETED"
                  ? "bg-green-100 text-green-700"
                  : instance.status === "IN_PROGRESS"
                  ? "bg-blue-100 text-blue-700"
                  : instance.status === "CANCELLED"
                  ? "bg-red-100 text-red-700"
                  : "bg-gray-100 text-gray-700"
              }`}
            >
              {instance.status || instance.statut}
            </span>
            <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs">
              {instance.request_type || instance.type_demande}
            </span>
          </div>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => {
              // Navigation vers les détails de l'instance
              window.location.hash = `#/workflows/instances/${instance.id}`;
            }}
            className="p-2 text-blue-600 hover:bg-blue-50 rounded"
            title="Voir les détails"
          >
            <Eye className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="flex justify-between items-center text-xs text-gray-500">
        <span>
          Initié par {instance.initiator_name || instance.initiateur_nom}
        </span>
        <span>
          Démarré le{" "}
          {new Date(
            instance.start_date || instance.created_at
          ).toLocaleDateString()}
        </span>
      </div>
    </div>
  );

  const renderTaskCard = (task) => (
    <div
      key={task.id}
      className="border rounded-lg p-4 hover:shadow-md transition bg-white"
    >
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <h3 className="text-lg font-bold text-gray-900">{task.title}</h3>
          <p className="text-sm text-gray-600 mt-1">{task.description}</p>
          <div className="flex items-center space-x-2 mt-2">
            <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium">
              {task.task_number}
            </span>
            <span
              className={`px-2 py-1 rounded text-xs font-medium ${
                task.status === "COMPLETED"
                  ? "bg-green-100 text-green-700"
                  : task.status === "IN_PROGRESS"
                  ? "bg-blue-100 text-blue-700"
                  : task.status === "PENDING"
                  ? "bg-yellow-100 text-yellow-700"
                  : "bg-gray-100 text-gray-700"
              }`}
            >
              {task.status}
            </span>
            {task.priority === 1 && (
              <span className="px-2 py-1 bg-red-100 text-red-700 rounded text-xs">
                Urgent
              </span>
            )}
          </div>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => {
              // Navigation vers la tâche
              window.location.hash = `#/workflows/tasks/${task.id}`;
            }}
            className="p-2 text-blue-600 hover:bg-blue-50 rounded"
            title="Traiter la tâche"
          >
            <CheckCircle className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="flex justify-between items-center text-xs text-gray-500">
        <span>
          Échéance:{" "}
          {task.due_date
            ? new Date(task.due_date).toLocaleDateString()
            : "Non définie"}
        </span>
        <span>Assigné à {task.assignee_name}</span>
      </div>
    </div>
  );

  if (error) {
    return (
      <div className="p-6 bg-red-50 border border-red-200 rounded-lg m-4">
        <h2 className="text-lg font-bold text-red-800 mb-2">
          Erreur de chargement
        </h2>
        <p className="text-red-600 mb-4">{error}</p>
        <button
          onClick={loadInitialData}
          className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
        >
          Réessayer
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6 p-4">
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold flex items-center">
            <GitBranch className="w-6 h-6 mr-2 text-blue-600" />
            Gestion des Workflows
          </h2>
          <button
            onClick={() => setShowTemplateForm(true)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center"
          >
            <Plus className="w-5 h-5 mr-2" />
            Nouveau workflow
          </button>
        </div>

        {/* Tabs */}
        <div className="flex space-x-4 mb-6 border-b">
          {[
            { key: "templates", label: "Templates", icon: FileText },
            { key: "instances", label: "Instances actives", icon: GitBranch },
            { key: "tasks", label: "Mes tâches", icon: CheckCircle },
            { key: "statistics", label: "Statistiques", icon: BarChart },
          ].map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`pb-2 px-1 flex items-center space-x-2 ${
                activeTab === tab.key
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              <tab.icon className="w-4 h-4" />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Contenu */}
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <Loader className="w-8 h-8 animate-spin text-blue-600" />
            <span className="ml-2">Chargement...</span>
          </div>
        ) : (
          <>
            {activeTab === "templates" && (
              <div>
                {showTemplateForm && (
                  <div className="bg-gray-50 rounded-lg p-6 mb-6 border">
                    <h3 className="text-lg font-bold mb-4">
                      Nouveau template de workflow
                    </h3>

                    <form onSubmit={handleCreateTemplate}>
                      <div className="grid md:grid-cols-2 gap-4 mb-4">
                        <div>
                          <label className="block text-sm font-semibold mb-2">
                            Code *
                          </label>
                          <input
                            type="text"
                            value={templateFormData.code}
                            onChange={(e) =>
                              setTemplateFormData({
                                ...templateFormData,
                                code: e.target.value,
                              })
                            }
                            className="w-full px-4 py-2 border rounded-lg"
                            placeholder="Ex: WF_VOYAGE_001"
                            required
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-semibold mb-2">
                            Nom *
                          </label>
                          <input
                            type="text"
                            value={templateFormData.nom}
                            onChange={(e) =>
                              setTemplateFormData({
                                ...templateFormData,
                                nom: e.target.value,
                              })
                            }
                            className="w-full px-4 py-2 border rounded-lg"
                            placeholder="Ex: Workflow de demande de voyage"
                            required
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-semibold mb-2">
                            Type de demande *
                          </label>
                          <select
                            value={templateFormData.type_demande}
                            onChange={(e) =>
                              setTemplateFormData({
                                ...templateFormData,
                                type_demande: e.target.value,
                              })
                            }
                            className="w-full px-4 py-2 border rounded-lg"
                            required
                          >
                            <option value="">Sélectionner</option>
                            {typesDemande.map((type) => (
                              <option key={type.value} value={type.value}>
                                {type.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-semibold mb-2">
                            Entité
                          </label>
                          <select
                            value={templateFormData.entite_id}
                            onChange={(e) =>
                              setTemplateFormData({
                                ...templateFormData,
                                entite_id: e.target.value,
                              })
                            }
                            className="w-full px-4 py-2 border rounded-lg"
                          >
                            <option value="">Toutes les entités</option>
                            {entities.map((entity) => (
                              <option key={entity.id} value={entity.id}>
                                {entity.nom}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="mb-4">
                        <label className="block text-sm font-semibold mb-2">
                          Description
                        </label>
                        <textarea
                          value={templateFormData.description}
                          onChange={(e) =>
                            setTemplateFormData({
                              ...templateFormData,
                              description: e.target.value,
                            })
                          }
                          className="w-full px-4 py-2 border rounded-lg"
                          rows="3"
                          placeholder="Description du workflow..."
                        />
                      </div>

                      <div className="flex space-x-3">
                        <button
                          type="submit"
                          disabled={loading}
                          className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
                        >
                          <Save className="w-4 h-4 mr-2" />
                          {loading ? "Création..." : "Créer"}
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setShowTemplateForm(false);
                            resetTemplateForm();
                          }}
                          className="border px-6 py-2 rounded-lg hover:bg-gray-50"
                        >
                          Annuler
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {/* Liste des templates */}
                <div className="space-y-4">
                  {templates.length === 0 ? (
                    <div className="text-center py-8 text-gray-500">
                      <FileText className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                      <p>Aucun template de workflow</p>
                      <p className="text-sm mt-2">
                        Commencez par créer votre premier template
                      </p>
                    </div>
                  ) : (
                    templates.map(renderTemplateCard)
                  )}
                </div>
              </div>
            )}

            {activeTab === "instances" && (
              <div className="space-y-4">
                {instances.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">
                    <GitBranch className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                    <p>Aucune instance de workflow active</p>
                  </div>
                ) : (
                  instances.map(renderInstanceCard)
                )}
              </div>
            )}

            {activeTab === "tasks" && (
              <div className="space-y-4">
                {tasks.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">
                    <CheckCircle className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                    <p>Aucune tâche en attente</p>
                  </div>
                ) : (
                  tasks.map(renderTaskCard)
                )}
              </div>
            )}

            {activeTab === "statistics" && (
              <div className="text-center py-8 text-gray-500">
                <BarChart className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                <p>Statistiques en cours de développement</p>
                <button
                  onClick={() => workflowService.getWorkflowStatistics()}
                  className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                  Voir les statistiques
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

////*************** */

const WorkflowStepsManager = ({ templateId, entities, agents, profiles }) => {
  const [loading, setLoading] = useState(false);
  const [steps, setSteps] = useState([]);
  const [transitions, setTransitions] = useState([]);
  const [showStepForm, setShowStepForm] = useState(false);
  const [showTransitionForm, setShowTransitionForm] = useState(false);
  const [editingStep, setEditingStep] = useState(null);
  const [editingTransition, setEditingTransition] = useState(null);

  // État du formulaire d'étape
  const [stepFormData, setStepFormData] = useState({
    workflow_template_id: templateId,
    code: "",
    nom: "",
    description: "",
    ordre: 1,
    type_etape: "APPROVAL",
    statut_initial: "PENDING",
    validateurs: {
      user_ids: [],
      role_ids: [],
      niveau_hierarchique: "",
      entite_id: "",
      auto_selection: false,
      selection_strategy: "ROUND_ROBIN",
    },
    type_validation: "SINGLE",
    quorum: null,
    delai_traitement: 24,
    action_timeout: "ESCALATE",
    escalation_config: {},
    champs_requis: {},
    actions_disponibles: {
      approve: true,
      reject: true,
      return: true,
      delegate: true,
      comment: true,
    },
    notifications: {
      on_assign: true,
      on_complete: true,
      on_reject: true,
      on_timeout: true,
    },
    peut_commenter: true,
    peut_attacher_fichiers: true,
    signature_requise: false,
    est_etape_initiale: false,
    est_etape_finale: false,
    conditions_entree: {},
    conditions_sortie: {},
    regles_metier: {},
    actif: true,
  });

  // État du formulaire de transition
  const [transitionFormData, setTransitionFormData] = useState({
    workflow_template_id: templateId,
    from_step_id: "",
    to_step_id: "",
    code: "",
    nom: "",
    action: "APPROVE",
    conditions: {},
    priorite: 1,
    regles_validation: {},
    actions_pre: {},
    actions_post: {},
    notifications: {},
    requiert_commentaire: false,
    requiert_signature: false,
    actif: true,
    type_declenchement: "MANUAL",
    declencheur_config: {},
  });

  const typesEtape = [
    {
      value: "INITIATION",
      label: "Initiation",
      icon: <Plus className="w-4 h-4" />,
    },
    {
      value: "APPROVAL",
      label: "Approbation",
      icon: <CheckCircle className="w-4 h-4" />,
    },
    {
      value: "REVIEW",
      label: "Révision",
      icon: <FileText className="w-4 h-4" />,
    },
    {
      value: "NOTIFICATION",
      label: "Notification",
      icon: <Mail className="w-4 h-4" />,
    },
    {
      value: "EXECUTION",
      label: "Exécution",
      icon: <Settings className="w-4 h-4" />,
    },
    { value: "END", label: "Fin", icon: <CheckCircle className="w-4 h-4" /> },
  ];

  const typesValidation = [
    { value: "SINGLE", label: "Validation simple" },
    { value: "MULTIPLE", label: "Validations multiples" },
    { value: "SEQUENTIAL", label: "Validation séquentielle" },
    { value: "PARALLEL", label: "Validation parallèle" },
    { value: "VOTE", label: "Vote majoritaire" },
  ];

  const actionsTimeout = [
    { value: "ESCALATE", label: "Escalader au supérieur" },
    { value: "AUTO_APPROVE", label: "Approuver automatiquement" },
    { value: "AUTO_REJECT", label: "Rejeter automatiquement" },
    { value: "NOTIFY", label: "Envoyer une notification" },
  ];

  const actionsTransition = [
    { value: "APPROVE", label: "Approuver", color: "green" },
    { value: "REJECT", label: "Rejeter", color: "red" },
    { value: "RETURN", label: "Retourner", color: "yellow" },
    { value: "ESCALATE", label: "Escalader", color: "orange" },
    { value: "AUTO", label: "Automatique", color: "blue" },
  ];

  useEffect(() => {
    if (templateId) {
      loadSteps();
      loadTransitions();
    }
  }, [templateId]);

  const loadSteps = async () => {
    setLoading(true);
    try {
      const data = await workflowService.getWorkflowSteps(templateId);
      setSteps(data.sort((a, b) => a.ordre - b.ordre));
    } catch (error) {
      console.error("Erreur lors du chargement des étapes:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadTransitions = async () => {
    try {
      const data = await workflowService.getWorkflowTransitions(templateId);
      setTransitions(data);
    } catch (error) {
      console.error("Erreur lors du chargement des transitions:", error);
    }
  };

  const handleCreateStep = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await workflowService.createWorkflowStep(stepFormData);
      await loadSteps();
      setShowStepForm(false);
      resetStepForm();
      alert("Étape créée avec succès");
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStep = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await workflowService.updateWorkflowStep(editingStep.id, stepFormData);
      await loadSteps();
      setShowStepForm(false);
      resetStepForm();
      alert("Étape mise à jour avec succès");
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteStep = async (stepId) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer cette étape ?"))
      return;

    setLoading(true);
    try {
      await workflowService.deleteWorkflowStep(stepId);
      await loadSteps();
      await loadTransitions(); // Recharger les transitions car certaines peuvent être supprimées
      alert("Étape supprimée avec succès");
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleMoveStep = async (stepId, direction) => {
    const currentIndex = steps.findIndex((s) => s.id === stepId);
    if (
      (direction === "up" && currentIndex === 0) ||
      (direction === "down" && currentIndex === steps.length - 1)
    ) {
      return;
    }

    const newSteps = [...steps];
    const targetIndex =
      direction === "up" ? currentIndex - 1 : currentIndex + 1;
    [newSteps[currentIndex], newSteps[targetIndex]] = [
      newSteps[targetIndex],
      newSteps[currentIndex],
    ];

    // Mettre à jour les ordres
    const stepsOrder = newSteps.map((step, index) => ({
      id: step.id,
      ordre: index + 1,
    }));

    setLoading(true);
    try {
      await workflowService.reorderWorkflowSteps(templateId, stepsOrder);
      await loadSteps();
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const resetStepForm = () => {
    setStepFormData({
      workflow_template_id: templateId,
      code: "",
      nom: "",
      description: "",
      ordre: steps.length + 1,
      type_etape: "APPROVAL",
      statut_initial: "PENDING",
      validateurs: {
        user_ids: [],
        role_ids: [],
        niveau_hierarchique: "",
        entite_id: "",
        auto_selection: false,
        selection_strategy: "ROUND_ROBIN",
      },
      type_validation: "SINGLE",
      quorum: null,
      delai_traitement: 24,
      action_timeout: "ESCALATE",
      escalation_config: {},
      champs_requis: {},
      actions_disponibles: {
        approve: true,
        reject: true,
        return: true,
        delegate: true,
        comment: true,
      },
      notifications: {
        on_assign: true,
        on_complete: true,
        on_reject: true,
        on_timeout: true,
      },
      peut_commenter: true,
      peut_attacher_fichiers: true,
      signature_requise: false,
      est_etape_initiale: false,
      est_etape_finale: false,
      conditions_entree: {},
      conditions_sortie: {},
      regles_metier: {},
      actif: true,
    });
    setEditingStep(null);
  };

  const renderStepForm = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b p-4 flex justify-between items-center">
          <h3 className="text-lg font-bold">
            {editingStep ? "Modifier l'étape" : "Nouvelle étape"}
          </h3>
          <button
            onClick={() => {
              setShowStepForm(false);
              resetStepForm();
            }}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form
          onSubmit={editingStep ? handleUpdateStep : handleCreateStep}
          className="p-6"
        >
          {/* Informations de base */}
          <div className="mb-6">
            <h4 className="font-semibold mb-3">Informations générales</h4>
            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">Code *</label>
                <input
                  type="text"
                  value={stepFormData.code}
                  onChange={(e) =>
                    setStepFormData({ ...stepFormData, code: e.target.value })
                  }
                  className="w-full px-3 py-2 border rounded-lg"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Nom *</label>
                <input
                  type="text"
                  value={stepFormData.nom}
                  onChange={(e) =>
                    setStepFormData({ ...stepFormData, nom: e.target.value })
                  }
                  className="w-full px-3 py-2 border rounded-lg"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">
                  Type d'étape *
                </label>
                <select
                  value={stepFormData.type_etape}
                  onChange={(e) =>
                    setStepFormData({
                      ...stepFormData,
                      type_etape: e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border rounded-lg"
                  required
                >
                  {typesEtape.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium mb-2">
                Description
              </label>
              <textarea
                value={stepFormData.description}
                onChange={(e) =>
                  setStepFormData({
                    ...stepFormData,
                    description: e.target.value,
                  })
                }
                className="w-full px-3 py-2 border rounded-lg"
                rows="2"
              />
            </div>
          </div>

          {/* Configuration des validateurs */}
          <div className="mb-6">
            <h4 className="font-semibold mb-3">
              Configuration des validateurs
            </h4>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Type de validation
                </label>
                <select
                  value={stepFormData.type_validation}
                  onChange={(e) =>
                    setStepFormData({
                      ...stepFormData,
                      type_validation: e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border rounded-lg"
                >
                  {typesValidation.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </div>
              {(stepFormData.type_validation === "MULTIPLE" ||
                stepFormData.type_validation === "VOTE") && (
                <div>
                  <label className="block text-sm font-medium mb-2">
                    Quorum
                  </label>
                  <input
                    type="number"
                    value={stepFormData.quorum || ""}
                    onChange={(e) =>
                      setStepFormData({
                        ...stepFormData,
                        quorum: parseInt(e.target.value),
                      })
                    }
                    className="w-full px-3 py-2 border rounded-lg"
                    min="1"
                    placeholder="Nombre minimum de validations"
                  />
                </div>
              )}
            </div>

            <div className="mt-4">
              <label className="block text-sm font-medium mb-2">
                Agents validateurs
              </label>
              <select
                multiple
                value={stepFormData.validateurs.user_ids}
                onChange={(e) => {
                  const selected = Array.from(
                    e.target.selectedOptions,
                    (option) => option.value
                  );
                  setStepFormData({
                    ...stepFormData,
                    validateurs: {
                      ...stepFormData.validateurs,
                      user_ids: selected,
                    },
                  });
                }}
                className="w-full px-3 py-2 border rounded-lg"
                size="4"
              >
                {agents.map((agent) => (
                  <option key={agent.id} value={agent.id}>
                    {agent.prenom} {agent.nom} - {agent.fonction}
                  </option>
                ))}
              </select>
              <p className="text-xs text-gray-500 mt-1">
                Maintenez Ctrl pour sélectionner plusieurs agents
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4 mt-4">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Niveau hiérarchique
                </label>
                <input
                  type="text"
                  value={stepFormData.validateurs.niveau_hierarchique}
                  onChange={(e) =>
                    setStepFormData({
                      ...stepFormData,
                      validateurs: {
                        ...stepFormData.validateurs,
                        niveau_hierarchique: e.target.value,
                      },
                    })
                  }
                  className="w-full px-3 py-2 border rounded-lg"
                  placeholder="Ex: N+1, N+2, DIRECTION"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">
                  Entité spécifique
                </label>
                <select
                  value={stepFormData.validateurs.entite_id}
                  onChange={(e) =>
                    setStepFormData({
                      ...stepFormData,
                      validateurs: {
                        ...stepFormData.validateurs,
                        entite_id: e.target.value,
                      },
                    })
                  }
                  className="w-full px-3 py-2 border rounded-lg"
                >
                  <option value="">Toutes les entités</option>
                  {entities.map((entity) => (
                    <option key={entity.id} value={entity.id}>
                      {entity.nom}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Délais et timeouts */}
          <div className="mb-6">
            <h4 className="font-semibold mb-3">
              Délais et actions automatiques
            </h4>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Délai de traitement (heures)
                </label>
                <input
                  type="number"
                  value={stepFormData.delai_traitement}
                  onChange={(e) =>
                    setStepFormData({
                      ...stepFormData,
                      delai_traitement: parseInt(e.target.value),
                    })
                  }
                  className="w-full px-3 py-2 border rounded-lg"
                  min="1"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">
                  Action en cas de timeout
                </label>
                <select
                  value={stepFormData.action_timeout}
                  onChange={(e) =>
                    setStepFormData({
                      ...stepFormData,
                      action_timeout: e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border rounded-lg"
                >
                  {actionsTimeout.map((action) => (
                    <option key={action.value} value={action.value}>
                      {action.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Options et permissions */}
          <div className="mb-6">
            <h4 className="font-semibold mb-3">Options et permissions</h4>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={stepFormData.peut_commenter}
                    onChange={(e) =>
                      setStepFormData({
                        ...stepFormData,
                        peut_commenter: e.target.checked,
                      })
                    }
                    className="mr-2"
                  />
                  <span className="text-sm">Autoriser les commentaires</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={stepFormData.peut_attacher_fichiers}
                    onChange={(e) =>
                      setStepFormData({
                        ...stepFormData,
                        peut_attacher_fichiers: e.target.checked,
                      })
                    }
                    className="mr-2"
                  />
                  <span className="text-sm">Autoriser les pièces jointes</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={stepFormData.signature_requise}
                    onChange={(e) =>
                      setStepFormData({
                        ...stepFormData,
                        signature_requise: e.target.checked,
                      })
                    }
                    className="mr-2"
                  />
                  <span className="text-sm">
                    Signature électronique requise
                  </span>
                </label>
              </div>
              <div className="space-y-2">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={stepFormData.est_etape_initiale}
                    onChange={(e) =>
                      setStepFormData({
                        ...stepFormData,
                        est_etape_initiale: e.target.checked,
                      })
                    }
                    className="mr-2"
                  />
                  <span className="text-sm">Étape initiale du workflow</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={stepFormData.est_etape_finale}
                    onChange={(e) =>
                      setStepFormData({
                        ...stepFormData,
                        est_etape_finale: e.target.checked,
                      })
                    }
                    className="mr-2"
                  />
                  <span className="text-sm">Étape finale du workflow</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={stepFormData.actif}
                    onChange={(e) =>
                      setStepFormData({
                        ...stepFormData,
                        actif: e.target.checked,
                      })
                    }
                    className="mr-2"
                  />
                  <span className="text-sm">Étape active</span>
                </label>
              </div>
            </div>
          </div>

          {/* Actions disponibles */}
          <div className="mb-6">
            <h4 className="font-semibold mb-3">Actions disponibles</h4>
            <div className="grid md:grid-cols-3 gap-3">
              {Object.entries({
                approve: "Approuver",
                reject: "Rejeter",
                return: "Retourner",
                delegate: "Déléguer",
                comment: "Commenter",
              }).map(([key, label]) => (
                <label key={key} className="flex items-center">
                  <input
                    type="checkbox"
                    checked={stepFormData.actions_disponibles[key]}
                    onChange={(e) =>
                      setStepFormData({
                        ...stepFormData,
                        actions_disponibles: {
                          ...stepFormData.actions_disponibles,
                          [key]: e.target.checked,
                        },
                      })
                    }
                    className="mr-2"
                  />
                  <span className="text-sm">{label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Notifications */}
          <div className="mb-6">
            <h4 className="font-semibold mb-3">Notifications</h4>
            <div className="grid md:grid-cols-2 gap-3">
              {Object.entries({
                on_assign: "À l'assignation",
                on_complete: "À la complétion",
                on_reject: "Au rejet",
                on_timeout: "Au timeout",
              }).map(([key, label]) => (
                <label key={key} className="flex items-center">
                  <input
                    type="checkbox"
                    checked={stepFormData.notifications[key]}
                    onChange={(e) =>
                      setStepFormData({
                        ...stepFormData,
                        notifications: {
                          ...stepFormData.notifications,
                          [key]: e.target.checked,
                        },
                      })
                    }
                    className="mr-2"
                  />
                  <span className="text-sm">Notifier {label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Boutons d'action */}
          <div className="flex justify-end space-x-3 pt-4 border-t">
            <button
              type="button"
              onClick={() => {
                setShowStepForm(false);
                resetStepForm();
              }}
              className="px-6 py-2 border rounded-lg hover:bg-gray-50"
              disabled={loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={loading}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
            >
              {loading ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Enregistrement...
                </>
              ) : (
                <>
                  <Save className="w-4 h-4 mr-2" />
                  {editingStep ? "Modifier" : "Créer"}
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  const renderStepCard = (step, index) => {
    const typeEtape = typesEtape.find((t) => t.value === step.type_etape);
    const isFirst = index === 0;
    const isLast = index === steps.length - 1;

    return (
      <div key={step.id} className="relative">
        {/* Ligne de connexion */}
        {!isLast && (
          <div className="absolute left-6 top-12 w-0.5 h-20 bg-gray-300"></div>
        )}

        <div className="flex items-start space-x-4">
          {/* Icône de l'étape */}
          <div
            className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${
              step.est_etape_initiale
                ? "bg-green-100 text-green-600"
                : step.est_etape_finale
                ? "bg-red-100 text-red-600"
                : "bg-blue-100 text-blue-600"
            }`}
          >
            {typeEtape?.icon || <CheckCircle className="w-6 h-6" />}
          </div>

          {/* Contenu de l'étape */}
          <div className="flex-1 bg-white rounded-lg border p-4 hover:shadow-md transition">
            <div className="flex justify-between items-start mb-2">
              <div>
                <h4 className="font-semibold text-lg">{step.nom}</h4>
                <div className="flex items-center space-x-2 mt-1">
                  <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs">
                    {step.code}
                  </span>
                  <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs">
                    {typeEtape?.label}
                  </span>
                  {step.type_validation !== "SINGLE" && (
                    <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs">
                      {
                        typesValidation.find(
                          (t) => t.value === step.type_validation
                        )?.label
                      }
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center space-x-2">
                {!isFirst && (
                  <button
                    onClick={() => handleMoveStep(step.id, "up")}
                    className="p-1 text-gray-600 hover:bg-gray-100 rounded"
                    title="Monter"
                  >
                    <ChevronUp className="w-4 h-4" />
                  </button>
                )}
                {!isLast && (
                  <button
                    onClick={() => handleMoveStep(step.id, "down")}
                    className="p-1 text-gray-600 hover:bg-gray-100 rounded"
                    title="Descendre"
                  >
                    <ChevronDown className="w-4 h-4" />
                  </button>
                )}
                <button
                  onClick={() => {
                    setEditingStep(step);
                    setStepFormData(step);
                    setShowStepForm(true);
                  }}
                  className="p-1 text-blue-600 hover:bg-blue-50 rounded"
                  title="Modifier"
                >
                  <Edit className="w-4 h-4" />
                </button>
                <button
                  onClick={() => handleDeleteStep(step.id)}
                  className="p-1 text-red-600 hover:bg-red-50 rounded"
                  title="Supprimer"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>

            {step.description && (
              <p className="text-sm text-gray-600 mb-3">{step.description}</p>
            )}

            <div className="grid grid-cols-2 gap-3 text-sm">
              <div className="flex items-center text-gray-600">
                <Clock className="w-4 h-4 mr-1" />
                Délai: {step.delai_traitement}h
              </div>
              <div className="flex items-center text-gray-600">
                <UserCheck className="w-4 h-4 mr-1" />
                {step.validateurs?.user_ids?.length > 0
                  ? `${step.validateurs.user_ids.length} validateur(s)`
                  : step.validateurs?.niveau_hierarchique || "Auto"}
              </div>
              {step.signature_requise && (
                <div className="flex items-center text-gray-600">
                  <FileText className="w-4 h-4 mr-1" />
                  Signature requise
                </div>
              )}
              {step.quorum && (
                <div className="flex items-center text-gray-600">
                  <Users className="w-4 h-4 mr-1" />
                  Quorum: {step.quorum}
                </div>
              )}
            </div>

            {/* Actions disponibles */}
            <div className="mt-3 flex flex-wrap gap-2">
              {Object.entries(step.actions_disponibles || {}).map(
                ([action, enabled]) =>
                  enabled && (
                    <span
                      key={action}
                      className="px-2 py-1 bg-gray-50 text-gray-600 rounded text-xs"
                    >
                      {action === "approve" && "Approuver"}
                      {action === "reject" && "Rejeter"}
                      {action === "return" && "Retourner"}
                      {action === "delegate" && "Déléguer"}
                      {action === "comment" && "Commenter"}
                    </span>
                  )
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex justify-between items-center">
        <h3 className="text-xl font-bold flex items-center">
          <Settings className="w-5 h-5 mr-2 text-blue-600" />
          Étapes du workflow
        </h3>
        <button
          onClick={() => setShowStepForm(true)}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center"
        >
          <Plus className="w-4 h-4 mr-2" />
          Ajouter une étape
        </button>
      </div>

      {/* Liste des étapes */}
      {loading ? (
        <div className="flex justify-center items-center py-8">
          <Loader className="w-8 h-8 animate-spin text-blue-600" />
        </div>
      ) : steps.length === 0 ? (
        <div className="text-center py-8 text-gray-500 bg-gray-50 rounded-lg">
          <Settings className="w-12 h-12 mx-auto mb-4 text-gray-300" />
          <p>Aucune étape configurée</p>
          <p className="text-sm mt-2">
            Commencez par ajouter une étape initiale
          </p>
        </div>
      ) : (
        <div className="space-y-6">
          {steps.map((step, index) => renderStepCard(step, index))}
        </div>
      )}

      {/* Formulaire d'étape */}
      {showStepForm && renderStepForm()}
    </div>
  );
};

// ==================== COMPOSANTS ADMINISTRATION AVEC APPELS API ====================
const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
const EntitiesManagement = ({ entities, onRefresh }) => {
  const [showForm, setShowForm] = useState(false);
  const [editingEntity, setEditingEntity] = useState(null);
  const [formData, setFormData] = useState({
    id: "",
    code: "",
    nom: "",
    type: "",
    adresse: "",
    ville: "",
    pays: "",
    telephone: "",
    email: "",
    responsable: "",
    entiteParente: "",
    statut: "active",
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editingEntity) {
        // Modification : utilise l'ID existant
        await administrationService.updateEntity(editingEntity.id, formData);
      } else {
        // Création : génère un nouvel UUID
        const newEntity = {
          ...formData,
          id: generateUUID(),
        };
        await administrationService.createEntity(newEntity);
      }
      await onRefresh();
      resetForm();
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer cette entité ?"))
      return;
    try {
      await administrationService.deleteEntity(id);
      alert("Entité supprimée avec succès !");
      await onRefresh();
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    }
  };

  const resetForm = () => {
    setFormData({
      code: "",
      nom: "",
      type: "",
      adresse: "",
      ville: "",
      pays: "",
      telephone: "",
      email: "",
      responsable: "",
      entiteParente: "",
      statut: "active",
    });
    setEditingEntity(null);
    setShowForm(false);
  };

  const handleEdit = (entity) => {
    setEditingEntity(entity);
    setFormData(entity);
    setShowForm(true);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold flex items-center">
            <Building2 className="w-6 h-6 mr-2 text-blue-600" />
            Gestion des Entités
          </h2>
          <button
            onClick={() => setShowForm(!showForm)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center"
          >
            <Plus className="w-5 h-5 mr-2" />
            Nouvelle entité
          </button>
        </div>

        {showForm && (
          <form
            onSubmit={handleSubmit}
            className="bg-gray-50 rounded-lg p-6 mb-6 space-y-4"
          >
            <h3 className="text-lg font-bold mb-4">
              {editingEntity ? "Modifier" : "Nouvelle"} Entité
            </h3>
            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Code *
                </label>
                <input
                  type="text"
                  value={formData.code}
                  onChange={(e) =>
                    setFormData({ ...formData, code: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Nom *
                </label>
                <input
                  type="text"
                  value={formData.nom}
                  onChange={(e) =>
                    setFormData({ ...formData, nom: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Type *
                </label>
                <select
                  value={formData.type}
                  onChange={(e) =>
                    setFormData({ ...formData, type: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                >
                  <option value="">Sélectionner</option>
                  <option value="Siège">Siège</option>
                  <option value="Direction">Direction</option>
                  <option value="Département">Département</option>
                  <option value="Service">Service</option>
                  <option value="Agence">Agence</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Adresse
                </label>
                <input
                  type="text"
                  value={formData.adresse}
                  onChange={(e) =>
                    setFormData({ ...formData, adresse: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Ville
                </label>
                <input
                  type="text"
                  value={formData.ville}
                  onChange={(e) =>
                    setFormData({ ...formData, ville: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">Pays</label>
                <input
                  type="text"
                  value={formData.pays}
                  onChange={(e) =>
                    setFormData({ ...formData, pays: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Téléphone
                </label>
                <input
                  type="tel"
                  value={formData.telephone}
                  onChange={(e) =>
                    setFormData({ ...formData, telephone: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Email
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Entité parente
                </label>
                <select
                  value={formData.entiteParente}
                  onChange={(e) =>
                    setFormData({ ...formData, entiteParente: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={saving}
                >
                  <option value="">Aucune</option>
                  {entities
                    .filter((e) => e.id !== editingEntity?.id)
                    .map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.nom}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="flex space-x-3">
              <button
                type="submit"
                disabled={saving}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
              >
                {saving ? (
                  <>
                    <Loader className="w-4 h-4 mr-2 animate-spin" />
                    Enregistrement...
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4 mr-2" />
                    {editingEntity ? "Modifier" : "Créer"}
                  </>
                )}
              </button>
              <button
                type="button"
                onClick={resetForm}
                className="border px-6 py-2 rounded-lg hover:bg-gray-50"
                disabled={saving}
              >
                Annuler
              </button>
            </div>
          </form>
        )}

        <div className="space-y-3">
          {entities.map((entity) => (
            <div
              key={entity.id}
              className="border rounded-lg p-4 hover:shadow-md transition"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center space-x-3 mb-2">
                    <h3 className="text-lg font-bold">{entity.nom}</h3>
                    <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-sm">
                      {entity.code}
                    </span>
                    <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-sm">
                      {entity.type}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm text-gray-600">
                    <p>
                      <span className="font-semibold">Ville:</span>{" "}
                      {entity.ville || "N/A"}
                    </p>
                    <p>
                      <span className="font-semibold">Pays:</span>{" "}
                      {entity.pays || "N/A"}
                    </p>
                    <p>
                      <span className="font-semibold">Tel:</span>{" "}
                      {entity.telephone || "N/A"}
                    </p>
                    <p>
                      <span className="font-semibold">Email:</span>{" "}
                      {entity.email || "N/A"}
                    </p>
                  </div>
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => handleEdit(entity)}
                    className="p-2 text-blue-600 hover:bg-blue-50 rounded"
                  >
                    <Edit className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => handleDelete(entity.id)}
                    className="p-2 text-red-600 hover:bg-red-50 rounded"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const AgentsManagement = ({ agents, entities, onRefresh }) => {
  const [showForm, setShowForm] = useState(false);
  const [editingAgent, setEditingAgent] = useState(null);
  const [formData, setFormData] = useState({
    id: "",
    matricule: "",
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
    fonction: "",
    categorie: "",
    entiteId: "",
    dateEntree: "",
    statut: "actif",
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editingAgent) {
        // Modification : utilise l'ID existant
        await administrationService.updateAgent(editingAgent.id, formData);
      } else {
        // Création : génère un nouvel UUID
        const newAgent = {
          ...formData,
          id: generateUUID(),
        };
        await administrationService.createAgent(newAgent);
      }

      await onRefresh();
      resetForm();
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer cet agent ?"))
      return;
    try {
      await administrationService.deleteAgent(id);
      alert("Agent supprimé avec succès !");
      await onRefresh();
    } catch (error) {
      alert(`Erreur: ${error.message}`);
    }
  };

  const resetForm = () => {
    setFormData({
      matricule: "",
      nom: "",
      prenom: "",
      email: "",
      telephone: "",
      fonction: "",
      categorie: "",
      entiteId: "",
      dateEntree: "",
      statut: "actif",
    });
    setEditingAgent(null);
    setShowForm(false);
  };

  const handleEdit = (agent) => {
    setEditingAgent(agent);
    setFormData(agent);
    setShowForm(true);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold flex items-center">
            <Users className="w-6 h-6 mr-2 text-blue-600" />
            Gestion des Agents
          </h2>
          <button
            onClick={() => setShowForm(!showForm)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center"
          >
            <UserPlus className="w-5 h-5 mr-2" />
            Nouvel agent
          </button>
        </div>

        {showForm && (
          <form
            onSubmit={handleSubmit}
            className="bg-gray-50 rounded-lg p-6 mb-6 space-y-4"
          >
            <h3 className="text-lg font-bold mb-4">
              {editingAgent ? "Modifier" : "Nouvel"} Agent
            </h3>
            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Matricule *
                </label>
                <input
                  type="text"
                  value={formData.matricule}
                  onChange={(e) =>
                    setFormData({ ...formData, matricule: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Nom *
                </label>
                <input
                  type="text"
                  value={formData.nom}
                  onChange={(e) =>
                    setFormData({ ...formData, nom: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Prénom *
                </label>
                <input
                  type="text"
                  value={formData.prenom}
                  onChange={(e) =>
                    setFormData({ ...formData, prenom: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Téléphone
                </label>
                <input
                  type="tel"
                  value={formData.telephone}
                  onChange={(e) =>
                    setFormData({ ...formData, telephone: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Fonction *
                </label>
                <input
                  type="text"
                  value={formData.fonction}
                  onChange={(e) =>
                    setFormData({ ...formData, fonction: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Catégorie *
                </label>
                <select
                  value={formData.categorie}
                  onChange={(e) =>
                    setFormData({ ...formData, categorie: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                >
                  <option value="">Sélectionner</option>
                  <option value="Cadre">Cadre</option>
                  <option value="Agent de maîtrise">Agent de maîtrise</option>
                  <option value="Employé">Employé</option>
                  <option value="Technicien">Technicien</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Entité *
                </label>
                <select
                  value={formData.entiteId}
                  onChange={(e) =>
                    setFormData({ ...formData, entiteId: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                >
                  <option value="">Sélectionner</option>
                  {entities.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.nom}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Date d'entrée
                </label>
                <input
                  type="date"
                  value={formData.dateEntree}
                  onChange={(e) =>
                    setFormData({ ...formData, dateEntree: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={saving}
                />
              </div>
            </div>
            <div className="flex space-x-3">
              <button
                type="submit"
                disabled={saving}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
              >
                {saving ? (
                  <>
                    <Loader className="w-4 h-4 mr-2 animate-spin" />
                    Enregistrement...
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4 mr-2" />
                    {editingAgent ? "Modifier" : "Créer"}
                  </>
                )}
              </button>
              <button
                type="button"
                onClick={resetForm}
                className="border px-6 py-2 rounded-lg hover:bg-gray-50"
                disabled={saving}
              >
                Annuler
              </button>
            </div>
          </form>
        )}

        <div className="space-y-3">
          {agents.map((agent) => {
            const entity = entities.find((e) => e.id === agent.entiteId);
            return (
              <div
                key={agent.id}
                className="border rounded-lg p-4 hover:shadow-md transition"
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="flex items-center space-x-3 mb-2">
                      <h3 className="text-lg font-bold">
                        {agent.prenom} {agent.nom}
                      </h3>
                      <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-sm">
                        {agent.matricule}
                      </span>
                      <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-sm">
                        {agent.statut}
                      </span>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm text-gray-600">
                      <p>
                        <span className="font-semibold">Fonction:</span>{" "}
                        {agent.fonction}
                      </p>
                      <p>
                        <span className="font-semibold">Catégorie:</span>{" "}
                        {agent.categorie}
                      </p>
                      <p>
                        <span className="font-semibold">Entité:</span>{" "}
                        {entity?.nom || "N/A"}
                      </p>
                      <p>
                        <span className="font-semibold">Email:</span>{" "}
                        {agent.email}
                      </p>
                    </div>
                  </div>
                  <div className="flex space-x-2">
                    <button
                      onClick={() => handleEdit(agent)}
                      className="p-2 text-blue-600 hover:bg-blue-50 rounded"
                    >
                      <Edit className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => handleDelete(agent.id)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const ProfilesManagement = ({ profiles, onRefresh }) => {
  const [showForm, setShowForm] = useState(false);
  const [editingProfile, setEditingProfile] = useState(null);
  const [formData, setFormData] = useState({
    id: "",
    nom: "",
    description: "",
    droits: [],
  });
  const [saving, setSaving] = useState(false);

  const availableDroits = [
    { id: "demandes_create", label: "Créer des demandes" },
    { id: "demandes_read", label: "Consulter les demandes" },
    { id: "demandes_update", label: "Modifier les demandes" },
    { id: "demandes_delete", label: "Supprimer les demandes" },
    { id: "demandes_approve", label: "Approuver les demandes" },
    { id: "billets_emit", label: "Émettre des billets" },
    { id: "admin_entities", label: "Gérer les entités" },
    { id: "workflow_view", label: "Consulter les workflows" },
    { id: "workflow_admin", label: "Administrer les workflows" },
    {
      id: "workflow_template_create",
      label: "Créer des templates de workflow",
    },
    { id: "workflow_acl_manage", label: "Gérer les ACL des workflows" },
    { id: "direct_purchase", label: "Achat direct sans demande" },
    { id: "admin_agents", label: "Gérer les agents" },
    { id: "admin_users", label: "Gérer les utilisateurs" },
    { id: "admin_profiles", label: "Gérer les profils" },
    { id: "reports_view", label: "Consulter les rapports" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editingProfile) {
        // Modification : utilise l'ID existant
        await administrationService.updateProfile(editingProfile.id, formData);
      } else {
        // Création : génère un nouvel UUID
        const newProfil = {
          ...formData,
          id: generateUUID(),
        };
        await administrationService.createProfile(newProfil);
      }

      await onRefresh();
      resetForm();
    } catch (error) {
      toast.error(`Erreur: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce profil ?"))
      return;
    try {
      await administrationService.deleteProfile(id);
      toast.success("Profil supprimé avec succès !");
      await onRefresh();
    } catch (error) {
      toast.error(`Erreur: ${error.message}`);
    }
  };

  const resetForm = () => {
    setFormData({ nom: "", description: "", droits: [] });
    setEditingProfile(null);
    setShowForm(false);
  };

  const handleEdit = (profile) => {
    setEditingProfile(profile);
    setFormData(profile);
    setShowForm(true);
  };

  const toggleDroit = (droitId) => {
    const newDroits = formData.droits.includes(droitId)
      ? formData.droits.filter((d) => d !== droitId)
      : [...formData.droits, droitId];
    setFormData({ ...formData, droits: newDroits });
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold flex items-center">
            <Shield className="w-6 h-6 mr-2 text-blue-600" />
            Gestion des Profils
          </h2>
          <button
            onClick={() => setShowForm(!showForm)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center"
          >
            <Plus className="w-5 h-5 mr-2" />
            Nouveau profil
          </button>
        </div>

        {showForm && (
          <form
            onSubmit={handleSubmit}
            className="bg-gray-50 rounded-lg p-6 mb-6 space-y-4"
          >
            <h3 className="text-lg font-bold mb-4">
              {editingProfile ? "Modifier" : "Nouveau"} Profil
            </h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Nom du profil *
                </label>
                <input
                  type="text"
                  value={formData.nom}
                  onChange={(e) =>
                    setFormData({ ...formData, nom: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Description
                </label>
                <input
                  type="text"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={saving}
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold mb-3">
                Droits d'accès
              </label>
              <div className="grid md:grid-cols-2 gap-3">
                {availableDroits.map((droit) => (
                  <label
                    key={droit.id}
                    className="flex items-center space-x-2 p-3 border rounded-lg hover:bg-white cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      checked={formData.droits.includes(droit.id)}
                      onChange={() => toggleDroit(droit.id)}
                      className="w-4 h-4"
                      disabled={saving}
                    />
                    <span className="text-sm">{droit.label}</span>
                  </label>
                ))}
              </div>
            </div>
            <div className="flex space-x-3">
              <button
                type="submit"
                disabled={saving}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
              >
                {saving ? (
                  <>
                    <Loader className="w-4 h-4 mr-2 animate-spin" />
                    Enregistrement...
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4 mr-2" />
                    {editingProfile ? "Modifier" : "Créer"}
                  </>
                )}
              </button>
              <button
                type="button"
                onClick={resetForm}
                className="border px-6 py-2 rounded-lg hover:bg-gray-50"
                disabled={saving}
              >
                Annuler
              </button>
            </div>
          </form>
        )}

        <div className="space-y-3">
          {profiles.map((profile) => (
            <div
              key={profile.id}
              className="border rounded-lg p-4 hover:shadow-md transition"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center space-x-3 mb-2">
                    <h3 className="text-lg font-bold">{profile.nom}</h3>
                    <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-sm">
                      {profile.droits?.length || 0} droits
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mb-3">
                    {profile.description}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {profile.droits?.map((droitId) => {
                      const droit = availableDroits.find(
                        (d) => d.id === droitId
                      );
                      return droit ? (
                        <span
                          key={droitId}
                          className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs"
                        >
                          {droit.label}
                        </span>
                      ) : null;
                    })}
                  </div>
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => handleEdit(profile)}
                    className="p-2 text-blue-600 hover:bg-blue-50 rounded"
                  >
                    <Edit className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => handleDelete(profile.id)}
                    className="p-2 text-red-600 hover:bg-red-50 rounded"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

//import { Shield, UserPlus, Save, Edit, Trash2, Loader } from 'lucide-react';

const UsersManagement = ({ users, profiles, agents, onRefresh }) => {
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    id: "",
    username: "",
    email: "",
    password: "",
    agentId: "",
    profilId: "",
    statut: "actif",
  });
  const [saving, setSaving] = useState(false);

  // Fonction pour générer un UUID (si non fourni par une librairie externe)
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      let userData = { ...formData };

      if (editingUser) {
        // MODIFICATION - Gestion du mot de passe
        if (formData.password) {
          // Si un nouveau mot de passe est fourni, l'envoyer en clair
          await administrationService.updateUser(editingUser.id, userData);
        } else {
          // Si pas de nouveau mot de passe, ne pas inclure le champ password
          const { password, ...userDataWithoutPassword } = userData;
          await administrationService.updateUser(
            editingUser.id,
            userDataWithoutPassword
          );
        }
      } else {
        // CRÉATION - Envoyer le mot de passe en CLAIR (le backend le hachera)
        const NewUser = {
          ...userData,
          id: generateUUID(),
          dateCreation: new Date().toISOString(),
        };
        await administrationService.createUser(NewUser);
      }

      await onRefresh();
      resetForm();
    } catch (error) {
      console.error("Erreur lors de la sauvegarde:", error);
      toast.error(`Erreur: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer cet utilisateur ?"))
      return;

    try {
      await administrationService.deleteUser(id);
      toast.success("Utilisateur supprimé avec succès !");
      await onRefresh();
    } catch (error) {
      console.error("Erreur lors de la suppression:", error);
      toast.error(`Erreur: ${error.message}`);
    }
  };

  const resetForm = () => {
    setFormData({
      username: "",
      email: "",
      password: "",
      agentId: "",
      profilId: "",
      statut: "actif",
    });
    setEditingUser(null);
    setShowForm(false);
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      ...user,
      password: "", // Réinitialiser le champ mot de passe en modification
    });
    setShowForm(true);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold flex items-center text-gray-800">
            <Shield className="w-6 h-6 mr-2 text-blue-600" />
            Gestion des Utilisateurs
          </h2>
          <button
            onClick={() => setShowForm(!showForm)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center transition-colors duration-200"
          >
            <UserPlus className="w-5 h-5 mr-2" />
            {showForm ? "Masquer le formulaire" : "Nouvel utilisateur"}
          </button>
        </div>

        {/* Formulaire de création/modification */}
        {showForm && (
          <form
            onSubmit={handleSubmit}
            className="bg-gray-50 rounded-lg p-6 mb-6 space-y-4 border border-gray-200"
          >
            <h3 className="text-lg font-bold text-gray-800 mb-4">
              {editingUser
                ? "Modifier l'utilisateur"
                : "Créer un nouvel utilisateur"}
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {/* Nom d'utilisateur */}
              <div>
                <label className="block text-sm font-semibold mb-2 text-gray-700">
                  Nom d'utilisateur *
                </label>
                <input
                  type="text"
                  value={formData.username}
                  onChange={(e) =>
                    setFormData({ ...formData, username: e.target.value })
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                  disabled={saving}
                  placeholder="ex: john.doe"
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-semibold mb-2 text-gray-700">
                  Email *
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                  disabled={saving}
                  placeholder="ex: john.doe@example.com"
                />
              </div>

              {/* Mot de passe */}
              <div>
                <label className="block text-sm font-semibold mb-2 text-gray-700">
                  Mot de passe{" "}
                  {editingUser && "(laisser vide pour ne pas changer)"}
                  {!editingUser && "*"}
                </label>
                <input
                  type="password"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required={!editingUser}
                  disabled={saving}
                  placeholder={
                    editingUser ? "Nouveau mot de passe" : "Mot de passe"
                  }
                  minLength={6}
                />
                {!editingUser && (
                  <p className="text-xs text-gray-500 mt-1">
                    Le mot de passe sera haché de manière sécurisée par le
                    serveur
                  </p>
                )}
              </div>

              {/* Agent rattaché */}
              <div>
                <label className="block text-sm font-semibold mb-2 text-gray-700">
                  Agent rattaché *
                </label>
                <select
                  value={formData.agentId}
                  onChange={(e) =>
                    setFormData({ ...formData, agentId: e.target.value })
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                  disabled={saving}
                >
                  <option value="">Sélectionner un agent</option>
                  {agents.map((agent) => (
                    <option key={agent.id} value={agent.id}>
                      {agent.prenom} {agent.nom} ({agent.matricule})
                    </option>
                  ))}
                </select>
              </div>

              {/* Profil */}
              <div>
                <label className="block text-sm font-semibold mb-2 text-gray-700">
                  Profil *
                </label>
                <select
                  value={formData.profilId}
                  onChange={(e) =>
                    setFormData({ ...formData, profilId: e.target.value })
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                  disabled={saving}
                >
                  <option value="">Sélectionner un profil</option>
                  {profiles.map((profil) => (
                    <option key={profil.id} value={profil.id}>
                      {profil.nom}
                    </option>
                  ))}
                </select>
              </div>

              {/* Statut */}
              <div>
                <label className="block text-sm font-semibold mb-2 text-gray-700">
                  Statut
                </label>
                <select
                  value={formData.statut}
                  onChange={(e) =>
                    setFormData({ ...formData, statut: e.target.value })
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  disabled={saving}
                >
                  <option value="actif">Actif</option>
                  <option value="inactif">Inactif</option>
                  <option value="suspendu">Suspendu</option>
                </select>
              </div>
            </div>

            {/* Boutons d'action */}
            <div className="flex space-x-3 pt-4">
              <button
                type="submit"
                disabled={saving}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
              >
                {saving ? (
                  <>
                    <Loader className="w-4 h-4 mr-2 animate-spin" />
                    Enregistrement...
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4 mr-2" />
                    {editingUser ? "Modifier" : "Créer"}
                  </>
                )}
              </button>
              <button
                type="button"
                onClick={resetForm}
                className="border border-gray-300 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                disabled={saving}
              >
                Annuler
              </button>
            </div>
          </form>
        )}

        {/* Liste des utilisateurs */}
        <div className="space-y-4">
          {users.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              <Shield className="w-12 h-12 mx-auto mb-4 text-gray-300" />
              <p>Aucun utilisateur trouvé</p>
            </div>
          ) : (
            users.map((user) => {
              const agent = agents.find((a) => a.id === user.agentId);
              const profil = profiles.find((p) => p.id === user.profilId);

              return (
                <div
                  key={user.id}
                  className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow duration-200 bg-white"
                >
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      {/* En-tête avec nom d'utilisateur et badges */}
                      <div className="flex items-center space-x-3 mb-3">
                        <h3 className="text-lg font-bold text-gray-800">
                          {user.username}
                        </h3>
                        <span className="px-2 py-1 bg-indigo-100 text-indigo-700 rounded text-sm font-medium">
                          {profil?.nom || "Profil non assigné"}
                        </span>
                        <span
                          className={`px-2 py-1 rounded text-sm font-medium ${
                            user.statut === "actif"
                              ? "bg-green-100 text-green-700"
                              : user.statut === "inactif"
                              ? "bg-yellow-100 text-yellow-700"
                              : "bg-red-100 text-red-700"
                          }`}
                        >
                          {user.statut?.charAt(0).toUpperCase() +
                            user.statut?.slice(1) || "Inconnu"}
                        </span>
                      </div>

                      {/* Informations détaillées */}
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 text-sm text-gray-600">
                        <div>
                          <span className="font-semibold text-gray-700">
                            Email:
                          </span>
                          <p className="truncate">{user.email}</p>
                        </div>
                        <div>
                          <span className="font-semibold text-gray-700">
                            Agent rattaché:
                          </span>
                          <p>
                            {agent
                              ? `${agent.prenom} ${agent.nom}`
                              : "Non assigné"}
                          </p>
                        </div>
                        <div>
                          <span className="font-semibold text-gray-700">
                            Matricule:
                          </span>
                          <p>{agent?.matricule || "N/A"}</p>
                        </div>
                        <div>
                          <span className="font-semibold text-gray-700">
                            Date de création:
                          </span>
                          <p>
                            {user.dateCreation
                              ? new Date(user.dateCreation).toLocaleDateString(
                                  "fr-FR"
                                )
                              : "N/A"}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Boutons d'action */}
                    <div className="flex space-x-2 ml-4">
                      <button
                        onClick={() => handleEdit(user)}
                        className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                        title="Modifier"
                      >
                        <Edit className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => handleDelete(user.id)}
                        className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
                        title="Supprimer"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

// ==================== MODULE PRINCIPAL ADMINISTRATION AVEC APPELS API ====================

const AdministrationModule = () => {
  const [activeTab, setActiveTab] = useState("entities");
  const [entities, setEntities] = useState([]);
  const [agents, setAgents] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadAllData();
  }, []);

  const loadAllData = async () => {
    setLoading(true);
    setError(null);
    try {
      const [entitiesData, agentsData, profilesData, usersData] =
        await Promise.all([
          administrationService.getEntities(),
          administrationService.getAgents(),
          administrationService.getProfiles(),
          administrationService.getUsers(),
        ]);

      setEntities(entitiesData);
      setAgents(agentsData);
      setProfiles(profilesData);
      setUsers(usersData);
    } catch (error) {
      console.error("Erreur chargement données:", error);
      setError("Erreur lors du chargement des données: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const tabs = [
    { id: "entities", label: "Entités", icon: Building2 },
    { id: "agents", label: "Agents", icon: Users },
    { id: "profiles", label: "Profils", icon: Shield },
    { id: "users", label: "Utilisateurs", icon: UserPlus },
    { id: "workflow", label: "workflow", icon: UserPlus },
  ];

  if (loading && entities.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-md p-12 text-center">
        <Loader className="w-12 h-12 text-blue-600 mx-auto mb-4 animate-spin" />
        <p className="text-gray-600">
          Chargement du module d'administration...
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold flex items-center">
            <Settings className="w-8 h-8 mr-3 text-blue-600" />
            Administration
          </h1>
          <button
            onClick={loadAllData}
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
          >
            {loading ? (
              <>
                <Loader className="w-4 h-4 mr-2 animate-spin" />
                Actualisation...
              </>
            ) : (
              <>
                <Download className="w-4 h-4 mr-2" />
                Actualiser
              </>
            )}
          </button>
        </div>

        {error && (
          <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-4">
            <p className="text-red-600 font-semibold">{error}</p>
            <button
              onClick={loadAllData}
              className="mt-2 text-sm text-red-700 underline"
            >
              Réessayer
            </button>
          </div>
        )}

        <div className="grid md:grid-cols-4 gap-4 mb-6">
          <div className="bg-blue-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Entités</p>
                <p className="text-2xl font-bold text-blue-600">
                  {entities.length}
                </p>
              </div>
              <Building2 className="w-10 h-10 text-blue-600 opacity-20" />
            </div>
          </div>
          <div className="bg-purple-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Agents</p>
                <p className="text-2xl font-bold text-purple-600">
                  {agents.length}
                </p>
              </div>
              <Users className="w-10 h-10 text-purple-600 opacity-20" />
            </div>
          </div>
          <div className="bg-green-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Profils</p>
                <p className="text-2xl font-bold text-green-600">
                  {profiles.length}
                </p>
              </div>
              <Shield className="w-10 h-10 text-green-600 opacity-20" />
            </div>
          </div>
          <div className="bg-orange-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Utilisateurs</p>
                <p className="text-2xl font-bold text-orange-600">
                  {users.length}
                </p>
              </div>
              <UserPlus className="w-10 h-10 text-orange-600 opacity-20" />
            </div>
          </div>
        </div>

        <div className="flex space-x-2 border-b overflow-x-auto">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 font-semibold flex items-center space-x-2 border-b-2 transition whitespace-nowrap ${
                  activeTab === tab.id
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-gray-600 hover:text-blue-600"
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {activeTab === "entities" && (
        <EntitiesManagement entities={entities} onRefresh={loadAllData} />
      )}

      {activeTab === "agents" && (
        <AgentsManagement
          agents={agents}
          entities={entities}
          onRefresh={loadAllData}
        />
      )}

      {activeTab === "profiles" && (
        <ProfilesManagement profiles={profiles} onRefresh={loadAllData} />
      )}

      {activeTab === "users" && (
        <UsersManagement
          users={users}
          profiles={profiles}
          agents={agents}
          onRefresh={loadAllData}
        />
      )}

      {activeTab === "workflows" && (
        <WorkflowManagement
          entities={entities} // ✅ Correct - pour associer les workflows aux entités
          agents={agents} // ✅ Correct - pour assigner les validateurs
          profiles={profiles} // ✅ Correct - pour gérer les permissions par profil
          onRefresh={loadAllData} // ✅ Correct - ou loadAllData selon votre préférence
        />
      )}
    </div>
  );
};
// ==================== SERVICES API ADMINISTRATION ====================

const administrationService = {
  // ==================== ENTITÉS ====================
  getEntities: async () => {
    const response = await fetch(`${API_BASE_URL2}/travel-entities`);
    if (!response.ok) throw new Error("Erreur récupération entités");
    return await response.json();
  },

  getEntityById: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/travel-entities/${id}`);
    if (!response.ok) throw new Error("Erreur récupération entité");
    return await response.json();
  },

  getEntityByCode: async (code) => {
    const response = await fetch(
      `${API_BASE_URL2}/travel-entities/code/${code}`
    );
    if (!response.ok) throw new Error("Erreur récupération entité");
    return await response.json();
  },

  getEntitiesByType: async (type) => {
    const response = await fetch(
      `${API_BASE_URL2}/travel-entities/type/${type}`
    );
    if (!response.ok) throw new Error("Erreur récupération entités par type");
    return await response.json();
  },

  createEntity: async (data) => {
    const response = await fetch(`${API_BASE_URL2}/travel-entities`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur création entité");
    }
    return await response.json();
  },

  updateEntity: async (id, data) => {
    const response = await fetch(`${API_BASE_URL2}/travel-entities/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur mise à jour entité");
    }
    return await response.json();
  },

  deleteEntity: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/travel-entities/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur suppression entité");
    }
    return await response.json();
  },

  // ==================== AGENTS ====================
  getAgents: async () => {
    const response = await fetch(`${API_BASE_URL2}/travel-agents`);
    if (!response.ok) throw new Error("Erreur récupération agents");
    return await response.json();
  },

  getAgentById: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/travel-agents/${id}`);
    if (!response.ok) throw new Error("Erreur récupération agent");
    return await response.json();
  },

  getAgentByMatricule: async (matricule) => {
    const response = await fetch(
      `${API_BASE_URL2}/travel-agents/matricule/${matricule}`
    );
    if (!response.ok) throw new Error("Erreur récupération agent");
    return await response.json();
  },

  getAgentByEmail: async (email) => {
    const response = await fetch(
      `${API_BASE_URL2}/travel-agents/email/${encodeURIComponent(email)}`
    );
    if (!response.ok) throw new Error("Erreur récupération agent");
    return await response.json();
  },

  getAgentsByEntite: async (entiteId) => {
    const response = await fetch(
      `${API_BASE_URL2}/travel-agents/entite/${entiteId}`
    );
    if (!response.ok) throw new Error("Erreur récupération agents par entité");
    return await response.json();
  },

  getAgentsByCategorie: async (categorie) => {
    const response = await fetch(
      `${API_BASE_URL2}/travel-agents/categorie/${categorie}`
    );
    if (!response.ok)
      throw new Error("Erreur récupération agents par catégorie");
    return await response.json();
  },

  createAgent: async (data) => {
    const response = await fetch(`${API_BASE_URL2}/travel-agents`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur création agent");
    }
    return await response.json();
  },

  updateAgent: async (id, data) => {
    const response = await fetch(`${API_BASE_URL2}/travel-agents/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur mise à jour agent");
    }
    return await response.json();
  },

  deleteAgent: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/travel-agents/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur suppression agent");
    }
    return await response.json();
  },

  // ==================== PROFILS ====================
  getProfiles: async () => {
    const response = await fetch(`${API_BASE_URL2}/travel-profiles`);
    if (!response.ok) throw new Error("Erreur récupération profils");
    return await response.json();
  },

  getProfileById: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/travel-profiles/${id}`);
    if (!response.ok) throw new Error("Erreur récupération profil");
    return await response.json();
  },

  getProfileByNom: async (nom) => {
    const response = await fetch(`${API_BASE_URL2}/travel-profiles/nom/${nom}`);
    if (!response.ok) throw new Error("Erreur récupération profil");
    return await response.json();
  },

  createProfile: async (data) => {
    const response = await fetch(`${API_BASE_URL2}/travel-profiles`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur création profil");
    }
    return await response.json();
  },

  updateProfile: async (id, data) => {
    const response = await fetch(`${API_BASE_URL2}/travel-profiles/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur mise à jour profil");
    }
    return await response.json();
  },

  deleteProfile: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/travel-profiles/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur suppression profil");
    }
    return await response.json();
  },

  // ==================== UTILISATEURS ====================
  getUsers: async () => {
    const response = await fetch(`${API_BASE_URL2}/travel-users`);
    if (!response.ok) throw new Error("Erreur récupération utilisateurs");
    return await response.json();
  },

  getUserById: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/travel-users/${id}`);
    if (!response.ok) throw new Error("Erreur récupération utilisateur");
    return await response.json();
  },

  getUserByUsername: async (username) => {
    const response = await fetch(
      `${API_BASE_URL2}/travel-users/username/${username}`
    );
    if (!response.ok) throw new Error("Erreur récupération utilisateur");
    return await response.json();
  },

  getUserByEmail: async (email) => {
    const response = await fetch(
      `${API_BASE_URL2}/travel-users/email/${encodeURIComponent(email)}`
    );
    if (!response.ok) throw new Error("Erreur récupération utilisateur");
    return await response.json();
  },

  createUser: async (data) => {
    const response = await fetch(`${API_BASE_URL2}/travel-users`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur création utilisateur");
    }
    return await response.json();
  },

  updateUser: async (id, data) => {
    const response = await fetch(`${API_BASE_URL2}/travel-users/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur mise à jour utilisateur");
    }
    return await response.json();
  },

  deleteUser: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/travel-users/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur suppression utilisateur");
    }
    return await response.json();
  },
};
// ==================== MODULES VOLS ====================

// ==================== COMPOSANT RECHERCHE DE VOLS AMÉLIORÉ ====================

const FlightSearch = ({ onSelectFlight }) => {
  const [searchParams, setSearchParams] = useState({
    originLocationCode: "",
    destinationLocationCode: "",
    departureDate: "",
    returnDate: "",
    adults: "1",
    children: "0",
    infants: "0",
    max: "10",
    tripType: "one-way", // 'one-way' ou 'round-trip'
    travelClass: "ECONOMY", // ECONOMY, PREMIUM_ECONOMY, BUSINESS, FIRST
  });
  const [flights, setFlights] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Valider la date de retour pour aller-retour
      if (searchParams.tripType === "round-trip" && !searchParams.returnDate) {
        setError(
          "Veuillez sélectionner une date de retour pour un vol aller-retour"
        );
        setLoading(false);
        return;
      }

      // Vérifier que la date de retour est après la date de départ
      if (searchParams.tripType === "round-trip" && searchParams.returnDate) {
        const depDate = new Date(searchParams.departureDate);
        const retDate = new Date(searchParams.returnDate);
        if (retDate <= depDate) {
          setError("La date de retour doit être après la date de départ");
          setLoading(false);
          return;
        }
      }

      const results = await amadeusService.searchFlights(searchParams);
      setFlights(results.data || []);

      if (!results.data || results.data.length === 0) {
        setError("Aucun vol trouvé pour ces critères.");
      }
    } catch (err) {
      console.error("Erreur recherche vols:", err);
      setError("Erreur lors de la recherche. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  const handleTripTypeChange = (type) => {
    setSearchParams({
      ...searchParams,
      tripType: type,
      returnDate: type === "one-way" ? "" : searchParams.returnDate,
    });
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <Plane className="w-6 h-6 mr-2 text-blue-600" />
          Rechercher un vol
        </h2>

        <form onSubmit={handleSearch} className="space-y-4">
          {/* Type de voyage */}
          <div className="bg-blue-50 rounded-lg p-4 mb-4">
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Type de voyage *
            </label>
            <div className="flex space-x-4">
              <button
                type="button"
                onClick={() => handleTripTypeChange("one-way")}
                className={`flex-1 py-3 px-4 rounded-lg font-semibold transition ${
                  searchParams.tripType === "one-way"
                    ? "bg-blue-600 text-white shadow-md"
                    : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400"
                }`}
              >
                <div className="flex items-center justify-center">
                  <Plane className="w-5 h-5 mr-2" />
                  Aller simple
                </div>
              </button>
              <button
                type="button"
                onClick={() => handleTripTypeChange("round-trip")}
                className={`flex-1 py-3 px-4 rounded-lg font-semibold transition ${
                  searchParams.tripType === "round-trip"
                    ? "bg-blue-600 text-white shadow-md"
                    : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400"
                }`}
              >
                <div className="flex items-center justify-center">
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                    />
                  </svg>
                  Aller-retour
                </div>
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* Aéroport de départ */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <MapPin className="w-4 h-4 inline mr-1" />
                Départ (Aéroport) *
              </label>
              <select
                name="originLocationCode"
                value={searchParams.originLocationCode}
                onChange={(e) =>
                  setSearchParams((prev) => ({
                    ...prev,
                    originLocationCode: e.target.value,
                  }))
                }
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Sélectionnez un aéroport de départ</option>

                {/* Afrique */}
                <optgroup label="Afrique">
                  <option value="ABJ">Abidjan, Côte d'Ivoire (ABJ)</option>
                  <option value="ACC">Accra, Ghana (ACC)</option>
                  <option value="ADD">Addis-Abeba, Éthiopie (ADD)</option>
                  <option value="ALG">Alger, Algérie (ALG)</option>
                  <option value="CMN">Casablanca, Maroc (CMN)</option>
                  <option value="COO">Cotonou, Bénin (COO)</option>
                  <option value="DKR">Dakar, Sénégal (DKR)</option>
                  <option value="DAR">Dar es Salaam, Tanzanie (DAR)</option>
                  <option value="EBB">Entebbe, Ouganda (EBB)</option>
                  <option value="FIH">Kinshasa, RDC (FIH)</option>
                  <option value="JNB">
                    Johannesburg, Afrique du Sud (JNB)
                  </option>
                  <option value="KGL">Kigali, Rwanda (KGL)</option>
                  <option value="LAD">Luanda, Angola (LAD)</option>
                  <option value="LOS">Lagos, Nigeria (LOS)</option>
                  <option value="NBO">Nairobi, Kenya (NBO)</option>
                  <option value="RAI">Praia, Cap-Vert (RAI)</option>
                  <option value="TUN">Tunis, Tunisie (TUN)</option>
                </optgroup>

                {/* Europe */}
                <optgroup label="Europe">
                  <option value="AMS">Amsterdam, Pays-Bas (AMS)</option>
                  <option value="BCN">Barcelone, Espagne (BCN)</option>
                  <option value="BER">Berlin, Allemagne (BER)</option>
                  <option value="BRU">Bruxelles, Belgique (BRU)</option>
                  <option value="CDG">
                    Paris Charles de Gaulle, France (CDG)
                  </option>
                  <option value="FCO">Rome Fiumicino, Italie (FCO)</option>
                  <option value="FRA">Francfort, Allemagne (FRA)</option>
                  <option value="GVA">Genève, Suisse (GVA)</option>
                  <option value="IST">Istanbul, Turquie (IST)</option>
                  <option value="LHR">
                    Londres Heathrow, Royaume-Uni (LHR)
                  </option>
                  <option value="LIS">Lisbonne, Portugal (LIS)</option>
                  <option value="MAD">Madrid, Espagne (MAD)</option>
                  <option value="MUC">Munich, Allemagne (MUC)</option>
                  <option value="ORY">Paris Orly, France (ORY)</option>
                  <option value="VIE">Vienne, Autriche (VIE)</option>
                  <option value="ZRH">Zurich, Suisse (ZRH)</option>
                </optgroup>

                {/* Amérique du Nord */}
                <optgroup label="Amérique du Nord">
                  <option value="ATL">Atlanta, USA (ATL)</option>
                  <option value="DFW">Dallas, USA (DFW)</option>
                  <option value="DTW">Detroit, USA (DTW)</option>
                  <option value="JFK">New York JFK, USA (JFK)</option>
                  <option value="LAX">Los Angeles, USA (LAX)</option>
                  <option value="MIA">Miami, USA (MIA)</option>
                  <option value="ORD">Chicago, USA (ORD)</option>
                  <option value="SFO">San Francisco, USA (SFO)</option>
                  <option value="YYZ">Toronto, Canada (YYZ)</option>
                  <option value="YUL">Montréal, Canada (YUL)</option>
                </optgroup>

                {/* Amérique du Sud */}
                <optgroup label="Amérique du Sud">
                  <option value="BOG">Bogota, Colombie (BOG)</option>
                  <option value="EZE">Buenos Aires, Argentine (EZE)</option>
                  <option value="GRU">São Paulo, Brésil (GRU)</option>
                  <option value="LIM">Lima, Pérou (LIM)</option>
                  <option value="SCL">Santiago, Chili (SCL)</option>
                </optgroup>

                {/* Asie */}
                <optgroup label="Asie">
                  <option value="BKK">Bangkok, Thaïlande (BKK)</option>
                  <option value="CAN">Guangzhou, Chine (CAN)</option>
                  <option value="DEL">Delhi, Inde (DEL)</option>
                  <option value="DXB">Dubaï, Émirats Arabes Unis (DXB)</option>
                  <option value="HKG">Hong Kong (HKG)</option>
                  <option value="ICN">Séoul, Corée du Sud (ICN)</option>
                  <option value="KUL">Kuala Lumpur, Malaisie (KUL)</option>
                  <option value="NRT">Tokyo Narita, Japon (NRT)</option>
                  <option value="PEK">Pékin, Chine (PEK)</option>
                  <option value="PVG">Shanghai Pudong, Chine (PVG)</option>
                  <option value="SIN">Singapour (SIN)</option>
                </optgroup>

                {/* Océanie */}
                <optgroup label="Océanie">
                  <option value="AKL">Auckland, Nouvelle-Zélande (AKL)</option>
                  <option value="BNE">Brisbane, Australie (BNE)</option>
                  <option value="MEL">Melbourne, Australie (MEL)</option>
                  <option value="SYD">Sydney, Australie (SYD)</option>
                </optgroup>

                {/* Moyen-Orient */}
                <optgroup label="Moyen-Orient">
                  <option value="AUH">
                    Abu Dhabi, Émirats Arabes Unis (AUH)
                  </option>
                  <option value="BAH">Bahreïn (BAH)</option>
                  <option value="DOH">Doha, Qatar (DOH)</option>
                  <option value="JED">Jeddah, Arabie Saoudite (JED)</option>
                  <option value="RUH">Riyad, Arabie Saoudite (RUH)</option>
                  <option value="TLV">Tel Aviv, Israël (TLV)</option>
                </optgroup>
              </select>
              <p className="text-xs text-gray-500 mt-1">
                Sélectionnez votre aéroport de départ
              </p>
            </div>

            {/* Aéroport d'arrivée */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <MapPin className="w-4 h-4 inline mr-1" />
                Arrivée (Aéroport) *
              </label>
              <select
                name="destinationLocationCode"
                value={searchParams.destinationLocationCode}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    destinationLocationCode: e.target.value,
                  })
                }
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Sélectionnez un aéroport d'arrivée</option>

                {/* Afrique */}
                <optgroup label="Afrique">
                  <option value="ABJ">Abidjan, Côte d'Ivoire (ABJ)</option>
                  <option value="ACC">Accra, Ghana (ACC)</option>
                  <option value="ADD">Addis-Abeba, Éthiopie (ADD)</option>
                  <option value="ALG">Alger, Algérie (ALG)</option>
                  <option value="CMN">Casablanca, Maroc (CMN)</option>
                  <option value="COO">Cotonou, Bénin (COO)</option>
                  <option value="DKR">Dakar, Sénégal (DKR)</option>
                  <option value="DAR">Dar es Salaam, Tanzanie (DAR)</option>
                  <option value="EBB">Entebbe, Ouganda (EBB)</option>
                  <option value="FIH">Kinshasa, RDC (FIH)</option>
                  <option value="JNB">
                    Johannesburg, Afrique du Sud (JNB)
                  </option>
                  <option value="KGL">Kigali, Rwanda (KGL)</option>
                  <option value="LAD">Luanda, Angola (LAD)</option>
                  <option value="LOS">Lagos, Nigeria (LOS)</option>
                  <option value="NBO">Nairobi, Kenya (NBO)</option>
                  <option value="RAI">Praia, Cap-Vert (RAI)</option>
                  <option value="TUN">Tunis, Tunisie (TUN)</option>
                </optgroup>

                {/* Europe */}
                <optgroup label="Europe">
                  <option value="AMS">Amsterdam, Pays-Bas (AMS)</option>
                  <option value="BCN">Barcelone, Espagne (BCN)</option>
                  <option value="BER">Berlin, Allemagne (BER)</option>
                  <option value="BRU">Bruxelles, Belgique (BRU)</option>
                  <option value="CDG">
                    Paris Charles de Gaulle, France (CDG)
                  </option>
                  <option value="FCO">Rome Fiumicino, Italie (FCO)</option>
                  <option value="FRA">Francfort, Allemagne (FRA)</option>
                  <option value="GVA">Genève, Suisse (GVA)</option>
                  <option value="IST">Istanbul, Turquie (IST)</option>
                  <option value="LHR">
                    Londres Heathrow, Royaume-Uni (LHR)
                  </option>
                  <option value="LIS">Lisbonne, Portugal (LIS)</option>
                  <option value="MAD">Madrid, Espagne (MAD)</option>
                  <option value="MUC">Munich, Allemagne (MUC)</option>
                  <option value="ORY">Paris Orly, France (ORY)</option>
                  <option value="VIE">Vienne, Autriche (VIE)</option>
                  <option value="ZRH">Zurich, Suisse (ZRH)</option>
                </optgroup>

                {/* Amérique du Nord */}
                <optgroup label="Amérique du Nord">
                  <option value="ATL">Atlanta, USA (ATL)</option>
                  <option value="DFW">Dallas, USA (DFW)</option>
                  <option value="DTW">Detroit, USA (DTW)</option>
                  <option value="JFK">New York JFK, USA (JFK)</option>
                  <option value="LAX">Los Angeles, USA (LAX)</option>
                  <option value="MIA">Miami, USA (MIA)</option>
                  <option value="ORD">Chicago, USA (ORD)</option>
                  <option value="SFO">San Francisco, USA (SFO)</option>
                  <option value="YYZ">Toronto, Canada (YYZ)</option>
                  <option value="YUL">Montréal, Canada (YUL)</option>
                </optgroup>

                {/* Amérique du Sud */}
                <optgroup label="Amérique du Sud">
                  <option value="BOG">Bogota, Colombie (BOG)</option>
                  <option value="EZE">Buenos Aires, Argentine (EZE)</option>
                  <option value="GRU">São Paulo, Brésil (GRU)</option>
                  <option value="LIM">Lima, Pérou (LIM)</option>
                  <option value="SCL">Santiago, Chili (SCL)</option>
                </optgroup>

                {/* Asie */}
                <optgroup label="Asie">
                  <option value="BKK">Bangkok, Thaïlande (BKK)</option>
                  <option value="CAN">Guangzhou, Chine (CAN)</option>
                  <option value="DEL">Delhi, Inde (DEL)</option>
                  <option value="DXB">Dubaï, Émirats Arabes Unis (DXB)</option>
                  <option value="HKG">Hong Kong (HKG)</option>
                  <option value="ICN">Séoul, Corée du Sud (ICN)</option>
                  <option value="KUL">Kuala Lumpur, Malaisie (KUL)</option>
                  <option value="NRT">Tokyo Narita, Japon (NRT)</option>
                  <option value="PEK">Pékin, Chine (PEK)</option>
                  <option value="PVG">Shanghai Pudong, Chine (PVG)</option>
                  <option value="SIN">Singapour (SIN)</option>
                </optgroup>

                {/* Océanie */}
                <optgroup label="Océanie">
                  <option value="AKL">Auckland, Nouvelle-Zélande (AKL)</option>
                  <option value="BNE">Brisbane, Australie (BNE)</option>
                  <option value="MEL">Melbourne, Australie (MEL)</option>
                  <option value="SYD">Sydney, Australie (SYD)</option>
                </optgroup>

                {/* Moyen-Orient */}
                <optgroup label="Moyen-Orient">
                  <option value="AUH">
                    Abu Dhabi, Émirats Arabes Unis (AUH)
                  </option>
                  <option value="BAH">Bahreïn (BAH)</option>
                  <option value="DOH">Doha, Qatar (DOH)</option>
                  <option value="JED">Jeddah, Arabie Saoudite (JED)</option>
                  <option value="RUH">Riyad, Arabie Saoudite (RUH)</option>
                  <option value="TLV">Tel Aviv, Israël (TLV)</option>
                </optgroup>
              </select>
              <p className="text-xs text-gray-500 mt-1">
                Sélectionnez votre aéroport d'arrivée
              </p>
            </div>
            {/* Date de départ */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Calendar className="w-4 h-4 inline mr-1" />
                Date de départ *
              </label>
              <input
                type="date"
                value={searchParams.departureDate}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    departureDate: e.target.value,
                  })
                }
                min={new Date().toISOString().split("T")[0]}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            {/* Date de retour (conditionnel) */}
            {searchParams.tripType === "round-trip" && (
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  <Calendar className="w-4 h-4 inline mr-1" />
                  Date de retour *
                </label>
                <input
                  type="date"
                  value={searchParams.returnDate}
                  onChange={(e) =>
                    setSearchParams({
                      ...searchParams,
                      returnDate: e.target.value,
                    })
                  }
                  min={
                    searchParams.departureDate ||
                    new Date().toISOString().split("T")[0]
                  }
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            )}

            {/* Nombre de passagers */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Users className="w-4 h-4 inline mr-1" />
                Passagers adultes
              </label>
              <select
                value={searchParams.adults}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    adults: e.target.value,
                  })
                }
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              >
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                  <option key={n} value={n}>
                    {n} adulte{n > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Users className="w-4 h-4 inline mr-1" />
                Passagers enfants
              </label>
              <select
                value={searchParams.children}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    children: e.target.value,
                  })
                }
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              >
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                  <option key={n} value={n}>
                    {n} enfant{n > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Users className="w-4 h-4 inline mr-1" />
                Passagers bébé
              </label>
              <select
                value={searchParams.infants}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    infants: e.target.value,
                  })
                }
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              >
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                  <option key={n} value={n}>
                    {n} bébé{n > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>
            {/* Classe de voyage */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Star className="w-4 h-4 inline mr-1" />
                Classe de voyage
              </label>
              <select
                value={searchParams.travelClass}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    travelClass: e.target.value,
                  })
                }
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              >
                <option value="ECONOMY">Économique</option>
                <option value="PREMIUM_ECONOMY">Économique Premium</option>
                <option value="BUSINESS">Affaires</option>
                <option value="FIRST">Première Classe</option>
              </select>
            </div>
          </div>

          {/* Résumé de la recherche */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200">
            <p className="text-sm font-semibold text-gray-700 mb-2">
              Résumé de votre recherche :
            </p>
            <div className="flex flex-wrap gap-3 text-sm">
              <span className="px-3 py-1 bg-white rounded-full text-gray-700 shadow-sm">
                {searchParams.tripType === "one-way"
                  ? "✈️ Aller simple"
                  : "↔️ Aller-retour"}
              </span>
              {searchParams.originLocationCode &&
                searchParams.destinationLocationCode && (
                  <span className="px-3 py-1 bg-white rounded-full text-gray-700 shadow-sm">
                    📍 {searchParams.originLocationCode} →{" "}
                    {searchParams.destinationLocationCode}
                  </span>
                )}
              {searchParams.departureDate && (
                <span className="px-3 py-1 bg-white rounded-full text-gray-700 shadow-sm">
                  📅 Départ:{" "}
                  {new Date(searchParams.departureDate).toLocaleDateString(
                    "fr-FR"
                  )}
                </span>
              )}
              {searchParams.tripType === "round-trip" &&
                searchParams.returnDate && (
                  <span className="px-3 py-1 bg-white rounded-full text-gray-700 shadow-sm">
                    📅 Retour:{" "}
                    {new Date(searchParams.returnDate).toLocaleDateString(
                      "fr-FR"
                    )}
                  </span>
                )}
              <span className="px-3 py-1 bg-white rounded-full text-gray-700 shadow-sm">
                👤 {searchParams.adults} adulte
                {searchParams.adults > 1 ? "s" : ""}
              </span>
              <span className="px-3 py-1 bg-white rounded-full text-gray-700 shadow-sm">
                💺{" "}
                {searchParams.travelClass === "ECONOMY"
                  ? "Économique"
                  : searchParams.travelClass === "PREMIUM_ECONOMY"
                  ? "Éco. Premium"
                  : searchParams.travelClass === "BUSINESS"
                  ? "Affaires"
                  : "Première"}
              </span>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center shadow-lg"
          >
            {loading ? (
              <>
                <Loader className="w-5 h-5 mr-2 animate-spin" />
                Recherche en cours...
              </>
            ) : (
              <>
                <Search className="w-5 h-5 mr-2" />
                Rechercher des vols
              </>
            )}
          </button>
        </form>
      </div>

      {/* Messages d'erreur */}
      {error && (
        <div className="bg-red-50 border-l-4 border-red-500 rounded-lg p-4 shadow-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <X className="h-5 w-5 text-red-400" />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-red-800">{error}</p>
            </div>
          </div>
        </div>
      )}

      {/* Résultats de recherche */}
      {flights.length > 0 && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold text-gray-800">
              {flights.length} vol{flights.length > 1 ? "s" : ""} trouvé
              {flights.length > 1 ? "s" : ""}
            </h3>
            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <Clock className="w-4 h-4" />
              <span>Triés par prix</span>
            </div>
          </div>

          <div className="space-y-4">
            {flights.map((flight, index) => {
              const firstSegment = flight.itineraries?.[0]?.segments?.[0];
              const lastSegment =
                flight.itineraries?.[0]?.segments?.[
                  flight.itineraries[0].segments.length - 1
                ];
              const hasReturn = flight.itineraries?.length > 1;
              const returnFirstSegment = hasReturn
                ? flight.itineraries[1]?.segments?.[0]
                : null;
              const returnLastSegment = hasReturn
                ? flight.itineraries[1]?.segments?.[
                    flight.itineraries[1].segments.length - 1
                  ]
                : null;

              return (
                <div
                  key={index}
                  className="border-2 rounded-lg p-5 hover:shadow-xl hover:border-blue-400 transition-all"
                >
                  {/* Vol aller */}
                  <div className="mb-4">
                    <div className="flex items-center mb-2">
                      <Plane className="w-4 h-4 text-blue-600 mr-2" />
                      <span className="text-sm font-semibold text-gray-600">
                        VOL ALLER
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="flex items-center space-x-6 flex-1">
                        <div className="bg-blue-100 p-3 rounded-lg">
                          <Plane className="w-6 h-6 text-blue-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center justify-between mb-2">
                            <div className="text-center">
                              <p className="text-2xl font-bold text-gray-800">
                                {firstSegment?.departure?.iataCode || "N/A"}
                              </p>
                              <p className="text-sm text-gray-500">
                                {firstSegment?.departure?.at
                                  ? new Date(
                                      firstSegment.departure.at
                                    ).toLocaleTimeString("fr-FR", {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                  : "N/A"}
                              </p>
                            </div>

                            <div className="flex-1 mx-4">
                              <div className="relative">
                                <div className="border-t-2 border-dashed border-gray-300"></div>
                                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white px-2">
                                  <p className="text-xs text-gray-500 whitespace-nowrap">
                                    {flight.itineraries?.[0]?.segments
                                      ?.length || 0}{" "}
                                    escale
                                    {flight.itineraries?.[0]?.segments?.length >
                                    1
                                      ? "s"
                                      : ""}
                                  </p>
                                </div>
                              </div>
                              <p className="text-center text-xs text-gray-500 mt-1">
                                {flight.itineraries?.[0]?.duration
                                  ?.replace("PT", "")
                                  .replace("H", "h ")
                                  .replace("M", "min") || "N/A"}
                              </p>
                            </div>

                            <div className="text-center">
                              <p className="text-2xl font-bold text-gray-800">
                                {lastSegment?.arrival?.iataCode || "N/A"}
                              </p>
                              <p className="text-sm text-gray-500">
                                {lastSegment?.arrival?.at
                                  ? new Date(
                                      lastSegment.arrival.at
                                    ).toLocaleTimeString("fr-FR", {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                  : "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="flex items-center space-x-2 text-sm text-gray-600">
                            <span className="px-2 py-1 bg-gray-100 rounded">
                              {firstSegment?.carrierCode || "N/A"}{" "}
                              {firstSegment?.number || ""}
                            </span>
                            <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded">
                              {flight.travelerPricings?.[0]
                                ?.fareDetailsBySegment?.[0]?.cabin || "ECONOMY"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Vol retour (si aller-retour) */}
                  {hasReturn && returnFirstSegment && (
                    <>
                      <div className="border-t border-gray-200 my-4"></div>
                      <div className="mb-4">
                        <div className="flex items-center mb-2">
                          <Plane className="w-4 h-4 text-purple-600 mr-2 transform rotate-180" />
                          <span className="text-sm font-semibold text-gray-600">
                            VOL RETOUR
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <div className="flex items-center space-x-6 flex-1">
                            <div className="bg-purple-100 p-3 rounded-lg">
                              <Plane className="w-6 h-6 text-purple-600 transform rotate-180" />
                            </div>
                            <div className="flex-1">
                              <div className="flex items-center justify-between mb-2">
                                <div className="text-center">
                                  <p className="text-2xl font-bold text-gray-800">
                                    {returnFirstSegment?.departure?.iataCode ||
                                      "N/A"}
                                  </p>
                                  <p className="text-sm text-gray-500">
                                    {returnFirstSegment?.departure?.at
                                      ? new Date(
                                          returnFirstSegment.departure.at
                                        ).toLocaleTimeString("fr-FR", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })
                                      : "N/A"}
                                  </p>
                                </div>

                                <div className="flex-1 mx-4">
                                  <div className="relative">
                                    <div className="border-t-2 border-dashed border-gray-300"></div>
                                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white px-2">
                                      <p className="text-xs text-gray-500 whitespace-nowrap">
                                        {flight.itineraries?.[1]?.segments
                                          ?.length || 0}{" "}
                                        escale
                                        {flight.itineraries?.[1]?.segments
                                          ?.length > 1
                                          ? "s"
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  <p className="text-center text-xs text-gray-500 mt-1">
                                    {flight.itineraries?.[1]?.duration
                                      ?.replace("PT", "")
                                      .replace("H", "h ")
                                      .replace("M", "min") || "N/A"}
                                  </p>
                                </div>

                                <div className="text-center">
                                  <p className="text-2xl font-bold text-gray-800">
                                    {returnLastSegment?.arrival?.iataCode ||
                                      "N/A"}
                                  </p>
                                  <p className="text-sm text-gray-500">
                                    {returnLastSegment?.arrival?.at
                                      ? new Date(
                                          returnLastSegment.arrival.at
                                        ).toLocaleTimeString("fr-FR", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })
                                      : "N/A"}
                                  </p>
                                </div>
                              </div>
                              <div className="flex items-center space-x-2 text-sm text-gray-600">
                                <span className="px-2 py-1 bg-gray-100 rounded">
                                  {returnFirstSegment?.carrierCode || "N/A"}{" "}
                                  {returnFirstSegment?.number || ""}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Prix et bouton de sélection */}
                  <div className="border-t border-gray-200 pt-4 mt-4 flex justify-between items-center">
                    <div>
                      <p className="text-sm text-gray-500">Prix total</p>
                      <p className="text-3xl font-bold text-blue-600">
                        {flight.price?.total} {flight.price?.currency}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        Pour {searchParams.adults} passager
                        {searchParams.adults > 1 ? "s" : ""}
                      </p>
                    </div>
                    <button
                      onClick={() =>
                        onSelectFlight && onSelectFlight(flight, searchParams)
                      }
                      className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-lg hover:from-blue-700 hover:to-indigo-700 font-semibold shadow-lg transform hover:scale-105 transition-all flex items-center"
                    >
                      <CheckCircle className="w-5 h-5 mr-2" />
                      Sélectionner
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
// ==================== SERVICES API DEMANDES DE BILLETS ====================



// Service pour les demandes de billets
const flightRequestsService = {
  getAll: async () => {
    const response = await fetch(`${API_BASE_URL2}/flight-requests`);
    if (!response.ok) throw new Error("Erreur récupération demandes");
    return await response.json();
  },

  create: async (data) => {
    // Ajouter un timestamp pour éviter les doublons
    const requestData = {
      ...data,
      _submittedAt: new Date().toISOString(),
    };

    const response = await fetch(`${API_BASE_URL2}/flight-requests`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur création demande");
    }

    return await response.json();
  },

  approve: async (id) => {
    const response = await fetch(
      `${API_BASE_URL2}/flight-requests/${id}/approve`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
    if (!response.ok) throw new Error("Erreur approbation");
    return await response.json();
  },

  reject: async (id) => {
    const response = await fetch(
      `${API_BASE_URL2}/flight-requests/${id}/reject`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
    if (!response.ok) throw new Error("Erreur rejet");
    return await response.json();
  },

  emitTicket: async (id) => {
    try {
      console.log(`🎫 Début de l'émission du ticket pour la demande: ${id}`);

      // 1. Récupérer les détails de la demande pour obtenir les données nécessaires
      const requestResponse = await fetch(
        `${API_BASE_URL2}/flight-requests/${id}`
      );
      if (!requestResponse.ok) {
        toast.error(
          "Erreur lors de la récupération des détails de la demande"
        );
        return;
      }
      const request = await requestResponse.json();

      // 2. Vérifier qu'il y a des voyageurs et des données de vol
      if (!request.travelers || request.travelers.length === 0) {
        toast.error("Aucun voyageur trouvé pour cette demande");
        return;
      }

      if (!request.vol || request.vol.length === 0) {
        toast.error("Aucune offre de vol trouvée pour cette demande");
        return;
      }

      // 3. Préparer les données pour Amadeus complete-booking
      const searchParams = request.searchParams || request.vol[0]?.searchParams;
      const adultsCount = parseInt(searchParams?.adults) || 1;
      const childrenCount = parseInt(searchParams?.children) || 0;
      const infantsCount = parseInt(searchParams?.infants) || 0;

      // Fonction pour nettoyer le countryCallingCode
      const cleanCountryCallingCode = (code) => {
        if (!code) return "225";
        return code.replace(/[^\d]/g, "");
      };

      // Préparer les voyageurs au format Amadeus
      const amadeusTravelers = request.travelers.map((traveler, index) => {
        let passengerType = "ADULT";
        if (index >= adultsCount && index < adultsCount + childrenCount) {
          passengerType = "CHILD";
        } else if (index >= adultsCount + childrenCount) {
          passengerType = "INFANT";
        }

        return {
          id: (index + 1).toString(),
          dateOfBirth: traveler.date_naissance,
          name: {
            firstName: traveler.prenom,
            lastName: traveler.nom,
          },
          gender: traveler.genre || "MALE",
          contact: {
            emailAddress: traveler.email || "info@abmtravel.com",
            phones: [
              {
                deviceType: "MOBILE",
                countryCallingCode: cleanCountryCallingCode(traveler.code_pays),
                number: traveler.telephone || "0708837660",
              },
            ],
          },
          documents: [
            {
              documentType: "PASSPORT",
              birthPlace: traveler.lieu_naissance || "Abidjan",
              issuanceLocation: traveler.lieu_emission || "Abidjan",
              issuanceDate: traveler.date_emission_passeport || "2020-01-01",
              number: traveler.numero_passeport,
              expiryDate: traveler.date_expiration_passeport,
              issuanceCountry: traveler.pays_emission || "CI",
              validityCountry: traveler.pays_validite || "CI",
              nationality: traveler.nationalite || "CI",
              holder: true,
            },
          ],
        };
      });

      // CORRECTION : Préparer les flightOffers avec la structure Amadeus correcte
      const correctedFlightOffers = request.vol.map((offer) => {
        const flightData = offer.flightData;

        return {
          type: "flight-offer",
          id: flightData.id,
          source: flightData.source,
          instantTicketingRequired: flightData.instantTicketingRequired,
          nonHomogeneous: flightData.nonHomogeneous,
          oneWay: flightData.oneWay,
          lastTicketingDate: flightData.lastTicketingDate,
          numberOfBookableSeats: flightData.numberOfBookableSeats,
          itineraries: flightData.itineraries,
          price: flightData.price,
          pricingOptions: flightData.pricingOptions,
          validatingAirlineCodes: flightData.validatingAirlineCodes,
          travelerPricings: flightData.travelerPricings,
        };
      });

      // CORRECTION : Formater correctement le délai pour Amadeus
      const formatDelayForAmadeus = (delay) => {
        if (delay === "24H") return "1D";
        if (delay === "48H") return "2D";
        if (delay === "72H") return "3D";
        return delay;
      };

      // Structure pour Amadeus
      const amadeusBookingData = {
        type: "flight-order",
        flightOffers: correctedFlightOffers,
        travelers: amadeusTravelers,
        remarks: {
          general: [
            {
              subType: "GENERAL_MISCELLANEOUS",
              text: `Billet émis via système - Demande: ${request.numeroRequete}`,
            },
          ],
        },
        ticketingAgreement: {
          option: "DELAY_TO_CANCEL",
          delay: formatDelayForAmadeus("24H"),
        },
        contacts: [
          {
            addresseeName: {
              firstName: "Support",
              lastName: "Voyages",
            },
            companyName: "Agence de Voyage",
            purpose: "STANDARD",
            phones: [
              {
                deviceType: "LANDLINE",
                countryCallingCode: "33",
                number: "0123456789",
              },
            ],
            emailAddress: "support@voyage.com",
            address: {
              lines: ["123 Avenue des Voyages"],
              postalCode: "75001",
              cityName: "Paris",
              countryCode: "FR",
            },
          },
        ],
      };

      console.log(
        "DONNEES AMADEUS CORRIGEES:",
        JSON.stringify(amadeusBookingData, null, 2)
      );

      // 4. Lancer les opérations en parallèle
      const operations = [];

      // Opération 1: Appel à l'API interne pour émettre le ticket
      operations.push(
        (async () => {
          try {
            console.log("🎫 Émission du ticket interne...");
            const response = await fetch(
              `${API_BASE_URL2}/flight-requests/${id}/emit-ticket`,
              {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
              }
            );

            if (!response.ok) {
              const errorText = await response.text();
              toast.error(`Interne: ${response.status} - ${errorText}`);
              return;
            }

            const result = await response.json();
            console.log("✅ Ticket interne émis avec succès");
            return {
              success: true,
              type: "internal",
              data: result,
            };
          } catch (error) {
            console.error("❌ Erreur émission ticket interne:", error.message);
            return {
              success: false,
              type: "internal",
              error: error.message,
            };
          }
        })()
      );

      // CORRECTION : Vérifier et utiliser le bon endpoint Amadeus
      // Option 1: Essayer avec l'endpoint standard de booking Amadeus
      const amadeusEndpoints = [
        // `${API_BASE_URL}/booking`, // Endpoint standard Amadeus
        // `${API_BASE_URL3}/v1/booking/flight-orders`, // Avec version
        `${API_BASE_URL3}/flights/complete-booking`, // Endpoint original (au cas où)
      ];

      // Opération 2: Complete-booking Amadeus avec données corrigées
      operations.push(
        (async () => {
          try {
            console.log("🚀 Appel à Amadeus complete-booking...");

            let amadeusResponse;
            let lastError;

            // Essayer différents endpoints
            for (const endpoint of amadeusEndpoints) {
              try {
                console.log(`🔍 Essai avec l'endpoint: ${endpoint}`);
                amadeusResponse = await fetch(endpoint, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(amadeusBookingData),
                });

                if (amadeusResponse.ok) {
                  console.log(`✅ Endpoint trouvé: ${endpoint}`);
                  break;
                } else {
                  const errorText = await amadeusResponse.text();
                  lastError = new Error(
                    `Amadeus (${endpoint}): ${
                      errorText || `HTTP ${amadeusResponse.status}`
                    }`
                  );
                  console.log(
                    `❌ Échec avec ${endpoint}: ${amadeusResponse.status}`
                  );
                }
              } catch (endpointError) {
                lastError = endpointError;
                console.log(
                  `❌ Erreur avec ${endpoint}: ${endpointError.message}`
                );
              }
            }

            if (!amadeusResponse || !amadeusResponse.ok) {
              throw (
                lastError || new Error("Aucun endpoint Amadeus ne fonctionne")
              );
            }

            const amadeusResult = await amadeusResponse.json();
            console.log("✅ Complete-booking Amadeus réussi");

            // Extraire les informations importantes
            const amadeusData = amadeusResult.data;
            return {
              success: true,
              type: "amadeus",
              data: amadeusResult,
              orderId: amadeusData?.orderId,
              pnr: amadeusData?.pnr,
              associatedRecords: amadeusData?.associatedRecords,
            };
          } catch (amadeusError) {
            console.error(
              "❌ Erreur complete-booking Amadeus:",
              amadeusError.message
            );
            return {
              success: false,
              type: "amadeus",
              error: amadeusError.message,
            };
          }
        })()
      );

      // Opération 3: Synchronisation des voyages
      operations.push(
        (async () => {
          try {
            console.log("🔄 Synchronisation des voyages...");
            const syncResponse = await fetch(
              `${API_BASE_URL2}/travelers/sync`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
              }
            );

            if (!syncResponse.ok)
              throw new Error(`Sync: ${syncResponse.status}`);

            console.log("✅ Synchronisation des voyages réussie");
            return {
              success: true,
              type: "sync",
            };
          } catch (syncError) {
            console.error(
              "❌ Erreur synchronisation voyages:",
              syncError.message
            );
            return {
              success: false,
              type: "sync",
              error: syncError.message,
            };
          }
        })()
      );

      // 5. Exécuter toutes les opérations en parallèle
      const results = await Promise.allSettled(operations);

      // 6. Traiter les résultats
      const finalResults = {
        internal: null,
        amadeus: null,
        sync: null,
      };

      results.forEach((result) => {
        if (result.status === "fulfilled") {
          const value = result.value;
          switch (value.type) {
            case "internal":
              finalResults.internal = value;
              break;
            case "amadeus":
              finalResults.amadeus = value;
              break;
            case "sync":
              finalResults.sync = value;
              break;
          }
        }
      });

      // 7. Vérifier si l'émission interne a réussi (critique)
      if (!finalResults.internal || !finalResults.internal.success) {
        throw new Error(
          "Émission interne a échoué: " +
            (finalResults.internal?.error || "Unknown error")
        );
      }

      // 8. Construire le résultat final
      const finalResult = {
        ...finalResults.internal.data,
        operations: {
          internal: { success: true, data: finalResults.internal.data },
          amadeus: finalResults.amadeus || {
            success: false,
            error: "Non exécuté",
          },
          sync: finalResults.sync || { success: false, error: "Non exécuté" },
        },
      };

      // 9. Log du résumé
      console.log("📊 Résumé des opérations:");
      console.log("- Interne: ✅ Succès");
      console.log(
        `- Amadeus: ${finalResult.operations.amadeus.success ? "✅" : "❌"} ${
          finalResult.operations.amadeus.success
            ? "Succès"
            : finalResult.operations.amadeus.error
        }`
      );
      console.log(
        `- Synchronisation: ${
          finalResult.operations.sync.success ? "✅" : "❌"
        } ${
          finalResult.operations.sync.success
            ? "Succès"
            : finalResult.operations.sync.error
        }`
      );

      // 10. Si Amadeus a réussi, mettre à jour la demande avec les infos Amadeus
      if (finalResult.operations.amadeus.success) {
        try {
          console.log("💾 Mise à jour des informations Amadeus...");
          const updateData = {
            amadeusOrderId: finalResult.operations.amadeus.orderId,
            amadeusPnr: finalResult.operations.amadeus.pnr,
            amadeusData: finalResult.operations.amadeus.data,
          };

          await fetch(`${API_BASE_URL2}/flight-requests/${id}/amadeus-info`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData),
          });
          console.log("✅ Informations Amadeus mises à jour");
        } catch (updateError) {
          console.error("❌ Erreur mise à jour infos Amadeus:", updateError);
        }
      }

      return finalResult;
    } catch (error) {
      console.error("❌ Erreur globale emitTicket:", error);
      throw error;
    }
  },

  delete: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/flight-requests/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) throw new Error("Erreur suppression");
    return await response.json();
  },
};

// Composant pour la recherche multi-segments
const MultiSegmentFlightSearch = ({ onSelectFlights }) => {
  const [segments, setSegments] = useState([
    {
      id: 1,
      originLocationCode: "",
      destinationLocationCode: "",
      departureDate: "",
      flights: [],
      selectedFlight: null,
      loading: false,
      error: null,
    },
  ]);

  const [globalParams, setGlobalParams] = useState({
    adults: "1",
    travelClass: "ECONOMY",
  });

  const addSegment = () => {
    const lastSegment = segments[segments.length - 1];
    const newSegmentDate = lastSegment.departureDate
      ? new Date(
          new Date(lastSegment.departureDate).getTime() + 24 * 60 * 60 * 1000
        )
          .toISOString()
          .split("T")[0]
      : "";

    setSegments([
      ...segments,
      {
        id: segments.length + 1,
        originLocationCode: lastSegment.destinationLocationCode || "",
        destinationLocationCode: "",
        departureDate: newSegmentDate,
        flights: [],
        selectedFlight: null,
        loading: false,
        error: null,
      },
    ]);
  };

  const removeSegment = (id) => {
    if (segments.length > 1) {
      setSegments(segments.filter((s) => s.id !== id));
    }
  };

  const updateSegment = (id, field, value) => {
    setSegments(
      segments.map((seg) => (seg.id === id ? { ...seg, [field]: value } : seg))
    );
  };

  const searchSegmentFlights = async (segmentId) => {
    const segment = segments.find((s) => s.id === segmentId);
    if (!segment) return;

    updateSegment(segmentId, "loading", true);
    updateSegment(segmentId, "error", null);

    try {
      const searchParams = {
        originLocationCode: segment.originLocationCode,
        destinationLocationCode: segment.destinationLocationCode,
        departureDate: segment.departureDate,
        adults: globalParams.adults,
        children: 1,
        infants: 1, // ← Clé pour les bébés
        travelClass: "ECONOMY",
        currencyCode: "EUR",
        travelClass: globalParams.travelClass,
        tripType: "one-way",
        max: 10,
      };

      const results = await amadeusService.searchFlights(searchParams);
      updateSegment(segmentId, "flights", results.data || []);

      if (!results.data || results.data.length === 0) {
        updateSegment(segmentId, "error", "Aucun vol trouvé pour ce segment");
      }
    } catch (err) {
      updateSegment(segmentId, "error", "Erreur lors de la recherche");
    } finally {
      updateSegment(segmentId, "loading", false);
    }
  };

  const selectFlight = (segmentId, flight) => {
    setSegments(
      segments.map((seg) =>
        seg.id === segmentId ? { ...seg, selectedFlight: flight } : seg
      )
    );
  };

  const handleConfirmSelection = () => {
    const selectedFlights = segments
      .filter((seg) => seg.selectedFlight)
      .map((seg) => ({
        segment: {
          id: seg.id,
          origin: seg.originLocationCode,
          destination: seg.destinationLocationCode,
          date: seg.departureDate,
        },
        flight: seg.selectedFlight,
      }));

    if (selectedFlights.length === segments.length) {
      onSelectFlights(selectedFlights, globalParams);
    } else {
      toast.info("Veuillez sélectionner un vol pour chaque segment");
    }
  };

  const calculateTotalPrice = () => {
    return segments
      .reduce((total, seg) => {
        if (seg.selectedFlight?.price?.total) {
          return total + parseFloat(seg.selectedFlight.price.total);
        }
        return total;
      }, 0)
      .toFixed(2);
  };
  // ==================== COMPOSANT WORKFLOW NOUVELLE DEMANDE AVEC API ====================

  // ==================== COMPOSANT WORKFLOW MULTI-VOLS AVEC PANIER ====================

  const [formData, setFormData] = useState({
    objetVoyage: "",
    motifDeplacement: "",
    projet: "",
    centreCoût: "",
  });
  // ==================== ONGLET RECHERCHE ====================
  const SearchTab = ({
    totalPassengers,
    searchParams,
    setSearchParams,
    handleSearch,
    loading,
    error,
    searchResults,
    addToCart,
    cart,
  }) => {
    const [multiCitySegments, setMultiCitySegments] = useState([
      { origin: "", destination: "", date: "" },
    ]);

    formData = { formData };
    setFormData = { setFormData };
    // Gestion des segments multi-destinations
    const addSegment = () => {
      const lastSegment = multiCitySegments[multiCitySegments.length - 1];
      const newSegmentDate = lastSegment.date
        ? new Date(new Date(lastSegment.date).getTime() + 24 * 60 * 60 * 1000)
            .toISOString()
            .split("T")[0]
        : "";

      setMultiCitySegments([
        ...multiCitySegments,
        {
          origin: lastSegment.destination || "",
          destination: "",
          date: newSegmentDate,
        },
      ]);
    };

    const removeSegment = (index) => {
      if (multiCitySegments.length > 1) {
        setMultiCitySegments(multiCitySegments.filter((_, i) => i !== index));
      }
    };

    const updateSegment = (index, field, value) => {
      const updated = [...multiCitySegments];
      updated[index][field] = value;
      setMultiCitySegments(updated);
    };

    const handleTripTypeChange = (type) => {
      setSearchParams({
        ...searchParams,
        tripType: type,
        returnDate: type === "one-way" ? "" : searchParams.returnDate,
      });

      // Réinitialiser les segments si on change de type
      if (type !== "multi-city") {
        setMultiCitySegments([{ origin: "", destination: "", date: "" }]);
      }
    };

    return (
      <div className="space-y-6">
        {/* Formulaire de recherche */}
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-bold mb-4">Rechercher des vols</h2>
          {/* Type de voyage */}
          // Dans SearchTab, remplacez la section "Type de voyage" par :
          <div className="bg-blue-50 rounded-lg p-4 mb-4">
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Type de voyage *
            </label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <button
                type="button"
                onClick={() => {
                  setSearchParams({
                    ...searchParams,
                    tripType: "one-way",
                    returnDate: "",
                  });
                  setMultiCitySegments([
                    { origin: "", destination: "", date: "" },
                  ]);
                }}
                className={`py-3 px-4 rounded-lg font-semibold transition ${
                  searchParams.tripType === "one-way"
                    ? "bg-blue-600 text-white shadow-md"
                    : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400"
                }`}
              >
                <div className="flex items-center justify-center">
                  <Plane className="w-5 h-5 mr-2" />
                  Aller simple
                </div>
              </button>
              <button
                type="button"
                onClick={() => {
                  setSearchParams({
                    ...searchParams,
                    tripType: "round-trip",
                  });
                  setMultiCitySegments([
                    { origin: "", destination: "", date: "" },
                  ]);
                }}
                className={`py-3 px-4 rounded-lg font-semibold transition ${
                  searchParams.tripType === "round-trip"
                    ? "bg-blue-600 text-white shadow-md"
                    : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400"
                }`}
              >
                <div className="flex items-center justify-center">
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                    />
                  </svg>
                  Aller-retour
                </div>
              </button>
              <button
                type="button"
                onClick={() => {
                  setSearchParams({
                    ...searchParams,
                    tripType: "multi-city",
                    returnDate: "",
                  });
                  // Initialiser avec 2 segments pour multi-destinations
                  setMultiCitySegments([
                    { origin: "", destination: "", date: "" },
                    { origin: "", destination: "", date: "" },
                  ]);
                }}
                className={`py-3 px-4 rounded-lg font-semibold transition ${
                  searchParams.tripType === "multi-city"
                    ? "bg-blue-600 text-white shadow-md"
                    : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400"
                }`}
              >
                <div className="flex items-center justify-center">
                  <MapPin className="w-5 h-5 mr-2" />
                  Multi-Destinations
                </div>
              </button>
            </div>
          </div>
          <form
            onSubmit={(e) =>
              handleSearch(
                e,
                searchParams.tripType === "multi-city" ? multiCitySegments : []
              )
            }
            className="space-y-6"
          >
            {/* Sélection du type de voyage */}
            <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
              <label className="block text-lg font-bold text-gray-800 mb-4">
                Type de voyage *
              </label>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <button
                  type="button"
                  onClick={() => {
                    setSearchParams({
                      ...searchParams,
                      tripType: "one-way",
                      returnDate: "",
                    });
                    setMultiCitySegments([
                      { origin: "", destination: "", date: "" },
                    ]);
                  }}
                  className={`p-4 rounded-xl font-semibold transition-all duration-200 ${
                    searchParams.tripType === "one-way"
                      ? "bg-blue-600 text-white shadow-lg transform scale-105"
                      : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400 hover:shadow-md"
                  }`}
                >
                  <div className="flex flex-col items-center space-y-2">
                    <Plane className="w-6 h-6" />
                    <span>Aller simple</span>
                    <p className="text-xs opacity-80">Un seul trajet</p>
                  </div>
                </button>

                <button
                  type="button"
                  onClick={() => {
                    setSearchParams({
                      ...searchParams,
                      tripType: "round-trip",
                    });
                    setMultiCitySegments([
                      { origin: "", destination: "", date: "" },
                    ]);
                  }}
                  className={`p-4 rounded-xl font-semibold transition-all duration-200 ${
                    searchParams.tripType === "round-trip"
                      ? "bg-blue-600 text-white shadow-lg transform scale-105"
                      : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400 hover:shadow-md"
                  }`}
                >
                  <div className="flex flex-col items-center space-y-2">
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                      />
                    </svg>
                    <span>Aller-retour</span>
                    <p className="text-xs opacity-80">Aller + retour</p>
                  </div>
                </button>

                <button
                  type="button"
                  onClick={() => {
                    setSearchParams({
                      ...searchParams,
                      tripType: "multi-city",
                      returnDate: "",
                    });
                    // Initialiser avec 2 segments pour multi-destinations
                    setMultiCitySegments([
                      { origin: "", destination: "", date: "" },
                      { origin: "", destination: "", date: "" },
                    ]);
                  }}
                  className={`p-4 rounded-xl font-semibold transition-all duration-200 ${
                    searchParams.tripType === "multi-city"
                      ? "bg-blue-600 text-white shadow-lg transform scale-105"
                      : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400 hover:shadow-md"
                  }`}
                >
                  <div className="flex flex-col items-center space-y-2">
                    <MapPin className="w-6 h-6" />
                    <span>Multi-destinations</span>
                    <p className="text-xs opacity-80">Plusieurs étapes</p>
                  </div>
                </button>
              </div>
            </div>

            {/* Formulaire selon le type de voyage */}
            <div className="bg-white rounded-xl shadow-md p-6 border">
              {searchParams.tripType === "multi-city" ? (
                // ==================== FORMULAIRE MULTI-DESTINATIONS ====================
                <div className="space-y-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                    <MapPin className="w-5 h-5 mr-2 text-blue-600" />
                    Itinéraire Multi-Destinations
                  </h3>

                  <div className="space-y-4">
                    {multiCitySegments.map((segment, index) => (
                      <div
                        key={index}
                        className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 border-2 border-blue-200 relative"
                      >
                        {/* Indicateur d'étape */}
                        <div className="absolute -top-3 -left-3 bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                          {index + 1}
                        </div>

                        <div className="flex justify-between items-center mb-4">
                          <h4 className="font-semibold text-gray-800 text-lg">
                            Étape {index + 1}
                          </h4>
                          {multiCitySegments.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeSegment(index)}
                              className="text-red-600 hover:text-red-800 bg-red-50 p-2 rounded-lg transition-colors"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          )}
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                              <MapPin className="w-4 h-4 inline mr-1" />
                              Départ (Aéroport) *
                            </label>
                            <select
                              name="originLocationCode"
                              value={searchParams.originLocationCode}
                              onChange={(e) =>
                                setSearchParams((prev) => ({
                                  ...prev,
                                  originLocationCode: e.target.value,
                                }))
                              }
                              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                              required
                            >
                              <option value="">
                                Sélectionnez un aéroport de départ
                              </option>

                              {/* Afrique */}
                              <optgroup label="Afrique">
                                <option value="ABJ">
                                  Abidjan, Côte d'Ivoire (ABJ)
                                </option>
                                <option value="ACC">Accra, Ghana (ACC)</option>
                                <option value="ADD">
                                  Addis-Abeba, Éthiopie (ADD)
                                </option>
                                <option value="ALG">
                                  Alger, Algérie (ALG)
                                </option>
                                <option value="CMN">
                                  Casablanca, Maroc (CMN)
                                </option>
                                <option value="COO">
                                  Cotonou, Bénin (COO)
                                </option>
                                <option value="DKR">
                                  Dakar, Sénégal (DKR)
                                </option>
                                <option value="DAR">
                                  Dar es Salaam, Tanzanie (DAR)
                                </option>
                                <option value="EBB">
                                  Entebbe, Ouganda (EBB)
                                </option>
                                <option value="FIH">Kinshasa, RDC (FIH)</option>
                                <option value="JNB">
                                  Johannesburg, Afrique du Sud (JNB)
                                </option>
                                <option value="KGL">
                                  Kigali, Rwanda (KGL)
                                </option>
                                <option value="LAD">
                                  Luanda, Angola (LAD)
                                </option>
                                <option value="LOS">
                                  Lagos, Nigeria (LOS)
                                </option>
                                <option value="NBO">
                                  Nairobi, Kenya (NBO)
                                </option>
                                <option value="RAI">
                                  Praia, Cap-Vert (RAI)
                                </option>
                                <option value="TUN">
                                  Tunis, Tunisie (TUN)
                                </option>
                              </optgroup>

                              {/* Europe */}
                              <optgroup label="Europe">
                                <option value="AMS">
                                  Amsterdam, Pays-Bas (AMS)
                                </option>
                                <option value="BCN">
                                  Barcelone, Espagne (BCN)
                                </option>
                                <option value="BER">
                                  Berlin, Allemagne (BER)
                                </option>
                                <option value="BRU">
                                  Bruxelles, Belgique (BRU)
                                </option>
                                <option value="CDG">
                                  Paris Charles de Gaulle, France (CDG)
                                </option>
                                <option value="FCO">
                                  Rome Fiumicino, Italie (FCO)
                                </option>
                                <option value="FRA">
                                  Francfort, Allemagne (FRA)
                                </option>
                                <option value="GVA">
                                  Genève, Suisse (GVA)
                                </option>
                                <option value="IST">
                                  Istanbul, Turquie (IST)
                                </option>
                                <option value="LHR">
                                  Londres Heathrow, Royaume-Uni (LHR)
                                </option>
                                <option value="LIS">
                                  Lisbonne, Portugal (LIS)
                                </option>
                                <option value="MAD">
                                  Madrid, Espagne (MAD)
                                </option>
                                <option value="MUC">
                                  Munich, Allemagne (MUC)
                                </option>
                                <option value="ORY">
                                  Paris Orly, France (ORY)
                                </option>
                                <option value="VIE">
                                  Vienne, Autriche (VIE)
                                </option>
                                <option value="ZRH">
                                  Zurich, Suisse (ZRH)
                                </option>
                              </optgroup>

                              {/* Amérique du Nord */}
                              <optgroup label="Amérique du Nord">
                                <option value="ATL">Atlanta, USA (ATL)</option>
                                <option value="DFW">Dallas, USA (DFW)</option>
                                <option value="DTW">Detroit, USA (DTW)</option>
                                <option value="JFK">
                                  New York JFK, USA (JFK)
                                </option>
                                <option value="LAX">
                                  Los Angeles, USA (LAX)
                                </option>
                                <option value="MIA">Miami, USA (MIA)</option>
                                <option value="ORD">Chicago, USA (ORD)</option>
                                <option value="SFO">
                                  San Francisco, USA (SFO)
                                </option>
                                <option value="YYZ">
                                  Toronto, Canada (YYZ)
                                </option>
                                <option value="YUL">
                                  Montréal, Canada (YUL)
                                </option>
                              </optgroup>

                              {/* Amérique du Sud */}
                              <optgroup label="Amérique du Sud">
                                <option value="BOG">
                                  Bogota, Colombie (BOG)
                                </option>
                                <option value="EZE">
                                  Buenos Aires, Argentine (EZE)
                                </option>
                                <option value="GRU">
                                  São Paulo, Brésil (GRU)
                                </option>
                                <option value="LIM">Lima, Pérou (LIM)</option>
                                <option value="SCL">
                                  Santiago, Chili (SCL)
                                </option>
                              </optgroup>

                              {/* Asie */}
                              <optgroup label="Asie">
                                <option value="BKK">
                                  Bangkok, Thaïlande (BKK)
                                </option>
                                <option value="CAN">
                                  Guangzhou, Chine (CAN)
                                </option>
                                <option value="DEL">Delhi, Inde (DEL)</option>
                                <option value="DXB">
                                  Dubaï, Émirats Arabes Unis (DXB)
                                </option>
                                <option value="HKG">Hong Kong (HKG)</option>
                                <option value="ICN">
                                  Séoul, Corée du Sud (ICN)
                                </option>
                                <option value="KUL">
                                  Kuala Lumpur, Malaisie (KUL)
                                </option>
                                <option value="NRT">
                                  Tokyo Narita, Japon (NRT)
                                </option>
                                <option value="PEK">Pékin, Chine (PEK)</option>
                                <option value="PVG">
                                  Shanghai Pudong, Chine (PVG)
                                </option>
                                <option value="SIN">Singapour (SIN)</option>
                              </optgroup>

                              {/* Océanie */}
                              <optgroup label="Océanie">
                                <option value="AKL">
                                  Auckland, Nouvelle-Zélande (AKL)
                                </option>
                                <option value="BNE">
                                  Brisbane, Australie (BNE)
                                </option>
                                <option value="MEL">
                                  Melbourne, Australie (MEL)
                                </option>
                                <option value="SYD">
                                  Sydney, Australie (SYD)
                                </option>
                              </optgroup>

                              {/* Moyen-Orient */}
                              <optgroup label="Moyen-Orient">
                                <option value="AUH">
                                  Abu Dhabi, Émirats Arabes Unis (AUH)
                                </option>
                                <option value="BAH">Bahreïn (BAH)</option>
                                <option value="DOH">Doha, Qatar (DOH)</option>
                                <option value="JED">
                                  Jeddah, Arabie Saoudite (JED)
                                </option>
                                <option value="RUH">
                                  Riyad, Arabie Saoudite (RUH)
                                </option>
                                <option value="TLV">
                                  Tel Aviv, Israël (TLV)
                                </option>
                              </optgroup>
                            </select>
                            <p className="text-xs text-gray-500 mt-1">
                              Sélectionnez votre aéroport de départ
                            </p>
                          </div>

                          <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                              <MapPin className="w-4 h-4 inline mr-1" />
                              Arrivée (Aéroport) *
                            </label>
                            <select
                              name="destinationLocationCode"
                              value={searchParams.destinationLocationCode}
                              onChange={(e) =>
                                setSearchParams({
                                  ...searchParams,
                                  destinationLocationCode: e.target.value,
                                })
                              }
                              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                              required
                            >
                              <option value="">
                                Sélectionnez un aéroport d'arrivée
                              </option>

                              {/* Afrique */}
                              <optgroup label="Afrique">
                                <option value="ABJ">
                                  Abidjan, Côte d'Ivoire (ABJ)
                                </option>
                                <option value="ACC">Accra, Ghana (ACC)</option>
                                <option value="ADD">
                                  Addis-Abeba, Éthiopie (ADD)
                                </option>
                                <option value="ALG">
                                  Alger, Algérie (ALG)
                                </option>
                                <option value="CMN">
                                  Casablanca, Maroc (CMN)
                                </option>
                                <option value="COO">
                                  Cotonou, Bénin (COO)
                                </option>
                                <option value="DKR">
                                  Dakar, Sénégal (DKR)
                                </option>
                                <option value="DAR">
                                  Dar es Salaam, Tanzanie (DAR)
                                </option>
                                <option value="EBB">
                                  Entebbe, Ouganda (EBB)
                                </option>
                                <option value="FIH">Kinshasa, RDC (FIH)</option>
                                <option value="JNB">
                                  Johannesburg, Afrique du Sud (JNB)
                                </option>
                                <option value="KGL">
                                  Kigali, Rwanda (KGL)
                                </option>
                                <option value="LAD">
                                  Luanda, Angola (LAD)
                                </option>
                                <option value="LOS">
                                  Lagos, Nigeria (LOS)
                                </option>
                                <option value="NBO">
                                  Nairobi, Kenya (NBO)
                                </option>
                                <option value="RAI">
                                  Praia, Cap-Vert (RAI)
                                </option>
                                <option value="TUN">
                                  Tunis, Tunisie (TUN)
                                </option>
                              </optgroup>

                              {/* Europe */}
                              <optgroup label="Europe">
                                <option value="AMS">
                                  Amsterdam, Pays-Bas (AMS)
                                </option>
                                <option value="BCN">
                                  Barcelone, Espagne (BCN)
                                </option>
                                <option value="BER">
                                  Berlin, Allemagne (BER)
                                </option>
                                <option value="BRU">
                                  Bruxelles, Belgique (BRU)
                                </option>
                                <option value="CDG">
                                  Paris Charles de Gaulle, France (CDG)
                                </option>
                                <option value="FCO">
                                  Rome Fiumicino, Italie (FCO)
                                </option>
                                <option value="FRA">
                                  Francfort, Allemagne (FRA)
                                </option>
                                <option value="GVA">
                                  Genève, Suisse (GVA)
                                </option>
                                <option value="IST">
                                  Istanbul, Turquie (IST)
                                </option>
                                <option value="LHR">
                                  Londres Heathrow, Royaume-Uni (LHR)
                                </option>
                                <option value="LIS">
                                  Lisbonne, Portugal (LIS)
                                </option>
                                <option value="MAD">
                                  Madrid, Espagne (MAD)
                                </option>
                                <option value="MUC">
                                  Munich, Allemagne (MUC)
                                </option>
                                <option value="ORY">
                                  Paris Orly, France (ORY)
                                </option>
                                <option value="VIE">
                                  Vienne, Autriche (VIE)
                                </option>
                                <option value="ZRH">
                                  Zurich, Suisse (ZRH)
                                </option>
                              </optgroup>

                              {/* Amérique du Nord */}
                              <optgroup label="Amérique du Nord">
                                <option value="ATL">Atlanta, USA (ATL)</option>
                                <option value="DFW">Dallas, USA (DFW)</option>
                                <option value="DTW">Detroit, USA (DTW)</option>
                                <option value="JFK">
                                  New York JFK, USA (JFK)
                                </option>
                                <option value="LAX">
                                  Los Angeles, USA (LAX)
                                </option>
                                <option value="MIA">Miami, USA (MIA)</option>
                                <option value="ORD">Chicago, USA (ORD)</option>
                                <option value="SFO">
                                  San Francisco, USA (SFO)
                                </option>
                                <option value="YYZ">
                                  Toronto, Canada (YYZ)
                                </option>
                                <option value="YUL">
                                  Montréal, Canada (YUL)
                                </option>
                              </optgroup>

                              {/* Amérique du Sud */}
                              <optgroup label="Amérique du Sud">
                                <option value="BOG">
                                  Bogota, Colombie (BOG)
                                </option>
                                <option value="EZE">
                                  Buenos Aires, Argentine (EZE)
                                </option>
                                <option value="GRU">
                                  São Paulo, Brésil (GRU)
                                </option>
                                <option value="LIM">Lima, Pérou (LIM)</option>
                                <option value="SCL">
                                  Santiago, Chili (SCL)
                                </option>
                              </optgroup>

                              {/* Asie */}
                              <optgroup label="Asie">
                                <option value="BKK">
                                  Bangkok, Thaïlande (BKK)
                                </option>
                                <option value="CAN">
                                  Guangzhou, Chine (CAN)
                                </option>
                                <option value="DEL">Delhi, Inde (DEL)</option>
                                <option value="DXB">
                                  Dubaï, Émirats Arabes Unis (DXB)
                                </option>
                                <option value="HKG">Hong Kong (HKG)</option>
                                <option value="ICN">
                                  Séoul, Corée du Sud (ICN)
                                </option>
                                <option value="KUL">
                                  Kuala Lumpur, Malaisie (KUL)
                                </option>
                                <option value="NRT">
                                  Tokyo Narita, Japon (NRT)
                                </option>
                                <option value="PEK">Pékin, Chine (PEK)</option>
                                <option value="PVG">
                                  Shanghai Pudong, Chine (PVG)
                                </option>
                                <option value="SIN">Singapour (SIN)</option>
                              </optgroup>

                              {/* Océanie */}
                              <optgroup label="Océanie">
                                <option value="AKL">
                                  Auckland, Nouvelle-Zélande (AKL)
                                </option>
                                <option value="BNE">
                                  Brisbane, Australie (BNE)
                                </option>
                                <option value="MEL">
                                  Melbourne, Australie (MEL)
                                </option>
                                <option value="SYD">
                                  Sydney, Australie (SYD)
                                </option>
                              </optgroup>

                              {/* Moyen-Orient */}
                              <optgroup label="Moyen-Orient">
                                <option value="AUH">
                                  Abu Dhabi, Émirats Arabes Unis (AUH)
                                </option>
                                <option value="BAH">Bahreïn (BAH)</option>
                                <option value="DOH">Doha, Qatar (DOH)</option>
                                <option value="JED">
                                  Jeddah, Arabie Saoudite (JED)
                                </option>
                                <option value="RUH">
                                  Riyad, Arabie Saoudite (RUH)
                                </option>
                                <option value="TLV">
                                  Tel Aviv, Israël (TLV)
                                </option>
                              </optgroup>
                            </select>
                            <p className="text-xs text-gray-500 mt-1">
                              Sélectionnez votre aéroport d'arrivée
                            </p>
                          </div>

                          <div>
                            <label className="block text-sm font-semibold mb-2 flex items-center">
                              <Calendar className="w-4 h-4 mr-1 text-purple-600" />
                              Date de vol *
                            </label>
                            <input
                              type="date"
                              value={segment.date}
                              onChange={(e) =>
                                updateSegment(index, "date", e.target.value)
                              }
                              min={
                                index > 0
                                  ? multiCitySegments[index - 1].date
                                  : new Date().toISOString().split("T")[0]
                              }
                              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                              required
                            />
                          </div>
                        </div>

                        {/* Indicateur de connexion entre les segments */}
                        {index < multiCitySegments.length - 1 && (
                          <div className="flex justify-center mt-4">
                            <div className="bg-blue-200 text-blue-800 px-3 py-1 rounded-full text-xs font-semibold flex items-center">
                              <ChevronDown className="w-3 h-3 mr-1" />
                              Prochaine étape
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  <button
                    type="button"
                    onClick={addSegment}
                    className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white py-3 rounded-lg font-semibold hover:from-green-600 hover:to-emerald-600 transition flex items-center justify-center"
                  >
                    <PlusCircle className="w-5 h-5 mr-2" />
                    Ajouter une étape (Maximum 5)
                  </button>
                </div>
              ) : (
                // ==================== FORMULAIRE STANDARD (ALLER SIMPLE / ALLER-RETOUR) ====================
                <div className="space-y-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                    {searchParams.tripType === "one-way" ? (
                      <>
                        <Plane className="w-5 h-5 mr-2 text-blue-600" />
                        Vol Aller Simple
                      </>
                    ) : (
                      <>
                        <svg
                          className="w-5 h-5 mr-2 text-blue-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                          />
                        </svg>
                        Vol Aller-Retour
                      </>
                    )}
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {/* Aéroport de départ */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <MapPin className="w-4 h-4 inline mr-1" />
                        Départ (Aéroport) *
                      </label>
                      <select
                        name="originLocationCode"
                        value={searchParams.originLocationCode}
                        onChange={(e) =>
                          setSearchParams((prev) => ({
                            ...prev,
                            originLocationCode: e.target.value,
                          }))
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                        required
                      >
                        <option value="">
                          Sélectionnez un aéroport de départ
                        </option>

                        {/* Afrique */}
                        <optgroup label="Afrique">
                          <option value="ABJ">
                            Abidjan, Côte d'Ivoire (ABJ)
                          </option>
                          <option value="ACC">Accra, Ghana (ACC)</option>
                          <option value="ADD">
                            Addis-Abeba, Éthiopie (ADD)
                          </option>
                          <option value="ALG">Alger, Algérie (ALG)</option>
                          <option value="CMN">Casablanca, Maroc (CMN)</option>
                          <option value="COO">Cotonou, Bénin (COO)</option>
                          <option value="DKR">Dakar, Sénégal (DKR)</option>
                          <option value="DAR">
                            Dar es Salaam, Tanzanie (DAR)
                          </option>
                          <option value="EBB">Entebbe, Ouganda (EBB)</option>
                          <option value="FIH">Kinshasa, RDC (FIH)</option>
                          <option value="JNB">
                            Johannesburg, Afrique du Sud (JNB)
                          </option>
                          <option value="KGL">Kigali, Rwanda (KGL)</option>
                          <option value="LAD">Luanda, Angola (LAD)</option>
                          <option value="LOS">Lagos, Nigeria (LOS)</option>
                          <option value="NBO">Nairobi, Kenya (NBO)</option>
                          <option value="RAI">Praia, Cap-Vert (RAI)</option>
                          <option value="TUN">Tunis, Tunisie (TUN)</option>
                        </optgroup>

                        {/* Europe */}
                        <optgroup label="Europe">
                          <option value="AMS">Amsterdam, Pays-Bas (AMS)</option>
                          <option value="BCN">Barcelone, Espagne (BCN)</option>
                          <option value="BER">Berlin, Allemagne (BER)</option>
                          <option value="BRU">Bruxelles, Belgique (BRU)</option>
                          <option value="CDG">
                            Paris Charles de Gaulle, France (CDG)
                          </option>
                          <option value="FCO">
                            Rome Fiumicino, Italie (FCO)
                          </option>
                          <option value="FRA">
                            Francfort, Allemagne (FRA)
                          </option>
                          <option value="GVA">Genève, Suisse (GVA)</option>
                          <option value="IST">Istanbul, Turquie (IST)</option>
                          <option value="LHR">
                            Londres Heathrow, Royaume-Uni (LHR)
                          </option>
                          <option value="LIS">Lisbonne, Portugal (LIS)</option>
                          <option value="MAD">Madrid, Espagne (MAD)</option>
                          <option value="MUC">Munich, Allemagne (MUC)</option>
                          <option value="ORY">Paris Orly, France (ORY)</option>
                          <option value="VIE">Vienne, Autriche (VIE)</option>
                          <option value="ZRH">Zurich, Suisse (ZRH)</option>
                        </optgroup>

                        {/* Amérique du Nord */}
                        <optgroup label="Amérique du Nord">
                          <option value="ATL">Atlanta, USA (ATL)</option>
                          <option value="DFW">Dallas, USA (DFW)</option>
                          <option value="DTW">Detroit, USA (DTW)</option>
                          <option value="JFK">New York JFK, USA (JFK)</option>
                          <option value="LAX">Los Angeles, USA (LAX)</option>
                          <option value="MIA">Miami, USA (MIA)</option>
                          <option value="ORD">Chicago, USA (ORD)</option>
                          <option value="SFO">San Francisco, USA (SFO)</option>
                          <option value="YYZ">Toronto, Canada (YYZ)</option>
                          <option value="YUL">Montréal, Canada (YUL)</option>
                        </optgroup>

                        {/* Amérique du Sud */}
                        <optgroup label="Amérique du Sud">
                          <option value="BOG">Bogota, Colombie (BOG)</option>
                          <option value="EZE">
                            Buenos Aires, Argentine (EZE)
                          </option>
                          <option value="GRU">São Paulo, Brésil (GRU)</option>
                          <option value="LIM">Lima, Pérou (LIM)</option>
                          <option value="SCL">Santiago, Chili (SCL)</option>
                        </optgroup>

                        {/* Asie */}
                        <optgroup label="Asie">
                          <option value="BKK">Bangkok, Thaïlande (BKK)</option>
                          <option value="CAN">Guangzhou, Chine (CAN)</option>
                          <option value="DEL">Delhi, Inde (DEL)</option>
                          <option value="DXB">
                            Dubaï, Émirats Arabes Unis (DXB)
                          </option>
                          <option value="HKG">Hong Kong (HKG)</option>
                          <option value="ICN">Séoul, Corée du Sud (ICN)</option>
                          <option value="KUL">
                            Kuala Lumpur, Malaisie (KUL)
                          </option>
                          <option value="NRT">Tokyo Narita, Japon (NRT)</option>
                          <option value="PEK">Pékin, Chine (PEK)</option>
                          <option value="PVG">
                            Shanghai Pudong, Chine (PVG)
                          </option>
                          <option value="SIN">Singapour (SIN)</option>
                        </optgroup>

                        {/* Océanie */}
                        <optgroup label="Océanie">
                          <option value="AKL">
                            Auckland, Nouvelle-Zélande (AKL)
                          </option>
                          <option value="BNE">Brisbane, Australie (BNE)</option>
                          <option value="MEL">
                            Melbourne, Australie (MEL)
                          </option>
                          <option value="SYD">Sydney, Australie (SYD)</option>
                        </optgroup>

                        {/* Moyen-Orient */}
                        <optgroup label="Moyen-Orient">
                          <option value="AUH">
                            Abu Dhabi, Émirats Arabes Unis (AUH)
                          </option>
                          <option value="BAH">Bahreïn (BAH)</option>
                          <option value="DOH">Doha, Qatar (DOH)</option>
                          <option value="JED">
                            Jeddah, Arabie Saoudite (JED)
                          </option>
                          <option value="RUH">
                            Riyad, Arabie Saoudite (RUH)
                          </option>
                          <option value="TLV">Tel Aviv, Israël (TLV)</option>
                        </optgroup>
                      </select>
                      <p className="text-xs text-gray-500 mt-1">
                        Sélectionnez votre aéroport de départ
                      </p>
                    </div>

                    {/* Aéroport d'arrivée */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <MapPin className="w-4 h-4 inline mr-1" />
                        Arrivée (Aéroport) *
                      </label>
                      <select
                        name="destinationLocationCode"
                        value={searchParams.destinationLocationCode}
                        onChange={(e) =>
                          setSearchParams({
                            ...searchParams,
                            destinationLocationCode: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                        required
                      >
                        <option value="">
                          Sélectionnez un aéroport d'arrivée
                        </option>

                        {/* Afrique */}
                        <optgroup label="Afrique">
                          <option value="ABJ">
                            Abidjan, Côte d'Ivoire (ABJ)
                          </option>
                          <option value="ACC">Accra, Ghana (ACC)</option>
                          <option value="ADD">
                            Addis-Abeba, Éthiopie (ADD)
                          </option>
                          <option value="ALG">Alger, Algérie (ALG)</option>
                          <option value="CMN">Casablanca, Maroc (CMN)</option>
                          <option value="COO">Cotonou, Bénin (COO)</option>
                          <option value="DKR">Dakar, Sénégal (DKR)</option>
                          <option value="DAR">
                            Dar es Salaam, Tanzanie (DAR)
                          </option>
                          <option value="EBB">Entebbe, Ouganda (EBB)</option>
                          <option value="FIH">Kinshasa, RDC (FIH)</option>
                          <option value="JNB">
                            Johannesburg, Afrique du Sud (JNB)
                          </option>
                          <option value="KGL">Kigali, Rwanda (KGL)</option>
                          <option value="LAD">Luanda, Angola (LAD)</option>
                          <option value="LOS">Lagos, Nigeria (LOS)</option>
                          <option value="NBO">Nairobi, Kenya (NBO)</option>
                          <option value="RAI">Praia, Cap-Vert (RAI)</option>
                          <option value="TUN">Tunis, Tunisie (TUN)</option>
                        </optgroup>

                        {/* Europe */}
                        <optgroup label="Europe">
                          <option value="AMS">Amsterdam, Pays-Bas (AMS)</option>
                          <option value="BCN">Barcelone, Espagne (BCN)</option>
                          <option value="BER">Berlin, Allemagne (BER)</option>
                          <option value="BRU">Bruxelles, Belgique (BRU)</option>
                          <option value="CDG">
                            Paris Charles de Gaulle, France (CDG)
                          </option>
                          <option value="FCO">
                            Rome Fiumicino, Italie (FCO)
                          </option>
                          <option value="FRA">
                            Francfort, Allemagne (FRA)
                          </option>
                          <option value="GVA">Genève, Suisse (GVA)</option>
                          <option value="IST">Istanbul, Turquie (IST)</option>
                          <option value="LHR">
                            Londres Heathrow, Royaume-Uni (LHR)
                          </option>
                          <option value="LIS">Lisbonne, Portugal (LIS)</option>
                          <option value="MAD">Madrid, Espagne (MAD)</option>
                          <option value="MUC">Munich, Allemagne (MUC)</option>
                          <option value="ORY">Paris Orly, France (ORY)</option>
                          <option value="VIE">Vienne, Autriche (VIE)</option>
                          <option value="ZRH">Zurich, Suisse (ZRH)</option>
                        </optgroup>

                        {/* Amérique du Nord */}
                        <optgroup label="Amérique du Nord">
                          <option value="ATL">Atlanta, USA (ATL)</option>
                          <option value="DFW">Dallas, USA (DFW)</option>
                          <option value="DTW">Detroit, USA (DTW)</option>
                          <option value="JFK">New York JFK, USA (JFK)</option>
                          <option value="LAX">Los Angeles, USA (LAX)</option>
                          <option value="MIA">Miami, USA (MIA)</option>
                          <option value="ORD">Chicago, USA (ORD)</option>
                          <option value="SFO">San Francisco, USA (SFO)</option>
                          <option value="YYZ">Toronto, Canada (YYZ)</option>
                          <option value="YUL">Montréal, Canada (YUL)</option>
                        </optgroup>

                        {/* Amérique du Sud */}
                        <optgroup label="Amérique du Sud">
                          <option value="BOG">Bogota, Colombie (BOG)</option>
                          <option value="EZE">
                            Buenos Aires, Argentine (EZE)
                          </option>
                          <option value="GRU">São Paulo, Brésil (GRU)</option>
                          <option value="LIM">Lima, Pérou (LIM)</option>
                          <option value="SCL">Santiago, Chili (SCL)</option>
                        </optgroup>

                        {/* Asie */}
                        <optgroup label="Asie">
                          <option value="BKK">Bangkok, Thaïlande (BKK)</option>
                          <option value="CAN">Guangzhou, Chine (CAN)</option>
                          <option value="DEL">Delhi, Inde (DEL)</option>
                          <option value="DXB">
                            Dubaï, Émirats Arabes Unis (DXB)
                          </option>
                          <option value="HKG">Hong Kong (HKG)</option>
                          <option value="ICN">Séoul, Corée du Sud (ICN)</option>
                          <option value="KUL">
                            Kuala Lumpur, Malaisie (KUL)
                          </option>
                          <option value="NRT">Tokyo Narita, Japon (NRT)</option>
                          <option value="PEK">Pékin, Chine (PEK)</option>
                          <option value="PVG">
                            Shanghai Pudong, Chine (PVG)
                          </option>
                          <option value="SIN">Singapour (SIN)</option>
                        </optgroup>

                        {/* Océanie */}
                        <optgroup label="Océanie">
                          <option value="AKL">
                            Auckland, Nouvelle-Zélande (AKL)
                          </option>
                          <option value="BNE">Brisbane, Australie (BNE)</option>
                          <option value="MEL">
                            Melbourne, Australie (MEL)
                          </option>
                          <option value="SYD">Sydney, Australie (SYD)</option>
                        </optgroup>

                        {/* Moyen-Orient */}
                        <optgroup label="Moyen-Orient">
                          <option value="AUH">
                            Abu Dhabi, Émirats Arabes Unis (AUH)
                          </option>
                          <option value="BAH">Bahreïn (BAH)</option>
                          <option value="DOH">Doha, Qatar (DOH)</option>
                          <option value="JED">
                            Jeddah, Arabie Saoudite (JED)
                          </option>
                          <option value="RUH">
                            Riyad, Arabie Saoudite (RUH)
                          </option>
                          <option value="TLV">Tel Aviv, Israël (TLV)</option>
                        </optgroup>
                      </select>
                      <p className="text-xs text-gray-500 mt-1">
                        Sélectionnez votre aéroport d'arrivée
                      </p>
                    </div>

                    {/* Date de départ */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <Calendar className="w-4 h-4 inline mr-1" />
                        Date de départ *
                      </label>
                      <input
                        type="date"
                        value={searchParams.departureDate}
                        onChange={(e) =>
                          setSearchParams({
                            ...searchParams,
                            departureDate: e.target.value,
                          })
                        }
                        min={new Date().toISOString().split("T")[0]}
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                        required
                      />
                    </div>

                    {/* Date de retour (conditionnel) */}
                    {searchParams.tripType === "round-trip" && (
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          <Calendar className="w-4 h-4 inline mr-1" />
                          Date de retour *
                        </label>
                        <input
                          type="date"
                          value={searchParams.returnDate}
                          onChange={(e) =>
                            setSearchParams({
                              ...searchParams,
                              returnDate: e.target.value,
                            })
                          }
                          min={
                            searchParams.departureDate ||
                            new Date().toISOString().split("T")[0]
                          }
                          className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                          required
                        />
                      </div>
                    )}

                    {/* Nombre de passagers */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <Users className="w-4 h-4 inline mr-1" />
                        Passagers adultes
                      </label>
                      <select
                        value={searchParams.adults}
                        onChange={(e) =>
                          setSearchParams({
                            ...searchParams,
                            adults: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                          <option key={n} value={n}>
                            {n} adulte{n > 1 ? "s" : ""}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <Users className="w-4 h-4 inline mr-1" />
                        Passagers enfants
                      </label>
                      <select
                        value={searchParams.children}
                        onChange={(e) =>
                          setSearchParams({
                            ...searchParams,
                            children: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                          <option key={n} value={n}>
                            {n} enfant{n > 1 ? "s" : ""}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <Users className="w-4 h-4 inline mr-1" />
                        Passagers bébé
                      </label>
                      <select
                        value={searchParams.infants}
                        onChange={(e) =>
                          setSearchParams({
                            ...searchParams,
                            infants: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                          <option key={n} value={n}>
                            {n} bébé{n > 1 ? "s" : ""}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Classe de voyage */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <Star className="w-4 h-4 inline mr-1" />
                        Classe de voyage
                      </label>
                      <select
                        value={searchParams.travelClass}
                        onChange={(e) =>
                          setSearchParams({
                            ...searchParams,
                            travelClass: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="ECONOMY">Économique</option>
                        <option value="PREMIUM_ECONOMY">
                          Économique Premium
                        </option>
                        <option value="BUSINESS">Affaires</option>
                        <option value="FIRST">Première Classe</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Résumé visuel de la recherche */}
            <div className="bg-gradient-to-r from-blue-500 to-indigo-600 rounded-xl shadow-lg p-6 text-white">
              <h3 className="text-lg font-bold mb-4 flex items-center">
                <Info className="w-5 h-5 mr-2" />
                Récapitulatif de votre recherche
              </h3>

              <div className="flex flex-wrap gap-3">
                {/* Type de voyage */}
                <span className="px-4 py-2 bg-white bg-opacity-20 rounded-full text-sm font-semibold backdrop-blur-sm">
                  {searchParams.tripType === "one-way"
                    ? "✈️ Aller Simple"
                    : searchParams.tripType === "round-trip"
                    ? "🔄 Aller-Retour"
                    : "🌍 Multi-Destinations"}
                </span>

                {/* Affichage selon le type */}
                {searchParams.tripType === "multi-city" ? (
                  <>
                    <span className="px-4 py-2 bg-white bg-opacity-20 rounded-full text-sm font-semibold backdrop-blur-sm">
                      {multiCitySegments.length} étape
                      {multiCitySegments.length > 1 ? "s" : ""}
                    </span>
                    {multiCitySegments.map((segment, index) => (
                      <span
                        key={index}
                        className="px-4 py-2 bg-white bg-opacity-20 rounded-full text-sm font-semibold backdrop-blur-sm"
                      >
                        📍 {segment.origin || "?"} →{" "}
                        {segment.destination || "?"}
                        {segment.date &&
                          ` (${new Date(segment.date).toLocaleDateString(
                            "fr-FR"
                          )})`}
                      </span>
                    ))}
                  </>
                ) : (
                  <>
                    {searchParams.originLocationCode &&
                      searchParams.destinationLocationCode && (
                        <span className="px-4 py-2 bg-white bg-opacity-20 rounded-full text-sm font-semibold backdrop-blur-sm">
                          📍 {searchParams.originLocationCode} →{" "}
                          {searchParams.destinationLocationCode}
                        </span>
                      )}
                    {searchParams.departureDate && (
                      <span className="px-4 py-2 bg-white bg-opacity-20 rounded-full text-sm font-semibold backdrop-blur-sm">
                        📅 Départ:{" "}
                        {new Date(
                          searchParams.departureDate
                        ).toLocaleDateString("fr-FR")}
                      </span>
                    )}
                    {searchParams.tripType === "round-trip" &&
                      searchParams.returnDate && (
                        <span className="px-4 py-2 bg-white bg-opacity-20 rounded-full text-sm font-semibold backdrop-blur-sm">
                          📅 Retour:{" "}
                          {new Date(searchParams.returnDate).toLocaleDateString(
                            "fr-FR"
                          )}
                        </span>
                      )}
                  </>
                )}

                {/* Informations communes *****/}
              </div>
            </div>

            {/* Bouton de recherche */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white py-4 rounded-xl font-bold text-lg shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {loading ? (
                <>
                  <Loader className="w-6 h-6 mr-3 animate-spin" />
                  Recherche en cours...
                </>
              ) : (
                <>
                  <Search className="w-6 h-6 mr-3" />
                  {searchParams.tripType === "multi-city"
                    ? `Rechercher ${multiCitySegments.length} vol${
                        multiCitySegments.length > 1 ? "s" : ""
                      } multi-destinations`
                    : searchParams.tripType === "round-trip"
                    ? "Rechercher des vols aller-retour"
                    : "Rechercher des vols aller simple"}
                </>
              )}
            </button>
          </form>
        </div>

        {/* Message d'erreur */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <p className="text-red-600">{error}</p>
          </div>
        )}

        {/* Résultats de recherche */}
        {searchResults.length > 0 && (
          <div className="bg-white rounded-xl shadow-md p-6">
            <h3 className="text-xl font-bold mb-4">
              {searchParams.tripType === "multi-city"
                ? `Vols trouvés pour ${searchResults.length} segment${
                    searchResults.length > 1 ? "s" : ""
                  }`
                : `${searchResults.length} vol${
                    searchResults.length > 1 ? "s" : ""
                  } trouvé${searchResults.length > 1 ? "s" : ""}`}
            </h3>

            {searchParams.tripType === "multi-city" ? (
              // AFFICHAGE MULTI-DESTINATIONS
              <div className="space-y-6">
                {searchResults.map((segmentGroup, segmentIndex) => (
                  <div
                    key={segmentIndex}
                    className="border-2 border-blue-200 rounded-lg p-5 bg-blue-50"
                  >
                    <div className="flex items-center mb-4">
                      <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-3">
                        {segmentIndex + 1}
                      </div>
                      <h4 className="text-lg font-bold text-blue-900">
                        {segmentGroup.segment.origin} →{" "}
                        {segmentGroup.segment.destination}
                      </h4>
                      <span className="ml-auto text-sm text-blue-700">
                        {new Date(segmentGroup.segment.date).toLocaleDateString(
                          "fr-FR"
                        )}
                      </span>
                    </div>

                    <div className="space-y-4">
                      {segmentGroup.flights.map((flight, flightIndex) => {
                        const firstSegment =
                          flight.itineraries?.[0]?.segments?.[0];
                        const lastSegment =
                          flight.itineraries?.[0]?.segments?.[
                            flight.itineraries[0].segments.length - 1
                          ];
                        const isInCart = cart.some(
                          (c) =>
                            c.segmentId === `${segmentIndex}-${flightIndex}`
                        );

                        return (
                          <div
                            key={flightIndex}
                            className="bg-white rounded-lg p-4 hover:shadow-md transition"
                          >
                            <div className="flex justify-between items-start">
                              <div className="flex-1">
                                <div className="flex items-center space-x-3 mb-2">
                                  <h5 className="font-semibold">
                                    {firstSegment?.departure?.iataCode} →
                                    {"ALIA"}
                                    {lastSegment?.arrival?.iataCode}
                                  </h5>
                                  <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs">
                                    {flight.travelerPricings?.[0]
                                      ?.fareDetailsBySegment?.[0]?.cabin ||
                                      "ECONOMY"}
                                  </span>
                                </div>
                                <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm text-gray-600">
                                  <div>
                                    <span className="font-semibold">
                                      Départ:
                                    </span>{" "}
                                    {firstSegment?.departure?.at
                                      ? new Date(
                                          firstSegment.departure.at
                                        ).toLocaleTimeString("fr-FR", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })
                                      : "N/A"}
                                  </div>
                                  <div>
                                    <span className="font-semibold">
                                      Arrivée:
                                    </span>{" "}
                                    {lastSegment?.arrival?.at
                                      ? new Date(
                                          lastSegment.arrival.at
                                        ).toLocaleTimeString("fr-FR", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })
                                      : "N/A"}
                                  </div>
                                  <div>
                                    <span className="font-semibold">
                                      Durée:
                                    </span>{" "}
                                    {flight.itineraries?.[0]?.duration
                                      ?.replace("PT", "")
                                      .replace("H", "h ")
                                      .replace("M", "min") || "N/A"}
                                  </div>
                                </div>
                              </div>
                              <div className="text-right ml-4">
                                <p className="text-lg font-bold text-blue-600">
                                  {flight.price?.total} {flight.price?.currency}
                                </p>
                                {isInCart ? (
                                  <button
                                    disabled
                                    className="mt-3 w-full bg-gray-300 text-gray-500 px-4 py-2 rounded-lg cursor-not-allowed flex items-center justify-center"
                                  >
                                    <CheckCircle className="w-4 h-4 mr-2" />
                                    {
                                      cart.filter(
                                        (item) =>
                                          item.flightData.id === flight.id
                                      ).length
                                    }{" "}
                                    ticket(s) dans le panier
                                  </button>
                                ) : (
                                  <button
                                    onClick={() =>
                                      addToCart({
                                        ...flight,
                                        searchParams: {
                                          ...segmentGroup.searchParams,
                                          adults: searchParams.adults,
                                          children: searchParams.children,
                                          infants: searchParams.infants,
                                          originLocationCode:
                                            segmentGroup.segment.origin,
                                          destinationLocationCode:
                                            segmentGroup.segment.destination,
                                          departureDate:
                                            segmentGroup.segment.date,
                                        },
                                        segmentId: `${segmentIndex}-${flightIndex}`,
                                        segment: segmentGroup.segment,
                                      })
                                    }
                                    className="mt-3 w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center justify-center"
                                  >
                                    <PlusCircle className="w-4 h-4 mr-2" />
                                    Ajouter {totalPassengers} ticket(s) au
                                    panier
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              // AFFICHAGE STANDARD (one-way/round-trip)
              <div className="space-y-4">
                {searchResults.map((flight, index) => {
                  const firstItinerary = flight.itineraries?.[0];
                  const firstSegment = firstItinerary?.segments?.[0];
                  const lastSegment =
                    firstItinerary?.segments?.[
                      firstItinerary.segments.length - 1
                    ];
                  const numberOfStops =
                    (firstItinerary?.segments?.length || 1) - 1;
                  const isInCart = cart.some((c) => c.id === flight.id);

                  return (
                    <div
                      key={flight.id || `flight-${index}`}
                      className="border rounded-lg p-4 hover:shadow-lg transition"
                    >
                      <div className="flex justify-between items-center">
                        <div className="flex-1">
                          <div className="flex items-center space-x-4 mb-3">
                            <h4 className="font-bold text-xl">
                              {firstSegment?.departure?.iataCode || "N/A"} →{" "}
                              {lastSegment?.arrival?.iataCode || "N/A"}
                            </h4>
                            <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
                              {firstSegment?.carrierCode || "N/A"}{" "}
                              {firstSegment?.number || ""}
                            </span>
                            {numberOfStops > 0 && (
                              <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm">
                                {numberOfStops} escale
                                {numberOfStops > 1 ? "s" : ""}
                              </span>
                            )}
                            {numberOfStops === 0 && (
                              <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm">
                                Vol direct
                              </span>
                            )}
                          </div>

                          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                            <div>
                              <p className="text-gray-500">Départ</p>
                              <p className="font-semibold">
                                {firstSegment?.departure?.at
                                  ? new Date(
                                      firstSegment.departure.at
                                    ).toLocaleString("fr-FR", {
                                      day: "2-digit",
                                      month: "short",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                  : "N/A"}
                              </p>
                            </div>
                            <div>
                              <p className="text-gray-500">Arrivée</p>
                              <p className="font-semibold">
                                {lastSegment?.arrival?.at
                                  ? new Date(
                                      lastSegment.arrival.at
                                    ).toLocaleString("fr-FR", {
                                      day: "2-digit",
                                      month: "short",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                  : "N/A"}
                              </p>
                            </div>
                            <div>
                              <p className="text-gray-500">Durée</p>
                              <p className="font-semibold">
                                {firstItinerary?.duration
                                  ?.replace("PT", "")
                                  .replace("H", "h ")
                                  .replace("M", "min") || "N/A"}
                              </p>
                            </div>
                            <div>
                              <p className="text-gray-500">Classe</p>
                              <p className="font-semibold">
                                {flight.travelerPricings?.[0]
                                  ?.fareDetailsBySegment?.[0]?.cabin ||
                                  "ECONOMY"}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="ml-4">
                          <div className="text-right">
                            <p className="text-sm text-gray-500">Prix total</p>
                            <p className="text-3xl font-bold text-blue-600">
                              {flight.price?.total || "0"}{" "}
                              {flight.price?.currency || "EUR"}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                              Pour {searchParams.adults} passager
                              {searchParams.adults > 1 ? "s" : ""}
                            </p>
                          </div>
                          {isInCart ? (
                            <button
                              disabled
                              className="mt-3 w-full bg-gray-300 text-gray-500 px-4 py-2 rounded-lg cursor-not-allowed flex items-center justify-center"
                            >
                              <CheckCircle className="w-4 h-4 mr-2" />
                              {
                                cart.filter(
                                  (item) => item.flightData.id === flight.id
                                ).length
                              }{" "}
                              ticket(s) dans le panier
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                addToCart({
                                  ...flight,
                                  searchParams: {
                                    originLocationCode:
                                      firstSegment?.departure?.iataCode,
                                    destinationLocationCode:
                                      lastSegment?.arrival?.iataCode,
                                    departureDate:
                                      firstSegment?.departure?.at?.split(
                                        "T"
                                      )[0],
                                    adults: searchParams.adults,
                                    children: searchParams.children,
                                    infants: searchParams.infants,
                                    travelClass:
                                      flight.travelerPricings?.[0]
                                        ?.fareDetailsBySegment?.[0]?.cabin ||
                                      "ECONOMY",
                                    tripType: searchParams.tripType,
                                  },
                                });
                              }}
                              className="mt-3 w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center justify-center"
                            >
                              <PlusCircle className="w-4 h-4 mr-2" />
                              Ajouter {totalPassengers} ticket(s) au panier
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* Message si panier contient des éléments */}
        {cart.length > 0 && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-blue-800">
              Vous avez {cart.length} ticket dans votre panier (
              {new Set(cart.map((item) => item.flightData.id)).size} vol{"s"}{" "}
              distinct{"s"}). Continuez à chercher ou consultez votre panier
              pour finaliser.
            </p>
          </div>
        )}
      </div>
    );
  };

  // ==================== ONGLET PANIER ====================
  const CartTab = ({
    cart,
    removeFromCart,
    clearCart,
    calculateCartTotal,
    setActiveTab,
    searchParams,
  }) => {
    console.error("Le code est passé par ici :", searchParams);

    // Correction : supprimer cette ligne qui crée un objet inutile
    // searchParams = { searchParams } // ← LIGNE À SUPPRIMER

    if (cart.length === 0) {
      console.error("Le code est passé par ici :", cart);
      return (
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <ShoppingCart className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-xl font-bold text-gray-700 mb-2">
            Votre panier est vide
          </h3>
          <p className="text-gray-500 mb-6">
            Recherchez et ajoutez des vols à votre panier
          </p>
          <button
            onClick={() => setActiveTab("search")}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700"
          >
            Rechercher des vols
          </button>
        </div>
      );
    }

    // Obtenir le libellé du type de voyage
    const getTripTypeLabel = () => {
      switch (searchParams.tripType) {
        case "one-way":
          return "Aller Simple";
        case "round-trip":
          return "Aller-Retour";
        case "multi-city":
          return "Multi-Destinations";
        default:
          return "Vols";
      }
    };

    // Obtenir le libellé pour un vol spécifique
    const getFlightLabel = (index, totalFlights) => {
      if (searchParams.tripType === "round-trip" && totalFlights === 2) {
        return index === 0 ? "Aller" : "Retour";
      } else if (searchParams.tripType === "multi-city") {
        return `Étape ${index + 1}`;
      } else {
        return `Vol ${index + 1}`;
      }
    };

    // Fonction pour obtenir les numéros de vol - NOUVELLE FONCTION
    const getFlightNumbers = (flightData) => {
      const segments =
        flightData.itineraries?.[0]?.segments || flightData.segments || [];
      if (segments.length === 0) return "N/A";

      return segments
        .map((segment) => `${segment.carrierCode} ${segment.number}`)
        .join(" → ");
    };

    // Fonction pour obtenir les détails des segments - NOUVELLE FONCTION
    const getFlightSegmentsDetails = (flightData) => {
      const segments =
        flightData.itineraries?.[0]?.segments || flightData.segments || [];
      return segments.map((segment, index) => ({
        number: `${segment.carrierCode} ${segment.number}`,
        route: `${segment.departure?.iataCode} → ${segment.arrival?.iataCode}`,
        departureTime: segment.departure?.at
          ? new Date(segment.departure.at).toLocaleTimeString("fr-FR", {
              hour: "2-digit",
              minute: "2-digit",
            })
          : "N/A",
        arrivalTime: segment.arrival?.at
          ? new Date(segment.arrival.at).toLocaleTimeString("fr-FR", {
              hour: "2-digit",
              minute: "2-digit",
            })
          : "N/A",
        duration:
          segment.duration
            ?.replace("PT", "")
            .replace("H", "h ")
            .replace("M", "min") || "N/A",
        isLast: index === segments.length - 1,
      }));
    };

    // Grouper les tickets par vol
    const groupedTickets = cart.reduce((groups, ticket) => {
      const flightId = ticket.flightData?.id || ticket.id;
      if (!groups[flightId]) {
        groups[flightId] = [];
      }
      groups[flightId].push(ticket);
      return groups;
    }, {});

    return (
      <div className="space-y-6">
        <div className="bg-white rounded-xl shadow-md p-6">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-xl font-bold flex items-center">
                <ShoppingCart className="w-6 h-6 mr-2 text-blue-600" />
                Mon Panier - {getTripTypeLabel()}
              </h2>
              <p className="text-gray-600 text-sm mt-1">
                {Object.keys(groupedTickets).length}{" "}
                {searchParams.tripType === "multi-city" ? "étape" : "vol"}
                {Object.keys(groupedTickets).length > 1 ? "s" : ""} •
                {cart.length} ticket{cart.length > 1 ? "s" : ""}
              </p>
            </div>
            <button
              onClick={clearCart}
              className="text-red-600 hover:bg-red-50 px-4 py-2 rounded-lg flex items-center transition-colors"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Vider le panier
            </button>
          </div>

          {/* Résumé du type de voyage */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <div className="flex items-center">
              <Info className="w-5 h-5 text-blue-600 mr-2" />
              <div>
                <p className="text-blue-800 font-semibold">
                  {searchParams.tripType === "one-way"
                    ? "Demande de vol aller simple"
                    : searchParams.tripType === "round-trip"
                    ? "Demande de vol aller-retour"
                    : "Demande de voyage multi-destinations"}
                </p>
                <p className="text-blue-600 text-sm">
                  {searchParams.tripType === "round-trip"
                    ? "Votre panier inclut les vols aller et retour"
                    : searchParams.tripType === "multi-city"
                    ? "Votre itinéraire comprend plusieurs destinations"
                    : "Vol simple sans retour"}
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            {Object.entries(groupedTickets).map(
              ([flightId, tickets], index, array) => {
                const firstTicket = tickets[0];
                const flightData = firstTicket.flightData || firstTicket;
                const firstItinerary = flightData.itineraries?.[0];
                const firstSegment = firstItinerary?.segments?.[0];
                const lastSegment =
                  firstItinerary?.segments?.[
                    firstItinerary?.segments?.length - 1
                  ];
                const flightSearchParams = firstTicket.searchParams || {};

                // Obtenir les numéros de vol et détails des segments
                const flightNumbers = getFlightNumbers(flightData);
                const segmentsDetails = getFlightSegmentsDetails(flightData);
                const hasMultipleSegments = segmentsDetails.length > 1;

                return (
                  <div
                    key={flightId}
                    className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
                  >
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        {/* En-tête du vol */}
                        <div className="flex items-center space-x-3 mb-3">
                          <span
                            className={`px-3 py-1 rounded-full text-sm font-semibold ${
                              searchParams.tripType === "round-trip" &&
                              array.length === 2
                                ? index === 0
                                  ? "bg-green-100 text-green-700"
                                  : "bg-blue-100 text-blue-700"
                                : "bg-blue-100 text-blue-700"
                            }`}
                          >
                            {getFlightLabel(index, array.length)}
                          </span>
                          <h4 className="font-bold text-gray-800">
                            {firstSegment?.departure?.iataCode || "N/A"} →
                            {lastSegment?.arrival?.iataCode || "N/A"}
                          </h4>
                          {/* AFFICHAGE DU NUMÉRO DE VOL - CORRIGÉ */}
                          <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
                            {flightNumbers}
                          </span>
                          {hasMultipleSegments && (
                            <span className="px-2 py-1 bg-orange-100 text-orange-700 rounded text-xs">
                              {segmentsDetails.length - 1} escale
                              {segmentsDetails.length - 1 > 1 ? "s" : ""}
                            </span>
                          )}
                        </div>

                        {/* Informations détaillées */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 text-sm text-gray-600 mb-3">
                          <div>
                            <p className="text-gray-500 text-xs">Date</p>
                            <p className="font-semibold">
                              {firstSegment?.departure?.at
                                ? new Date(
                                    firstSegment.departure.at
                                  ).toLocaleDateString("fr-FR")
                                : flightSearchParams.departureDate
                                ? new Date(
                                    flightSearchParams.departureDate
                                  ).toLocaleDateString("fr-FR")
                                : "N/A"}
                            </p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs">Horaires</p>
                            <p className="font-semibold">
                              {firstSegment?.departure?.at
                                ? new Date(
                                    firstSegment.departure.at
                                  ).toLocaleTimeString("fr-FR", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : "N/A"}{" "}
                              -
                              {lastSegment?.arrival?.at
                                ? new Date(
                                    lastSegment.arrival.at
                                  ).toLocaleTimeString("fr-FR", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : "N/A"}
                            </p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs">
                              Durée totale
                            </p>
                            <p className="font-semibold">
                              {firstItinerary?.duration
                                ?.replace("PT", "")
                                .replace("H", "h ")
                                .replace("M", "min") || "N/A"}
                            </p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs">Classe</p>
                            <p className="font-semibold">
                              {flightSearchParams.travelClass === "ECONOMY"
                                ? "Économique"
                                : flightSearchParams.travelClass ===
                                  "PREMIUM_ECONOMY"
                                ? "Éco. Premium"
                                : flightSearchParams.travelClass === "BUSINESS"
                                ? "Affaires"
                                : "Première"}
                            </p>
                          </div>
                        </div>

                        {/* Détails des segments pour les vols avec escales */}
                        {hasMultipleSegments && (
                          <div className="bg-gray-50 rounded p-3 mb-3">
                            <p className="text-xs font-semibold text-gray-700 mb-2">
                              Détail de l'itinéraire :
                            </p>
                            <div className="space-y-2">
                              {segmentsDetails.map((segment, segIndex) => (
                                <div
                                  key={segIndex}
                                  className="flex items-center justify-between text-xs"
                                >
                                  <div className="flex items-center space-x-3">
                                    <span className="font-semibold text-blue-600 min-w-[80px]">
                                      {segment.number}
                                    </span>
                                    <span className="text-gray-600">
                                      {segment.route}
                                    </span>
                                  </div>
                                  <div className="text-right text-gray-500">
                                    <div>
                                      {segment.departureTime} →{" "}
                                      {segment.arrivalTime}
                                    </div>
                                    <div className="text-xs">
                                      {segment.duration}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Détail des passagers */}
                        <div className="p-2 bg-gray-50 rounded">
                          <p className="text-xs text-gray-500 mb-1">
                            Détail des passagers :
                          </p>
                          <div className="space-y-1">
                            {tickets.map((ticket) => (
                              <div
                                key={ticket.cartId}
                                className="flex justify-between text-xs"
                              >
                                <span>
                                  {ticket.passengerType === "ADULT"
                                    ? "👤 Adulte"
                                    : ticket.passengerType === "CHILD"
                                    ? "🧒 Enfant"
                                    : "👶 Bébé"}
                                  #{ticket.passengerNumber}
                                </span>
                                <span className="font-semibold">
                                  {ticket.price?.total} {ticket.price?.currency}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="text-right ml-4 min-w-[150px]">
                        <p className="text-2xl font-bold text-blue-600">
                          {tickets
                            .reduce(
                              (sum, ticket) =>
                                sum + parseFloat(ticket.price?.total || 0),
                              0
                            )
                            .toFixed(2)}
                          {tickets[0]?.price?.currency || "EUR"}
                        </p>
                        <p className="text-sm text-gray-500 mt-1">
                          {tickets.length} ticket{tickets.length > 1 ? "s" : ""}
                        </p>
                        <button
                          onClick={() =>
                            tickets.forEach((ticket) =>
                              removeFromCart(ticket.cartId)
                            )
                          }
                          className="mt-2 text-red-600 hover:bg-red-50 px-3 py-2 rounded flex items-center transition-colors text-sm"
                        >
                          <Trash2 className="w-4 h-4 mr-1" />
                          Retirer ce vol
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </div>

          {/* Résumé et total */}
          <div className="mt-6 pt-6 border-t">
            <div className="flex justify-between items-center text-xl font-bold">
              <span>Total du panier:</span>
              <span className="text-3xl text-blue-600">
                {calculateCartTotal()} {cart[0]?.price?.currency || "EUR"}
              </span>
            </div>
            <p className="text-gray-600 text-sm mt-2 text-right">
              {Object.keys(groupedTickets).length}{" "}
              {searchParams.tripType === "multi-city" ? "étape" : "vol"}
              {Object.keys(groupedTickets).length > 1 ? "s" : ""} •{cart.length}{" "}
              ticket{cart.length > 1 ? "s" : ""}
            </p>
          </div>

          {/* Boutons d'action */}
          <div className="flex space-x-4 mt-6">
            <button
              onClick={() => setActiveTab("search")}
              className="flex-1 border border-blue-600 text-blue-600 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors"
            >
              Continuer les achats
            </button>
            <button
              onClick={() => setActiveTab("form")}
              className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 transition-colors"
            >
              Finaliser la demande
            </button>
          </div>
        </div>
      </div>
    );
  };
  // ==================== ONGLET FORMULAIRE ====================
  const FormTab = ({
    cart,
    agents,
    loadingAgents,
    user,
    submitting,
    setSubmitting,
    onRequestSubmitted,
    calculateCartTotal,
    searchParams,
  }) => {
    const [formData, setFormData] = useState({
      agentId: "",
      objetVoyage: "",
      motifDeplacement: "",
      projet: "",
      centreCoût: "",
    });
    const localValuesRef = useRef({
      origin: searchParams.originLocationCode || "",
      destination: searchParams.destinationLocationCode || "",
      objetVoyage: formData.objetVoyage || "",
    });

    const generateUUID = () => {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

      if (!formData.agentId) {
        toast.info("Veuillez sélectionner un agent");
        return;
      }

      const selectedAgent = agents.find((a) => a.id === formData.agentId);
      if (!selectedAgent) {
        toast.info("Agent sélectionné introuvable");
        return;
      }

      setSubmitting(true);

      const requestData = {
        id: generateUUID(),
        numeroRequete: `MULTI-${Date.now()}`,
        type: searchParams.tripType,
        flights: cart,
        matricule: selectedAgent.matricule,
        nom: selectedAgent.nom,
        prenom: selectedAgent.prenom,
        fonction: selectedAgent.fonction,
        categorie: selectedAgent.categorie,
        agent: selectedAgent,
        agentId: selectedAgent.id,
        objetVoyage: formData.objetVoyage,
        motifDeplacement: formData.motifDeplacement,
        projet: formData.projet,
        centreCoût: formData.centreCoût,
        montantTotal: calculateCartTotal(),
        devise: "EUR",
        dateRequete: new Date().toISOString(),
        createdAt: new Date(),
        statut: "En attente",
        createdBy: user.id,
      };

      try {
        // Appel API pour sauvegarder
        await onRequestSubmitted(requestData);
        toast.success("Demande multi-vols créée avec succès !");
        setSubmitting(false);
      } catch (error) {
        toast.error(`Erreur: ${error.message}`);
        setSubmitting(false);
      }
    };

    return (
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-2xl font-bold mb-6 flex items-center">
          <FileText className="w-6 h-6 mr-2 text-blue-600" />
          Finaliser la demande
        </h2>

        {/* Résumé du panier */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 mb-6">
          <h3 className="font-bold text-blue-900 mb-3">
            Résumé de votre sélection
          </h3>
          <div className="space-y-2">
            {cart.map((item, index) => (
              <div
                key={item.cartId}
                className="bg-white p-3 rounded flex justify-between"
              >
                <span>
                  <strong>Vol {index + 1}:</strong>{" "}
                  {item.itineraries[0].segments[0].departure.iataCode} →{" "}
                  {item.itineraries[0].segments[0].arrival.iataCode}
                  <span className="text-sm text-gray-600 ml-2">
                    (
                    {new Date(
                      item.searchParams.departureDate
                    ).toLocaleDateString("fr-FR")}
                    )
                  </span>
                </span>
                <span className="font-semibold">
                  {item.price.total} {item.price.currency}
                </span>
              </div>
            ))}
          </div>
          <div className="mt-4 pt-4 border-t border-blue-200">
            <div className="flex justify-between items-center text-lg font-bold">
              <span>Total:</span>
              <span className="text-2xl text-blue-600">
                {calculateCartTotal()} EUR
              </span>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Sélection de l'agent */}
          <div>
            <label className="block text-sm font-semibold mb-2">
              Agent voyageur *
            </label>
            <select
              value={formData.agentId}
              onChange={(e) =>
                setFormData({ ...formData, agentId: e.target.value })
              }
              className="w-full px-4 py-2 border rounded-lg"
              required
              disabled={submitting || loadingAgents}
            >
              <option value="">-- Sélectionner un agent --</option>
              {agents.map((agent) => (
                <option key={agent.id} value={agent.id}>
                  {agent.prenom} {agent.nom} - {agent.fonction} (Mat:{" "}
                  {agent.matricule})
                </option>
              ))}
            </select>
          </div>

          {/* Détails du voyage */}
          <div>
            <label className="block text-sm font-semibold mb-2">
              Objet du voyage *
            </label>
            <input
              type="text"
              value={formData.objetVoyage}
              onChange={(e) =>
                setFormData({ ...formData, objetVoyage: e.target.value })
              }
              placeholder="Ex: Tournée commerciale multi-destinations"
              className="w-full px-4 py-2 border rounded-lg"
              required
              disabled={submitting}
            />
            <input
              type="text"
              value={formData.objetVoyage}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  objetVoyage: e.target.value,
                }))
              }
              placeholder="Ex: Tournée commerciale multi-destinations"
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-semibold mb-2">
              Motif du déplacement *
            </label>
            <textarea
              value={formData.motifDeplacement}
              onChange={(e) =>
                setFormData({ ...formData, motifDeplacement: e.target.value })
              }
              rows="3"
              className="w-full px-4 py-2 border rounded-lg"
              required
              disabled={submitting}
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-2">Projet</label>
              <input
                type="text"
                value={formData.projet}
                onChange={(e) =>
                  setFormData({ ...formData, projet: e.target.value })
                }
                className="w-full px-4 py-2 border rounded-lg"
                disabled={submitting}
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Centre de coût
              </label>
              <input
                type="text"
                value={formData.centreCoût}
                onChange={(e) =>
                  setFormData({ ...formData, centreCoût: e.target.value })
                }
                className="w-full px-4 py-2 border rounded-lg"
                disabled={submitting}
              />
            </div>
          </div>

          {/* Boutons d'action */}
          <div className="flex space-x-4">
            <button
              type="submit"
              disabled={submitting}
              className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 text-white py-3 rounded-lg font-semibold hover:from-green-700 hover:to-emerald-700 disabled:opacity-50 flex items-center justify-center"
            >
              {submitting ? (
                <>
                  <Loader className="w-5 h-5 mr-2 animate-spin" />
                  Soumission en cours...
                </>
              ) : (
                <>
                  <CheckCircle className="w-5 h-5 mr-2" />
                  Soumettre la demande
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    );
  };

  // Formulaire de demande multi-vols
  const MultiFlightRequestForm = ({
    selectedFlights,
    globalParams,
    user,
    onSubmit,
    onCancel,
  }) => {
    const [formData, setFormData] = useState({
      objetVoyage: "",
      motifDeplacement: "",
      projet: "",
      centreCoût: "",
      agentId: "agent-001", // Simulé pour l'exemple
    });
    const [submitting, setSubmitting] = useState(false);
    const [safeSearchParams, setSafeSearchParams] = useState({
      originLocationCode: "",
      destinationLocationCode: "",
      departureDate: "",
      returnDate: "",
      adults: "1",
      children: "0",
      infants: "0",
      tripType: "one-way",
      travelClass: "ECONOMY",
    });
    const handleSubmit = async () => {
      if (!formData.objetVoyage || !formData.motifDeplacement) {
        toast.error("Veuillez remplir tous les champs obligatoires");
        return;
      }

      setSubmitting(true);

      const requestData = {
        id: `REQ-${Date.now()}`,
        numeroRequete: `MF-${Date.now()}`,
        type: "multi-segment",
        segments: selectedFlights,
        globalParams: globalParams,
        ...formData,
        dateRequete: new Date().toISOString(),
        createdAt: new Date(),
        statut: "En attente",
        montantTotal: calculateTotal(),
        devise: "EUR",
      };

      await onSubmit(requestData);
      setSubmitting(false);
    };

    const calculateTotal = () => {
      return selectedFlights
        .reduce((total, item) => total + parseFloat(item.flight.price.total), 0)
        .toFixed(2);
    };

    return (
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between mb-6">
          <h2 className="text-2xl font-bold flex items-center">
            <FileText className="w-6 h-6 mr-2 text-blue-600" />
            Demande Multi-Destinations
          </h2>
          <button onClick={onCancel} disabled={submitting}>
            <X className="w-6 h-6 text-gray-500 hover:text-gray-700" />
          </button>
        </div>

        {/* Résumé de l'itinéraire */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 mb-6">
          <h3 className="font-bold text-blue-900 mb-3">Itinéraire complet</h3>
          <div className="space-y-2">
            {selectedFlights.map((item, index) => (
              <div key={index} className="flex items-center">
                <div className="flex-1 bg-white p-3 rounded-lg">
                  <p className="font-semibold">
                    Segment {index + 1}: {item.segment.origin} →{" "}
                    {item.segment.destination}
                  </p>
                  <p className="text-sm text-gray-600">
                    {new Date(item.segment.date).toLocaleDateString("fr-FR")} -
                    {item.flight.price.total} {item.flight.price.currency}
                  </p>
                </div>
                {index < selectedFlights.length - 1 && (
                  <ChevronRight className="w-5 h-5 mx-2 text-gray-400" />
                )}
              </div>
            ))}
          </div>
          <div className="mt-4 pt-4 border-t border-blue-200">
            <div className="flex justify-between items-center">
              <span className="font-semibold">Total de l'itinéraire:</span>
              <span className="text-2xl font-bold text-blue-600">
                {calculateTotal()} EUR
              </span>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-semibold mb-2">
              Objet du voyage *
            </label>
            <input
              type="text"
              value={formData.objetVoyage}
              onChange={(e) =>
                setFormData({ ...formData, objetVoyage: e.target.value })
              }
              placeholder="Ex: Tournée commerciale Europe-Asie"
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold mb-2">
              Motif du déplacement *
            </label>
            <textarea
              value={formData.motifDeplacement}
              onChange={(e) =>
                setFormData({ ...formData, motifDeplacement: e.target.value })
              }
              rows="3"
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-2">Projet</label>
              <input
                type="text"
                value={formData.projet}
                onChange={(e) =>
                  setFormData({ ...formData, projet: e.target.value })
                }
                className="w-full px-4 py-2 border rounded-lg"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Centre de coût
              </label>
              <input
                type="text"
                value={formData.centreCoût}
                onChange={(e) =>
                  setFormData({ ...formData, centreCoût: e.target.value })
                }
                className="w-full px-4 py-2 border rounded-lg"
              />
            </div>
          </div>

          <div className="flex space-x-4">
            <button
              onClick={handleSubmit}
              disabled={
                submitting ||
                !formData.objetVoyage ||
                !formData.motifDeplacement
              }
              className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center"
            >
              {submitting ? (
                <>
                  <Loader className="w-5 h-5 mr-2 animate-spin" />
                  Envoi en cours...
                </>
              ) : (
                <>
                  <Save className="w-5 h-5 mr-2" />
                  Soumettre la demande
                </>
              )}
            </button>
            <button
              onClick={onCancel}
              disabled={submitting}
              className="px-6 py-3 border rounded-lg hover:bg-gray-50 disabled:opacity-50"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Génération du ticket PDF consolidé
  const generateMultiSegmentTicket = (request) => {
    const doc = new jsPDF();

    // En-tête élégant
    doc.setFillColor(37, 99, 235);
    doc.rect(0, 0, 210, 45, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(22);
    doc.text("BILLET MULTI-DESTINATIONS", 105, 20, { align: "center" });
    doc.setFontSize(14);
    doc.text("E-TICKET CONSOLIDÉ", 105, 30, { align: "center" });
    doc.setFontSize(11);
    doc.text(`N° ${request.numeroRequete}`, 105, 38, { align: "center" });

    let yPos = 55;

    // Informations passager
    doc.setTextColor(0, 0, 0);
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("INFORMATIONS PASSAGER", 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    yPos += 8;
    doc.text(`Nom: ${request.nom || "DUPONT"}`, 20, yPos);
    doc.text(`Prénom: ${request.prenom || "Jean"}`, 100, yPos);
    yPos += 15;

    // Itinéraire détaillé
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("ITINÉRAIRE COMPLET", 20, yPos);
    yPos += 8;

    request.segments.forEach((item, index) => {
      // Cadre pour chaque segment
      doc.setFillColor(245, 245, 250);
      doc.rect(15, yPos - 5, 180, 30, "F");

      doc.setFont(undefined, "bold");
      doc.setFontSize(11);
      doc.text(`SEGMENT ${index + 1}`, 20, yPos);

      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      yPos += 7;

      doc.setFont(undefined, "bold");
      doc.text(
        `${item.segment.origin} → ${item.segment.destination}`,
        20,
        yPos
      );
      doc.setFont(undefined, "normal");

      yPos += 6;
      const date = new Date(item.segment.date).toLocaleDateString("fr-FR", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      doc.text(`Date: ${date}`, 20, yPos);
      doc.text(
        `Prix: ${item.flight.price.total} ${item.flight.price.currency}`,
        120,
        yPos
      );

      yPos += 6;
      const carrier =
        item.flight.itineraries?.[0]?.segments?.[0]?.carrierCode || "N/A";
      doc.text(`Transporteur: ${carrier}`, 20, yPos);
      doc.text(
        `Classe: ${request.globalParams?.travelClass || "ECONOMY"}`,
        120,
        yPos
      );

      yPos += 12;
    });

    // Résumé tarifaire
    yPos += 5;
    doc.setFillColor(230, 240, 255);
    doc.rect(15, yPos - 5, 180, 25, "F");
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("TOTAL ITINÉRAIRE", 20, yPos);
    yPos += 8;

    const total = request.segments
      .reduce((sum, item) => sum + parseFloat(item.flight.price.total), 0)
      .toFixed(2);

    doc.setFontSize(14);
    doc.text(`${total} EUR`, 20, yPos);
    doc.setFont(undefined, "normal");
    doc.setFontSize(9);
    doc.text(`Pour ${request.globalParams?.adults || 1} passager(s)`, 60, yPos);

    // Code-barres
    yPos += 15;
    doc.setFillColor(0, 0, 0);
    doc.rect(50, yPos, 110, 15, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(10);
    doc.text(request.numeroRequete, 105, yPos + 10, { align: "center" });

    // Pied de page
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.text("Document généré électroniquement - ABM Travel Agency", 105, 280, {
      align: "center",
    });

    doc.save(`Ticket_Multi_${request.numeroRequete}.pdf`);
  };

  // Liste des demandes avec support multi-segments nouveau bloc
  const EnhancedFlightRequestsList = ({ onRefresh }) => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedRequests, setExpandedRequests] = useState([]);
    const handleApprove = async (id) => {
      confirmToast(
        "Êtes-vous sûr de vouloir approuver cette demande ?",
        async () => {
          try {
        await flightRequestsService.approve(id);
        toast.success("Demande approuvée avec succès !");
        await loadRequests();
        onRefresh && onRefresh();
      } catch (error) {
        toast.error(`Erreur: ${error.message}`);
      }
        },
        () => {
          toast.info("Action annulée.");
          return;
        }
      );

      
    };
    const [currentRequestId, setCurrentRequestId] = useState(null);
    const [travelersData, setTravelersData] = useState([]);
    const [editingTravelers, setEditingTravelers] = useState(false);
    const [flightRequests, setFlightRequests] = useState([]);
    const [ticketData, setTicketData] = useState(null);
    const [showTicket, setShowTicket] = useState({
      show: false,
      request: null,
      billetReference: null,
    });
    const handleReject = async (id) => {
      if (!window.confirm("Êtes-vous sûr de vouloir rejeter cette demande ?"))
        return;

      try {
        await hotelRequestsService.reject(id);
        toast.success("Demande rejetée");
        await loadRequests();
        onRefresh && onRefresh();
      } catch (error) {
        toast.error(`Erreur: ${error.message}`);
      }
    };
    const handleEditTravelers = useCallback((request) => {
      setCurrentRequestId(request.id);

      const totalPassengers =
        parseInt(request.searchParams?.adults || 1) +
        parseInt(request.searchParams?.children || 0) +
        parseInt(request.searchParams?.infants || 0);

      let initialTravelers = [];

      if (request.travelers && request.travelers.length > 0) {
        initialTravelers = [...request.travelers];
      } else {
        for (let i = 0; i < totalPassengers; i++) {
          let passengerType = "ADULT";
          if (i >= parseInt(request.searchParams?.adults || 1)) {
            if (
              i <
              parseInt(request.searchParams?.adults || 1) +
                parseInt(request.searchParams?.children || 0)
            ) {
              passengerType = "CHILD";
            } else {
              passengerType = "INFANT";
            }
          }

          initialTravelers.push({
            type: passengerType,
            nom: "",
            prenom: "",
            datenaissance: "",
            numero_passeport: "",
            dateExpirationp: "",
            numero_piece: "",
            numero_siege: "",
            passenger_index: i,
          });
        }
      }

      setTravelersData(initialTravelers);
      setEditingTravelers(true);
    }, []);

    const handleEmitTicket = async (id) => {
      try {
        console.log(`🎫 Début de l'émission du ticket pour la demande: ${id}`);

        // Récupérer la demande depuis l'état local
        const request = requests.find((r) => r.id === id);
        if (!request) {
          throw new Error("Demande non trouvée");
        }

        // ==================================================
        // 1. VÉRIFICATIONS PRÉLIMINAIRES
        // ==================================================

        // Vérifier qu'il y a des voyageurs
        if (!request.travelers || request.travelers.length === 0) {
          toast.error(
            "❌ Veuillez d'abord saisir les informations des voyageurs avant d'émettre le billet"
          );
          return;
        }

        // Calculer le nombre attendu de passagers
        const searchParams =
          request.searchParams || request.vol?.[0]?.searchParams;
        const adultsCount = parseInt(searchParams?.adults) || 1;
        const childrenCount = parseInt(searchParams?.children) || 0;
        const infantsCount = parseInt(searchParams?.infants) || 0;
        const expectedTotalPassengers =
          adultsCount + childrenCount + infantsCount;

        // Vérifier que le nombre de voyageurs correspond
        if (request.travelers.length !== expectedTotalPassengers) {
          toast.error(
            `❌ Nombre de passagers incorrect\n\nAttendu: ${expectedTotalPassengers} passagers (${adultsCount} adulte(s), ${childrenCount} enfant(s), ${infantsCount} bébé(s))\nSaisi: ${request.travelers.length} passagers\n\nVeuillez compléter tous les passagers.`
          );
          return;
        }

        // ==================================================
        // 2. VALIDATION DÉTAILLÉE DE CHAQUE PASSAGER
        // ==================================================

        const validationErrors = [];

        request.travelers.forEach((traveler, index) => {
          const errors = [];
          let passengerType = "Adulte";

          // Déterminer le type de passager
          if (index >= adultsCount && index < adultsCount + childrenCount) {
            passengerType = "Enfant";
          } else if (index >= adultsCount + childrenCount) {
            passengerType = "Bébé";
          }

          // Vérifier chaque champ obligatoire
          if (!traveler.nom || traveler.nom.trim() === "") {
            errors.push("Nom manquant");
          }
          if (!traveler.prenom || traveler.prenom.trim() === "") {
            errors.push("Prénom manquant");
          }
          if (!traveler.date_naissance) {
            errors.push("Date de naissance manquante");
          }
          if (
            !traveler.numero_passeport ||
            traveler.numero_passeport.trim() === ""
          ) {
            errors.push("Numéro de passeport manquant");
          }
          if (!traveler.date_expiration_passeport) {
            errors.push("Date d'expiration du passeport manquante");
          }
          if (!traveler.numero_siege || traveler.numero_siege.trim() === "") {
            errors.push("Numéro de siège manquant");
          }

          // Vérifications supplémentaires
          if (traveler.date_expiration_passeport) {
            const expirationDate = new Date(traveler.date_expiration_passeport);
            const departureDate = new Date(searchParams?.departureDate);

            // Vérifier que le passeport est valide au moment du voyage
            if (expirationDate < departureDate) {
              errors.push("Passeport expiré à la date du voyage");
            }

            // Vérifier que le passeport est valide au moins 6 mois après le voyage
            const sixMonthsAfterDeparture = new Date(departureDate);
            sixMonthsAfterDeparture.setMonth(
              sixMonthsAfterDeparture.getMonth() + 6
            );

            if (expirationDate < sixMonthsAfterDeparture) {
              errors.push(
                "Le passeport doit être valide au moins 6 mois après le voyage"
              );
            }
          }

          if (errors.length > 0) {
            validationErrors.push({
              passenger: `${passengerType} ${index + 1} (${
                traveler.nom || "Sans nom"
              } ${traveler.prenom || ""})`,
              errors: errors,
            });
          }
        });

        // Afficher les erreurs de validation s'il y en a
        if (validationErrors.length > 0) {
          let errorMessage = "❌ Erreurs de validation des passagers:\n\n";
          validationErrors.forEach((validation) => {
            errorMessage += `👤 ${validation.passenger}:\n`;
            validation.errors.forEach((error) => {
              errorMessage += `   • ${error}\n`;
            });
            errorMessage += "\n";
          });
          toast.error(errorMessage);
          return;
        }

        // ==================================================
        // 3. VÉRIFICATION DES SIÈGES
        // ==================================================

        const travelersWithoutSeats = request.travelers.filter(
          (t) => !t.numero_siege
        );
        if (travelersWithoutSeats.length > 0) {
          const names = travelersWithoutSeats
            .map((t) => `${t.nom} ${t.prenom}`)
            .join(", ");
          toast.error(
            `❌ Les passagers suivants n'ont pas de siège assigné:\n${names}\n\nTous les voyageurs doivent avoir un siège assigné avant d'émettre le billet.`
          );
          return;
        }

        // Vérifier les doublons de sièges
        const seats = request.travelers.map((t) => t.numero_siege);
        const duplicateSeats = seats.filter(
          (seat, index) => seats.indexOf(seat) !== index
        );

        if (duplicateSeats.length > 0) {
          toast.error(
            `❌ Sièges en double détectés: ${duplicateSeats.join(
              ", "
            )}\n\nChaque passager doit avoir un siège unique.`
          );
          return;
        }

        // ==================================================
        // 4. CONFIRMATION FINALE AVEC RÉSUMÉ
        // ==================================================

        // Créer le tableau récapitulatif des passagers
        let passengersSummary = "";
        request.travelers.forEach((traveler, index) => {
          let type = "👤 Adulte";
          if (index >= adultsCount && index < adultsCount + childrenCount) {
            type = "👦 Enfant";
          } else if (index >= adultsCount + childrenCount) {
            type = "👶 Bébé";
          }

          passengersSummary += `\n${index + 1}. ${type}\n`;
          passengersSummary += `   Nom: ${traveler.nom.toUpperCase()} ${
            traveler.prenom
          }\n`;
          passengersSummary += `   Passeport: ${traveler.numero_passeport}\n`;
          passengersSummary += `   Siège: ${traveler.numero_siege}\n`;
        });

        const confirmMessage = `
📋 CONFIRMATION D'ÉMISSION DE BILLET
════════════════════════════════════════

✈️ VOL: ${searchParams?.originLocationCode} → ${
          searchParams?.destinationLocationCode
        }
📅 DATE: ${new Date(searchParams?.departureDate).toLocaleDateString("fr-FR")}
💺 CLASSE: ${searchParams?.travelClass || "ECONOMY"}

👥 PASSAGERS (${request.travelers.length}):${passengersSummary}

💰 MONTANT TOTAL: ${request.montant} ${request.devise || "EUR"}

════════════════════════════════════════
Confirmez-vous l'émission du billet pour tous ces passagers ?
  `;

        if (!window.confirm(confirmMessage)) {
          return;
        }

        // ==================================================
        // 5. EXÉCUTION DU PROCESSUS COMPLET (identique à emitTicket)
        // ==================================================

        // 1. Récupérer les détails complets de la demande via API
        console.log("🔍 Récupération des détails complets de la demande...");
        const requestResponse = await fetch(
          `${API_BASE_URL2}/flight-requests/${id}`
        );
        if (!requestResponse.ok) {
          throw new Error(
            "Erreur lors de la récupération des détails de la demande"
          );
        }
        const requestDetails = await requestResponse.json();

        // 2. Vérifier qu'il y a des voyageurs et des données de vol
        if (
          !requestDetails.travelers ||
          requestDetails.travelers.length === 0
        ) {
          throw new Error("Aucun voyageur trouvé pour cette demande");
        }

        if (!requestDetails.vol || requestDetails.vol.length === 0) {
          throw new Error("Aucune offre de vol trouvée pour cette demande");
        }

        // 3. Préparer les données pour Amadeus complete-booking
        const searchParamsDetails =
          requestDetails.searchParams || requestDetails.vol[0]?.searchParams;
        const adultsCountDetails = parseInt(searchParamsDetails?.adults) || 1;
        const childrenCountDetails =
          parseInt(searchParamsDetails?.children) || 0;
        const infantsCountDetails = parseInt(searchParamsDetails?.infants) || 0;

        // Fonction pour nettoyer le countryCallingCode
        const cleanCountryCallingCode = (code) => {
          if (!code) return "225";
          return code.replace(/[^\d]/g, "");
        };

        // Préparer les voyageurs au format Amadeus
        const amadeusTravelers = requestDetails.travelers.map(
          (traveler, index) => {
            let passengerType = "ADULT";
            if (
              index >= adultsCountDetails &&
              index < adultsCountDetails + childrenCountDetails
            ) {
              passengerType = "CHILD";
            } else if (index >= adultsCountDetails + childrenCountDetails) {
              passengerType = "INFANT";
            }

            return {
              id: (index + 1).toString(),
              dateOfBirth: traveler.date_naissance,
              name: {
                firstName: traveler.prenom,
                lastName: traveler.nom,
              },
              gender: traveler.genre || "MALE",
              contact: {
                emailAddress: traveler.email || "info@abmtravel.com",
                phones: [
                  {
                    deviceType: "MOBILE",
                    countryCallingCode: cleanCountryCallingCode(
                      traveler.code_pays
                    ),
                    number: traveler.telephone || "0708837660",
                  },
                ],
              },
              documents: [
                {
                  documentType: "PASSPORT",
                  birthPlace: traveler.lieu_naissance || "Abidjan",
                  issuanceLocation: traveler.lieu_emission || "Abidjan",
                  issuanceDate:
                    traveler.date_emission_passeport || "2020-01-01",
                  number: traveler.numero_passeport,
                  expiryDate: traveler.date_expiration_passeport,
                  issuanceCountry: traveler.pays_emission || "CI",
                  validityCountry: traveler.pays_validite || "CI",
                  nationality: traveler.nationalite || "CI",
                  holder: true,
                },
              ],
            };
          }
        );

        // Préparer les flightOffers avec la structure Amadeus correcte
        const correctedFlightOffers = requestDetails.vol.map((offer) => {
          const flightData = offer.flightData;

          return {
            type: "flight-offer",
            id: flightData.id,
            source: flightData.source,
            instantTicketingRequired: flightData.instantTicketingRequired,
            nonHomogeneous: flightData.nonHomogeneous,
            oneWay: flightData.oneWay,
            lastTicketingDate: flightData.lastTicketingDate,
            numberOfBookableSeats: flightData.numberOfBookableSeats,
            itineraries: flightData.itineraries,
            price: flightData.price,
            pricingOptions: flightData.pricingOptions,
            validatingAirlineCodes: flightData.validatingAirlineCodes,
            travelerPricings: flightData.travelerPricings,
          };
        });

        // Formater correctement le délai pour Amadeus
        const formatDelayForAmadeus = (delay) => {
          if (delay === "24H") return "1D";
          if (delay === "48H") return "2D";
          if (delay === "72H") return "3D";
          return delay;
        };

        // Structure pour Amadeus
        const amadeusBookingData = {
          type: "flight-order",
          flightOffers: correctedFlightOffers,
          travelers: amadeusTravelers,
          remarks: {
            general: [
              {
                subType: "GENERAL_MISCELLANEOUS",
                text: `Billet émis via système - Demande: ${requestDetails.numeroRequete}`,
              },
            ],
          },
          ticketingAgreement: {
            option: "DELAY_TO_CANCEL",
            delay: formatDelayForAmadeus("24H"),
          },
          contacts: [
            {
              addresseeName: {
                firstName: "Support",
                lastName: "Voyages",
              },
              companyName: "Agence de Voyage",
              purpose: "STANDARD",
              phones: [
                {
                  deviceType: "LANDLINE",
                  countryCallingCode: "33",
                  number: "0123456789",
                },
              ],
              emailAddress: "support@voyage.com",
              address: {
                lines: ["123 Avenue des Voyages"],
                postalCode: "75001",
                cityName: "Paris",
                countryCode: "FR",
              },
            },
          ],
        };

        console.log(
          "DONNEES AMADEUS CORRIGEES:",
          JSON.stringify(amadeusBookingData, null, 2)
        );

        // 4. Lancer les opérations en parallèle
        const operations = [];

        // Opération 1: Appel à l'API interne pour émettre le ticket
        operations.push(
          (async () => {
            try {
              console.log("🎫 Émission du ticket interne...");
              const response = await fetch(
                `${API_BASE_URL2}/flight-requests/${id}/emit-ticket`,
                {
                  method: "PUT",
                  headers: { "Content-Type": "application/json" },
                }
              );

              if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Interne: ${response.status} - ${errorText}`);
              }

              const result = await response.json();
              console.log("✅ Ticket interne émis avec succès");
              return {
                success: true,
                type: "internal",
                data: result,
              };
            } catch (error) {
              console.error(
                "❌ Erreur émission ticket interne:",
                error.message
              );
              return {
                success: false,
                type: "internal",
                error: error.message,
              };
            }
          })()
        );

        // Opération 2: Complete-booking Amadeus avec données corrigées
        operations.push(
          (async () => {
            try {
              console.log("🚀 Appel à Amadeus complete-booking...");

              let amadeusResponse;
              let lastError;

              // Essayer différents endpoints
              const amadeusEndpoints = [
                `${API_BASE_URL}/booking/flight-orders`,
                `${API_BASE_URL}/v1/booking/flight-orders`,
                `${API_BASE_URL}/flights/complete-booking`,
              ];

              for (const endpoint of amadeusEndpoints) {
                try {
                  console.log(`🔍 Essai avec l'endpoint: ${endpoint}`);
                  amadeusResponse = await fetch(endpoint, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(amadeusBookingData),
                  });

                  if (amadeusResponse.ok) {
                    console.log(`✅ Endpoint trouvé: ${endpoint}`);
                    break;
                  } else {
                    const errorText = await amadeusResponse.text();
                    lastError = new Error(
                      `Amadeus (${endpoint}): ${
                        errorText || `HTTP ${amadeusResponse.status}`
                      }`
                    );
                    console.log(
                      `❌ Échec avec ${endpoint}: ${amadeusResponse.status}`
                    );
                  }
                } catch (endpointError) {
                  lastError = endpointError;
                  console.log(
                    `❌ Erreur avec ${endpoint}: ${endpointError.message}`
                  );
                }
              }

              if (!amadeusResponse || !amadeusResponse.ok) {
                throw (
                  lastError || new Error("Aucun endpoint Amadeus ne fonctionne")
                );
              }

              const amadeusResult = await amadeusResponse.json();
              console.log("✅ Complete-booking Amadeus réussi");

              // Extraire les informations importantes
              const amadeusData = amadeusResult.data;
              return {
                success: true,
                type: "amadeus",
                data: amadeusResult,
                orderId: amadeusData?.orderId,
                pnr: amadeusData?.pnr,
                associatedRecords: amadeusData?.associatedRecords,
              };
            } catch (amadeusError) {
              console.error(
                "❌ Erreur complete-booking Amadeus:",
                amadeusError.message
              );
              return {
                success: false,
                type: "amadeus",
                error: amadeusError.message,
              };
            }
          })()
        );

        // Opération 3: Synchronisation des voyages
        operations.push(
          (async () => {
            try {
              console.log("🔄 Synchronisation des voyages...");
              const syncResponse = await fetch(
                `${API_BASE_URL2}/travelers/sync`,
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                }
              );

              if (!syncResponse.ok)
                throw new Error(`Sync: ${syncResponse.status}`);

              console.log("✅ Synchronisation des voyages réussie");
              return {
                success: true,
                type: "sync",
              };
            } catch (syncError) {
              console.error(
                "❌ Erreur synchronisation voyages:",
                syncError.message
              );
              return {
                success: false,
                type: "sync",
                error: syncError.message,
              };
            }
          })()
        );

        // 5. Exécuter toutes les opérations en parallèle
        const results = await Promise.allSettled(operations);

        // 6. Traiter les résultats
        const finalResults = {
          internal: null,
          amadeus: null,
          sync: null,
        };

        results.forEach((result) => {
          if (result.status === "fulfilled") {
            const value = result.value;
            switch (value.type) {
              case "internal":
                finalResults.internal = value;
                break;
              case "amadeus":
                finalResults.amadeus = value;
                break;
              case "sync":
                finalResults.sync = value;
                break;
            }
          }
        });

        // 7. Vérifier si l'émission interne a réussi (critique)
        if (!finalResults.internal || !finalResults.internal.success) {
          throw new Error(
            "Émission interne a échoué: " +
              (finalResults.internal?.error || "Unknown error")
          );
        }

        // 8. Construire le résultat final
        const finalResult = {
          ...finalResults.internal.data,
          operations: {
            internal: { success: true, data: finalResults.internal.data },
            amadeus: finalResults.amadeus || {
              success: false,
              error: "Non exécuté",
            },
            sync: finalResults.sync || { success: false, error: "Non exécuté" },
          },
        };

        // 9. Log du résumé
        console.log("📊 Résumé des opérations:");
        console.log("- Interne: ✅ Succès");
        console.log(
          `- Amadeus: ${finalResult.operations.amadeus.success ? "✅" : "❌"} ${
            finalResult.operations.amadeus.success
              ? "Succès"
              : finalResult.operations.amadeus.error
          }`
        );
        console.log(
          `- Synchronisation: ${
            finalResult.operations.sync.success ? "✅" : "❌"
          } ${
            finalResult.operations.sync.success
              ? "Succès"
              : finalResult.operations.sync.error
          }`
        );

        // 10. Si Amadeus a réussi, mettre à jour la demande avec les infos Amadeus
        if (finalResult.operations.amadeus.success) {
          try {
            console.log("💾 Mise à jour des informations Amadeus...");
            const updateData = {
              amadeusOrderId: finalResult.operations.amadeus.orderId,
              amadeusPnr: finalResult.operations.amadeus.pnr,
              amadeusData: finalResult.operations.amadeus.data,
            };

            await fetch(`${API_BASE_URL2}/flight-requests/${id}/amadeus-info`, {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(updateData),
            });
            console.log("✅ Informations Amadeus mises à jour");
          } catch (updateError) {
            console.error("❌ Erreur mise à jour infos Amadeus:", updateError);
          }
        }

        // ==================================================
        // 11. AFFICHAGE DU RÉSULTAT FINAL
        // ==================================================

        let successMessage = `
✅ PROCESSUS D'ÉMISSION TERMINÉ !
════════════════════════════════════════

📋 Détails de l'opération:

🎫 ÉMISSION INTERNE: ✅ SUCCÈS
   • Référence: ${finalResults.internal.data?.billetReference || "N/A"}
   • Statut: Confirmé

`;

        if (finalResult.operations.amadeus.success) {
          successMessage += `🚀 RÉSERVATION AMADEUS: ✅ SUCCÈS\n`;
          successMessage += `   • Order ID: ${
            finalResult.operations.amadeus.orderId || "N/A"
          }\n`;
          successMessage += `   • PNR: ${
            finalResult.operations.amadeus.pnr || "N/A"
          }\n`;
          successMessage += `   • Statut: Complet\n\n`;
        } else {
          successMessage += `🚀 RÉSERVATION AMADEUS: ❌ ÉCHEC\n`;
          successMessage += `   • Erreur: ${finalResult.operations.amadeus.error}\n`;
          successMessage += `   • Statut: Billet interne uniquement\n\n`;
        }

        successMessage += `🔄 SYNCHRONISATION: ${
          finalResult.operations.sync.success ? "✅ SUCCÈS" : "❌ ÉCHEC"
        }\n\n`;

        successMessage += `👥 ${request.travelers.length} PASSAGER(S) ÉMIS:\n`;
        successMessage += request.travelers
          .map(
            (t, i) =>
              `${i + 1}. ${t.nom} ${t.prenom} - Siège: ${
                t.numero_siege
              } - Passeport: ${t.numero_passeport}`
          )
          .join("\n");

        successMessage += `\n\n════════════════════════════════════════\nLe billet a été émis avec succès.`;

        alert(successMessage);

        // Rafraîchir la liste des demandes
        await loadRequests();
        onRefresh && onRefresh();

        return finalResult;
      } catch (error) {
        console.error("❌ Erreur globale handleEmitTicket:", error);

        let errorMessage = `❌ Erreur lors de l'émission du billet:\n${error.message}\n\n`;

        if (error.message.includes("Aucun voyageur")) {
          errorMessage +=
            "Veuillez saisir les informations des voyageurs avant d'émettre le billet.";
        } else if (error.message.includes("Aucune offre de vol")) {
          errorMessage += "Aucune offre de vol trouvée pour cette demande.";
        } else if (error.message.includes("Émission interne a échoué")) {
          errorMessage +=
            "L'émission interne a échoué. Veuillez contacter le support technique.";
        } else {
          errorMessage +=
            "Veuillez réessayer ou contacter le support technique.";
        }

        alert(errorMessage);
        throw error;
      }
    };

    // TODO ADAPTER POUR VOL SIMPLE
    const getFlightNumbers = (flightData) => {
      const segments =
        flightData.itineraries?.[0]?.segments || flightData.segments || [];
      if (segments.length === 0) return "N/A";

      return segments
        .map((segment) => `${segment.carrierCode} ${segment.number}`)
        .join(" → ");
    };
    const handleDownloadTicket = (request) => {
      const doc = new jsPDF();
      const flightNumbers = getFlightNumbers(request.flight);
      // En-tête avec design moderne
      doc.setFillColor(37, 99, 235);
      doc.rect(0, 0, 210, 40, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(24);
      doc.text("BILLET D'AVION ÉLECTRONIQUE", 105, 20, { align: "center" });
      doc.setFontSize(12);
      doc.text(`N° ${flightNumbers}`, 105, 30, { align: "center" });

      // Logo et informations de l'agence
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(10);
      let yPos = 50;
      doc.setFont(undefined, "bold");
      doc.text("ABM Travel Agency", 20, yPos);
      doc.setFont(undefined, "normal");
      yPos += 5;
      doc.text("Conakry, Guinée", 20, yPos);
      yPos += 5;
      doc.text("contact@abmtravel.com", 20, yPos);

      // Date d'émission
      yPos = 50;
      doc.text(
        `Émis le: ${new Date().toLocaleDateString("fr-FR")}`,
        190,
        yPos,
        { align: "right" }
      );

      yPos = 75;

      // Informations du passager
      doc.setFillColor(245, 245, 245);
      doc.rect(15, yPos - 5, 180, 30, "F");
      doc.setFont(undefined, "bold");
      doc.setFontSize(12);
      doc.text("INFORMATIONS DU PASSAGER", 20, yPos);
      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      yPos += 8;
      doc.text(`Nom: ${request.nom?.toUpperCase() || "N/A"}`, 20, yPos);
      doc.text(`Prénom: ${request.prenom || "N/A"}`, 100, yPos);
      yPos += 7;
      doc.text(`Matricule: ${request.matricule || "N/A"}`, 20, yPos);
      doc.text(`Fonction: ${request.fonction || "N/A"}`, 100, yPos);

      yPos += 15;

      // Vérifier si c'est une demande multi-vols
      if (
        request.type === "multi-flights" &&
        request.vol &&
        Array.isArray(request.vol)
      ) {
        // MULTI-VOLS : Afficher tous les vols
        doc.setFillColor(245, 245, 245);
        doc.rect(15, yPos - 5, 180, 10, "F");
        doc.setFont(undefined, "bold");
        doc.setFontSize(12);
        doc.text("ITINÉRAIRE MULTI-DESTINATIONS", 20, yPos);
        yPos += 12;

        request.vol.forEach((vol, index) => {
          const firstSegment = vol.itineraries?.[0]?.segments?.[0];
          const lastSegment =
            vol.itineraries?.[0]?.segments?.[
              vol.itineraries[0].segments.length - 1
            ];

          // Section pour chaque vol
          doc.setFillColor(250, 250, 250);
          doc.rect(15, yPos - 3, 180, 35, "F");

          doc.setFont(undefined, "bold");
          doc.setFontSize(11);
          doc.text(`VOL ${index + 1}`, 20, yPos);
          doc.setFont(undefined, "normal");
          yPos += 6;

          doc.setFont(undefined, "bold");
          doc.setFontSize(14);
          doc.text(
            `${
              firstSegment?.departure?.iataCode ||
              vol.searchParams?.originLocationCode ||
              "N/A"
            } → ${
              lastSegment?.arrival?.iataCode ||
              vol.searchParams?.destinationLocationCode ||
              "N/A"
            }`,
            20,
            yPos
          );
          doc.setFont(undefined, "normal");
          doc.setFontSize(10);
          yPos += 8;

          const departureDate = vol.searchParams?.departureDate
            ? new Date(vol.searchParams.departureDate).toLocaleDateString(
                "fr-FR",
                {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }
              )
            : "N/A";
          doc.text(`Date: ${departureDate}`, 20, yPos);
          yPos += 6;

          doc.text(
            `Transporteur: ${firstSegment?.carrierCode || "N/A"}`,
            20,
            yPos
          );
          doc.text(
            `Classe: ${vol.searchParams?.travelClass || "ECONOMY"}`,
            100,
            yPos
          );
          doc.text(
            `Prix: ${vol.price?.total || "0"} ${vol.price?.currency || "EUR"}`,
            150,
            yPos
          );

          yPos += 10;
        });

        // Total pour multi-vols
        doc.setFillColor(230, 240, 255);
        doc.rect(15, yPos - 5, 180, 20, "F");
        doc.setFont(undefined, "bold");
        doc.setFontSize(12);
        doc.text("MONTANT TOTAL", 20, yPos);
        yPos += 7;
        doc.setFontSize(14);
        doc.text(
          `${request.montant || "0"} ${request.devise || "EUR"}`,
          20,
          yPos
        );
      } else {
        // VOL SIMPLE : Affichage normal
        doc.setFillColor(245, 245, 245);
        doc.rect(15, yPos - 5, 180, 45, "F");
        doc.setFont(undefined, "bold");
        doc.setFontSize(12);
        doc.text("DÉTAILS DU VOL", 20, yPos);
        doc.setFont(undefined, "normal");
        doc.setFontSize(10);
        yPos += 8;

        // Trajet
        doc.setFont(undefined, "bold");
        doc.setFontSize(14);
        doc.text(
          `${request.searchParams?.originLocationCode || "N/A"} → ${
            request.searchParams?.destinationLocationCode || "N/A"
          }`,
          20,
          yPos
        );
        doc.setFont(undefined, "normal");
        doc.setFontSize(10);
        yPos += 8;

        // Date et heure
        const departureDate = request.searchParams?.departureDate
          ? new Date(request.searchParams.departureDate).toLocaleDateString(
              "fr-FR",
              {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              }
            )
          : "N/A";
        doc.text(`Date de départ: ${departureDate}`, 20, yPos);
        yPos += 7;

        // Type de voyage
        const tripType =
          request.searchParams?.tripType === "round-trip"
            ? "Aller-retour"
            : "Aller simple";
        doc.text(`Type: ${tripType}`, 20, yPos);
        doc.text(
          `Classe: ${request.searchParams?.travelClass || "ECONOMY"}`,
          100,
          yPos
        );

        yPos += 15;

        // Informations tarifaires
        doc.setFillColor(245, 245, 245);
        doc.rect(15, yPos - 5, 180, 25, "F");
        doc.setFont(undefined, "bold");
        doc.setFontSize(12);
        doc.text("INFORMATIONS TARIFAIRES", 20, yPos);
        doc.setFont(undefined, "normal");
        doc.setFontSize(10);
        yPos += 8;
        doc.text(
          `Nombre de passagers: ${request.searchParams?.adults || 1} adulte(s)`,
          20,
          yPos
        );
        yPos += 7;
        doc.setFont(undefined, "bold");
        doc.setFontSize(12);
        doc.text(
          `Prix total: ${request.montant || "0"} ${request.devise || "EUR"}`,
          20,
          yPos
        );
      }

      yPos += 15;

      // Conditions
      doc.setFont(undefined, "bold");
      doc.setFontSize(11);
      doc.text("CONDITIONS ET INFORMATIONS IMPORTANTES", 20, yPos);
      doc.setFont(undefined, "normal");
      doc.setFontSize(9);
      yPos += 7;

      const conditions = [
        "• Ce billet est non transférable et non remboursable.",
        "• Présentez-vous à l'enregistrement au moins 2h avant le départ (vols internationaux).",
        "• Une pièce d'identité valide est requise pour l'embarquement.",
      ];

      conditions.forEach((condition) => {
        doc.text(condition, 20, yPos);
        yPos += 6;
      });

      // Code-barres
      yPos += 10;
      doc.setFillColor(0, 0, 0);
      doc.rect(50, yPos, 110, 15, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(10);
      doc.text(request.numeroRequete || "TICKET-2024", 105, yPos + 10, {
        align: "center",
      });

      // Pied de page
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(8);
      doc.setFont(undefined, "italic");
      doc.text(
        "Document généré électroniquement - ABM Travel Agency",
        105,
        280,
        { align: "center" }
      );

      doc.save(`Billet_${request.numeroRequete || "TICKET"}.pdf`);
    };
    const getAirlineName = (code) => {
      const airlines = {
        // Europe
        AF: "Air France",
        LH: "Lufthansa",
        BA: "British Airways",
        KL: "KLM",
        SN: "Brussels Airlines",
        LX: "Swiss International Air Lines",
        IB: "Iberia",
        AZ: "Alitalia",
        TP: "TAP Air Portugal",
        AY: "Finnair",
        SK: "SAS Scandinavian Airlines",
        LO: "LOT Polish Airlines",
        OS: "Austrian Airlines",
        SU: "Aeroflot",
        TK: "Turkish Airlines",
        A3: "Aegean Airlines",
        DY: "Norwegian Air Shuttle",
        FR: "Ryanair",
        U2: "easyJet",
        VY: "Vueling",
        EW: "Eurowings",
        BT: "Air Baltic",
        JU: "Air Serbia",
        OU: "Croatia Airlines",
        KM: "Air Malta",
        FI: "Icelandair",

        // Moyen-Orient
        EK: "Emirates",
        EY: "Etihad Airways",
        QR: "Qatar Airways",
        SV: "Saudia",
        RJ: "Royal Jordanian",
        WY: "Oman Air",
        GF: "Gulf Air",
        KU: "Kuwait Airways",
        ME: "Middle East Airlines",

        // Afrique
        ET: "Ethiopian Airlines",
        MS: "EgyptAir",
        AT: "Royal Air Maroc",
        TU: "Tunisair",
        KQ: "Kenya Airways",
        SA: "South African Airways",
        MK: "Air Mauritius",
        UL: "SriLankan Airlines",
        WB: "RwandAir",
        P4: "Air Peace",
        "9U": "Air Moldova",

        // Amérique du Nord
        AA: "American Airlines",
        DL: "Delta Air Lines",
        UA: "United Airlines",
        AC: "Air Canada",
        WN: "Southwest Airlines",
        B6: "JetBlue Airways",
        AS: "Alaska Airlines",
        WS: "WestJet",
        F9: "Frontier Airlines",

        // Amérique du Sud
        LA: "LATAM Airlines",
        AV: "Avianca",
        CM: "Copa Airlines",
        AR: "Aerolíneas Argentinas",
        G3: "Gol Transportes Aéreos",
        AD: "Azul Brazilian Airlines",
        JJ: "LATAM Brasil",

        // Asie
        SQ: "Singapore Airlines",
        CX: "Cathay Pacific",
        NH: "ANA All Nippon Airways",
        JL: "Japan Airlines",
        KE: "Korean Air",
        OZ: "Asiana Airlines",
        CI: "China Airlines",
        BR: "EVA Air",
        TG: "Thai Airways",
        MH: "Malaysia Airlines",
        GA: "Garuda Indonesia",
        PR: "Philippine Airlines",
        VN: "Vietnam Airlines",
        CZ: "China Southern Airlines",
        MU: "China Eastern Airlines",
        CA: "Air China",
        HU: "Hainan Airlines",
        FM: "Shanghai Airlines",
        "3U": "Sichuan Airlines",
        "9C": "Spring Airlines",

        // Océanie
        QF: "Qantas",
        VA: "Virgin Australia",
        NZ: "Air New Zealand",
        FJ: "Fiji Airways",

        // Compagnies low-cost
        NK: "Spirit Airlines",
        SY: "Sun Country Airlines",
        G4: "Allegiant Air",
        Y4: "Volaris",
        Y9: "Air Arabia",
        FD: "Thai AirAsia",
        AK: "AirAsia",
        D7: "AirAsia X",
        TR: "Scoot",
        Z2: "Philippines AirAsia",

        // Compagnies cargo
        "5Y": "Atlas Air",
        K4: "Kalitta Air",
        W8: "Cargojet Airways",

        // Régionales
        YX: "Republic Airways",
        OO: "SkyWest Airlines",
        "9E": "Endeavor Air",
        MQ: "Envoy Air",
        OH: "PSA Airlines",

        // Autres
        "2J": 'Air Burkina',
        AI: "Air India",
        PK: "Pakistan International Airlines",
        BG: "Biman Bangladesh Airlines",
        UL: "SriLankan Airlines",
        UL: "SriLankan Airlines",
        BI: "Royal Brunei Airlines",
        OM: "MIAT Mongolian Airlines",
        RGN: "Regional Express",
        J2: "Azerbaijan Airlines",
        KC: "Air Astana",
        HY: "Uzbekistan Airways",
        FV: "Rossiya Airlines",
        S7: "S7 Airlines",
        U6: "Ural Airlines",
        "5N": "Nordavia",
        D2: "Severstal Air Company",
        N4: "Nordwind Airlines",
        ZF: "Azur Air",
        Y7: "NordStar Airlines",
        DP: "Pobeda",
        "6W": "Saratov Airlines",
        B2: "Belavia",
        "7J": "Tajik Air",
        NQ: "Air Japan",
        JW: "Vanilla Air",
        MM: "Peach Aviation",
        GK: "Jetstar Japan",
        BC: "Skymark Airlines",
        LJ: "Jin Air",
        ZE: "Eastar Jet",
        TW: "Tway Air",
        BX: "Air Busan",
        RS: "Air Seoul",
        VZ: "Thai Vietjet Air",
        SL: "Thai Lion Air",
        DD: "Nok Air",
        XJ: "Thai AirAsia X",
        Z8: "Amaszonas",
        "8L": "Lucky Air",
        GJ: "Loong Air",
        DR: "Ruili Airlines",
        A6: "Air Travel",
        GT: "Air Guilin",
        QW: "Qingdao Airlines",
        CN: "West Air",
        PN: "China West Air",
        RY: "Jiangxi Air",
        VD: "Henan Airlines",
        G5: "China Express Air",
        "9H": "Air Changan",
        NS: "Hebei Airlines",
        KN: "China United",
        JD: "Capital Airlines",
        DZ: "Donghai Airlines",
        Y8: "Yangtze River Express",
        OQ: "Chongqing Airlines",
        GX: "GX Airlines",
        AQ: "9 Air",
        EU: "Chengdu Airlines",
        UQ: "Urumqi Air",
        QW: "Qingdao Airlines",
        RY: "Jiangxi Air",
        VD: "Henan Airlines",
      };

      return airlines[code] || code;
    };

    useEffect(() => {
      loadRequests();
    }, []);

    const loadRequests = async () => {
      setLoading(true);
      try {
        const data = await flightRequestsService.getAll();
        setRequests(data);
      } catch (error) {
        console.error("Erreur:", error);
      } finally {
        setLoading(false);
      }
    };

    const toggleExpand = (id) => {
      setExpandedRequests((prev) =>
        prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
      );
    };

    return (
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-2xl font-bold mb-6 flex items-center">
          <Plane className="w-6 h-6 mr-2 text-blue-600" />
          Demandes de billets d'avion 22
        </h2>

        {loading ? (
          <div className="text-center py-12">
            <Loader className="w-12 h-12 text-blue-600 mx-auto animate-spin" />
          </div>
        ) : (
          <div className="space-y-4">
            {requests.map((request) => {
              const isExpanded = expandedRequests.includes(request.id);
              const isMultiFlight = request.type === "multi-flights";

              // Fonction pour obtenir les numéros de vol
              const getFlightNumbers = (flightData) => {
                const segments =
                  flightData.itineraries?.[0]?.segments ||
                  flightData.segments ||
                  [];
                if (segments.length === 0) return "N/A";

                return segments
                  .map((segment) => `${segment.carrierCode} ${segment.number}`)
                  .join(" → ");
              };

              // Fonction pour obtenir les informations du premier segment
              const getFirstSegmentInfo = (flightData) => {
                const segments =
                  flightData.itineraries?.[0]?.segments ||
                  flightData.segments ||
                  [];
                if (segments.length === 0) return null;

                const firstSegment = segments[0];
                const lastSegment = segments[segments.length - 1];

                return {
                  departure: firstSegment.departure?.iataCode || "N/A",
                  arrival: lastSegment.arrival?.iataCode || "N/A",
                  flightNumbers: getFlightNumbers(flightData),
                };
              };

              // Obtenir les informations de passagers
              const getPassengersInfo = () => {
                const adults = parseInt(request.searchParams?.adults || 0);
                const children = parseInt(request.searchParams?.children || 0);
                const infants = parseInt(request.searchParams?.infants || 0);
                const total = adults + children + infants;

                return {
                  adults,
                  children,
                  infants,
                  total,
                  display: `${adults} adulte${adults > 1 ? "s" : ""}${
                    children > 0
                      ? `, ${children} enfant${children > 1 ? "s" : ""}`
                      : ""
                  }${
                    infants > 0
                      ? `, ${infants} bébé${infants > 1 ? "s" : ""}`
                      : ""
                  }`,
                };
              };

              const passengers = getPassengersInfo();
              const flightInfo = !isMultiFlight
                ? getFirstSegmentInfo(request)
                : null;

              return (
                <div
                  key={request.id}
                  className="border rounded-lg overflow-hidden hover:shadow-md transition-shadow"
                >
                  <div className="p-6 hover:bg-gray-50 transition">
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        {/* En-tête de la demande */}
                        <div className="flex items-center space-x-3 mb-3">
                          <h3 className="text-lg font-bold text-gray-900">
                            N° {request.numeroRequete}
                          </h3>
                          {isMultiFlight && (
                            <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-sm font-semibold">
                              Multi-vols ({request.vols?.length || 0} segments)
                            </span>
                          )}
                          <span
                            className={`px-3 py-1 rounded-full text-sm font-semibold ${
                              request.statut === "En attente"
                                ? "bg-yellow-100 text-yellow-700"
                                : request.statut === "Approuvée"
                                ? "bg-green-100 text-green-700"
                                : request.statut === "Rejetée"
                                ? "bg-red-100 text-red-700"
                                : request.statut === "Billet émis"
                                ? "bg-blue-100 text-blue-700"
                                : "bg-gray-100 text-gray-700"
                            }`}
                          >
                            {request.statut}
                          </span>
                        </div>

                        {/* Informations principales */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-3 text-sm">
                          <div>
                            <p className="text-gray-500 text-xs">Agent</p>
                            <p className="font-semibold text-gray-900">
                              {request.prenom} {request.nom}
                            </p>
                            <p className="text-gray-600 text-xs">
                              {request.fonction}
                            </p>
                          </div>

                          <div>
                            <p className="text-gray-500 text-xs">
                              Date de création
                            </p>
                            <p className="font-semibold text-gray-900">
                              {new Date(request.createdAt).toLocaleDateString(
                                "fr-FR"
                              )}
                            </p>
                          </div>

                          <div>
                            <p className="text-gray-500 text-xs">
                              Montant total
                            </p>
                            <p className="font-bold text-blue-600 text-lg">
                              {request.montant} {request.devise}
                            </p>
                          </div>

                          <div>
                            <p className="text-gray-500 text-xs">Passagers</p>
                            <p className="font-semibold text-gray-900">
                              {passengers.display}
                            </p>
                            <p className="text-gray-600 text-xs">
                              {passengers.total} voyageur
                              {passengers.total > 1 ? "s" : ""}
                            </p>
                          </div>
                        </div>

                        {/* Informations du vol (pour les vols simples) */}
                        {!isMultiFlight && flightInfo && (
                          <div className="bg-blue-50 rounded-lg p-3 mb-3">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="font-semibold text-gray-900 text-sm">
                                  {flightInfo.departure} → {flightInfo.arrival}
                                </p>
                                <p className="text-gray-600 text-xs">
                                  Vol {flightInfo.flightNumbers}
                                </p>
                              </div>
                              <div className="text-right">
                                <p className="text-gray-600 text-xs">
                                  Date de départ
                                </p>
                                <p className="font-semibold text-gray-900 text-sm">
                                  {request.searchParams?.departureDate
                                    ? new Date(
                                        request.searchParams.departureDate
                                      ).toLocaleDateString("fr-FR")
                                    : "N/A"}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Bouton pour voir les détails des multi-vols */}
                        {isMultiFlight && (
                          <button
                            onClick={() => toggleExpand(request.id)}
                            className="mt-2 text-blue-600 hover:text-blue-800 flex items-center text-sm font-semibold"
                          >
                            {isExpanded ? (
                              <>
                                <ChevronDown className="w-4 h-4 mr-1" />
                                Masquer les détails des vols
                              </>
                            ) : (
                              <>
                                <ChevronRight className="w-4 h-4 mr-1" />
                                Voir les {request.vols?.length || 0} vol
                                {request.vols?.length > 1 ? "s" : ""}
                              </>
                            )}
                          </button>
                        )}
                      </div>

                      {/* Actions */}
                      <div className="flex space-x-2 ml-4">
                        {request.statut === "En attente" && (
                          <>
                            <button
                              onClick={() => handleApprove(request.id)}
                              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center text-sm"
                            >
                              <CheckCircle className="w-4 h-4 mr-1" />
                              Approuver 22
                            </button>
                            <button
                              onClick={() => handleReject(request.id)}
                              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center text-sm"
                            >
                              <X className="w-4 h-4 mr-1" />
                              Rejeter
                            </button>
                          </>
                        )}
                        {request.statut === "Approuvée" && (
                          <>
                            <button
                              onClick={() => handleEditTravelers(request)}
                              className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center text-sm"
                            >
                              <Users className="w-4 h-4 mr-1" />
                              Voyageurs
                            </button>
                            <button
                              onClick={() => handleEmitTicket(request.id)}
                              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center text-sm"
                            >
                              <FileText className="w-4 h-4 mr-1" />
                              Émettre
                            </button>
                          </>
                        )}
                        {request.statut === "Billet émis" && (
                          <button
                            onClick={() => handleDownloadTicket(request)}
                            className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 flex items-center text-sm"
                          >
                            <Download className="w-4 h-4 mr-1" />
                            Télécharger
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Section détaillée pour les multi-vols */}
                  {isExpanded && isMultiFlight && request.vols && (
                    <div className="border-t bg-gray-50 p-6">
                      <h4 className="font-semibold mb-4 text-gray-900 flex items-center">
                        <Plane className="w-5 h-5 mr-2 text-blue-600" />
                        Détails des {request.vols.length} vol
                        {request.vols.length > 1 ? "s" : ""}
                      </h4>
                      <div className="space-y-4">
                        {request.vols.map((vol, idx) => {
                          const firstSegment =
                            vol.itineraries?.[0]?.segments?.[0];
                          const lastSegment =
                            vol.itineraries?.[0]?.segments?.[
                              vol.itineraries[0].segments.length - 1
                            ];
                          const flightNumbers = getFlightNumbers(vol);
                          const numberOfStops =
                            (vol.itineraries?.[0]?.segments?.length || 1) - 1;

                          return (
                            <div
                              key={idx}
                              className="bg-white p-4 rounded-lg border hover:shadow-sm transition"
                            >
                              <div className="flex justify-between items-start">
                                <div className="flex-1">
                                  {/* En-tête du vol */}
                                  <div className="flex items-center space-x-3 mb-2">
                                    <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
                                      {idx + 1}
                                    </div>
                                    <h5 className="font-semibold text-gray-900">
                                      {firstSegment?.departure?.iataCode ||
                                        "N/A"}{" "}
                                      →{" "}
                                      {lastSegment?.arrival?.iataCode || "N/A"}
                                    </h5>
                                    <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-semibold">
                                      {flightNumbers}
                                    </span>
                                    {numberOfStops > 0 ? (
                                      <span className="px-2 py-1 bg-orange-100 text-orange-700 rounded text-xs">
                                        {numberOfStops} escale
                                        {numberOfStops > 1 ? "s" : ""}
                                      </span>
                                    ) : (
                                      <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-xs">
                                        Vol direct
                                      </span>
                                    )}
                                  </div>

                                  {/* Détails du vol */}
                                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600">
                                    <div>
                                      <p className="text-gray-500 text-xs">
                                        Date
                                      </p>
                                      <p className="font-semibold">
                                        {vol.searchParams?.departureDate
                                          ? new Date(
                                              vol.searchParams.departureDate
                                            ).toLocaleDateString("fr-FR")
                                          : "N/A"}
                                      </p>
                                    </div>
                                    <div>
                                      <p className="text-gray-500 text-xs">
                                        Départ
                                      </p>
                                      <p className="font-semibold">
                                        {firstSegment?.departure?.at
                                          ? new Date(
                                              firstSegment.departure.at
                                            ).toLocaleTimeString("fr-FR", {
                                              hour: "2-digit",
                                              minute: "2-digit",
                                            })
                                          : "N/A"}
                                      </p>
                                    </div>
                                    <div>
                                      <p className="text-gray-500 text-xs">
                                        Arrivée
                                      </p>
                                      <p className="font-semibold">
                                        {lastSegment?.arrival?.at
                                          ? new Date(
                                              lastSegment.arrival.at
                                            ).toLocaleTimeString("fr-FR", {
                                              hour: "2-digit",
                                              minute: "2-digit",
                                            })
                                          : "N/A"}
                                      </p>
                                    </div>
                                    <div>
                                      <p className="text-gray-500 text-xs">
                                        Durée
                                      </p>
                                      <p className="font-semibold">
                                        {vol.itineraries?.[0]?.duration
                                          ?.replace("PT", "")
                                          .replace("H", "h ")
                                          .replace("M", "min") || "N/A"}
                                      </p>
                                    </div>
                                  </div>

                                  {/* Classe de voyage */}
                                  <div className="mt-2">
                                    <span className="text-xs text-gray-500">
                                      Classe:{" "}
                                    </span>
                                    <span className="text-xs font-semibold text-purple-600">
                                      {vol.searchParams?.travelClass ===
                                      "ECONOMY"
                                        ? "Économique"
                                        : vol.searchParams?.travelClass ===
                                          "PREMIUM_ECONOMY"
                                        ? "Éco. Premium"
                                        : vol.searchParams?.travelClass ===
                                          "BUSINESS"
                                        ? "Affaires"
                                        : "Première"}
                                    </span>
                                  </div>
                                </div>

                                <div className="text-right ml-4">
                                  <p className="text-lg font-bold text-blue-600">
                                    {vol.price?.total || "0"}{" "}
                                    {vol.price?.currency || "EUR"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };
  // Workflow principal pour multi-segments
  const MultiSegmentBookingWorkflow = ({ user }) => {
    const [step, setStep] = useState(1);
    const [selectedFlights, setSelectedFlights] = useState(null);
    const [globalParams, setGlobalParams] = useState(null);

    const handleFlightsSelected = (flights, params) => {
      setSelectedFlights(flights);
      setGlobalParams(params);
      setStep(2);
    };

    const handleSubmit = async (requestData) => {
      try {
        await flightRequestsService.create(requestData);
        alert("Demande multi-destinations créée avec succès !");
        setStep(1);
        setSelectedFlights(null);
        setGlobalParams(null);
      } catch (error) {
        alert(`Erreur: ${error.message}`);
      }
    };

    return (
      <div className="space-y-6">
        {/* Indicateur de progression */}
        <div className="bg-white rounded-xl shadow-md p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  step >= 1 ? "bg-blue-600 text-white" : "bg-gray-200"
                }`}
              >
                1
              </div>
              <div>
                <p className="font-semibold">Sélection</p>
                <p className="text-sm text-gray-500">Choisir les vols</p>
              </div>
            </div>

            <div className="flex-1 h-1 bg-gray-200 mx-4">
              <div
                className={`h-full bg-blue-600 transition-all`}
                style={{ width: step >= 2 ? "100%" : "0%" }}
              />
            </div>

            <div className="flex items-center space-x-4">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  step >= 2 ? "bg-blue-600 text-white" : "bg-gray-200"
                }`}
              >
                2
              </div>
              <div>
                <p className="font-semibold">Finalisation</p>
                <p className="text-sm text-gray-500">Confirmer la demande</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contenu selon l'étape */}
        {step === 1 && (
          <MultiSegmentFlightSearch onSelectFlights={handleFlightsSelected} />
        )}

        {step === 2 && selectedFlights && (
          <MultiFlightRequestForm
            selectedFlights={selectedFlights}
            globalParams={globalParams}
            user={user}
            onSubmit={handleSubmit}
            onCancel={() => {
              setStep(1);
              setSelectedFlights(null);
              setGlobalParams(null);
            }}
          />
        )}
      </div>
    );
  };
  const FlightBookingWorkflow = ({ user, onRequestSubmitted }) => {
    const [step, setStep] = useState(1);
    const [selectedFlight, setSelectedFlight] = useState(null);
    const [searchParams, setSearchParams] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [safeSearchParams, setSafeSearchParams] = useState({
      originLocationCode: "",
      destinationLocationCode: "",
      departureDate: "",
      returnDate: "",
      adults: "1",
      children: "0",
      infants: "0",
      tripType: "one-way",
      travelClass: "ECONOMY",
    });
    const handleFlightSelect = (flight, params) => {
      setSelectedFlight(flight);
      setSearchParams(params);
      setStep(2);
    };

    const handleRequestSubmit = async (requestData) => {
      setSubmitting(true);
      try {
        const createdRequest = await flightRequestsService.create(requestData);
        alert("Demande de billet créée avec succès !");
        onRequestSubmitted && onRequestSubmitted(createdRequest);
        // Réinitialiser le workflow
        setStep(1);
        setSelectedFlight(null);
        setSearchParams(null);
      } catch (error) {
        alert(`Erreur lors de la création: ${error.message}`);
      } finally {
        setSubmitting(false);
      }
    };

    return (
      <div className="space-y-6">
        {/* Indicateur de progression */}
        <div className="bg-white rounded-xl shadow-md p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  step >= 1 ? "bg-blue-600 text-white" : "bg-gray-200"
                }`}
              >
                1
              </div>
              <div>
                <p className="font-semibold">Recherche</p>
                <p className="text-sm text-gray-500">Trouvez votre vol</p>
              </div>
            </div>
            <div className="flex-1 h-1 bg-gray-200 mx-4">
              <div
                className={`h-full bg-blue-600 transition-all`}
                style={{ width: step >= 2 ? "100%" : "0%" }}
              ></div>
            </div>
            <div className="flex items-center space-x-4">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  step >= 2 ? "bg-blue-600 text-white" : "bg-gray-200"
                }`}
              >
                2
              </div>
              <div>
                <p className="font-semibold">Demande</p>
                <p className="text-sm text-gray-500">Complétez le formulaire</p>
              </div>
            </div>
          </div>
        </div>

        {/* Étape 1: Recherche de vol */}
        {step === 1 && <FlightSearch onSelectFlight={handleFlightSelect} />}

        {/* Étape 2: Formulaire de demande */}
        {step === 2 && selectedFlight && (
          <PurchaseRequestForm
            selectedFlight={selectedFlight}
            searchParams={searchParams}
            user={user}
            submitting={submitting}
            onSubmit={handleRequestSubmit}
            onCancel={() => {
              setStep(1);
              setSelectedFlight(null);
              setSearchParams(null);
            }}
          />
        )}
      </div>
    );
  };

  ////
  function App() {
    const [currentView, setCurrentView] = useState("workflow");
    const mockUser = { name: "Jean Dupont", id: "user-001" };

    return (
      <div className="min-h-screen bg-gray-100 p-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6 flex space-x-4">
            <button
              onClick={() => setCurrentView("workflow")}
              className={`px-6 py-3 rounded-lg font-semibold ${
                currentView === "workflow"
                  ? "bg-blue-600 text-white"
                  : "bg-white text-gray-700 hover:bg-gray-100"
              }`}
            >
              Nouvelle demande multi-vols
            </button>
            <button
              onClick={() => setCurrentView("list")}
              className={`px-6 py-3 rounded-lg font-semibold ${
                currentView === "list"
                  ? "bg-blue-600 text-white"
                  : "bg-white text-gray-700 hover:bg-gray-100"
              }`}
            >
              Liste des demandes
            </button>
          </div>

          {currentView === "workflow" && (
            <MultiSegmentBookingWorkflow user={mockUser} />
          )}

          {currentView === "list" && <EnhancedFlightRequestsList />}
        </div>
      </div>
    );
  }
};

// ==================== COMPOSANT FORMULAIRE DE DEMANDE AVEC API ====================
const PurchaseRequestForm = ({
  selectedFlight = {},
  searchParams = {},
  user = {},
  submitting = false,
  onSubmit = () => {},
  onCancel = () => {},
  agentService,
}) => {
  const [agents, setAgents] = useState([]);
  const [loadingAgents, setLoadingAgents] = useState(false);

  const [formData, setFormData] = useState({
    matricule: user?.matricule || "",
    nom: user?.name ? user.name.split(" ")[1] || "" : "",
    prenom: user?.name ? user.name.split(" ")[0] || "" : "",
    categorie: user?.categorie || "",
    fonction: user?.fonction || "",
    objetVoyage: "",
    motifDeplacement: "",
    projet: "",
    centreCoût: "",
    agentId: "",
  });
  const localValuesRef = useRef({
    origin: searchParams.originLocationCode || "",
    destination: searchParams.destinationLocationCode || "",
    objetVoyage: formData.objetVoyage || "",
  });

  const handleFormFieldChange = (field, value) => {
    localValuesRef.current[field] = value;

    const handler = setTimeout(() => {
      setFormData((prev) => ({
        ...prev,
        [field]: localValuesRef.current[field],
      }));
    }, 50);

    return () => clearTimeout(handler);
  };

  // const handleLocalChange = (field, value) => {
  //  setLocalValues(prev => ({
  // ...prev,
  //  [field]: value.toUpperCase()
  //  }));
  // };
  // Service d'administration pour récupérer les agents
  const administrationService = {
    getAgents: async () => {
      const response = await fetch(`${API_BASE_URL2}/travel-agents`);

      if (!response.ok) throw new Error("Erreur récupération agents");
      return await response.json();
    },
  };

  // Chargement des agents au montage du composant
  useEffect(() => {
    loadAgents();
  }, []);

  const loadAgents = async () => {
    setLoadingAgents(true);
    try {
      // Chargement des agents depuis la base de données
      const agentsData = await administrationService.getAgents();
      setAgents(agentsData);
    } catch (error) {
      console.error("Erreur lors du chargement des agents:", error);
      alert("Impossible de charger la liste des agents. Veuillez réessayer.");
    } finally {
      setLoadingAgents(false);
    }
  };

  // Fonction pour générer un UUID
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.agentId) {
      alert("Veuillez sélectionner un agent");
      return;
    }

    const selectedAgent = agents.find((a) => a.id === formData.agentId);

    if (!selectedAgent) {
      alert("Agent sélectionné introuvable");
      return;
    }

    // Utilisation des données de l'agent sélectionné
    const requestData = {
      id: generateUUID(),
      numeroRequete: `REQ-${Date.now()}`,
      matricule: selectedAgent.matricule, // Matricule de l'agent sélectionné
      nom: selectedAgent.nom, // Nom de l'agent sélectionné
      prenom: selectedAgent.prenom, // Prénom de l'agent sélectionné
      categorie: selectedAgent.categorie, // Catégorie de l'agent sélectionné
      fonction: selectedAgent.fonction, // Fonction de l'agent sélectionné
      objetVoyage: formData.objetVoyage,
      motifDeplacement: formData.motifDeplacement,
      projet: formData.projet,
      centreCoût: formData.centreCoût,
      vol: selectedFlight,
      searchParams,
      createdAt: new Date(),
      dateRequete: new Date().toISOString(),
      createdById: user.id,
      statut: "En attente",
      montant: selectedFlight?.price?.total || 0,
      devise: selectedFlight?.price?.currency || "EUR",
      agentId: formData.agentId,
      agentNom: `${selectedAgent.prenom} ${selectedAgent.nom}`,
    };

    onSubmit(requestData);
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex justify-between mb-6">
        <h2 className="text-2xl font-bold flex items-center">
          <FileText className="w-6 h-6 mr-2 text-blue-600" />
          Demande d'achat de billet
        </h2>
        <button onClick={onCancel} disabled={submitting}>
          <X className="w-6 h-6 text-gray-500 hover:text-gray-700" />
        </button>
      </div>

      {/* Section Vol sélectionné */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <h3 className="font-bold text-blue-900 mb-3 flex items-center">
          <Plane className="w-5 h-5 mr-2" />
          Vol sélectionné
        </h3>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-gray-600">Trajet</p>
            <p className="font-semibold">
              {searchParams?.originLocationCode || "N/A"} →{" "}
              {searchParams?.destinationLocationCode || "N/A"}
            </p>
          </div>
          <div>
            <p className="text-gray-600">Date</p>
            <p className="font-semibold">
              {searchParams?.departureDate
                ? new Date(searchParams.departureDate).toLocaleDateString(
                    "fr-FR"
                  )
                : "N/A"}
            </p>
          </div>
          <div>
            <p className="text-gray-600">Passagers</p>
            <p className="font-semibold">
              {searchParams?.adults || 1} adulte(s)
            </p>
          </div>
          <div>
            <p className="text-gray-600">Prix</p>
            <p className="font-semibold text-blue-600 text-lg">
              {selectedFlight?.price?.total || "0"}{" "}
              {selectedFlight?.price?.currency || "EUR"}
            </p>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Section Agent Responsable - SIMPLE SELECT */}
        <div>
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <Users className="w-5 h-5 mr-2 text-blue-600" />
            Agent voyageur
          </h3>
          <div>
            <label className="block text-sm font-semibold mb-2">
              Sélectionner un agent *
            </label>
            <select
              value={formData.agentId}
              onChange={(e) =>
                setFormData({ ...formData, agentId: e.target.value })
              }
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
              disabled={submitting || loadingAgents}
            >
              <option value="">-- Choisir un agent --</option>
              {agents.map((agent) => (
                <option key={agent.id} value={agent.id}>
                  {agent.prenom} {agent.nom} - {agent.fonction} (Mat:{" "}
                  {agent.matricule})
                </option>
              ))}
            </select>
            {loadingAgents && (
              <p className="text-sm text-gray-500 mt-1">
                Chargement des agents...
              </p>
            )}
          </div>
        </div>

        {/* Section Détails du voyage */}
        <div>
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <MapPin className="w-5 h-5 mr-2 text-blue-600" />
            Détails du voyage demandé
          </h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Objet du voyage *
              </label>
              <input
                type="text"
                defaultValue={localValuesRef.current.objetVoyage}
                onChange={(e) =>
                  handleFormFieldChange("objetVoyage", e.target.value)
                }
                onBlur={() =>
                  setFormData((prev) => ({
                    ...prev,
                    objetVoyage: localValuesRef.current.objetVoyage,
                  }))
                }
                placeholder="Ex: Tournée commerciale multi-destinations"
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Motif du déplacement *
              </label>
              <textarea
                value={formData.motifDeplacement}
                onChange={(e) =>
                  setFormData({ ...formData, motifDeplacement: e.target.value })
                }
                rows="3"
                className="w-full px-4 py-2 border rounded-lg"
                required
                disabled={submitting}
              />
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Projet
                </label>
                <input
                  type="text"
                  value={formData.projet}
                  onChange={(e) =>
                    setFormData({ ...formData, projet: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={submitting}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Centre de coût
                </label>
                <input
                  type="text"
                  value={formData.centreCoût}
                  onChange={(e) =>
                    setFormData({ ...formData, centreCoût: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={submitting}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Boutons d'action */}
        <div className="flex space-x-4">
          <button
            type="submit"
            disabled={submitting}
            className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center"
          >
            {submitting ? (
              <>
                <Loader className="w-5 h-5 mr-2 animate-spin" />
                Envoi en cours...
              </>
            ) : (
              <>
                <Save className="w-5 h-5 mr-2" />
                Soumettre la demande
              </>
            )}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={submitting}
            className="px-6 py-3 border rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
};

// ==================== COMPOSANT LISTE DES DEMANDES AVEC API ====================

// const RequestCard = ({
//   request,
//   expandedRequest,
//   onExpand,
//   onApprove,
//   onReject,
//   onEditTravelers,
//   onEmitTicket,
//   onDownloadTicket,
//   onDelete,
//   getStatusColor,
//   onRefresh,
// }) => {
//   const isMultiFlight = request.type === "multi-flights";
//   const flightCount = isMultiFlight && request.vol ? request.vol.length : 1;
//   const [error, setError] = useState(null);
//   const [filterStatus, setFilterStatus] = useState("all");
//   const [requests, setRequests] = useState([]);
//   const [loading, setLoading] = useState(false);
//   // TODO ADAPTER POUR VOL SIMPLE
//   const getFlightNumbers = (flightData) => {
//     const segments =
//       flightData.itineraries?.[0]?.segments || flightData.segments || [];
//     if (segments.length === 0) return "N/A";

//     return segments
//       .map((segment) => `${segment.carrierCode} ${segment.number}`)
//       .join(" → ");
//   };

//   const handleRejectFligth = async (id) => {
//     if (!window.confirm("Êtes-vous sûr de vouloir rejeter cette demande ?"))
//       return;

//     try {
//       await flightRequestsService.reject(id);
//       alert("Demande rejetée");
//       await loadRequests();
//       onRefresh && onRefresh();
//     } catch (error) {
//       alert(`Erreur: ${error.message}`);
//     }
//   };
//   // Fonction pour obtenir le nom de la compagnie aérienne
//   const getAirlineName = (code) => {
//     const airlines = {
//       // Europe
//       AF: "Air France",
//       LH: "Lufthansa",
//       BA: "British Airways",
//       KL: "KLM",
//       SN: "Brussels Airlines",
//       LX: "Swiss International Air Lines",
//       IB: "Iberia",
//       AZ: "Alitalia",
//       TP: "TAP Air Portugal",
//       AY: "Finnair",
//       SK: "SAS Scandinavian Airlines",
//       LO: "LOT Polish Airlines",
//       OS: "Austrian Airlines",
//       SU: "Aeroflot",
//       TK: "Turkish Airlines",
//       A3: "Aegean Airlines",
//       DY: "Norwegian Air Shuttle",
//       FR: "Ryanair",
//       U2: "easyJet",
//       VY: "Vueling",
//       EW: "Eurowings",
//       BT: "Air Baltic",
//       JU: "Air Serbia",
//       OU: "Croatia Airlines",
//       KM: "Air Malta",
//       FI: "Icelandair",

//       // Moyen-Orient
//       EK: "Emirates",
//       EY: "Etihad Airways",
//       QR: "Qatar Airways",
//       SV: "Saudia",
//       RJ: "Royal Jordanian",
//       WY: "Oman Air",
//       GF: "Gulf Air",
//       KU: "Kuwait Airways",
//       ME: "Middle East Airlines",

//       // Afrique
//       ET: "Ethiopian Airlines",
//       MS: "EgyptAir",
//       AT: "Royal Air Maroc",
//       TU: "Tunisair",
//       KQ: "Kenya Airways",
//       SA: "South African Airways",
//       MK: "Air Mauritius",
//       UL: "SriLankan Airlines",
//       WB: "RwandAir",
//       P4: "Air Peace",
//       "9U": "Air Moldova",

//       // Amérique du Nord
//       AA: "American Airlines",
//       DL: "Delta Air Lines",
//       UA: "United Airlines",
//       AC: "Air Canada",
//       WN: "Southwest Airlines",
//       B6: "JetBlue Airways",
//       AS: "Alaska Airlines",
//       WS: "WestJet",
//       F9: "Frontier Airlines",

//       // Amérique du Sud
//       LA: "LATAM Airlines",
//       AV: "Avianca",
//       CM: "Copa Airlines",
//       AR: "Aerolíneas Argentinas",
//       G3: "Gol Transportes Aéreos",
//       AD: "Azul Brazilian Airlines",
//       JJ: "LATAM Brasil",

//       // Asie
//       SQ: "Singapore Airlines",
//       CX: "Cathay Pacific",
//       NH: "ANA All Nippon Airways",
//       JL: "Japan Airlines",
//       KE: "Korean Air",
//       OZ: "Asiana Airlines",
//       CI: "China Airlines",
//       BR: "EVA Air",
//       TG: "Thai Airways",
//       MH: "Malaysia Airlines",
//       GA: "Garuda Indonesia",
//       PR: "Philippine Airlines",
//       VN: "Vietnam Airlines",
//       CZ: "China Southern Airlines",
//       MU: "China Eastern Airlines",
//       CA: "Air China",
//       HU: "Hainan Airlines",
//       FM: "Shanghai Airlines",
//       "3U": "Sichuan Airlines",
//       "9C": "Spring Airlines",

//       // Océanie
//       QF: "Qantas",
//       VA: "Virgin Australia",
//       NZ: "Air New Zealand",
//       FJ: "Fiji Airways",

//       // Compagnies low-cost
//       NK: "Spirit Airlines",
//       SY: "Sun Country Airlines",
//       G4: "Allegiant Air",
//       Y4: "Volaris",
//       Y9: "Air Arabia",
//       FD: "Thai AirAsia",
//       AK: "AirAsia",
//       D7: "AirAsia X",
//       TR: "Scoot",
//       Z2: "Philippines AirAsia",

//       // Compagnies cargo
//       "5Y": "Atlas Air",
//       K4: "Kalitta Air",
//       W8: "Cargojet Airways",

//       // Régionales
//       YX: "Republic Airways",
//       OO: "SkyWest Airlines",
//       "9E": "Endeavor Air",
//       MQ: "Envoy Air",
//       OH: "PSA Airlines",

//       // Autres
//       AI: "Air India",
//       PK: "Pakistan International Airlines",
//       BG: "Biman Bangladesh Airlines",
//       UL: "SriLankan Airlines",
//       UL: "SriLankan Airlines",
//       BI: "Royal Brunei Airlines",
//       OM: "MIAT Mongolian Airlines",
//       RGN: "Regional Express",
//       J2: "Azerbaijan Airlines",
//       KC: "Air Astana",
//       HY: "Uzbekistan Airways",
//       FV: "Rossiya Airlines",
//       S7: "S7 Airlines",
//       U6: "Ural Airlines",
//       "5N": "Nordavia",
//       D2: "Severstal Air Company",
//       N4: "Nordwind Airlines",
//       ZF: "Azur Air",
//       Y7: "NordStar Airlines",
//       DP: "Pobeda",
//       "6W": "Saratov Airlines",
//       B2: "Belavia",
//       "7J": "Tajik Air",
//       NQ: "Air Japan",
//       JW: "Vanilla Air",
//       MM: "Peach Aviation",
//       GK: "Jetstar Japan",
//       BC: "Skymark Airlines",
//       LJ: "Jin Air",
//       ZE: "Eastar Jet",
//       TW: "Tway Air",
//       BX: "Air Busan",
//       RS: "Air Seoul",
//       VZ: "Thai Vietjet Air",
//       SL: "Thai Lion Air",
//       DD: "Nok Air",
//       XJ: "Thai AirAsia X",
//       Z8: "Amaszonas",
//       "8L": "Lucky Air",
//       GJ: "Loong Air",
//       DR: "Ruili Airlines",
//       A6: "Air Travel",
//       GT: "Air Guilin",
//       QW: "Qingdao Airlines",
//       CN: "West Air",
//       PN: "China West Air",
//       RY: "Jiangxi Air",
//       VD: "Henan Airlines",
//       G5: "China Express Air",
//       "9H": "Air Changan",
//       NS: "Hebei Airlines",
//       KN: "China United",
//       JD: "Capital Airlines",
//       DZ: "Donghai Airlines",
//       Y8: "Yangtze River Express",
//       OQ: "Chongqing Airlines",
//       GX: "GX Airlines",
//       AQ: "9 Air",
//       EU: "Chengdu Airlines",
//       UQ: "Urumqi Air",
//       QW: "Qingdao Airlines",
//       RY: "Jiangxi Air",
//       VD: "Henan Airlines",
//     };

//     return airlines[code] || code;
//   };

//   useEffect(() => {
//     loadRequests();
//   }, [filterStatus]);

//   const loadRequests = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       let data;
//       if (filterStatus === "all") {
//         data = await hotelRequestsService.getAll();
//       } else {
//         data = await hotelRequestsService.getByStatus(filterStatus);
//       }
//       setRequests(data);
//     } catch (error) {
//       console.error("Erreur chargement demandes:", error);
//       setError("Erreur lors du chargement des demandes: " + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleApproveFligth = async (id) => {
//     if (!window.confirm("Êtes-vous sûr de vouloir approuver cette demande ?"))
//       return;

//     try {
//       await flightRequestsService.approve(id);
//       alert("Demande approuvée avec succès !");
//       await loadRequests();
//       onRefresh && onRefresh();
//     } catch (error) {
//       alert(`Erreur: ${error.message}`);
//     }
//   };

//   const handleDownloadTicket = (request) => {
//     const doc = new jsPDF();
//     const flightNumbers = getFlightNumbers(request.flight);
//     // En-tête avec design moderne
//     doc.setFillColor(37, 99, 235);
//     doc.rect(0, 0, 210, 40, "F");
//     doc.setTextColor(255, 255, 255);
//     doc.setFontSize(24);
//     doc.text("BILLET D'AVION ÉLECTRONIQUE", 105, 20, { align: "center" });
//     doc.setFontSize(12);
//     doc.text(`N° ${flightNumbers}`, 105, 30, { align: "center" });

//     // Logo et informations de l'agence
//     doc.setTextColor(0, 0, 0);
//     doc.setFontSize(10);
//     let yPos = 50;
//     doc.setFont(undefined, "bold");
//     doc.text("ABM Travel Agency", 20, yPos);
//     doc.setFont(undefined, "normal");
//     yPos += 5;
//     doc.text("Conakry, Guinée", 20, yPos);
//     yPos += 5;
//     doc.text("contact@abmtravel.com", 20, yPos);

//     // Date d'émission
//     yPos = 50;
//     doc.text(`Émis le: ${new Date().toLocaleDateString("fr-FR")}`, 190, yPos, {
//       align: "right",
//     });

//     yPos = 75;

//     // Informations du passager
//     doc.setFillColor(245, 245, 245);
//     doc.rect(15, yPos - 5, 180, 30, "F");
//     doc.setFont(undefined, "bold");
//     doc.setFontSize(12);
//     doc.text("INFORMATIONS DU PASSAGER", 20, yPos);
//     doc.setFont(undefined, "normal");
//     doc.setFontSize(10);
//     yPos += 8;
//     doc.text(`Nom: ${request.nom?.toUpperCase() || "N/A"}`, 20, yPos);
//     doc.text(`Prénom: ${request.prenom || "N/A"}`, 100, yPos);
//     yPos += 7;
//     doc.text(`Matricule: ${request.matricule || "N/A"}`, 20, yPos);
//     doc.text(`Fonction: ${request.fonction || "N/A"}`, 100, yPos);

//     yPos += 15;

//     // Vérifier si c'est une demande multi-vols
//     if (
//       request.type === "multi-flights" &&
//       request.vol &&
//       Array.isArray(request.vol)
//     ) {
//       // MULTI-VOLS : Afficher tous les vols
//       doc.setFillColor(245, 245, 245);
//       doc.rect(15, yPos - 5, 180, 10, "F");
//       doc.setFont(undefined, "bold");
//       doc.setFontSize(12);
//       doc.text("ITINÉRAIRE MULTI-DESTINATIONS", 20, yPos);
//       yPos += 12;

//       request.vol.forEach((vol, index) => {
//         const firstSegment = vol.itineraries?.[0]?.segments?.[0];
//         const lastSegment =
//           vol.itineraries?.[0]?.segments?.[
//             vol.itineraries[0].segments.length - 1
//           ];

//         // Section pour chaque vol
//         doc.setFillColor(250, 250, 250);
//         doc.rect(15, yPos - 3, 180, 35, "F");

//         doc.setFont(undefined, "bold");
//         doc.setFontSize(11);
//         doc.text(`VOL ${index + 1}`, 20, yPos);
//         doc.setFont(undefined, "normal");
//         yPos += 6;

//         doc.setFont(undefined, "bold");
//         doc.setFontSize(14);
//         doc.text(
//           `${
//             firstSegment?.departure?.iataCode ||
//             vol.searchParams?.originLocationCode ||
//             "N/A"
//           } → ${
//             lastSegment?.arrival?.iataCode ||
//             vol.searchParams?.destinationLocationCode ||
//             "N/A"
//           }`,
//           20,
//           yPos
//         );
//         doc.setFont(undefined, "normal");
//         doc.setFontSize(10);
//         yPos += 8;

//         const departureDate = vol.searchParams?.departureDate
//           ? new Date(vol.searchParams.departureDate).toLocaleDateString(
//               "fr-FR",
//               {
//                 weekday: "long",
//                 year: "numeric",
//                 month: "long",
//                 day: "numeric",
//               }
//             )
//           : "N/A";
//         doc.text(`Date: ${departureDate}`, 20, yPos);
//         yPos += 6;

//         doc.text(
//           `Transporteur: ${firstSegment?.carrierCode || "N/A"}`,
//           20,
//           yPos
//         );
//         doc.text(
//           `Classe: ${vol.searchParams?.travelClass || "ECONOMY"}`,
//           100,
//           yPos
//         );
//         doc.text(
//           `Prix: ${vol.price?.total || "0"} ${vol.price?.currency || "EUR"}`,
//           150,
//           yPos
//         );

//         yPos += 10;
//       });

//       // Total pour multi-vols
//       doc.setFillColor(230, 240, 255);
//       doc.rect(15, yPos - 5, 180, 20, "F");
//       doc.setFont(undefined, "bold");
//       doc.setFontSize(12);
//       doc.text("MONTANT TOTAL", 20, yPos);
//       yPos += 7;
//       doc.setFontSize(14);
//       doc.text(
//         `${request.montant || "0"} ${request.devise || "EUR"}`,
//         20,
//         yPos
//       );
//     } else {
//       // VOL SIMPLE : Affichage normal
//       doc.setFillColor(245, 245, 245);
//       doc.rect(15, yPos - 5, 180, 45, "F");
//       doc.setFont(undefined, "bold");
//       doc.setFontSize(12);
//       doc.text("DÉTAILS DU VOL", 20, yPos);
//       doc.setFont(undefined, "normal");
//       doc.setFontSize(10);
//       yPos += 8;

//       // Trajet
//       doc.setFont(undefined, "bold");
//       doc.setFontSize(14);
//       doc.text(
//         `${request.searchParams?.originLocationCode || "N/A"} → ${
//           request.searchParams?.destinationLocationCode || "N/A"
//         }`,
//         20,
//         yPos
//       );
//       doc.setFont(undefined, "normal");
//       doc.setFontSize(10);
//       yPos += 8;

//       // Date et heure
//       const departureDate = request.searchParams?.departureDate
//         ? new Date(request.searchParams.departureDate).toLocaleDateString(
//             "fr-FR",
//             {
//               weekday: "long",
//               year: "numeric",
//               month: "long",
//               day: "numeric",
//             }
//           )
//         : "N/A";
//       doc.text(`Date de départ: ${departureDate}`, 20, yPos);
//       yPos += 7;

//       // Type de voyage
//       const tripType =
//         request.searchParams?.tripType === "round-trip"
//           ? "Aller-retour"
//           : "Aller simple";
//       doc.text(`Type: ${tripType}`, 20, yPos);
//       doc.text(
//         `Classe: ${request.searchParams?.travelClass || "ECONOMY"}`,
//         100,
//         yPos
//       );

//       yPos += 15;

//       // Informations tarifaires
//       doc.setFillColor(245, 245, 245);
//       doc.rect(15, yPos - 5, 180, 25, "F");
//       doc.setFont(undefined, "bold");
//       doc.setFontSize(12);
//       doc.text("INFORMATIONS TARIFAIRES", 20, yPos);
//       doc.setFont(undefined, "normal");
//       doc.setFontSize(10);
//       yPos += 8;
//       doc.text(
//         `Nombre de passagers: ${request.searchParams?.adults || 1} adulte(s)`,
//         20,
//         yPos
//       );
//       yPos += 7;
//       doc.setFont(undefined, "bold");
//       doc.setFontSize(12);
//       doc.text(
//         `Prix total: ${request.montant || "0"} ${request.devise || "EUR"}`,
//         20,
//         yPos
//       );
//     }

//     yPos += 15;

//     // Conditions
//     doc.setFont(undefined, "bold");
//     doc.setFontSize(11);
//     doc.text("CONDITIONS ET INFORMATIONS IMPORTANTES", 20, yPos);
//     doc.setFont(undefined, "normal");
//     doc.setFontSize(9);
//     yPos += 7;

//     const conditions = [
//       "• Ce billet est non transférable et non remboursable.",
//       "• Présentez-vous à l'enregistrement au moins 2h avant le départ (vols internationaux).",
//       "• Une pièce d'identité valide est requise pour l'embarquement.",
//     ];

//     conditions.forEach((condition) => {
//       doc.text(condition, 20, yPos);
//       yPos += 6;
//     });

//     // Code-barres
//     yPos += 10;
//     doc.setFillColor(0, 0, 0);
//     doc.rect(50, yPos, 110, 15, "F");
//     doc.setTextColor(255, 255, 255);
//     doc.setFontSize(10);
//     doc.text(request.numeroRequete || "TICKET-2024", 105, yPos + 10, {
//       align: "center",
//     });

//     // Pied de page
//     doc.setTextColor(0, 0, 0);
//     doc.setFontSize(8);
//     doc.setFont(undefined, "italic");
//     doc.text("Document généré électroniquement - ABM Travel Agency", 105, 280, {
//       align: "center",
//     });

//     doc.save(`Billet_${request.numeroRequete || "TICKET"}.pdf`);
//   };
//   // Fonction pour formater la durée
//   const formatDuration = (duration) => {
//     if (!duration) return "N/A";
//     const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);
//     const hours = match[1] ? parseInt(match[1]) : 0;
//     const minutes = match[2] ? parseInt(match[2]) : 0;

//     if (hours > 0 && minutes > 0) {
//       return `${hours}h ${minutes}min`;
//     } else if (hours > 0) {
//       return `${hours}h`;
//     } else {
//       return `${minutes}min`;
//     }
//   };

//   // Rendu des détails du vol
//   const renderFlightDetails = () => {
//     if (request.vol) {
//       return request.vol.map((vol, index) => (
//         <div key={index} className="mb-4 p-4 bg-white rounded-lg border">
//           <h4 className="font-semibold text-lg mb-3">Vol {index + 1}</h4>
//           {vol.itineraries?.map((itinerary, itinIndex) => (
//             <div key={itinIndex} className="space-y-3">
//               {itinerary.segments?.map((segment, segIndex) => (
//                 <div
//                   key={segIndex}
//                   className="flex items-center justify-between p-3 bg-gray-50 rounded"
//                 >
//                   <div className="flex items-center space-x-4">
//                     <div className="text-center">
//                       <div className="font-bold text-lg">
//                         {segment.departure?.at
//                           ? new Date(segment.departure.at).toLocaleTimeString(
//                               "fr-FR",
//                               { hour: "2-digit", minute: "2-digit" }
//                             )
//                           : "N/A"}
//                       </div>
//                       <div className="text-sm text-gray-600">
//                         {segment.departure?.iataCode}
//                       </div>
//                     </div>
//                     <div className="flex-1 text-center">
//                       <div className="flex items-center justify-center space-x-2">
//                         <Plane className="w-4 h-4 text-gray-400 rotate-45" />
//                         <span className="text-sm text-gray-500">
//                           {formatDuration(segment.duration)}
//                         </span>
//                       </div>
//                       <div className="w-full h-px bg-gray-300 mt-1"></div>
//                     </div>
//                     <div className="text-center">
//                       <div className="font-bold text-lg">
//                         {segment.arrival?.at
//                           ? new Date(segment.arrival.at).toLocaleTimeString(
//                               "fr-FR",
//                               { hour: "2-digit", minute: "2-digit" }
//                             )
//                           : "N/A"}
//                       </div>
//                       <div className="text-sm text-gray-600">
//                         {segment.arrival?.iataCode}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="text-right">
//                     <div className="font-semibold">
//                       {getAirlineName(segment.carrierCode)}
//                     </div>
//                     <div className="text-sm text-gray-600">
//                       Vol {segment.number}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ))}
//         </div>
//       ));
//     } else {
//       // Vol simple
//       return request.itineraries?.map((itinerary, index) => (
//         <div key={index} className="space-y-3">
//           {itinerary.segments?.map((segment, segIndex) => (
//             <div
//               key={segIndex}
//               className="flex items-center justify-between p-4 bg-white rounded-lg border"
//             >
//               <div className="flex items-center space-x-6">
//                 <div className="text-center">
//                   <div className="font-bold text-xl">
//                     {segment.departure?.at
//                       ? new Date(segment.departure.at).toLocaleTimeString(
//                           "fr-FR",
//                           { hour: "2-digit", minute: "2-digit" }
//                         )
//                       : "N/A"}
//                   </div>
//                   <div className="text-sm font-medium text-gray-700">
//                     {segment.departure?.iataCode}
//                   </div>
//                 </div>

//                 <div className="flex-1">
//                   <div className="flex items-center justify-center space-x-3">
//                     <Clock className="w-4 h-4 text-gray-400" />
//                     <span className="text-sm font-medium text-gray-600">
//                       {formatDuration(segment.duration)}
//                     </span>
//                     <Plane className="w-4 h-4 text-gray-400 rotate-45" />
//                   </div>
//                   <div className="w-full h-px bg-gray-200 mt-2"></div>
//                   <div className="text-xs text-center text-gray-500 mt-1">
//                     {segment.departure?.at
//                       ? new Date(segment.departure.at).toLocaleDateString(
//                           "fr-FR"
//                         )
//                       : ""}
//                   </div>
//                 </div>

//                 <div className="text-center">
//                   <div className="font-bold text-xl">
//                     {segment.arrival?.at
//                       ? new Date(segment.arrival.at).toLocaleTimeString(
//                           "fr-FR",
//                           { hour: "2-digit", minute: "2-digit" }
//                         )
//                       : "N/A"}
//                   </div>
//                   <div className="text-sm font-medium text-gray-700">
//                     {segment.arrival?.iataCode}
//                   </div>
//                 </div>
//               </div>

//               <div className="text-right border-l pl-4">
//                 <div className="font-semibold text-gray-900">
//                   {getAirlineName(segment.carrierCode)}
//                 </div>
//                 <div className="text-sm text-gray-600">
//                   Vol {segment.number}
//                 </div>
//                 <div
//                   className={`text-xs px-2 py-1 rounded-full mt-1 ${
//                     request.searchParams?.travelClass === "BUSINESS"
//                       ? "bg-purple-100 text-purple-700"
//                       : "bg-blue-100 text-blue-700"
//                   }`}
//                 >
//                   {request.searchParams?.travelClass === "BUSINESS"
//                     ? "Affaires"
//                     : "Économique"}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       ));
//     }
//   };
//   const [travelersData, setTravelersData] = useState([]);
//   const [currentRequestId, setCurrentRequestId] = useState(null);
//   const [editingTravelers, setEditingTravelers] = useState(false);
//   // Rendu des voyageurs si existants
//   const handleEditTravelers = useCallback((request) => {
//     setCurrentRequestId(request.id);

//     const totalPassengers =
//       parseInt(request.searchParams?.adults || 1) +
//       parseInt(request.searchParams?.children || 0) +
//       parseInt(request.searchParams?.infants || 0);

//     let initialTravelers = [];

//     if (request.travelers && request.travelers.length > 0) {
//       initialTravelers = [...request.travelers];
//     } else {
//       for (let i = 0; i < totalPassengers; i++) {
//         let passengerType = "ADULT";
//         if (i >= parseInt(request.searchParams?.adults || 1)) {
//           if (
//             i <
//             parseInt(request.searchParams?.adults || 1) +
//               parseInt(request.searchParams?.children || 0)
//           ) {
//             passengerType = "CHILD";
//           } else {
//             passengerType = "INFANT";
//           }
//         }

//         initialTravelers.push({
//           type: passengerType,
//           nom: "",
//           prenom: "",
//           datenaissance: "",
//           numero_passeport: "",
//           dateExpirationp: "",
//           numero_piece: "",
//           numero_siege: "",
//           passenger_index: i,
//         });
//       }
//     }

//     setTravelersData(initialTravelers);
//     setEditingTravelers(true);
//   }, []);

//   // Rendu des voyageurs - version complètement réécrite
//   const renderTravelers = () => {
//     // Extraction des données depuis searchParams
//     console.log("LA DONNEE", request);
//     const adults = parseInt(request.searchParams?.adults || 0);
//     const children = parseInt(request.searchParams?.children || 0);
//     const infants = parseInt(request.searchParams?.infants || 0);
//     const totalTravelers = adults + children + infants;

//     // Si aucun voyageur n'est défini
//     if (totalTravelers === 0) {
//       return (
//         <div className="text-center py-8 text-gray-500 bg-gray-50 rounded-lg border border-gray-200">
//           <Users className="w-16 h-16 mx-auto mb-4 text-gray-300" />
//           <p className="text-lg font-medium text-gray-600">
//             Aucun voyageur défini
//           </p>
//           <p className="text-sm mt-2">
//             Les informations des voyageurs n'ont pas été spécifiées
//           </p>
//         </div>
//       );
//     }

//     return (
//       <div className="space-y-6">
//         {/* En-tête du résumé */}
//         <div className="bg-blue-50 rounded-lg border border-blue-200 p-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center">
//               <Users className="w-5 h-5 text-blue-600 mr-2" />
//               <h5 className="font-semibold text-blue-800">
//                 Résumé des voyageurs
//               </h5>
//             </div>
//             <div className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
//               {totalTravelers} voyageur{totalTravelers > 1 ? "s" : ""}
//             </div>
//           </div>
//         </div>

//         {/* Cartes des types de voyageurs */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//           {/* Adultes */}
//           {adults > 0 && (
//             <div className="bg-white rounded-lg border border-blue-200 p-4 shadow-sm">
//               <div className="flex items-center justify-between mb-3">
//                 <div className="flex items-center">
//                   <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
//                     <User className="w-5 h-5 text-blue-600" />
//                   </div>
//                   <span className="ml-3 font-semibold text-gray-800">
//                     Adultes
//                   </span>
//                 </div>
//                 <span className="text-2xl font-bold text-blue-600">
//                   {adults}
//                 </span>
//               </div>
//               <div className="text-sm text-gray-600">
//                 <div className="flex items-center">
//                   <CheckCircle className="w-4 h-4 text-green-500 mr-1" />
//                   <span>12 ans et plus</span>
//                 </div>
//                 <div className="flex items-center mt-1">
//                   <CheckCircle className="w-4 h-4 text-green-500 mr-1" />
//                   <span>Tarif standard</span>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Enfants */}
//           {children > 0 && (
//             <div className="bg-white rounded-lg border border-green-200 p-4 shadow-sm">
//               <div className="flex items-center justify-between mb-3">
//                 <div className="flex items-center">
//                   <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
//                     <User className="w-5 h-5 text-green-600" />
//                   </div>
//                   <span className="ml-3 font-semibold text-gray-800">
//                     Enfants
//                   </span>
//                 </div>
//                 <span className="text-2xl font-bold text-green-600">
//                   {children}
//                 </span>
//               </div>
//               <div className="text-sm text-gray-600">
//                 <div className="flex items-center">
//                   <CheckCircle className="w-4 h-4 text-green-500 mr-1" />
//                   <span>2 à 11 ans</span>
//                 </div>
//                 <div className="flex items-center mt-1">
//                   <CheckCircle className="w-4 h-4 text-green-500 mr-1" />
//                   <span>Tarif réduit</span>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Bébés */}
//           {infants > 0 && (
//             <div className="bg-white rounded-lg border border-pink-200 p-4 shadow-sm">
//               <div className="flex items-center justify-between mb-3">
//                 <div className="flex items-center">
//                   <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center">
//                     <User className="w-5 h-5 text-pink-600" />
//                   </div>
//                   <span className="ml-3 font-semibold text-gray-800">
//                     Bébés
//                   </span>
//                 </div>
//                 <span className="text-2xl font-bold text-pink-600">
//                   {infants}
//                 </span>
//               </div>
//               <div className="text-sm text-gray-600">
//                 <div className="flex items-center">
//                   <CheckCircle className="w-4 h-4 text-green-500 mr-1" />
//                   <span>Moins de 2 ans</span>
//                 </div>
//                 <div className="flex items-center mt-1">
//                   <CheckCircle className="w-4 h-4 text-green-500 mr-1" />
//                   <span>Sur les genoux</span>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Section informations détaillées manquantes */}
//         {(!request.travelers || request.travelers.length === 0) && (
//           <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
//             <div className="flex items-start">
//               <Info className="w-5 h-5 text-amber-600 mr-3 mt-0.5 flex-shrink-0" />
//               <div>
//                 <p className="font-medium text-amber-800 mb-2">
//                   Informations détaillées manquantes
//                 </p>
//                 <p className="text-amber-700 text-sm">
//                   Les noms, prénoms et informations personnelles des voyageurs
//                   n'ont pas encore été saisis. Pour compléter ces informations,
//                   veuillez utiliser le bouton "Saisir voyageurs".
//                 </p>
//                 <div className="mt-3">
//                   <button
//                     onClick={() => onEditTravelers(request)}
//                     className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 flex items-center"
//                   >
//                     <Users className="w-4 h-4 mr-2" />
//                     Saisir les voyageurs
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Affichage des voyageurs détaillés si disponibles */}
//         {request.travelers && request.travelers.length > 0 && (
//           <div className="bg-white rounded-lg border border-gray-200 p-4">
//             <h5 className="font-semibold text-lg mb-4 text-gray-800 flex items-center">
//               <UserCheck className="w-5 h-5 mr-2 text-green-600" />
//               Voyageurs détaillés
//             </h5>
//             <div className="space-y-3">
//               {request.travelers.map((traveler, index) => (
//                 <div
//                   key={index}
//                   className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
//                 >
//                   <div className="flex items-center space-x-3">
//                     <div
//                       className={`w-8 h-8 rounded-full flex items-center justify-center ${
//                         traveler.type === "ADULT"
//                           ? "bg-blue-100 text-blue-600"
//                           : traveler.type === "CHILD"
//                           ? "bg-green-100 text-green-600"
//                           : "bg-pink-100 text-pink-600"
//                       }`}
//                     >
//                       <User className="w-4 h-4" />
//                     </div>
//                     <div>
//                       <div className="font-medium">
//                         {traveler.prenom} {traveler.nom?.toUpperCase()}
//                       </div>
//                       <div className="text-sm text-gray-600">
//                         {traveler.type === "ADULT"
//                           ? "Adulte"
//                           : traveler.type === "CHILD"
//                           ? "Enfant"
//                           : "Bébé"}
//                         {traveler.dateNaissance &&
//                           ` • Né(e) le ${new Date(
//                             traveler.dateNaissance
//                           ).toLocaleDateString("fr-FR")}`}
//                       </div>
//                       {traveler.numero_passeport && (
//                         <div className="text-xs text-gray-500 mt-1">
//                           Passeport: {traveler.numero_passeport}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="text-right">
//                     {traveler.numero_siege ? (
//                       <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs font-medium">
//                         Siège {traveler.numero_siege}
//                       </span>
//                     ) : (
//                       <span className="bg-gray-100 text-gray-600 px-2 py-1 rounded-full text-xs font-medium">
//                         Siège à assigner
//                       </span>
//                     )}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Récapitulatif final */}
//         <div className="bg-gray-50 rounded-lg border border-gray-200 p-4">
//           <div className="flex justify-between items-center">
//             <span className="font-semibold text-gray-700">
//               Total des voyageurs
//             </span>
//             <div className="text-right">
//               <span className="text-2xl font-bold text-blue-600">
//                 {totalTravelers}
//               </span>
//               <div className="text-sm text-gray-600">
//                 {adults > 0 && `${adults} adulte(s)`}
//                 {children > 0 && `, ${children} enfant(s)`}
//                 {infants > 0 && `, ${infants} bébé(s)`}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow duration-200">
//       <div className="p-6">
//         {/* En-tête de la carte */}
//         <div className="flex justify-between items-start mb-6">
//           <div className="flex-1">
//             <div className="flex items-center space-x-3 mb-3">
//               <h3 className="text-xl font-bold text-gray-900">
//                 N° {request.numeroRequete}
//               </h3>
//               {isMultiFlight && (
//                 <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm font-semibold">
//                   Multi-vols ({flightCount} vols)
//                 </span>
//               )}
//               <span
//                 className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(
//                   request.statut
//                 )}`}
//               >
//                 {request.statut}
//               </span>
//             </div>

//             <div className="flex items-center space-x-4 text-sm text-gray-600">
//               <div className="flex items-center">
//                 <Clock className="w-4 h-4 mr-1" />
//                 <span>
//                   Créée le{" "}
//                   {new Date(request.createdAt).toLocaleDateString("fr-FR")}
//                 </span>
//               </div>
//               <div className="flex items-center">
//                 <User className="w-4 h-4 mr-1" />
//                 <span>
//                   {request.prenom} {request.nom}
//                 </span>
//               </div>
//             </div>
//           </div>

//           <div className="text-right">
//             <p className="text-sm text-gray-600 mb-1">Montant total</p>
//             <p className="text-2xl font-bold text-blue-600">
//               {request.montant} {request.devise}
//             </p>
//           </div>
//         </div>

//         {/* Informations principales */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
//           <div className="space-y-2">
//             <div className="flex items-center text-sm text-gray-500">
//               <MapPin className="w-4 h-4 mr-2" />
//               <span className="font-medium">Trajet</span>
//             </div>
//             <p className="font-semibold text-gray-900">
//               {request.searchParams?.originLocationCode} →{" "}
//               {request.searchParams?.destinationLocationCode}
//             </p>
//             {request.searchParams?.departureDate && (
//               <p className="text-sm text-gray-600">
//                 Départ:{" "}
//                 {new Date(
//                   request.searchParams.departureDate
//                 ).toLocaleDateString("fr-FR")}
//               </p>
//             )}
//           </div>

//           <div className="space-y-2">
//             <div className="flex items-center text-sm text-gray-500">
//               <User className="w-4 h-4 mr-2" />
//               <span className="font-medium">Demandeur</span>
//             </div>
//             <p className="font-semibold text-gray-900">{request.fonction}</p>
//             <p className="text-sm text-gray-600">{request.matricule}</p>
//           </div>

//           <div className="space-y-2">
//             <div className="flex items-center text-sm text-gray-500">
//               <FileText className="w-4 h-4 mr-2" />
//               <span className="font-medium">Objet</span>
//             </div>
//             <p className="font-semibold text-gray-900">{request.objetVoyage}</p>
//             <p className="text-sm text-gray-600">{request.categorie}</p>
//           </div>
//         </div>

//         {/* Motif de déplacement */}
//         <div className="bg-blue-50 rounded-lg p-4 mb-6 border border-blue-100">
//           <p className="text-sm text-blue-800">
//             <span className="font-semibold">Motif du déplacement:</span>{" "}
//             {request.motifDeplacement}
//           </p>
//         </div>

//         {/* Actions */}
//         <div className="flex flex-wrap gap-3">
//           {request.statut === "En attente" && (
//             <>
//               <button
//                 onClick={() => handleApproveFligth(request.id)}
//                 className="px-5 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center transition-colors duration-200 font-medium"
//               >
//                 <CheckCircle className="w-4 h-4 mr-2" />
//                 Approuver
//               </button>
//               <button
//                 onClick={() => handleRejectFligth(request.id)}
//                 className="px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center transition-colors duration-200 font-medium"
//               >
//                 <X className="w-4 h-4 mr-2" />
//                 Rejeter
//               </button>
//             </>
//           )}

//           {request.statut === "Approuvée" && (
//             <>
//               <button
//                 onClick={() => handleEditTravelers(request)}
//                 className="px-5 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center transition-colors duration-200 font-medium"
//               >
//                 <Users className="w-4 h-4 mr-2" />
//                 Saisir voyageurs
//               </button>
//               <button
//                 onClick={() => onEmitTicket(request.id)}
//                 className="px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center transition-colors duration-200 font-medium"
//               >
//                 <FileText className="w-4 h-4 mr-2" />
//                 Émettre billet
//               </button>
//             </>
//           )}

//           {request.statut === "Billet émis" && (
//             <button
//               onClick={() => handleDownloadTicket(request)}
//               className="px-5 py-2.5 bg-gray-600 text-white rounded-lg hover:bg-gray-700 flex items-center transition-colors duration-200 font-medium"
//             >
//               <Eye className="w-4 h-4 mr-2" />
//               Télécharger billet
//             </button>
//           )}

//           <button
//             onClick={() => onDelete(request.id)}
//             className="px-5 py-2.5 border border-red-300 text-red-600 rounded-lg hover:bg-red-50 flex items-center transition-colors duration-200 font-medium"
//           >
//             <Trash2 className="w-4 h-4 mr-2" />
//             Supprimer
//           </button>

//           <button
//             onClick={() =>
//               onExpand(expandedRequest === request.id ? null : request.id)
//             }
//             className="px-5 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center transition-colors duration-200 font-medium"
//           >
//             {expandedRequest === request.id ? (
//               <>
//                 <ChevronDown className="w-4 h-4 mr-2" />
//                 Masquer détails
//               </>
//             ) : (
//               <>
//                 <ChevronRight className="w-4 h-4 mr-2" />
//                 Voir détails
//               </>
//             )}
//           </button>
//         </div>
//       </div>

//       {/* Section détails expandable */}
//       {expandedRequest === request.id && (
//         <div className="border-t border-gray-200 bg-gray-50 p-6">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//             {/* Détails des vols */}
//             <div>
//               <h4 className="font-bold text-lg mb-4 flex items-center">
//                 <Plane className="w-5 h-5 mr-2 text-blue-600" />
//                 Détails du vol
//               </h4>
//               {renderFlightDetails()}
//             </div>

//             {/* Voyageurs */}
//             <div>
//               <h4 className="font-bold text-lg mb-4 flex items-center">
//                 <Users className="w-5 h-5 mr-2 text-green-600" />
//                 Voyageurs {request.travelers && `(${request.travelers.length})`}
//               </h4>
//               {renderTravelers()}

//               {/* Informations supplémentaires */}
//               <div className="mt-6 space-y-3">
//                 <div className="p-4 bg-white rounded-lg border">
//                   <h5 className="font-semibold mb-2">
//                     Paramètres de recherche
//                   </h5>
//                   <div className="grid grid-cols-2 gap-2 text-sm">
//                     <div>
//                       <span className="text-gray-600">Classe:</span>{" "}
//                       <span className="font-medium">
//                         {request.searchParams?.travelClass === "BUSINESS"
//                           ? "Affaires"
//                           : "Économique"}
//                       </span>
//                     </div>
//                     <div>
//                       <span className="text-gray-600">Adultes:</span>{" "}
//                       <span className="font-medium">
//                         {request.searchParams?.adults || 1}
//                       </span>
//                     </div>
//                     <div>
//                       <span className="text-gray-600">Enfants:</span>{" "}
//                       <span className="font-medium">
//                         {request.searchParams?.children || 0}
//                       </span>
//                     </div>
//                     <div>
//                       <span className="text-gray-600">Bébés:</span>{" "}
//                       <span className="font-medium">
//                         {request.searchParams?.infants || 0}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

const SeatMap1 = React.memo(
  ({ selectedSeat, onSeatSelect, travelClass, passengerType, onClose }) => {
    const rows = ["A", "B", "C", "D", "E", "F"];
    const [hoveredSeat, setHoveredSeat] = useState(null);
    const [occupiedSeats] = useState(() => {
      // Simulation de sièges occupés (dans la réalité, ça viendrait de l'API)
      const occupied = new Set();
      for (let i = 0; i < 20; i++) {
        const row = rows[Math.floor(Math.random() * rows.length)];
        const num = Math.floor(Math.random() * 6) + 1;
        occupied.add(`${row}${num}`);
      }
      return occupied;
    });

    const handleSeatClick = (seatId) => {
      onSeatSelect(seatId);
      setTimeout(() => onClose(), 200); // Fermer le modal après sélection
    };

    const getSeatStatus = (seatId) => {
      if (selectedSeat === seatId) return "selected";
      if (occupiedSeats.has(seatId)) return "occupied";
      return "available";
    };

    const getSeatColor = (seatId) => {
      const status = getSeatStatus(seatId);
      switch (status) {
        case "selected":
          return "bg-blue-500 text-white border-blue-600 shadow-md transform scale-105";
        case "occupied":
          return "bg-gray-300 text-gray-500 border-gray-400 cursor-not-allowed opacity-50";
        default:
          return "bg-green-50 text-green-700 border-green-500 hover:bg-green-100 hover:shadow-md hover:scale-105";
      }
    };

    const getPassengerTypeIcon = (type) => {
      switch (type) {
        case "Adulte":
          return "👤";
        case "Enfant":
          return "👦";
        case "Bébé":
          return "👶";
        default:
          return "👤";
      }
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
        <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            {/* En-tête */}
            <div className="flex justify-between items-center mb-6">
              <div>
                <h3 className="text-xl font-bold text-gray-900 flex items-center">
                  <Plane className="w-5 h-5 mr-2" />
                  Sélection du siège
                </h3>
                <p className="text-sm text-gray-600 mt-1">
                  Cabine {travelClass} • {getPassengerTypeIcon(passengerType)}{" "}
                  {passengerType}
                </p>
              </div>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Légende */}
            <div className="flex justify-center space-x-6 mb-6 text-sm">
              <div className="flex items-center">
                <div className="w-4 h-4 bg-green-50 border-2 border-green-500 rounded mr-2"></div>
                <span>Disponible</span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-blue-500 rounded mr-2"></div>
                <span>Sélectionné</span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-gray-300 rounded mr-2"></div>
                <span>Occupé</span>
              </div>
            </div>

            {/* Plan de cabine */}
            <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
              {/* Cockpit */}
              <div className="text-center mb-6">
                <div className="w-20 h-8 bg-gradient-to-t from-gray-400 to-gray-500 rounded-t-full mx-auto"></div>
                <span className="text-xs text-gray-500 font-semibold">
                  COCKPIT
                </span>
              </div>

              {/* Numéros de colonnes */}
              <div className="flex justify-center mb-2">
                <div className="w-[140px] mr-8 flex justify-around">
                  <span className="text-xs font-bold text-gray-600 w-10 text-center">
                    1
                  </span>
                  <span className="text-xs font-bold text-gray-600 w-10 text-center">
                    2
                  </span>
                  <span className="text-xs font-bold text-gray-600 w-10 text-center">
                    3
                  </span>
                </div>
                <div className="w-12"></div>
                <div className="w-[140px] ml-8 flex justify-around">
                  <span className="text-xs font-bold text-gray-600 w-10 text-center">
                    4
                  </span>
                  <span className="text-xs font-bold text-gray-600 w-10 text-center">
                    5
                  </span>
                  <span className="text-xs font-bold text-gray-600 w-10 text-center">
                    6
                  </span>
                </div>
              </div>

              {/* Rangées de sièges */}
              {["A", "B", "C", "D", "E", "F", "G", "H"].map((row) => (
                <div
                  key={row}
                  className="flex justify-center items-center mb-3"
                >
                  {/* Lettre de rangée gauche */}
                  <div className="w-8 text-center">
                    <span className="text-sm font-bold text-gray-600">
                      {row}
                    </span>
                  </div>

                  {/* Sièges gauche (fenêtre) */}
                  <div className="flex space-x-2 mr-4">
                    {[1, 2, 3].map((seatNum) => {
                      const seatId = `${row}${seatNum}`;
                      const status = getSeatStatus(seatId);
                      const isOccupied = status === "occupied";

                      return (
                        <button
                          key={seatNum}
                          onClick={() => !isOccupied && handleSeatClick(seatId)}
                          onMouseEnter={() =>
                            !isOccupied && setHoveredSeat(seatId)
                          }
                          onMouseLeave={() => setHoveredSeat(null)}
                          disabled={isOccupied}
                          className={`
                          w-10 h-10 rounded-lg border-2 font-semibold text-xs
                          transition-all duration-200 flex items-center justify-center
                          ${getSeatColor(seatId)}
                          ${
                            hoveredSeat === seatId && !isOccupied
                              ? "ring-2 ring-blue-300"
                              : ""
                          }
                        `}
                          title={
                            isOccupied
                              ? "Siège occupé"
                              : `Sélectionner ${seatId}`
                          }
                        >
                          {seatId}
                        </button>
                      );
                    })}
                  </div>

                  {/* Allée centrale */}
                  <div className="w-12 flex items-center justify-center">
                    <div className="h-10 w-1 bg-gray-300 rounded"></div>
                  </div>

                  {/* Sièges droite (fenêtre) */}
                  <div className="flex space-x-2 ml-4">
                    {[4, 5, 6].map((seatNum) => {
                      const seatId = `${row}${seatNum}`;
                      const status = getSeatStatus(seatId);
                      const isOccupied = status === "occupied";

                      return (
                        <button
                          key={seatNum}
                          onClick={() => !isOccupied && handleSeatClick(seatId)}
                          onMouseEnter={() =>
                            !isOccupied && setHoveredSeat(seatId)
                          }
                          onMouseLeave={() => setHoveredSeat(null)}
                          disabled={isOccupied}
                          className={`
                          w-10 h-10 rounded-lg border-2 font-semibold text-xs
                          transition-all duration-200 flex items-center justify-center
                          ${getSeatColor(seatId)}
                          ${
                            hoveredSeat === seatId && !isOccupied
                              ? "ring-2 ring-blue-300"
                              : ""
                          }
                        `}
                          title={
                            isOccupied
                              ? "Siège occupé"
                              : `Sélectionner ${seatId}`
                          }
                        >
                          {seatId}
                        </button>
                      );
                    })}
                  </div>

                  {/* Lettre de rangée droite */}
                  <div className="w-8 text-center">
                    <span className="text-sm font-bold text-gray-600">
                      {row}
                    </span>
                  </div>
                </div>
              ))}

              {/* Queue de l'avion */}
              <div className="text-center mt-6">
                <div className="w-16 h-6 bg-gradient-to-b from-gray-400 to-gray-500 rounded-b-full mx-auto"></div>
                <span className="text-xs text-gray-500 font-semibold">
                  QUEUE
                </span>
              </div>

              {/* Indications fenêtres */}
              <div className="mt-6 flex justify-center space-x-16 text-xs text-gray-500">
                <div className="text-center">
                  <div className="font-semibold">Colonnes 1-3</div>
                  <div>Côté fenêtre gauche</div>
                </div>
                <div className="text-center">
                  <div className="font-semibold">Colonnes 4-6</div>
                  <div>Côté fenêtre droite</div>
                </div>
              </div>
            </div>

            {/* Siège actuellement sélectionné */}
            <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <div className="text-center">
                <p className="text-sm text-gray-600">
                  Siège actuellement sélectionné
                </p>
                <p className="text-2xl font-bold mt-1">
                  {selectedSeat ? (
                    <span className="text-blue-600">{selectedSeat}</span>
                  ) : (
                    <span className="text-gray-400">
                      Aucun siège sélectionné
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);


// ==================== TRAVELER FORM COMPONENT ====================
// const TravelerForm2 = React.memo(
//   ({ traveler, index, travelerType, onChange, onSeatSelect, travelClass }) => {
//     const [showSeatMap, setShowSeatMap] = useState(false);

//     const handleInputChange = (field, value) => {
//       onChange(index, field, value);
//     };

//     const handleSeatSelection = (seatId) => {
     
//       onSeatSelect(index, seatId);
//       setShowSeatMap(false);
//     };

//     return (
//       <>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {/* Nom */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Nom *
//             </label>
//             <input
//               type="text"
//               value={traveler.nom || ""}
//               onChange={(e) => handleInputChange("nom", e.target.value)}
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//               placeholder="Nom de famille"
//               required
//             />
//           </div>

//           {/* Prénom */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Prénom *
//             </label>
//             <input
//               type="text"
//               value={traveler.prenom || ""}
//               onChange={(e) => handleInputChange("prenom", e.target.value)}
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//               placeholder="Prénom"
//               required
//             />
//           </div>

//           {/* Date de naissance */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Date de naissance *
//             </label>
//             <input
//               type="date"
//               value={traveler.date_naissance || ""}
//               onChange={(e) =>
//                 handleInputChange("date_naissance", e.target.value)
//               }
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//               required
//             />
//           </div>

//           {/* Numéro de passeport */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               N° Passeport *
//             </label>
//             <input
//               type="text"
//               value={traveler.numero_passeport || ""}
//               onChange={(e) =>
//                 handleInputChange("numero_passeport", e.target.value)
//               }
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//               placeholder="Numéro de passeport"
//               required
//             />
//           </div>

//           {/* Date d'expiration du passeport - CORRECTION DU NOM DU CHAMP */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Expiration passeport *
//             </label>
//             <input
//               type="date"
//               value={traveler.date_expiration_passeport || ""}
//               onChange={(e) =>
//                 handleInputChange("date_expiration_passeport", e.target.value)
//               }
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//               required
//             />
//           </div>

//           {/* Sélection du siège avec plan visuel */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Siège *
//             </label>
//             <button
//               onClick={() => setShowSeatMap(true)}
//               className={`
//               w-full px-3 py-2 border rounded-lg text-left 
//               flex items-center justify-between transition-all duration-200
//               ${
//                 traveler.numero_siege
//                   ? "border-green-500 bg-green-50 hover:bg-green-100"
//                   : "border-gray-300 hover:bg-gray-50 hover:border-gray-400"
//               }
//             `}
//             >
//               <span className="flex items-center">
//                 <MapPin className="w-4 h-4 mr-2 text-gray-500" />
//                 <span
//                   className={
//                     traveler.numero_siege
//                       ? "text-gray-900 font-medium"
//                       : "text-gray-500"
//                   }
//                 >
//                   {traveler.numero_siege || "Sélectionner un siège"}
//                 </span>
//               </span>
//               <ChevronRight className="w-4 h-4 text-gray-400" />
//             </button>
//             {!traveler.numero_siege && (
//               <p className="text-xs text-red-500 mt-1">
//                 Siège obligatoire pour l'émission du billet
//               </p>
//             )}
//           </div>
//         </div>

//         {/* Modal SeatMap */}
//         {showSeatMap && (
//           <SeatMap
//             selectedSeat={traveler.numero_siege}
//             onSeatSelect={handleSeatSelection}
//             travelClass={travelClass}
//             passengerType={travelerType}
//             onClose={() => setShowSeatMap(false)}
//           />
//         )}
//       </>
//     );
//   }
// );

// // ==================== TRAVELERS REDUCER ====================
// const travelersReducer1 = (state, action) => {
//   switch (action.type) {
//     case "INIT_TRAVELERS":
//       return {
//         ...state,
//         localTravelersData: action.payload,
//         isInitialized: true,
//       };
//     case "UPDATE_TRAVELER":
//       return {
//         ...state,
//         localTravelersData: state.localTravelersData.map((traveler, i) =>
//           i === action.index
//             ? { ...traveler, [action.field]: action.value }
//             : traveler
//         ),
//       };
//     case "SELECT_SEAT":
//       return {
//         ...state,
//         localTravelersData: state.localTravelersData.map((traveler, i) =>
//           i === action.index
//             ? { ...traveler, numero_siege: action.seatId }
//             : traveler
//         ),
//       };
//     case "RESET":
//       return {
//         localTravelersData: action.payload,
//         isInitialized: false,
//       };
//     case "SET_INITIALIZED":
//       return {
//         ...state,
//         isInitialized: action.payload,
//       };
//     default:
//       return state;
//   }
// };

// // ==================== MAIN TRAVELERS MODAL ====================
// const TravelersModal1 = ({
//   isOpen = false,
//   onClose = () => {},
//   travelersData = [],
//   setTravelersData = () => {},
//   currentRequestId = null,
//   requests = [],
//   saving = false,
//   onSave = () => {},
// }) => {
//   // État géré par reducer
//   const [state, dispatch] = useReducer(travelersReducer, {
//     localTravelersData: [],
//     isInitialized: false,
//   });

//   // Calculs dérivés
//   const currentRequest = useMemo(() => {
//     if (!requests || !Array.isArray(requests) || !currentRequestId) {
//       return null;
//     }
//     return requests.find((r) => r && r.id === currentRequestId) || null;
//   }, [currentRequestId, requests]);

//   const travelersCount = useMemo(() => {
//     const defaultCount = { adults: 1, children: 0, infants: 0, total: 1 };

//     if (!currentRequest) return defaultCount;

//     try {
//       const searchParams =
//         currentRequest.vol &&
//         Array.isArray(currentRequest.vol) &&
//         currentRequest.vol.length > 0
//           ? currentRequest.vol[0].searchParams
//           : currentRequest.searchParams;

//       if (!searchParams) return defaultCount;

//       const adults = parseInt(searchParams.adults) || 1;
//       const children = parseInt(searchParams.children) || 0;
//       const infants = parseInt(searchParams.infants) || 0;

//       return {
//         adults,
//         children,
//         infants,
//         total: adults + children + infants,
//       };
//     } catch (e) {
//       return defaultCount;
//     }
//   }, [currentRequest]);

//   // Synchronisation avec les données externes - CORRIGÉ
//   useEffect(() => {
//     if (isOpen && currentRequest && !state.isInitialized) {
//       const expectedCount = travelersCount.total;

//       // Si on a déjà des données de voyageurs existantes
//       if (travelersData && travelersData.length > 0) {
//         // Utiliser les données existantes et compléter si nécessaire
//         const existingData = [...travelersData];

//         // Si on a moins de voyageurs que prévu, ajouter des voyageurs vides
//         while (existingData.length < expectedCount) {
//           existingData.push({
//             id: existingData.length + 1,
//             nom: "",
//             prenom: "",
//             date_naissance: "",
//             numero_passeport: "",
//             date_expiration_passeport: "", // Nom correct du champ
//             numero_siege: "",
//             type:
//               existingData.length < travelersCount.adults
//                 ? "ADULT"
//                 : existingData.length <
//                   travelersCount.adults + travelersCount.children
//                 ? "CHILD"
//                 : "INFANT",
//           });
//         }

//         // Si on a trop de voyageurs, couper à la taille attendue
//         if (existingData.length > expectedCount) {
//           existingData.length = expectedCount;
//         }

//         dispatch({ type: "INIT_TRAVELERS", payload: existingData });
//       } else {
//         // Créer de nouveaux voyageurs
//         const newTravelersData = [];
//         for (let i = 0; i < expectedCount; i++) {
//           let passengerType = "ADULT";
//           if (i >= travelersCount.adults) {
//             if (i < travelersCount.adults + travelersCount.children) {
//               passengerType = "CHILD";
//             } else {
//               passengerType = "INFANT";
//             }
//           }

//           newTravelersData.push({
//             id: i + 1,
//             nom: "",
//             prenom: "",
//             date_naissance: "",
//             numero_passeport: "",
//             date_expiration_passeport: "", // Nom correct du champ
//             numero_siege: "",
//             type: passengerType,
//             passenger_index: i,
//           });
//         }
//         dispatch({ type: "INIT_TRAVELERS", payload: newTravelersData });
//       }
//     }
//   }, [
//     isOpen,
//     currentRequest,
//     state.isInitialized,
//     travelersCount,
//     travelersData,
//   ]);

//   // Reset quand le modal se ferme
//   useEffect(() => {
//     if (!isOpen) {
//       dispatch({ type: "SET_INITIALIZED", payload: false });
//     }
//   }, [isOpen]);

//   // Callbacks
//   const handleTravelerChange = useCallback((index, field, value) => {
//     dispatch({ type: "UPDATE_TRAVELER", index, field, value });
//   }, []);

//   const handleSeatSelect = useCallback((travelerIndex, seatId) => {
//     dispatch({ type: "SELECT_SEAT", index: travelerIndex, seatId });
//   }, []);

//   // CORRECTION: Sauvegarder tous les passagers correctement
//   const handleSave = useCallback(async () => {
//     // Validation
//     const invalidTravelers = state.localTravelersData.filter(
//       (traveler, index) => {
//         const isInvalid =
//           !traveler.nom ||
//           !traveler.prenom ||
//           !traveler.numero_passeport ||
//           !traveler.numero_siege ||
//           !traveler.date_naissance ||
//           !traveler.date_expiration_passeport;

//         if (isInvalid) {
//           console.log(`Voyageur ${index + 1} incomplet:`, {
//             nom: !!traveler.nom,
//             prenom: !!traveler.prenom,
//             numero_passeport: !!traveler.numero_passeport,
//             numero_siege: !!traveler.numero_siege,
//             date_naissance: !!traveler.date_naissance,
//             date_expiration_passeport: !!traveler.date_expiration_passeport,
//           });
//         }

//         return isInvalid;
//       }
//     );

//     if (invalidTravelers.length > 0) {
//       alert(
//         `${invalidTravelers.length} voyageur(s) ont des champs manquants. Veuillez remplir tous les champs obligatoires (incluant le siège).`
//       );
//       return;
//     }

//     // Préparer les données pour la sauvegarde avec les informations de vol
//     const dataToSave = state.localTravelersData.map((traveler, index) => {
//       // Déterminer le type de passager
//       let passengerType = "ADULT";
//       if (index >= travelersCount.adults) {
//         if (index < travelersCount.adults + travelersCount.children) {
//           passengerType = "CHILD";
//         } else {
//           passengerType = "INFANT";
//         }
//       }

//       // Récupérer les informations de vol
//       let flightInfo = {};
//       if (currentRequest) {
//         if (currentRequest.type === "multi-flights" && currentRequest.vol) {
//           const vol = currentRequest.vol[0];
//           const firstItinerary = vol.itineraries?.[0];
//           const firstSegment = firstItinerary?.segments?.[0];
//           const lastSegment =
//             firstItinerary?.segments?.[firstItinerary.segments.length - 1];

//           flightInfo = {
//             date_depart:
//               vol.searchParams?.departureDate ||
//               firstSegment?.departure?.at?.split("T")[0],
//             date_arrivee: lastSegment?.arrival?.at?.split("T")[0],
//             heure_depart:
//               firstSegment?.departure?.at?.split("T")[1]?.substring(0, 5) || "",
//             heure_arrivee:
//               lastSegment?.arrival?.at?.split("T")[1]?.substring(0, 5) || "",
//             aeroport_depart:
//               firstSegment?.departure?.iataCode ||
//               vol.searchParams?.originLocationCode,
//             aeroport_arrivee:
//               lastSegment?.arrival?.iataCode ||
//               vol.searchParams?.destinationLocationCode,
//             numero_vol: firstSegment?.number,
//             compagnie: firstSegment?.carrierCode,
//           };
//         } else {
//           const firstItinerary = currentRequest.itineraries?.[0];
//           const firstSegment = firstItinerary?.segments?.[0];
//           const lastSegment =
//             firstItinerary?.segments?.[firstItinerary.segments.length - 1];

//           flightInfo = {
//             date_depart:
//               currentRequest.searchParams?.departureDate ||
//               firstSegment?.departure?.at?.split("T")[0],
//             date_arrivee: lastSegment?.arrival?.at?.split("T")[0],
//             heure_depart:
//               firstSegment?.departure?.at?.split("T")[1]?.substring(0, 5) || "",
//             heure_arrivee:
//               lastSegment?.arrival?.at?.split("T")[1]?.substring(0, 5) || "",
//             aeroport_depart:
//               currentRequest.searchParams?.originLocationCode ||
//               firstSegment?.departure?.iataCode,
//             aeroport_arrivee:
//               currentRequest.searchParams?.destinationLocationCode ||
//               lastSegment?.arrival?.iataCode,
//             numero_vol: firstSegment?.number,
//             compagnie: firstSegment?.carrierCode,
//           };
//         }
//       }

//       return {
//         ...traveler,
//         type: passengerType,
//         passenger_index: index,
//         ...flightInfo,
//       };
//     });

//     console.log("Données à sauvegarder:", dataToSave);

//     // Sauvegarder les données
//     setTravelersData(dataToSave);

//     // Appeler la fonction de sauvegarde du parent
//     // qui doit faire l'appel API pour sauvegarder en base de données
//     await onSave();
//   }, [
//     state.localTravelersData,
//     setTravelersData,
//     onSave,
//     currentRequest,
//     travelersCount,
//   ]);

//   const handleClose = useCallback(() => {
//     onClose();
//   }, [onClose]);

//   const getTravelerType = useCallback(
//     (index) => {
//       const defaultType = { type: "Voyageur", color: "gray", index: 1 };

//       if (typeof index !== "number" || !travelersCount) return defaultType;

//       if (index < travelersCount.adults) {
//         return { type: "Adulte", color: "blue", index: index + 1 };
//       }

//       const afterAdults = index - travelersCount.adults;
//       if (afterAdults < travelersCount.children) {
//         return { type: "Enfant", color: "green", index: afterAdults + 1 };
//       }

//       const afterChildren = afterAdults - travelersCount.children;
//       return { type: "Bébé", color: "pink", index: afterChildren + 1 };
//     },
//     [travelersCount]
//   );

//   // Constantes
//   const colorClasses = {
//     blue: { bg: "bg-blue-50", border: "border-blue-200", dot: "bg-blue-500" },
//     green: {
//       bg: "bg-green-50",
//       border: "border-green-200",
//       dot: "bg-green-500",
//     },
//     pink: { bg: "bg-pink-50", border: "border-pink-200", dot: "bg-pink-500" },
//     gray: { bg: "bg-gray-50", border: "border-gray-200", dot: "bg-gray-500" },
//   };

//   // Vérification pour le rendu
//   const shouldRender = isOpen && currentRequestId && currentRequest;

//   // Toujours retourner du JSX
//   return (
//     <div
//       className={`fixed inset-0 bg-black bg-opacity-50 items-center justify-center z-50 p-4 ${
//         shouldRender ? "flex" : "hidden"
//       }`}
//     >
//       <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
//         {/* En-tête du modal */}
//         <div className="p-6 border-b sticky top-0 bg-white z-10">
//           <div className="flex justify-between items-center">
//             <div>
//               <h3 className="text-xl font-bold text-gray-900">
//                 Saisie des voyageurs et choix des sièges
//               </h3>
//               {currentRequest && (
//                 <p className="text-gray-600 mt-1">
//                   Vol {currentRequest.searchParams?.originLocationCode || "---"}{" "}
//                   →{" "}
//                   {currentRequest.searchParams?.destinationLocationCode ||
//                     "---"}
//                   {currentRequest.searchParams?.departureDate &&
//                     ` • ${new Date(
//                       currentRequest.searchParams.departureDate
//                     ).toLocaleDateString("fr-FR")}`}
//                 </p>
//               )}
//             </div>
//             <button
//               onClick={handleClose}
//               className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
//               aria-label="Fermer"
//             >
//               <X className="w-6 h-6" />
//             </button>
//           </div>

//           {/* Résumé des voyageurs */}
//           <div className="mt-3 flex items-center space-x-4 text-sm text-gray-500">
//             <div className="flex items-center">
//               <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
//               <span>Adultes: {travelersCount.adults}</span>
//             </div>
//             {travelersCount.children > 0 && (
//               <div className="flex items-center">
//                 <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
//                 <span>Enfants: {travelersCount.children}</span>
//               </div>
//             )}
//             {travelersCount.infants > 0 && (
//               <div className="flex items-center">
//                 <div className="w-2 h-2 bg-pink-500 rounded-full mr-2"></div>
//                 <span>Bébés: {travelersCount.infants}</span>
//               </div>
//             )}
//             <div className="flex items-center ml-auto bg-gray-100 px-3 py-1 rounded-full">
//               <Users className="w-4 h-4 mr-2" />
//               <span className="font-medium">
//                 Total: {travelersCount.total} voyageurs
//               </span>
//             </div>
//           </div>

//           {/* Barre de progression */}
//           <div className="mt-4">
//             <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
//               <div
//                 className="h-full bg-green-500 transition-all duration-300"
//                 style={{
//                   width: `${
//                     (state.localTravelersData.filter(
//                       (t) =>
//                         t.nom &&
//                         t.prenom &&
//                         t.numero_passeport &&
//                         t.numero_siege &&
//                         t.date_naissance &&
//                         t.date_expiration_passeport
//                     ).length /
//                       travelersCount.total) *
//                     100
//                   }%`,
//                 }}
//               />
//             </div>
//             <p className="text-xs text-gray-500 mt-1">
//               {
//                 state.localTravelersData.filter(
//                   (t) =>
//                     t.nom &&
//                     t.prenom &&
//                     t.numero_passeport &&
//                     t.numero_siege &&
//                     t.date_naissance &&
//                     t.date_expiration_passeport
//                 ).length
//               }{" "}
//               / {travelersCount.total} voyageurs complétés
//             </p>
//           </div>
//         </div>

//         {/* Contenu principal */}
//         <div className="p-6 space-y-6">
//           {Array.isArray(state.localTravelersData) &&
//             state.localTravelersData.map((traveler, index) => {
//               const travelerType = getTravelerType(index);
//               const colors =
//                 colorClasses[travelerType.color] || colorClasses.gray;
//               const isComplete =
//                 traveler.nom &&
//                 traveler.prenom &&
//                 traveler.numero_passeport &&
//                 traveler.numero_siege &&
//                 traveler.date_naissance &&
//                 traveler.date_expiration_passeport;

//               return (
//                 <div
//                   key={`traveler-${index}`}
//                   className={`border rounded-lg overflow-hidden transition-all duration-200 ${
//                     isComplete
//                       ? "border-green-300 shadow-sm"
//                       : "border-gray-200"
//                   }`}
//                 >
//                   {/* En-tête du bloc voyageur */}
//                   <div
//                     className={`${colors.bg} border-b ${colors.border} px-4 py-3`}
//                   >
//                     <div className="flex items-center justify-between">
//                       <div className="flex items-center">
//                         <div
//                           className={`w-3 h-3 ${colors.dot} rounded-full mr-3`}
//                         ></div>
//                         <h4 className="font-bold text-gray-900">
//                           {travelerType.type} {travelerType.index}
//                         </h4>
//                         {isComplete && (
//                           <span className="ml-3 text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">
//                             ✓ Complet
//                           </span>
//                         )}
//                       </div>
//                       {traveler?.numero_siege && (
//                         <div className="bg-white px-3 py-1 rounded-full border border-gray-300">
//                           <span className="text-sm font-medium text-gray-700">
//                             Siège: {traveler.numero_siege}
//                           </span>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Formulaire du voyageur */}
//                   <div className="p-4">
//                     <TravelerForm
//                       traveler={traveler || {}}
//                       index={index}
//                       travelerType={travelerType.type}
//                       onChange={handleTravelerChange}
//                       onSeatSelect={handleSeatSelect}
//                       travelClass={
//                         currentRequest?.searchParams?.travelClass || "ECONOMY"
//                       }
//                     />
//                   </div>
//                 </div>
//               );
//             })}
//         </div>

//         {/* Pied de page */}
//         <div className="p-6 border-t bg-gray-50 sticky bottom-0">
//           <div className="flex items-center justify-between">
//             <div className="text-sm text-gray-600">
//               <p className="font-medium">* Tous les champs sont obligatoires</p>
//               <p className="text-xs mt-1">
//                 Assurez-vous que les informations correspondent exactement aux
//                 passeports
//               </p>
//             </div>
//             <div className="flex space-x-3">
//               <button
//                 onClick={handleClose}
//                 className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium"
//               >
//                 Annuler
//               </button>
//               <button
//                 onClick={handleSave}
//                 disabled={
//                   saving ||
//                   state.localTravelersData.some(
//                     (t) =>
//                       !t.nom ||
//                       !t.prenom ||
//                       !t.numero_passeport ||
//                       !t.numero_siege ||
//                       !t.date_naissance ||
//                       !t.date_expiration_passeport
//                   )
//                 }
//                 className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 font-medium flex items-center"
//               >
//                 {saving ? (
//                   <>
//                     <Loader className="w-4 h-4 mr-2 animate-spin" />
//                     Sauvegarde en cours...
//                   </>
//                 ) : (
//                   <>
//                     <Save className="w-4 h-4 mr-2" />
//                     Sauvegarder les voyageurs
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const TravelersModal3 = ({
//   isOpen = false,
//   onClose = () => {},
//   travelersData = [],
//   setTravelersData = () => {},
//   currentRequestId = null,
//   requests = [],
//   saving = false,
//   onSave = () => {},
// }) => {
//   // État géré par reducer
//   const [state, dispatch] = useReducer(travelersReducer, {
//     localTravelersData: [],
//     isInitialized: false,
//   });

//   // État pour suivre si la sauvegarde est en cours localement
//   const [localSaving, setLocalSaving] = useState(false);

//   // Calculs dérivés
//   const currentRequest = useMemo(() => {
//     if (!requests || !Array.isArray(requests) || !currentRequestId) {
//       return null;
//     }
//     return requests.find((r) => r && r.id === currentRequestId) || null;
//   }, [currentRequestId, requests]);

//   const travelersCount = useMemo(() => {
//     const defaultCount = { adults: 1, children: 0, infants: 0, total: 1 };

//     if (!currentRequest) return defaultCount;

//     try {
//       const searchParams =
//         currentRequest.vol &&
//         Array.isArray(currentRequest.vol) &&
//         currentRequest.vol.length > 0
//           ? currentRequest.vol[0].searchParams
//           : currentRequest.searchParams;

//       if (!searchParams) return defaultCount;

//       const adults = parseInt(searchParams.adults) || 1;
//       const children = parseInt(searchParams.children) || 0;
//       const infants = parseInt(searchParams.infants) || 0;

//       return {
//         adults,
//         children,
//         infants,
//         total: adults + children + infants,
//       };
//     } catch (e) {
//       return defaultCount;
//     }
//   }, [currentRequest]);

//   // Synchronisation avec les données externes - CORRIGÉ
//   useEffect(() => {
//     if (isOpen && currentRequest && !state.isInitialized) {
//       const expectedCount = travelersCount.total;

//       // Si on a déjà des données de voyageurs existantes
//       if (travelersData && travelersData.length > 0) {
//         // Utiliser les données existantes et compléter si nécessaire
//         const existingData = [...travelersData];

//         // Si on a moins de voyageurs que prévu, ajouter des voyageurs vides
//         while (existingData.length < expectedCount) {
//           existingData.push({
//             id: existingData.length + 1,
//             nom: "",
//             prenom: "",
//             date_naissance: "",
//             numero_passeport: "",
//             date_expiration_passeport: "",
//             numero_siege: "",
//             nationality: "", // NOUVEAU CHAMP
//             birthPlace: "", // NOUVEAU CHAMP
//             type:
//               existingData.length < travelersCount.adults
//                 ? "ADULT"
//                 : existingData.length <
//                   travelersCount.adults + travelersCount.children
//                 ? "CHILD"
//                 : "INFANT",
//           });
//         }

//         // Si on a trop de voyageurs, couper à la taille attendue
//         if (existingData.length > expectedCount) {
//           existingData.length = expectedCount;
//         }

//         dispatch({ type: "INIT_TRAVELERS", payload: existingData });
//       } else {
//         // Créer de nouveaux voyageurs
//         const newTravelersData = [];
//         for (let i = 0; i < expectedCount; i++) {
//           let passengerType = "ADULT";
//           if (i >= travelersCount.adults) {
//             if (i < travelersCount.adults + travelersCount.children) {
//               passengerType = "CHILD";
//             } else {
//               passengerType = "INFANT";
//             }
//           }

//           newTravelersData.push({
//             id: i + 1,
//             nom: "",
//             prenom: "",
//             date_naissance: "",
//             numero_passeport: "",
//             date_expiration_passeport: "",
//             numero_siege: "",
//             nationality: "", // NOUVEAU CHAMP
//             birthPlace: "", // NOUVEAU CHAMP
//             type: passengerType,
//             passenger_index: i,
//           });
//         }
//         dispatch({ type: "INIT_TRAVELERS", payload: newTravelersData });
//       }
//     }
//   }, [
//     isOpen,
//     currentRequest,
//     state.isInitialized,
//     travelersCount,
//     travelersData,
//   ]);

//   // Reset quand le modal se ferme
//   useEffect(() => {
//     if (!isOpen) {
//       dispatch({ type: "SET_INITIALIZED", payload: false });
//       setLocalSaving(false); // Réinitialiser l'état de sauvegarde
//     }
//   }, [isOpen]);

//   // Callbacks
//   const handleTravelerChange = useCallback((index, field, value) => {
//     dispatch({ type: "UPDATE_TRAVELER", index, field, value });
//   }, []);

//   const handleSeatSelect = useCallback((travelerIndex, seatId) => {
//     dispatch({ type: "SELECT_SEAT", index: travelerIndex, seatId });
//   }, []);

//   // CORRECTION DU BUG DE DOUBLE CLIC : Utilisation d'un état local pour la sauvegarde
//   const handleSave = useCallback(async () => {
//     // Empêcher les clics multiples
//     await onSave();
//     onClose();
//     if (localSaving || saving) {
//       console.log("Sauvegarde déjà en cours, ignore le clic");
//       return;
//     }

//     setLocalSaving(true);

//     try {
//       // Validation
//       const invalidTravelers = state.localTravelersData.filter(
//         (traveler, index) => {
//           const isInvalid =
//             !traveler.nom ||
//             !traveler.prenom ||
//             !traveler.numero_passeport ||
//             !traveler.numero_siege ||
//             !traveler.date_naissance ||
//             !traveler.date_expiration_passeport;

//           if (isInvalid) {
//             console.log(`Voyageur ${index + 1} incomplet:`, {
//               nom: !!traveler.nom,
//               prenom: !!traveler.prenom,
//               numero_passeport: !!traveler.numero_passeport,
//               numero_siege: !!traveler.numero_siege,
//               date_naissance: !!traveler.date_naissance,
//               date_expiration_passeport: !!traveler.date_expiration_passeport,
//             });
//           }

//           return isInvalid;
//         }
//       );

//       if (invalidTravelers.length > 0) {
//         alert(
//           `${invalidTravelers.length} voyageur(s) ont des champs manquants. Veuillez remplir tous les champs obligatoires (incluant le siège).`
//         );
//         return;
//       }

//       // Préparer les données pour la sauvegarde avec les informations de vol
//       const dataToSave = state.localTravelersData.map((traveler, index) => {
//         // Déterminer le type de passager
//         let passengerType = "ADULT";
//         if (index >= travelersCount.adults) {
//           if (index < travelersCount.adults + travelersCount.children) {
//             passengerType = "CHILD";
//           } else {
//             passengerType = "INFANT";
//           }
//         }

//         // Récupérer les informations de vol
//         let flightInfo = {};
//         if (currentRequest) {
//           if (currentRequest.type === "multi-flights" && currentRequest.vol) {
//             const vol = currentRequest.vol[0];
//             const firstItinerary = vol.itineraries?.[0];
//             const firstSegment = firstItinerary?.segments?.[0];
//             const lastSegment =
//               firstItinerary?.segments?.[firstItinerary.segments.length - 1];

//             flightInfo = {
//               date_depart:
//                 vol.searchParams?.departureDate ||
//                 firstSegment?.departure?.at?.split("T")[0],
//               date_arrivee: lastSegment?.arrival?.at?.split("T")[0],
//               heure_depart:
//                 firstSegment?.departure?.at?.split("T")[1]?.substring(0, 5) ||
//                 "",
//               heure_arrivee:
//                 lastSegment?.arrival?.at?.split("T")[1]?.substring(0, 5) || "",
//               aeroport_depart:
//                 firstSegment?.departure?.iataCode ||
//                 vol.searchParams?.originLocationCode,
//               aeroport_arrivee:
//                 lastSegment?.arrival?.iataCode ||
//                 vol.searchParams?.destinationLocationCode,
//               numero_vol: firstSegment?.number,
//               compagnie: firstSegment?.carrierCode,
//             };
//           } else {
//             const firstItinerary = currentRequest.itineraries?.[0];
//             const firstSegment = firstItinerary?.segments?.[0];
//             const lastSegment =
//               firstItinerary?.segments?.[firstItinerary.segments.length - 1];

//             flightInfo = {
//               date_depart:
//                 currentRequest.searchParams?.departureDate ||
//                 firstSegment?.departure?.at?.split("T")[0],
//               date_arrivee: lastSegment?.arrival?.at?.split("T")[0],
//               heure_depart:
//                 firstSegment?.departure?.at?.split("T")[1]?.substring(0, 5) ||
//                 "",
//               heure_arrivee:
//                 lastSegment?.arrival?.at?.split("T")[1]?.substring(0, 5) || "",
//               aeroport_depart:
//                 currentRequest.searchParams?.originLocationCode ||
//                 firstSegment?.departure?.iataCode,
//               aeroport_arrivee:
//                 currentRequest.searchParams?.destinationLocationCode ||
//                 lastSegment?.arrival?.iataCode,
//               numero_vol: firstSegment?.number,
//               compagnie: firstSegment?.carrierCode,
//             };
//           }
//         }

//         return {
//           ...traveler,
//           type: passengerType,
//           passenger_index: index,
//           ...flightInfo,
//         };
//       });

//       console.log("Données à sauvegarder:", dataToSave);

//       // Sauvegarder les données
//       setTravelersData(dataToSave);

//       // Appeler la fonction de sauvegarde du parent
//       // Utiliser setTimeout pour s'assurer que setTravelersData est traité
//       await new Promise((resolve) => setTimeout(resolve, 0));
//       await onSave();

//       // Fermer le modal après sauvegarde réussie
//       onClose();
//     } catch (error) {
//       console.error("Erreur lors de la sauvegarde:", error);
//       alert(
//         "Une erreur est survenue lors de la sauvegarde. Veuillez réessayer."
//       );
//     } finally {
//       setLocalSaving(false);
//     }
//   }, [
//     state.localTravelersData,
//     setTravelersData,
//     onSave,
//     onClose,
//     currentRequest,
//     travelersCount,
//     localSaving,
//     saving,
//   ]);

//   const handleClose = useCallback(() => {
//     onClose();
//   }, [onClose]);

//   const getTravelerType = useCallback(
//     (index) => {
//       const defaultType = { type: "Voyageur", color: "gray", index: 1 };

//       if (typeof index !== "number" || !travelersCount) return defaultType;

//       if (index < travelersCount.adults) {
//         return { type: "Adulte", color: "blue", index: index + 1 };
//       }

//       const afterAdults = index - travelersCount.adults;
//       if (afterAdults < travelersCount.children) {
//         return { type: "Enfant", color: "green", index: afterAdults + 1 };
//       }

//       const afterChildren = afterAdults - travelersCount.children;
//       return { type: "Bébé", color: "pink", index: afterChildren + 1 };
//     },
//     [travelersCount]
//   );

//   // Constantes
//   const colorClasses = {
//     blue: { bg: "bg-blue-50", border: "border-blue-200", dot: "bg-blue-500" },
//     green: {
//       bg: "bg-green-50",
//       border: "border-green-200",
//       dot: "bg-green-500",
//     },
//     pink: { bg: "bg-pink-50", border: "border-pink-200", dot: "bg-pink-500" },
//     gray: { bg: "bg-gray-50", border: "border-gray-200", dot: "bg-gray-500" },
//   };

//   // Vérification pour le rendu
//   const shouldRender = isOpen && currentRequestId && currentRequest;

//   // Combinaison des états de sauvegarde
//   const isSaving = localSaving || saving;

//   return (
//     <div
//       className={`fixed inset-0 bg-black bg-opacity-50 items-center justify-center z-50 p-4 ${
//         shouldRender ? "flex" : "hidden"
//       }`}
//     >
//       <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
//         {/* En-tête du modal */}
//         <div className="p-6 border-b sticky top-0 bg-white z-10">
//           <div className="flex justify-between items-center">
//             <div>
//               <h3 className="text-xl font-bold text-gray-900">
//                 Saisie des voyageurs et choix des sièges
//               </h3>
//               {currentRequest && (
//                 <p className="text-gray-600 mt-1">
//                   Vol {currentRequest.searchParams?.originLocationCode || "---"}{" "}
//                   →{" "}
//                   {currentRequest.searchParams?.destinationLocationCode ||
//                     "---"}
//                   {currentRequest.searchParams?.departureDate &&
//                     ` • ${new Date(
//                       currentRequest.searchParams.departureDate
//                     ).toLocaleDateString("fr-FR")}`}
//                 </p>
//               )}
//             </div>
//             <button
//               onClick={handleClose}
//               className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
//               aria-label="Fermer"
//               disabled={isSaving}
//             >
//               <X className="w-6 h-6" />
//             </button>
//           </div>

//           {/* Résumé des voyageurs */}
//           <div className="mt-3 flex items-center space-x-4 text-sm text-gray-500">
//             <div className="flex items-center">
//               <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
//               <span>Adultes: {travelersCount.adults}</span>
//             </div>
//             {travelersCount.children > 0 && (
//               <div className="flex items-center">
//                 <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
//                 <span>Enfants: {travelersCount.children}</span>
//               </div>
//             )}
//             {travelersCount.infants > 0 && (
//               <div className="flex items-center">
//                 <div className="w-2 h-2 bg-pink-500 rounded-full mr-2"></div>
//                 <span>Bébés: {travelersCount.infants}</span>
//               </div>
//             )}
//             <div className="flex items-center ml-auto bg-gray-100 px-3 py-1 rounded-full">
//               <Users className="w-4 h-4 mr-2" />
//               <span className="font-medium">
//                 Total: {travelersCount.total} voyageurs
//               </span>
//             </div>
//           </div>

//           {/* Barre de progression */}
//           <div className="mt-4">
//             <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
//               <div
//                 className="h-full bg-green-500 transition-all duration-300"
//                 style={{
//                   width: `${
//                     (state.localTravelersData.filter(
//                       (t) =>
//                         t.nom &&
//                         t.prenom &&
//                         t.numero_passeport &&
//                         t.numero_siege &&
//                         t.date_naissance &&
//                         t.date_expiration_passeport
//                     ).length /
//                       travelersCount.total) *
//                     100
//                   }%`,
//                 }}
//               />
//             </div>
//             <p className="text-xs text-gray-500 mt-1">
//               {
//                 state.localTravelersData.filter(
//                   (t) =>
//                     t.nom &&
//                     t.prenom &&
//                     t.numero_passeport &&
//                     t.numero_siege &&
//                     t.date_naissance &&
//                     t.date_expiration_passeport
//                 ).length
//               }{" "}
//               / {travelersCount.total} voyageurs complétés
//             </p>
//           </div>
//         </div>

//         {/* Contenu principal */}
//         <div className="p-6 space-y-6">
//           {Array.isArray(state.localTravelersData) &&
//             state.localTravelersData.map((traveler, index) => {
//               const travelerType = getTravelerType(index);
//               const colors =
//                 colorClasses[travelerType.color] || colorClasses.gray;
//               const isComplete =
//                 traveler.nom &&
//                 traveler.prenom &&
//                 traveler.numero_passeport &&
//                 traveler.numero_siege &&
//                 traveler.date_naissance &&
//                 traveler.date_expiration_passeport;

//               return (
//                 <div
//                   key={`traveler-${index}`}
//                   className={`border rounded-lg overflow-hidden transition-all duration-200 ${
//                     isComplete
//                       ? "border-green-300 shadow-sm"
//                       : "border-gray-200"
//                   }`}
//                 >
//                   {/* En-tête du bloc voyageur */}
//                   <div
//                     className={`${colors.bg} border-b ${colors.border} px-4 py-3`}
//                   >
//                     <div className="flex items-center justify-between">
//                       <div className="flex items-center">
//                         <div
//                           className={`w-3 h-3 ${colors.dot} rounded-full mr-3`}
//                         ></div>
//                         <h4 className="font-bold text-gray-900">
//                           {travelerType.type} {travelerType.index}
//                         </h4>
//                         {isComplete && (
//                           <span className="ml-3 text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">
//                             ✓ Complet
//                           </span>
//                         )}
//                       </div>
//                       {traveler?.numero_siege && (
//                         <div className="bg-white px-3 py-1 rounded-full border border-gray-300">
//                           <span className="text-sm font-medium text-gray-700">
//                             Siège: {traveler.numero_siege}
//                           </span>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Formulaire du voyageur */}
//                   <div className="p-4">
//                     <TravelerForm
//                       traveler={traveler || {}}
//                       index={index}
//                       travelerType={travelerType.type}
//                       onChange={handleTravelerChange}
//                       onSeatSelect={handleSeatSelect}
//                       travelClass={
//                         currentRequest?.searchParams?.travelClass || "ECONOMY"
//                       }
//                       // NOUVEAUX PROPS POUR LES CHAMPS AJOUTÉS
//                       showNationality={true}
//                       showBirthPlace={true}
//                     />
//                   </div>
//                 </div>
//               );
//             })}
//         </div>

//         {/* Pied de page */}
//         <div className="p-6 border-t bg-gray-50 sticky bottom-0">
//           <div className="flex items-center justify-between">
//             <div className="text-sm text-gray-600">
//               <p className="font-medium">
//                 * Tous les champs sont obligatoires sauf nationalité et lieu de
//                 naissance
//               </p>
//               <p className="text-xs mt-1">
//                 Assurez-vous que les informations correspondent exactement aux
//                 passeports
//               </p>
//             </div>
//             <div className="flex space-x-3">
//               <button
//                 onClick={handleClose}
//                 disabled={isSaving}
//                 className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 font-medium"
//               >
//                 Annuler
//               </button>
//               <button
//                 onClick={handleSave}
//                 disabled={
//                   isSaving ||
//                   state.localTravelersData.some(
//                     (t) =>
//                       !t.nom ||
//                       !t.prenom ||
//                       !t.numero_passeport ||
//                       !t.numero_siege ||
//                       !t.date_naissance ||
//                       !t.date_expiration_passeport
//                   )
//                 }
//                 className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 font-medium flex items-center"
//               >
//                 {isSaving ? (
//                   <>
//                     <Loader className="w-4 h-4 mr-2 animate-spin" />
//                     Sauvegarde en cours...
//                   </>
//                 ) : (
//                   <>
//                     <Save className="w-4 h-4 mr-2" />
//                     Sauvegarder les voyageurs
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// Sous-composant SeatMap
// const SeatMap2 = React.memo(
//   ({ selectedSeat, onSeatSelect, travelClass, passengerType }) => {
//     const rows = ["A", "B", "C", "D", "E", "F"];
//     const [hoveredSeat, setHoveredSeat] = useState(null);

//     const handleSeatClick = (seatId) => {
//       onSeatSelect(seatId);
//     };

//     const getSeatStatus = (seatId) => {
//       if (selectedSeat === seatId) return "selected";
//       // Simulation d'occupation aléatoire (dans la réalité, ça viendrait de l'API)
//       const isOccupied = Math.random() > 0.7;
//       return isOccupied ? "occupied" : "available";
//     };

//     const getSeatColor = (seatId) => {
//       const status = getSeatStatus(seatId);
//       switch (status) {
//         case "selected":
//           return "bg-blue-500 text-white border-blue-600 shadow-md transform scale-105";
//         case "occupied":
//           return "bg-gray-300 text-gray-500 border-gray-400 cursor-not-allowed";
//         default:
//           return "bg-green-500 text-white border-green-600 hover:bg-green-600 hover:shadow-md";
//       }
//     };

//     const getPassengerTypeIcon = (type) => {
//       switch (type) {
//         case "ADULT":
//           return "👤";
//         case "CHILD":
//           return "👦";
//         case "INFANT":
//           return "👶";
//         default:
//           return "👤";
//       }
//     };

//     return (
//       <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
//         {/* En-tête de la cabine */}
//         <div className="flex justify-between items-center mb-6">
//           <div>
//             <h6 className="font-semibold text-gray-900">
//               Cabine {travelClass}
//             </h6>
//             <p className="text-sm text-gray-600">
//               {getPassengerTypeIcon(passengerType)}{" "}
//               {passengerType === "ADULT"
//                 ? "Adulte"
//                 : passengerType === "CHILD"
//                 ? "Enfant"
//                 : "Bébé"}
//             </p>
//           </div>
//           <div className="flex space-x-4 text-xs">
//             <div className="flex items-center">
//               <div className="w-3 h-3 bg-green-500 rounded mr-2"></div>
//               <span>Disponible</span>
//             </div>
//             <div className="flex items-center">
//               <div className="w-3 h-3 bg-blue-500 rounded mr-2"></div>
//               <span>Sélectionné</span>
//             </div>
//             <div className="flex items-center">
//               <div className="w-3 h-3 bg-gray-300 rounded mr-2"></div>
//               <span>Occupé</span>
//             </div>
//           </div>
//         </div>

//         {/* Représentation de l'avion */}
//         <div className="relative">
//           {/* Cockpit */}
//           <div className="text-center mb-4">
//             <div className="w-16 h-4 bg-gray-400 rounded-t-lg mx-auto"></div>
//             <span className="text-xs text-gray-500">Cockpit</span>
//           </div>

//           {/* Sièges */}
//           <div className="flex space-x-8 justify-center items-start">
//             {/* Fenêtre gauche */}
//             <div className="space-y-3">
//               {rows.slice(0, 3).map((row) => (
//                 <div key={row} className="flex space-x-2">
//                   {[1, 2, 3].map((seatNum) => {
//                     const seatId = `${row}${seatNum}`;
//                     const status = getSeatStatus(seatId);
//                     const isOccupied = status === "occupied";

//                     return (
//                       <button
//                         key={seatNum}
//                         onClick={() => !isOccupied && handleSeatClick(seatId)}
//                         onMouseEnter={() =>
//                           !isOccupied && setHoveredSeat(seatId)
//                         }
//                         onMouseLeave={() => setHoveredSeat(null)}
//                         disabled={isOccupied}
//                         className={`w-10 h-10 rounded-lg border-2 font-semibold transition-all duration-200 flex items-center justify-center ${getSeatColor(
//                           seatId
//                         )} ${
//                           hoveredSeat === seatId && !isOccupied
//                             ? "ring-2 ring-blue-300"
//                             : ""
//                         }`}
//                         title={
//                           isOccupied ? "Siège occupé" : `Sélectionner ${seatId}`
//                         }
//                       >
//                         {seatNum}
//                       </button>
//                     );
//                   })}
//                 </div>
//               ))}
//             </div>

//             {/* Allée */}
//             <div className="w-12 flex items-center justify-center">
//               <div className="h-32 w-1 bg-gray-300 rounded"></div>
//             </div>

//             {/* Fenêtre droite */}
//             <div className="space-y-3">
//               {rows.slice(3).map((row) => (
//                 <div key={row} className="flex space-x-2">
//                   {[4, 5, 6].map((seatNum) => {
//                     const seatId = `${row}${seatNum}`;
//                     const status = getSeatStatus(seatId);
//                     const isOccupied = status === "occupied";

//                     return (
//                       <button
//                         key={seatNum}
//                         onClick={() => !isOccupied && handleSeatClick(seatId)}
//                         onMouseEnter={() =>
//                           !isOccupied && setHoveredSeat(seatId)
//                         }
//                         onMouseLeave={() => setHoveredSeat(null)}
//                         disabled={isOccupied}
//                         className={`w-10 h-10 rounded-lg border-2 font-semibold transition-all duration-200 flex items-center justify-center ${getSeatColor(
//                           seatId
//                         )} ${
//                           hoveredSeat === seatId && !isOccupied
//                             ? "ring-2 ring-blue-300"
//                             : ""
//                         }`}
//                         title={
//                           isOccupied ? "Siège occupé" : `Sélectionner ${seatId}`
//                         }
//                       >
//                         {seatNum}
//                       </button>
//                     );
//                   })}
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Queue */}
//           <div className="text-center mt-4">
//             <div className="w-8 h-4 bg-gray-400 rounded-b-lg mx-auto"></div>
//             <span className="text-xs text-gray-500">Arrière</span>
//           </div>
//         </div>

//         {/* Statut de sélection */}
//         <div className="mt-6 p-4 bg-white rounded-lg border border-gray-200">
//           <div className="text-center">
//             <p className="text-sm text-gray-600">
//               Siège actuellement sélectionné
//             </p>
//             <p className="text-2xl font-bold text-gray-900 mt-1">
//               {selectedSeat ? (
//                 <span className="text-blue-600">{selectedSeat}</span>
//               ) : (
//                 <span className="text-gray-400">Aucun siège sélectionné</span>
//               )}
//             </p>
//             {!selectedSeat && (
//               <p className="text-xs text-red-500 mt-2">
//                 Veuillez sélectionner un siège pour ce voyageur
//               </p>
//             )}
//           </div>
//         </div>

//         {/* Légende des rangées */}
//         <div className="mt-4 flex justify-center space-x-6 text-xs text-gray-500">
//           <div className="text-center">
//             <div className="font-semibold">Rangées A-C</div>
//             <div>Fenêtre gauche</div>
//           </div>
//           <div className="text-center">
//             <div className="font-semibold">Rangées D-F</div>
//             <div>Fenêtre droite</div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// );

// ==================== WORKFLOW COMPLET FINALISATION DEMANDE ====================
const TravelDetailsStep1 = ({
  formData,
  onFormDataChange,
  setActiveStep,
  submitting,
  onFinalSubmit,
}) => {
  // Gestionnaires d'événements
  const handleMotifChange = (e) => {
    onFormDataChange("motifDeplacement", e.target.value);
  };

  const handleObjetChange = (e) => {
    onFormDataChange("objetVoyage", e.target.value);
  };

  const handleProjetChange = (e) => {
    onFormDataChange("projet", e.target.value);
  };

  const handleCentreCoutChange = (e) => {
    onFormDataChange("centreCoût", e.target.value);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-4 flex items-center">
          <FileText className="w-6 h-6 mr-2 text-blue-600" />
          Détails du Voyage
        </h3>

        <form onSubmit={onFinalSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-semibold mb-2">
              Objet du voyage *
            </label>
            <select
              value={formData.objetVoyage}
              onChange={handleObjetChange}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
              required
              disabled={submitting}
            >
              <option value="">Sélectionnez un objet de voyage</option>
              <option value="tournee-commerciale">Tournée commerciale</option>
              <option value="seminaire-formation">Séminaire / Formation</option>
              <option value="mission-technique">Mission technique</option>
              <option value="salon-conference">Salon / Conférence</option>
              <option value="visite-client">Visite client</option>
              <option value="audit-inspection">Audit / Inspection</option>
              <option value="reunion-partenaire">Réunion partenaire</option>
              <option value="recrutement">Recrutement</option>
              <option value="lancement-produit">Lancement de produit</option>
              <option value="negociation-contractuelle">
                Négociation contractuelle
              </option>
              <option value="support-technique">Support technique</option>
              <option value="formation-interne">Formation interne</option>
              <option value="team-building">Team building</option>
              <option value="visite-site">Visite de site</option>
              <option value="autre">Autre</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-semibold mb-2">
              Motif du déplacement *
            </label>
            <textarea
              value={formData.motifDeplacement}
              onChange={handleMotifChange}
              rows="3"
              className="w-full px-4 py-2 border rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
              placeholder="Décrivez le motif de votre déplacement..."
              required
              disabled={submitting}
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Projet associé
              </label>
              <select
                value={formData.projet}
                onChange={handleProjetChange}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                disabled={submitting}
              >
                <option value="">Sélectionnez un projet</option>
                <option value="projet-alpha">Projet Alpha</option>
                <option value="projet-beta">Projet Beta</option>
                <option value="projet-gamma">Projet Gamma</option>
                <option value="projet-delta">Projet Delta</option>
                <option value="expansion-regionale">Expansion Régionale</option>
                <option value="digitalisation-process">
                  Digitalisation des Processus
                </option>
                <option value="lancement-produit-2024">
                  Lancement Produit 2024
                </option>
                <option value="optimisation-couts">
                  Optimisation des Coûts
                </option>
                <option value="formation-equipe">Formation Équipe</option>
                <option value="recherche-developpement">
                  Recherche & Développement
                </option>
                <option value="aucun">Aucun projet associé</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Centre de coût
              </label>
              <select
                value={formData.centreCoût}
                onChange={handleCentreCoutChange}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                disabled={submitting}
              >
                <option value="">Sélectionnez un centre de coût</option>
                <option value="Groupe">Groupe</option>
                <option value="Direction Générale">Direction Générale</option>
                <option value="Direction SI">Direction SI</option>
                <option value="Direction RH">Direction RH</option>
                <option value="Direction Financière">
                  Direction Financière
                </option>
              </select>
            </div>
          </div>

          <div className="flex justify-between pt-4">
            <button
              type="button"
              onClick={() => setActiveStep("agent")}
              disabled={submitting}
              className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center transition disabled:opacity-50"
            >
              <ChevronLeft className="w-5 h-5 mr-2" />
              Retour
            </button>
            <button
              type="submit"
              disabled={
                submitting ||
                !formData.objetVoyage ||
                !formData.motifDeplacement
              }
              className="px-8 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 disabled:opacity-50 flex items-center transition"
            >
              {submitting ? (
                <>
                  <Loader className="w-5 h-5 mr-2 animate-spin" />
                  Soumission en cours...
                </>
              ) : (
                <>
                  <CheckCircle className="w-5 h-5 mr-2" />
                  Finaliser la demande 11
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const TravelDetailsStep11 = ({
  formData,
  onFormDataChange,
  setActiveStep,
  submitting,
  onFinalSubmit,
  onRequestSubmitted, // NOUVEAU : pour gérer la fermeture
}) => {
  // État local pour gérer la soumission de manière plus fiable
  const [localSubmitting, setLocalSubmitting] = useState(false);

  const isActuallySubmitting = localSubmitting || submitting;

  // Gestionnaires d'événements
  const handleMotifChange = (e) => {
    onFormDataChange("motifDeplacement", e.target.value);
  };

  const handleObjetChange = (e) => {
    onFormDataChange("objetVoyage", e.target.value);
  };

  const handleProjetChange = (e) => {
    onFormDataChange("projet", e.target.value);
  };

  const handleCentreCoutChange = (e) => {
    onFormDataChange("centreCoût", e.target.value);
  };

  // CORRECTION : Gestion améliorée de la soumission
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Empêcher les doubles soumissions
    if (isActuallySubmitting) {
      console.log("Soumission déjà en cours...");
      return;
    }

    // Validation des champs obligatoires
    if (!formData.objetVoyage || !formData.motifDeplacement) {
      toast.error("Veuillez remplir tous les champs obligatoires");
      return;
    }

    setLocalSubmitting(true);

    try {
      await onFinalSubmit(e);
      // Si onFinalSubmit réussit, l'état sera réinitialisé dans le parent
    } catch (error) {
      console.error("Erreur lors de la soumission du formulaire:", error);
    } finally {
      // S'assurer que l'état local est toujours réinitialisé
      setLocalSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-4 flex items-center">
          <FileText className="w-6 h-6 mr-2 text-blue-600" />
          Détails du Voyage
        </h3>

        {/* CORRECTION : Utiliser handleFormSubmit au lieu de onFinalSubmit directement */}
        <form onSubmit={handleFormSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-semibold mb-2">
              Objet du voyage *
            </label>
            <select
              value={formData.objetVoyage}
              onChange={handleObjetChange}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
              required
              disabled={isActuallySubmitting}
            >
              <option value="">Sélectionnez un objet de voyage</option>
              <option value="tournee-commerciale">Tournée commerciale</option>
              <option value="seminaire-formation">Séminaire / Formation</option>
              <option value="mission-technique">Mission technique</option>
              <option value="salon-conference">Salon / Conférence</option>
              <option value="visite-client">Visite client</option>
              <option value="audit-inspection">Audit / Inspection</option>
              <option value="reunion-partenaire">Réunion partenaire</option>
              <option value="recrutement">Recrutement</option>
              <option value="lancement-produit">Lancement de produit</option>
              <option value="negociation-contractuelle">
                Négociation contractuelle
              </option>
              <option value="support-technique">Support technique</option>
              <option value="formation-interne">Formation interne</option>
              <option value="team-building">Team building</option>
              <option value="visite-site">Visite de site</option>
              <option value="autre">Autre</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-semibold mb-2">
              Motif du déplacement *
            </label>
            <textarea
              value={formData.motifDeplacement}
              onChange={handleMotifChange}
              rows="3"
              className="w-full px-4 py-2 border rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
              placeholder="Décrivez le motif de votre déplacement..."
              required
              disabled={isActuallySubmitting}
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Projet associé
              </label>
              <select
                value={formData.projet}
                onChange={handleProjetChange}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                disabled={isActuallySubmitting}
              >
                <option value="">Sélectionnez un projet</option>
                <option value="projet-alpha">Projet Alpha</option>
                <option value="projet-beta">Projet Beta</option>
                <option value="projet-gamma">Projet Gamma</option>
                <option value="projet-delta">Projet Delta</option>
                <option value="expansion-regionale">Expansion Régionale</option>
                <option value="digitalisation-process">
                  Digitalisation des Processus
                </option>
                <option value="lancement-produit-2024">
                  Lancement Produit 2024
                </option>
                <option value="optimisation-couts">
                  Optimisation des Coûts
                </option>
                <option value="formation-equipe">Formation Équipe</option>
                <option value="recherche-developpement">
                  Recherche & Développement
                </option>
                <option value="aucun">Aucun projet associé</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Centre de coût
              </label>
              <select
                value={formData.centreCoût}
                onChange={handleCentreCoutChange}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                disabled={isActuallySubmitting}
              >
                <option value="">Sélectionnez un centre de coût</option>
                <option value="Groupe">Groupe</option>
                <option value="Direction Générale">Direction Générale</option>
                <option value="Direction SI">Direction SI</option>
                <option value="Direction RH">Direction RH</option>
                <option value="Direction Financière">
                  Direction Financière
                </option>
              </select>
            </div>
          </div>

          <div className="flex justify-between pt-4">
            <button
              type="button"
              onClick={() => setActiveStep("agent")}
              disabled={isActuallySubmitting}
              className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center transition disabled:opacity-50"
            >
              <ChevronLeft className="w-5 h-5 mr-2" />
              Retour
            </button>
            <button
              type="submit"
              disabled={
                isActuallySubmitting ||
                !formData.objetVoyage ||
                !formData.motifDeplacement
              }
              className="px-8 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 disabled:opacity-50 flex items-center transition"
            >
              {isActuallySubmitting ? (
                <>
                  <Loader className="w-5 h-5 mr-2 animate-spin" />
                  Soumission en cours...
                </>
              ) : (
                <>
                  <CheckCircle className="w-5 h-5 mr-2" />
                  Finaliser la demande
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


// ==================== APPLICATION PRINCIPALE ====================

// ==================== COMPOSANT SUIVI TEMPS RÉEL ====================

const RealTimeFlightTracker = ({ flight }) => {
  const [flightStatus, setFlightStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [error, setError] = useState(null);
  const [autoRefresh, setAutoRefresh] = useState(true);

  const fetchFlightStatus = async () => {
    if (!flight?.flightNumber) return;

    setLoading(true);
    setError(null);

    try {
      const status = await travelersService.getFlightStatus(
        flight.flightNumber,
        flight.departureDate
      );

      if (status) {
        setFlightStatus(status);
        setLastUpdate(new Date());

        // Mise à jour automatique du statut du voyage si le vol a atterri
        if (status.status === "landed" && flight.travelId) {
          await travelersService.updateTravelStatus(flight.travelId, "termine");
        }
      }
    } catch (error) {
      console.error("Erreur récupération statut vol:", error);
      setError("Impossible de récupérer le statut du vol");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFlightStatus();

    // Mise à jour automatique toutes les minutes si activée
    if (autoRefresh) {
      const interval = setInterval(fetchFlightStatus, 60000);
      return () => clearInterval(interval);
    }
  }, [flight, autoRefresh]);

  const getStatusColor = (status) => {
    const statusColors = {
      scheduled: "bg-blue-100 text-blue-800 border-blue-200",
      active: "bg-green-100 text-green-800 border-green-200",
      landed: "bg-gray-100 text-gray-800 border-gray-200",
      cancelled: "bg-red-100 text-red-800 border-red-200",
      delayed: "bg-yellow-100 text-yellow-800 border-yellow-200",
      diverted: "bg-orange-100 text-orange-800 border-orange-200",
    };
    return statusColors[status] || "bg-gray-100 text-gray-800 border-gray-200";
  };

  const getStatusText = (status) => {
    const statusTexts = {
      scheduled: "Programmé",
      active: "En vol",
      landed: "Atterri",
      cancelled: "Annulé",
      delayed: "Retardé",
      diverted: "Dérouté",
    };
    return statusTexts[status] || status;
  };

  const getStatusIcon = (status) => {
    const icons = {
      scheduled: Clock,
      active: Plane,
      landed: CheckCircle,
      cancelled: AlertCircle,
      delayed: Clock,
      diverted: MapPin,
    };
    const Icon = icons[status] || Clock;
    return <Icon className="w-4 h-4" />;
  };

  const formatDuration = (departure, arrival) => {
    if (!departure || !arrival) return null;

    const dep = new Date(departure);
    const arr = new Date(arrival);
    const diff = Math.abs(arr - dep);
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    return `${hours}h ${minutes}min`;
  };

  if (error) {
    return (
      <div className="bg-red-50 rounded-lg p-4 border border-red-200">
        <div className="flex items-center space-x-2">
          <AlertCircle className="w-5 h-5 text-red-600" />
          <div>
            <p className="font-semibold text-red-800">
              Vol {flight?.flightNumber}
            </p>
            <p className="text-sm text-red-600">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!flightStatus && loading) {
    return (
      <div className="bg-white rounded-lg p-4 border animate-pulse">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-semibold">Vol {flight?.flightNumber}</p>
            <p className="text-sm text-gray-600">Chargement du statut...</p>
          </div>
          <Loader className="w-5 h-5 animate-spin text-blue-600" />
        </div>
      </div>
    );
  }

  if (!flightStatus) {
    return (
      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-semibold text-gray-700">
              Vol {flight?.flightNumber}
            </p>
            <p className="text-sm text-gray-500">
              Aucune information disponible
            </p>
          </div>
          <button
            onClick={fetchFlightStatus}
            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition"
          >
            <RefreshCw className="w-4 h-4" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border hover:shadow-md transition">
      {/* En-tête avec statut */}
      <div className="p-4 border-b">
        <div className="flex justify-between items-start">
          <div className="flex-1">
            <div className="flex items-center space-x-3 mb-2">
              <p className="font-bold text-lg">
                Vol {flightStatus.flightNumber}
              </p>
              <span
                className={`px-3 py-1 rounded-full text-xs font-semibold flex items-center space-x-1 border ${getStatusColor(
                  flightStatus.status
                )}`}
              >
                {getStatusIcon(flightStatus.status)}
                <span>{getStatusText(flightStatus.status)}</span>
              </span>
            </div>

            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <MapPin className="w-4 h-4" />
              <span>
                {flightStatus.departure?.airport ||
                  flightStatus.departure?.iataCode}{" "}
                →{" "}
                {flightStatus.arrival?.airport ||
                  flightStatus.arrival?.iataCode}
              </span>
              {flightStatus.airline && (
                <span className="text-gray-500">• {flightStatus.airline}</span>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <button
              onClick={() => setAutoRefresh(!autoRefresh)}
              className={`p-2 rounded-lg transition ${
                autoRefresh
                  ? "text-green-600 bg-green-50"
                  : "text-gray-400 hover:bg-gray-50"
              }`}
              title={
                autoRefresh
                  ? "Désactiver l'actualisation auto"
                  : "Activer l'actualisation auto"
              }
            >
              <Clock className="w-4 h-4" />
            </button>
            <button
              onClick={fetchFlightStatus}
              disabled={loading}
              className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition"
              title="Actualiser maintenant"
            >
              <RefreshCw
                className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
              />
            </button>
          </div>
        </div>
      </div>

      {/* Informations de vol */}
      <div className="p-4">
        <div className="grid grid-cols-2 gap-6">
          {/* Départ */}
          <div className="space-y-3">
            <div>
              <p className="text-xs text-gray-500 uppercase font-semibold mb-1">
                Départ
              </p>
              <div className="space-y-1">
                <p className="text-2xl font-bold">
                  {flightStatus.departure?.scheduledTime
                    ? new Date(
                        flightStatus.departure.scheduledTime
                      ).toLocaleTimeString("fr-FR", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "--:--"}
                </p>
                {flightStatus.departure?.actualTime && (
                  <p className="text-sm text-green-600">
                    Réel:{" "}
                    {new Date(
                      flightStatus.departure.actualTime
                    ).toLocaleTimeString("fr-FR", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                )}
                {flightStatus.departure?.terminal && (
                  <p className="text-sm text-gray-600">
                    Terminal {flightStatus.departure.terminal}
                    {flightStatus.departure?.gate &&
                      ` • Porte ${flightStatus.departure.gate}`}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Arrivée */}
          <div className="space-y-3">
            <div>
              <p className="text-xs text-gray-500 uppercase font-semibold mb-1">
                Arrivée
              </p>
              <div className="space-y-1">
                <p className="text-2xl font-bold">
                  {flightStatus.arrival?.scheduledTime
                    ? new Date(
                        flightStatus.arrival.scheduledTime
                      ).toLocaleTimeString("fr-FR", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "--:--"}
                </p>
                {flightStatus.arrival?.actualTime && (
                  <p className="text-sm text-green-600">
                    Réel:{" "}
                    {new Date(
                      flightStatus.arrival.actualTime
                    ).toLocaleTimeString("fr-FR", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                )}
                {flightStatus.arrival?.terminal && (
                  <p className="text-sm text-gray-600">
                    Terminal {flightStatus.arrival.terminal}
                    {flightStatus.arrival?.baggage &&
                      ` • Tapis ${flightStatus.arrival.baggage}`}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Durée de vol */}
        {flightStatus.departure?.scheduledTime &&
          flightStatus.arrival?.scheduledTime && (
            <div className="mt-4 pt-4 border-t">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Durée du vol:</span>
                <span className="font-semibold">
                  {formatDuration(
                    flightStatus.departure.scheduledTime,
                    flightStatus.arrival.scheduledTime
                  )}
                </span>
              </div>
            </div>
          )}

        {/* Informations supplémentaires */}
        {(flightStatus.delay || flightStatus.aircraft) && (
          <div className="mt-4 pt-4 border-t space-y-2">
            {flightStatus.delay && (
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Retard:</span>
                <span className="font-semibold text-yellow-600">
                  {flightStatus.delay} minutes
                </span>
              </div>
            )}
            {flightStatus.aircraft && (
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Appareil:</span>
                <span className="font-semibold">{flightStatus.aircraft}</span>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Pied de page avec dernière mise à jour */}
      <div className="px-4 py-2 bg-gray-50 border-t">
        <div className="flex items-center justify-between text-xs text-gray-500">
          <span>
            Dernière mise à jour:{" "}
            {lastUpdate ? lastUpdate.toLocaleTimeString("fr-FR") : "N/A"}
          </span>
          {autoRefresh && (
            <span className="flex items-center space-x-1">
              <Clock className="w-3 h-3" />
              <span>Actualisation auto activée</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

// ==================== COMPOSANT LISTE DES VOYAGEURS ====================
// ==================== SERVICES POUR LES VOYAGEURS ====================

// Cache pour stocker les données et éviter les appels répétitifs
let travelsCache = {
  data: null,
  timestamp: null,
  ttl: 30000, // Time to live: 30 secondes
};

const travelersService = {
  // ========== MÉTHODE PRINCIPALE ==========

  /**
   * Récupère toutes les données de voyage avec billets
   * Cette méthode utilise un cache pour éviter les appels répétitifs
   */
  fetchAllTravelsWithCache: async (forceRefresh = false) => {
    try {
      const now = Date.now();

      // Vérifier si le cache est valide
      if (
        !forceRefresh &&
        travelsCache.data &&
        travelsCache.timestamp &&
        now - travelsCache.timestamp < travelsCache.ttl
      ) {
        console.log("Utilisation du cache pour les voyages");
        return travelsCache.data;
      }

      // Faire l'appel API
      console.log("Récupération des voyages depuis l'API");
      const response = await fetch(
        `${API_BASE_URL2}/travelers/all-with-tickets`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) throw new Error("Erreur récupération des voyages");

      const data = await response.json();

      // Mettre à jour le cache
      travelsCache = {
        data: data,
        timestamp: now,
        ttl: travelsCache.ttl,
      };

      return data;
    } catch (error) {
      console.error("Erreur fetchAllTravelsWithCache:", error);
      throw error;
    }
  },

  /**
   * Invalide le cache pour forcer un rechargement
   */
  invalidateCache: () => {
    travelsCache.data = null;
    travelsCache.timestamp = null;
  },

  // ========== MÉTHODES DE RÉCUPÉRATION FILTRÉE ==========

  /**
   * Récupère tous les voyages
   */
  getAllTravels: async (forceRefresh = false) => {
    try {
      const allTravels = await travelersService.fetchAllTravelsWithCache(
        forceRefresh
      );
      return allTravels || [];
    } catch (error) {
      console.error("Erreur getAllTravels:", error);
      return [];
    }
  },

  /**
   * Récupère les voyages confirmés (tous les voyages avec billets)
   */
  getConfirmedTravels: async () => {
    try {
      const allTravels = await travelersService.fetchAllTravelsWithCache();
      // Filtrer uniquement les voyages avec des billets confirmés
      return (
        allTravels.filter(
          (travel) =>
            travel.vol && travel.vol.billet && travel.vol.status !== "annule"
        ) || []
      );
    } catch (error) {
      console.error("Erreur getConfirmedTravels:", error);
      return [];
    }
  },

  /**
   * Récupère les voyages à venir
   */
  getUpcomingTravels: async () => {
    try {
      const allTravels = await travelersService.fetchAllTravelsWithCache();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return (
        allTravels.filter((travel) => {
          if (!travel.vol || !travel.vol[0].flightData.departure.at)
            return false;
          const departDate = new Date(travel.vol[0].flightData.departure.at);
          // Voyage à venir = date de départ dans le futur
          return departDate > today && travel.vol.status !== "annule";
        }) || []
      );
    } catch (error) {
      console.error("Erreur getUpcomingTravels:", error);
      return [];
    }
  },

  /**
   * Récupère les voyages en cours
   */
  getCurrentTravels: async () => {
    try {
      const allTravels = await travelersService.fetchAllTravelsWithCache();
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return (
        allTravels.filter((travel) => {
          if (!travel.vol) return false;

          const departDate = travel.vol.date_depart
            ? new Date(travel.vol.date_depart)
            : null;
          const returnDate = travel.vol.date_retour
            ? new Date(travel.vol.date_retour)
            : null;

          // Voyage en cours = date actuelle entre départ et retour
          return (
            departDate &&
            returnDate &&
            departDate <= today &&
            returnDate >= today &&
            travel.vol.status !== "annule"
          );
        }) || []
      );
    } catch (error) {
      console.error("Erreur getCurrentTravels:", error);
      return [];
    }
  },

  /**
   * Récupère les voyages terminés
   */
  getCompletedTravels: async () => {
    try {
      const allTravels = await travelersService.fetchAllTravelsWithCache();
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return (
        allTravels.filter((travel) => {
          if (!travel.vol || !travel.vol.date_retour) return false;

          const returnDate = new Date(travel.vol.date_retour);
          // Voyage terminé = date de retour passée ou statut terminé
          return (
            (returnDate < today || travel.vol.status === "termine") &&
            travel.vol.status !== "annule"
          );
        }) || []
      );
    } catch (error) {
      console.error("Erreur getCompletedTravels:", error);
      return [];
    }
  },

  // ========== FILTRAGE DES VOYAGES ==========

  /**
   * Récupère les voyages par agent
   */
  getTravelsByAgent: async (agentId) => {
    try {
      if (!agentId) throw new Error("ID agent requis");

      const allTravels = await travelersService.fetchAllTravelsWithCache();
      return (
        allTravels.filter(
          (travel) =>
            travel.agent_id === agentId ||
            (travel.agent && travel.agent.id === agentId)
        ) || []
      );
    } catch (error) {
      console.error("Erreur getTravelsByAgent:", error);
      return [];
    }
  },

  /**
   * Récupère les voyages par destination
   */
  getTravelsByDestination: async (destination) => {
    try {
      if (!destination) throw new Error("Destination requise");

      const allTravels = await travelersService.fetchAllTravelsWithCache();
      const searchTerm = destination.toLowerCase();

      return (
        allTravels.filter((travel) => {
          if (!travel.vol) return false;

          // Recherche dans différents champs de destination
          const dest = (travel.vol.destination || "").toLowerCase();
          const ville = (travel.vol.ville_destination || "").toLowerCase();
          const pays = (travel.vol.pays_destination || "").toLowerCase();
          const aeroport = (travel.vol.aeroport_arrivee || "").toLowerCase();

          return (
            dest.includes(searchTerm) ||
            ville.includes(searchTerm) ||
            pays.includes(searchTerm) ||
            aeroport.includes(searchTerm)
          );
        }) || []
      );
    } catch (error) {
      console.error("Erreur getTravelsByDestination:", error);
      return [];
    }
  },

  /**
   * Récupère les voyages par période
   */
  getTravelsByPeriod: async (startDate, endDate) => {
    try {
      if (!startDate || !endDate) throw new Error("Dates requises");

      const allTravels = await travelersService.fetchAllTravelsWithCache();
      const start = new Date(startDate);
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);

      return (
        allTravels.filter((travel) => {
          if (!travel.vol || !travel.vol.date_depart) return false;

          const departDate = new Date(travel.vol.date_depart);
          return departDate >= start && departDate <= end;
        }) || []
      );
    } catch (error) {
      console.error("Erreur getTravelsByPeriod:", error);
      return [];
    }
  },

  /**
   * Récupère les voyages par statut
   */
  getTravelsByStatus: async (status) => {
    try {
      if (!status) throw new Error("Statut requis");

      const allTravels = await travelersService.fetchAllTravelsWithCache();
      return (
        allTravels.filter(
          (travel) => travel.vol && travel.vol.status === status
        ) || []
      );
    } catch (error) {
      console.error("Erreur getTravelsByStatus:", error);
      return [];
    }
  },

  /**
   * Récupère les voyages avec retour aujourd'hui
   */
  getTodayReturns: async () => {
    try {
      const allTravels = await travelersService.fetchAllTravelsWithCache();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      return (
        allTravels.filter((travel) => {
          if (!travel.vol || !travel.vol.date_retour) return false;

          const returnDate = new Date(travel.vol.date_retour);
          return returnDate >= today && returnDate < tomorrow;
        }) || []
      );
    } catch (error) {
      console.error("Erreur getTodayReturns:", error);
      return [];
    }
  },

  // ========== GESTION DES VOYAGES (AVEC INVALIDATION DU CACHE) ==========

  /**
   * Ajoute un nouveau voyage
   */
  addTravel: async (travelData) => {
    try {
      if (!travelData) throw new Error("Données de voyage requises");

      const response = await fetch(`${API_BASE_URL2}/travelers/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(travelData),
      });

      if (!response.ok) throw new Error("Erreur ajout voyage");

      // Invalider le cache après ajout
      travelersService.invalidateCache();

      return await response.json();
    } catch (error) {
      console.error("Erreur addTravel:", error);
      throw error;
    }
  },

  /**
   * Met à jour un voyage
   */
  updateTravel: async (travelId, updateData) => {
    try {
      if (!travelId) throw new Error("ID voyage requis");
      if (!updateData) throw new Error("Données de mise à jour requises");

      const response = await fetch(
        `${API_BASE_URL2}/travelers/update/${travelId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(updateData),
        }
      );

      if (!response.ok) throw new Error("Erreur mise à jour voyage");

      // Invalider le cache après mise à jour
      travelersService.invalidateCache();

      return await response.json();
    } catch (error) {
      console.error("Erreur updateTravel:", error);
      throw error;
    }
  },

  /**
   * Met à jour le statut d'un voyage
   */
  updateTravelStatus: async (travelId, newStatus) => {
    try {
      if (!travelId) throw new Error("ID voyage requis");
      if (!newStatus) throw new Error("Nouveau statut requis");

      const validStatuses = ["a_venir", "en_cours", "termine", "annule"];
      if (!validStatuses.includes(newStatus)) {
        throw new Error(
          `Statut invalide. Statuts valides: ${validStatuses.join(", ")}`
        );
      }

      const response = await fetch(
        `${API_BASE_URL2}/travelers/status/${travelId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ status: newStatus }),
        }
      );

      if (!response.ok) throw new Error("Erreur mise à jour statut");

      // Invalider le cache après mise à jour
      travelersService.invalidateCache();

      return await response.json();
    } catch (error) {
      console.error("Erreur updateTravelStatus:", error);
      throw error;
    }
  },

  /**
   * Supprime un voyage
   */
  deleteTravel: async (travelId) => {
    try {
      if (!travelId) throw new Error("ID voyage requis");

      const response = await fetch(
        `${API_BASE_URL2}/travelers/delete/${travelId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) throw new Error("Erreur suppression voyage");

      // Invalider le cache après suppression
      travelersService.invalidateCache();

      return await response.json();
    } catch (error) {
      console.error("Erreur deleteTravel:", error);
      throw error;
    }
  },

  // ========== STATISTIQUES (CALCULÉES LOCALEMENT) ==========

  /**
   * Calcule les statistiques des voyages
   */
  isFlightInProgress(departureDateTime, arrivalDateTime) {
    // Vérifier que les paramètres sont valides
    if (!departureDateTime || !arrivalDateTime) {
      return false;
    }

    try {
      const now = new Date();
      const departure = new Date(departureDateTime);
      const arrival = new Date(arrivalDateTime);

      // Retourner true si l'heure actuelle est entre le départ et l'arrivée
      return now >= departure && now <= arrival;
    } catch (error) {
      console.error("Erreur lors du parsing des dates:", error);
      return false;
    }
  },

  getTravelStats: async () => {
    try {
      const allTravels = await travelersService.fetchAllTravelsWithCache();
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const stats = {
        total: 0,
        enCours: 0,
        aVenir: 0,
        retourPrevu: 0,
        termine: 0,
        annule: 0,
        topDestinations: [],
        averageDuration: 0,
        monthlyTravels: [],
      };

      // Calcul des destinations pour le top
      const destinationCount = {};
      let totalDuration = 0;
      let durationCount = 0;

      allTravels.forEach((travel) => {
        // Vérifier que travel.vol existe et est un tableau avec au moins un élément
        if (
          !travel.vol ||
          !Array.isArray(travel.vol) ||
          travel.vol.length === 0
        )
          return;
        if (!travel.vol[0].flightData) return;

        stats.total++;

        // Statut
        if (travel.vol[0].status === "annule" || travel.status === "annule") {
          stats.annule++;
        } else {
          // Récupérer les dates correctement
          const departureAt = travel.vol[0].flightData.departure?.at;
          const arrivalAt = travel.vol[0].flightData.arrival?.at;

          if (departureAt && arrivalAt) {
            const departDate = new Date(departureAt);
            const arrivalDate = new Date(arrivalAt);
            const now = new Date();

            // Utiliser isFlightInProgress pour vérifier si le vol est en cours
            if (travelersService.isFlightInProgress(departureAt, arrivalAt)) {
              stats.enCours++;
            }
            // Si le vol n'est pas en cours, vérifier s'il est à venir ou terminé
            else if (departDate > now) {
              stats.aVenir++;
            } else if (arrivalAt < now) {
              stats.termine++;
            }

            // Pour les retours (si vous avez un vol retour)
            if (travel.vol.length > 1 && travel.vol[1]?.flightData) {
              const returnDepartureAt = travel.vol[1].flightData.departure?.at;
              const returnArrivalAt = travel.vol[1].flightData.arrival?.at;

              if (returnArrivalAt) {
                const returnDate = new Date(returnArrivalAt);
                const inSevenDays = new Date(today);
                inSevenDays.setDate(inSevenDays.getDate() + 7);

                // Retours prévus dans les 7 prochains jours
                if (returnDate >= today && returnDate <= inSevenDays) {
                  stats.retourPrevu++;
                }

                // Calcul de la durée moyenne du voyage (aller-retour)
                const duration = Math.ceil(
                  (returnDate - departDate) / (1000 * 60 * 60 * 24)
                );
                if (duration > 0) {
                  totalDuration += duration;
                  durationCount++;
                }
              }
            } else {
              // Si pas de vol retour, calculer la durée juste pour l'aller
              const duration = Math.ceil(
                (arrivalDate - departDate) / (1000 * 60 * 60)
              );
              if (duration > 0) {
                // Convertir en heures pour un vol simple
                totalDuration += duration;
                durationCount++;
              }
            }
          }

          // Comptage des destinations
          const destination =
            travel.vol[0].flightData.arrival?.iataCode ||
            travel.vol[0].flightData.arrival?.city ||
            "Inconnu";
          destinationCount[destination] =
            (destinationCount[destination] || 0) + 1;
        }
      });

      // Calcul de la durée moyenne
      stats.averageDuration =
        durationCount > 0 ? Math.round(totalDuration / durationCount) : 0;

      // Top 5 des destinations
      stats.topDestinations = Object.entries(destinationCount)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([destination, count]) => ({ destination, count }));

      // Statistiques mensuelles (12 derniers mois)
      const monthlyData = {};
      const twelveMonthsAgo = new Date();
      twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12);

      allTravels.forEach((travel) => {
        if (
          !travel.vol ||
          !Array.isArray(travel.vol) ||
          travel.vol.length === 0
        )
          return;
        if (!travel.vol[0].flightData?.departure?.at) return;

        const departDate = new Date(travel.vol[0].flightData.departure.at);
        if (departDate >= twelveMonthsAgo) {
          const monthKey = `${departDate.getFullYear()}-${String(
            departDate.getMonth() + 1
          ).padStart(2, "0")}`;
          monthlyData[monthKey] = (monthlyData[monthKey] || 0) + 1;
        }
      });

      // Convertir en tableau pour les graphiques
      stats.monthlyTravels = Object.entries(monthlyData)
        .sort((a, b) => a[0].localeCompare(b[0]))
        .map(([month, count]) => ({ month, count }));

      return stats;
    } catch (error) {
      console.error("Erreur getTravelStats:", error);
      return {
        total: 0,
        enCours: 0,
        aVenir: 0,
        retourPrevu: 0,
        termine: 0,
        annule: 0,
        topDestinations: [],
        averageDuration: 0,
        monthlyTravels: [],
      };
    }
  },
  /**
   * Calcule les statistiques pour un agent spécifique
   */
  getAgentStats: async (agentId) => {
    try {
      if (!agentId) throw new Error("ID agent requis");

      const agentTravels = await travelersService.getTravelsByAgent(agentId);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const stats = {
        totalTravels: agentTravels.length,
        currentTravel: null,
        upcomingTravels: [],
        completedTravels: 0,
        totalDays: 0,
        mostVisitedDestination: null,
        lastTravel: null,
        nextTravel: null,
      };

      const destinationCount = {};
      let totalDuration = 0;

      agentTravels.forEach((travel) => {
        if (!travel.vol) return;

        const departDate = travel.vol.date_depart
          ? new Date(travel.vol.date_depart)
          : null;
        const returnDate = travel.vol.date_retour
          ? new Date(travel.vol.date_retour)
          : null;

        if (departDate && returnDate) {
          // Voyage en cours
          if (
            departDate <= today &&
            returnDate >= today &&
            travel.vol.status !== "annule"
          ) {
            stats.currentTravel = travel;
          }

          // Voyages à venir
          if (departDate > today && travel.vol.status !== "annule") {
            stats.upcomingTravels.push(travel);
          }

          // Voyages terminés
          if (returnDate < today || travel.vol.status === "termine") {
            stats.completedTravels++;

            // Dernier voyage
            if (
              !stats.lastTravel ||
              new Date(stats.lastTravel.vol.date_retour) < returnDate
            ) {
              stats.lastTravel = travel;
            }
          }

          // Calcul de la durée totale
          const duration = Math.ceil(
            (returnDate - departDate) / (1000 * 60 * 60 * 24)
          );
          if (duration > 0) {
            totalDuration += duration;
          }
        }

        // Comptage des destinations
        const destination =
          travel.vol.destination || travel.vol.ville_destination || "Inconnu";
        destinationCount[destination] =
          (destinationCount[destination] || 0) + 1;
      });

      // Trier les voyages à venir par date
      stats.upcomingTravels.sort(
        (a, b) => new Date(a.vol.date_depart) - new Date(b.vol.date_depart)
      );

      // Prochain voyage
      if (stats.upcomingTravels.length > 0) {
        stats.nextTravel = stats.upcomingTravels[0];
      }

      // Destination la plus visitée
      const topDestination = Object.entries(destinationCount).sort(
        (a, b) => b[1] - a[1]
      )[0];

      if (topDestination) {
        stats.mostVisitedDestination = {
          destination: topDestination[0],
          count: topDestination[1],
        };
      }

      stats.totalDays = totalDuration;

      return stats;
    } catch (error) {
      console.error("Erreur getAgentStats:", error);
      throw error;
    }
  },

  // ========== SUIVI DE VOL (TOUJOURS VIA API) ==========

  /**
   * Récupère le statut d'un vol en temps réel
   */
  getFlightStatus: async (flightNumber, date) => {
    try {
      if (!flightNumber) throw new Error("Numéro de vol requis");

      const response = await fetch(`${API_BASE_URL2}/travelers/flight-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          flightNumber: flightNumber.toUpperCase(),
          date: date || new Date().toISOString().split("T")[0],
        }),
      });

      if (!response.ok) throw new Error("Erreur récupération statut vol");
      return await response.json();
    } catch (error) {
      console.error("Erreur getFlightStatus:", error);
      throw error;
    }
  },

  // ========== UTILITAIRES ==========

  /**
   * Recherche dans tous les voyages
   */
  searchTravels: async (searchTerm) => {
    try {
      if (!searchTerm) return await travelersService.getAllTravels();

      const allTravels = await travelersService.fetchAllTravelsWithCache();
      const term = searchTerm.toLowerCase();

      return (
        allTravels.filter((travel) => {
          // Recherche dans les infos de l'agent
          if (travel.agent) {
            const agentName = `${travel.agent.nom || ""} ${
              travel.agent.prenom || ""
            }`.toLowerCase();
            if (agentName.includes(term)) return true;
          }

          // Recherche dans les infos de vol
          if (travel.vol) {
            const destination = (travel.vol.destination || "").toLowerCase();
            const ville = (travel.vol.ville_destination || "").toLowerCase();
            const pays = (travel.vol.pays_destination || "").toLowerCase();
            const numVol = (travel.vol.numero_vol || "").toLowerCase();
            const compagnie = (travel.vol.compagnie || "").toLowerCase();

            return (
              destination.includes(term) ||
              ville.includes(term) ||
              pays.includes(term) ||
              numVol.includes(term) ||
              compagnie.includes(term)
            );
          }

          return false;
        }) || []
      );
    } catch (error) {
      console.error("Erreur searchTravels:", error);
      return [];
    }
  },

  /**
   * Groupe les voyages par mois
   */
  groupTravelsByMonth: async () => {
    try {
      const allTravels = await travelersService.fetchAllTravelsWithCache();
      const grouped = {};

      allTravels.forEach((travel) => {
        if (!travel.vol || !travel.vol.date_depart) return;

        const date = new Date(travel.vol.date_depart);
        const monthKey = `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}`;

        if (!grouped[monthKey]) {
          grouped[monthKey] = [];
        }
        grouped[monthKey].push(travel);
      });

      // Trier chaque groupe par date
      Object.keys(grouped).forEach((key) => {
        grouped[key].sort(
          (a, b) => new Date(a.vol.date_depart) - new Date(b.vol.date_depart)
        );
      });

      return grouped;
    } catch (error) {
      console.error("Erreur groupTravelsByMonth:", error);
      return {};
    }
  },

  /**
   * Récupère les alertes (voyages nécessitant une attention)
   */
  getTravelAlerts: async () => {
    try {
      const allTravels = await travelersService.fetchAllTravelsWithCache();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const inThreeDays = new Date(today);
      inThreeDays.setDate(inThreeDays.getDate() + 3);

      const alerts = [];

      allTravels.forEach((travel) => {
        if (!travel.vol || travel.vol.status === "annule") return;

        const departDate = travel.vol.date_depart
          ? new Date(travel.vol.date_depart)
          : null;
        const returnDate = travel.vol.date_retour
          ? new Date(travel.vol.date_retour)
          : null;

        // Départ demain
        if (departDate && departDate >= today && departDate < tomorrow) {
          alerts.push({
            id: travel.id,
            type: "departure_tomorrow",
            message: `Départ demain pour ${travel.agent?.nom} ${travel.agent?.prenom}`,
            travel: travel,
            priority: "high",
          });
        }

        // Départ dans 3 jours
        else if (
          departDate &&
          departDate >= tomorrow &&
          departDate < inThreeDays
        ) {
          alerts.push({
            id: travel.id,
            type: "departure_soon",
            message: `Départ dans ${Math.ceil(
              (departDate - today) / (1000 * 60 * 60 * 24)
            )} jours pour ${travel.agent?.nom} ${travel.agent?.prenom}`,
            travel: travel,
            priority: "medium",
          });
        }

        // Retour aujourd'hui
        if (returnDate && returnDate >= today && returnDate < tomorrow) {
          alerts.push({
            id: travel.id,
            type: "return_today",
            message: `Retour aujourd'hui de ${travel.agent?.nom} ${travel.agent?.prenom}`,
            travel: travel,
            priority: "high",
          });
        }

        // Documents manquants (si applicable)
        if (travel.vol && !travel.vol.billet) {
          alerts.push({
            id: travel.id,
            type: "missing_ticket",
            message: `Billet manquant pour ${travel.agent?.nom} ${travel.agent?.prenom}`,
            travel: travel,
            priority: "high",
          });
        }
      });

      // Trier par priorité
      alerts.sort((a, b) => {
        const priorityOrder = { high: 0, medium: 1, low: 2 };
        return priorityOrder[a.priority] - priorityOrder[b.priority];
      });

      return alerts;
    } catch (error) {
      console.error("Erreur getTravelAlerts:", error);
      return [];
    }
  },

  /**
   * Force le rechargement des données depuis l'API
   */
  refreshData: async () => {
    travelersService.invalidateCache();
    return await travelersService.fetchAllTravelsWithCache(true);
  },
};
// ==================== COMPOSANT CARTES STATISTIQUES VOYAGEURS ====================

/////////Nouveau
const TravelersModule = () => {
  const [travels, setTravels] = useState([]);
  const [stats, setStats] = useState({
    total: 0,
    enCours: 0,
    aVenir: 0,
    retourPrevu: 0,
  });
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [error, setError] = useState(null);

  useEffect(() => {
    loadTravelsData();
  }, [activeTab]);

  const loadTravelsData = async () => {
    setLoading(true);
    setError(null);

    try {
      let travelsData = [];

      switch (activeTab) {
        case "upcoming":
          travelsData = await travelersService.getUpcomingTravels();
          break;
        case "current":
          travelsData = await travelersService.getCurrentTravels();
          break;
        case "completed":
          travelsData = await travelersService.getCompletedTravels();
          break;
        default:
          travelsData = await travelersService.getAllTravels();
      }

      // Chargement des statistiques
      const statsData = await travelersService.getTravelStats();

      setTravels(travelsData);
      setStats(statsData);
    } catch (error) {
      console.error("Erreur chargement données voyageurs:", error);
      setError("Erreur lors du chargement des données des voyageurs");
    } finally {
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (travelId, newStatus) => {
    try {
      await travelersService.updateTravelStatus(travelId, newStatus);
      await loadTravelsData(); // Recharger les données après la mise à jour
    } catch (error) {
      console.error("Erreur mise à jour statut:", error);
      setError("Erreur lors de la mise à jour du statut");
    }
  };

  // const handleAddTravel = async (travelData) => {
  //   try {
  //     await travelersService.addTravel(travelData);
  //     await loadTravelsData();
  //   } catch (error) {
  //     console.error("Erreur ajout voyage:", error);
  //     setError("Erreur lors de l'ajout du voyage");
  //   }
  // };

  const handleDeleteTravel = async (travelId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce voyage ?")) {
      try {
        await travelersService.deleteTravel(travelId);
        await loadTravelsData();
      } catch (error) {
        console.error("Erreur suppression voyage:", error);
        setError("Erreur lors de la suppression du voyage");
      }
    }
  };

  // const getTravelsByAgent = async (agentId) => {
  //   try {
  //     const agentTravels = await travelersService.getTravelsByAgent(agentId);
  //     return agentTravels;
  //   } catch (error) {
  //     console.error("Erreur récupération voyages agent:", error);
  //     return [];
  //   }
  // };

  // const getTravelsByDestination = async (destination) => {
  //   try {
  //     const destinationTravels = await travelersService.getTravelsByDestination(
  //       destination
  //     );
  //     return destinationTravels;
  //   } catch (error) {
  //     console.error("Erreur récupération voyages destination:", error);
  //     return [];
  //   }
  // };

  const tabs = [
    { id: "all", label: "Tous les voyages", icon: Users, count: stats.total },
    { id: "upcoming", label: "À venir", icon: Calendar, count: stats.aVenir },
    { id: "current", label: "En cours", icon: Plane, count: stats.enCours },
    {
      id: "completed",
      label: "Terminés",
      icon: Clock,
      count: stats.retourPrevu,
    },
  ];

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold mb-2 flex items-center">
              <Users className="w-8 h-8 mr-3 text-blue-600" />
              Gestion des Voyageurs
            </h1>
            <p className="text-gray-600">
              Suivi en temps réel des déplacements de vos agents
            </p>
          </div>
        </div>
      </div>

      {/* Affichage des erreurs */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-center">
          <AlertCircle className="w-5 h-5 text-red-600 mr-2" />
          <span className="text-red-800">{error}</span>
        </div>
      )}

      {/* Cartes statistiques */}
      <TravelersStatsCards stats={stats} loading={loading} />

      {/* Navigation par onglets */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex space-x-2 border-b overflow-x-auto">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 font-semibold flex items-center space-x-2 border-b-2 transition whitespace-nowrap ${
                  activeTab === tab.id
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-gray-600 hover:text-blue-600"
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{tab.label}</span>
                {tab.count > 0 && (
                  <span
                    className={`ml-2 px-2 py-1 text-xs rounded-full ${
                      activeTab === tab.id
                        ? "bg-blue-100 text-blue-600"
                        : "bg-gray-100 text-gray-600"
                    }`}
                  >
                    {tab.count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Contenu principal */}
      <TravelersList
        travels={travels}
        onRefresh={loadTravelsData}
        onStatusUpdate={handleStatusUpdate}
        onDelete={handleDeleteTravel}
        loading={loading}
      />
    </div>
  );
};

// Composant pour les cartes de statistiques
const TravelersStatsCards = ({ stats, loading }) => {
  const statCards = [
    {
      title: "Total voyages",
      value: stats.total || 0,
      icon: Users,
      color: "bg-blue-500",
      bgLight: "bg-blue-50",
    },
    {
      title: "En cours",
      value: stats.enCours || 0,
      icon: Plane,
      color: "bg-green-500",
      bgLight: "bg-green-50",
    },
    {
      title: "À venir",
      value: stats.aVenir || 0,
      icon: Calendar,
      color: "bg-yellow-500",
      bgLight: "bg-yellow-50",
    },
    {
      title: "Retours prévus",
      value: stats.retourPrevu || 0,
      icon: Clock,
      color: "bg-purple-500",
      bgLight: "bg-purple-50",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statCards.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div key={index} className="bg-white rounded-lg shadow-md p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm">{stat.title}</p>
                <p className="text-2xl font-bold mt-1">
                  {loading ? "..." : stat.value}
                </p>
              </div>
              <div className={`${stat.bgLight} p-3 rounded-lg`}>
                <Icon
                  className={`w-6 h-6 ${stat.color.replace("bg-", "text-")}`}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

// Composant pour la liste des voyageurs
const TravelersList = ({
  travels,
  onRefresh,
  onStatusUpdate,
  onDelete,
  loading,
}) => {
  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-md p-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement des voyages...</p>
        </div>
      </div>
    );
  }

  if (!travels || travels.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-md p-8">
        <div className="text-center">
          <MapPin className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600">Aucun voyage trouvé</p>
          <button
            onClick={onRefresh}
            className="mt-4 text-blue-600 hover:text-blue-700"
          >
            Actualiser
          </button>
        </div>
      </div>
    );
  }

  const getStatusBadge = (status) => {
    const statusConfig = {
      en_cours: { label: "En cours", className: "bg-green-100 text-green-800" },
      a_venir: { label: "À venir", className: "bg-yellow-100 text-yellow-800" },
      termine: { label: "Terminé", className: "bg-gray-100 text-gray-800" },
      annule: { label: "Annulé", className: "bg-red-100 text-red-800" },
    };

    const config = statusConfig[status] || statusConfig["a_venir"];
    return (
      <span
        className={`px-3 py-1 rounded-full text-xs font-semibold ${config.className}`}
      >
        {config.label}
      </span>
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Voyageur
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Date départ
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Destination
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Date de départ
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Durée du vol
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Statut
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {travels.map((travel) => (
              <tr key={travel.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div>
                    <div className="text-sm font-medium text-gray-900">
                      {travel?.nom} {travel.prenom}
                    </div>
                    <div className="text-sm text-gray-500">{travel.type}</div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <MapPin className="w-4 h-4 mr-2 text-gray-400" />
                    <span className="text-sm text-gray-900">
                      {travel.vol[0].searchParams.originLocationCode}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <MapPin className="w-4 h-4 mr-2 text-gray-400" />
                    <span className="text-sm text-gray-900">
                      {travel.vol[0].searchParams.destinationLocationCode}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {new Date(
                    travel.vol[0].flightData.departure.at
                  ).toLocaleDateString("fr-FR")}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {travel.vol[0].flightData.duration}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {getStatusBadge(travel.flightRequestStatus)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <button
                    onClick={() => onStatusUpdate(travel.id, "en_cours")}
                    className="text-blue-600 hover:text-blue-900 mr-3"
                    title="Marquer en cours"
                  >
                    <Plane className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => onDelete(travel.id)}
                    className="text-red-600 hover:text-red-900"
                    title="Supprimer"
                  >
                    <AlertCircle className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="px-6 py-4 bg-gray-50 border-t">
        <div className="flex justify-between items-center">
          <p className="text-sm text-gray-700">
            {travels.length} voyage{travels.length > 1 ? "s" : ""} trouvé
            {travels.length > 1 ? "s" : ""}
          </p>
          <button
            onClick={onRefresh}
            className="text-sm text-blue-600 hover:text-blue-700"
          >
            Actualiser
          </button>
        </div>
      </div>
    </div>
  );
};
// ==================== SERVICE AUTHENTIFICATION ====================
const AUTH_SERVICE = {
  // Stockage des tokens et données utilisateur
  storage: {
    get: (key) => {
      try {
        return localStorage.getItem(key);
      } catch {
        return null;
      }
    },
    set: (key, value) => {
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        console.error("Erreur stockage:", error);
      }
    },
    remove: (key) => {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.error("Erreur suppression:", error);
      }
    },
  },

  // Vérifier si l'utilisateur est connecté
  isAuthenticated: () => {
    const token = AUTH_SERVICE.storage.get("auth_token");
    const user = AUTH_SERVICE.storage.get("auth_user");

    if (!token || !user) return false;

    try {
      const userData = JSON.parse(user);
      const tokenExpiry = AUTH_SERVICE.storage.get("auth_token_expiry");

      // Vérifier l'expiration du token
      if (tokenExpiry && Date.now() > parseInt(tokenExpiry)) {
        AUTH_SERVICE.logout();
        return false;
      }

      return !!userData.id;
    } catch {
      return false;
    }
  },

  // Obtenir l'utilisateur connecté
  getCurrentUser: () => {
    try {
      const user = AUTH_SERVICE.storage.get("auth_user");
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  },

  // Connexion
  login: async (username, password) => {
    try {
      const response = await fetch(`${API_BASE_URL2}/travel-auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Erreur de connexion");
      }

      const data = await response.json();

      if (data.success && data.token && data.user) {
        // Stocker les informations d'authentification
        AUTH_SERVICE.storage.set("auth_token", data.token);
        AUTH_SERVICE.storage.set("auth_user", JSON.stringify(data.user));
        AUTH_SERVICE.storage.set(
          "auth_token_expiry",
          (Date.now() + 24 * 60 * 60 * 1000).toString()
        ); // 24h

        return data;
      } else {
        throw new Error("Réponse d'authentification invalide");
      }
    } catch (error) {
      throw new Error(error.message || "Erreur de connexion au serveur");
    }
  },

  // Déconnexion
  logout: () => {
    AUTH_SERVICE.storage.remove("auth_token");
    AUTH_SERVICE.storage.remove("auth_user");
    AUTH_SERVICE.storage.remove("auth_token_expiry");
    window.location.href = "/login";
  },

  // Vérifier les permissions
  hasPermission: (permission) => {
    const user = AUTH_SERVICE.getCurrentUser();
    if (!user || !user.profil) return false;

    // Si l'utilisateur est admin, il a tous les droits
    if (user.profil.nom === "Administrateur") return true;

    return user.profil.droits && user.profil.droits.includes(permission);
  },

  // Vérifier plusieurs permissions
  hasAnyPermission: (permissions) => {
    return permissions.some((permission) =>
      AUTH_SERVICE.hasPermission(permission)
    );
  },

  // Vérifier toutes les permissions
  hasAllPermissions: (permissions) => {
    return permissions.every((permission) =>
      AUTH_SERVICE.hasPermission(permission)
    );
  },

  // Rafraîchir le token
  refreshToken: async () => {
    try {
      const token = AUTH_SERVICE.storage.get("auth_token");
      if (!token) throw new Error("No token available");

      const response = await fetch(`${API_BASE_URL2}/travel-auth/refresh`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        AUTH_SERVICE.storage.set("auth_token", data.token);
        AUTH_SERVICE.storage.set(
          "auth_token_expiry",
          (Date.now() + 24 * 60 * 60 * 1000).toString()
        );
        return true;
      } else {
        throw new Error("Token refresh failed");
      }
    } catch (error) {
      AUTH_SERVICE.logout();
      return false;
    }
  },

  // Intercepteur pour les requêtes API
  apiRequest: async (url, options = {}) => {
    const token = AUTH_SERVICE.storage.get("auth_token");

    const config = {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    };

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(`${API_BASE_URL2}${url}`, config);

      // Si token expiré, essayer de le rafraîchir
      if (response.status === 401) {
        const refreshed = await AUTH_SERVICE.refreshToken();
        if (refreshed) {
          // Réessayer la requête avec le nouveau token
          return AUTH_SERVICE.apiRequest(url, options);
        } else {
          AUTH_SERVICE.logout();
          throw new Error("Session expirée");
        }
      }

      return response;
    } catch (error) {
      throw error;
    }
  },
};
// ==================== COMPOSANT DE CONNEXION ====================
// const LoginPage = ({ onLogin }) => {
//   const [formData, setFormData] = useState({
//     username: '',
//     password: ''
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     try {
//       const result = await AUTH_SERVICE.login(formData.username, formData.password);

//       if (result.success) {
//         onLogin(result.user);
//       } else {
//         setError(result.message || 'Erreur de connexion');
//       }
//     } catch (error) {
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   return (

//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
//       <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md">
//         <div className="text-center mb-8">
//           <div className="mx-auto w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4">
//             <Shield className="w-8 h-8 text-white" />
//           </div>
//           <h1 className="text-2xl font-bold text-gray-900">Connexion</h1>
//           <p className="text-gray-600 mt-2">Accédez à votre espace personnel</p>
//         </div>

//         {error && (
//           <div className="mb-6 bg-red-50 border border-red-200 rounded-lg p-4">
//             <div className="flex items-center">
//               <AlertCircle className="w-5 h-5 text-red-500 mr-2" />
//               <p className="text-red-700 text-sm">{error}</p>
//             </div>
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div>
//             <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
//               Nom d'utilisateur
//             </label>
//             <input
//               id="username"
//               name="username"
//               type="text"
//               required
//               value={formData.username}
//               onChange={handleChange}
//               disabled={loading}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition disabled:opacity-50"
//               placeholder="Entrez votre nom d'utilisateur"
//             />
//           </div>

//           <div>
//             <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
//               Mot de passe
//             </label>
//             <input
//               id="password"
//               name="password"
//               type="password"
//               required
//               value={formData.password}
//               onChange={handleChange}
//               disabled={loading}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition disabled:opacity-50"
//               placeholder="Entrez votre mot de passe"
//             />
//           </div>

//           <button
//             type="submit"
//             disabled={loading}
//             className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition disabled:opacity-50 flex items-center justify-center"
//           >
//             {loading ? (
//               <>
//                 <Loader className="w-5 h-5 mr-2 animate-spin" />
//                 Connexion...
//               </>
//             ) : (
//               <>
//                 <LogIn className="w-5 h-5 mr-2" />
//                 Se connecter
//               </>
//             )}
//           </button>
//         </form>

//         <div className="mt-6 text-center">
//           <p className="text-sm text-gray-600">
//             Probleme de connexion ?{' '}
//             <a href="#" className="text-blue-600 hover:text-blue-700 font-medium">
//               Contactez l'administrateur
//             </a>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// ==================== LAYOUT PRINCIPAL AVEC NAVIGATION ====================
// const MainLayout = ({ children, user, onLogout }) => {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [activeModule, setActiveModule] = useState('dashboard');

//   const navigationItems = [
//     {
//       id: 'dashboard',
//       label: 'Tableau de bord',
//       icon: Home,
//       permission: '', // Accessible à tous
//       path: '/'
//     },
//     {
//       id: 'quick-booking-section',
//       label: 'Réservation Rapide',
//       icon: 'flash',
//       isSection: true,
//       permissions: ['direct_purchase'],
//       items: [
//         {
//           id: 'direct-flight-purchase',
//           label: '✈️ Acheter un Billet',
//           permissions: ['direct_purchase'],
//           badge: 'DIRECT'
//         },
//         {
//           id: 'direct-hotel-booking',
//           label: '🏨 Réserver un Hôtel',
//           permissions: ['direct_purchase'],
//           badge: 'DIRECT'
//         },
//         {
//           id: 'my-direct-purchases',
//           label: '📋 Mes Achats Directs',
//           permissions: ['direct_purchase']
//         }
//       ]
//     },
//     {
//       id: 'demandes',
//       label: 'Gestion des demandes',
//       icon: FileText,
//       permission: 'demandes_read',
//       path: '/demandes'
//     },
//     {
//       id: 'billets',
//       label: 'Émission des billets',
//       icon: Ticket,
//       permission: 'billets_emit',
//       path: '/billets'
//     },
//     {
//       id: 'administration',
//       label: 'Administration',
//       icon: Settings,
//       permission: 'admin_entities',
//       path: '/admin'
//     },
//     {
//       id: 'rapports',
//       label: 'Rapports',
//       icon: BarChart3,
//       permission: 'reports_view',
//       path: '/reports'
//     }
//   ];

//   const filteredNavigation = navigationItems.filter(item =>
//     !item.permission || AUTH_SERVICE.hasPermission(item.permission)
//   );

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header */}
//       <header className="bg-white shadow-sm border-b">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center h-16">
//             <div className="flex items-center">
//               <button
//                 onClick={() => setSidebarOpen(!sidebarOpen)}
//                 className="md:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
//               >
//                 <Menu className="w-6 h-6" />
//               </button>
//               <div className="flex-shrink-0 flex items-center ml-4 md:ml-0">
//                 <Building2 className="w-8 h-8 text-blue-600" />
//                 <span className="ml-2 text-xl font-bold text-gray-900">Travel Management</span>
//               </div>
//             </div>

//             <div className="flex items-center space-x-4">
//               <div className="text-right">
//                 <p className="text-sm font-medium text-gray-900">
//                   {user.prenom} {user.nom}
//                 </p>
//                 <p className="text-xs text-gray-500 capitalize">
//                   {user.profil?.nom || 'Utilisateur'}
//                 </p>
//               </div>
//               <div className="relative">
//                 <button
//                   onClick={onLogout}
//                   className="flex items-center space-x-2 text-sm text-gray-600 hover:text-gray-900 p-2 rounded-md hover:bg-gray-100"
//                 >
//                   <LogOut className="w-4 h-4" />
//                   <span className="hidden md:inline">Déconnexion</span>
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>

//       <div className="flex">
//         {/* Sidebar pour desktop */}
//         <aside className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
//           <div className="flex-1 flex flex-col min-h-0 border-r bg-white">
//             <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
//               <nav className="mt-8 flex-1 px-4 space-y-2">
//                 {filteredNavigation.map((item) => {
//                   const Icon = item.icon;
//                   const isActive = activeModule === item.id;

//                   return (
//                     <button
//                       key={item.id}
//                       onClick={() => setActiveModule(item.id)}
//                       className={`w-full flex items-center px-4 py-3 text-sm font-medium rounded-lg transition ${isActive
//                         ? 'bg-blue-50 text-blue-700 border border-blue-200'
//                         : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
//                         }`}
//                     >
//                       <Icon className="w-5 h-5 mr-3" />
//                       {item.label}
//                     </button>
//                   );
//                 })}
//               </nav>
//             </div>
//           </div>
//         </aside>

//         {/* Sidebar mobile */}
//         {sidebarOpen && (
//           <div className="md:hidden">
//             <div className="fixed inset-0 flex z-40">
//               <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} />
//               <div className="relative flex-1 flex flex-col max-w-xs w-full bg-white">
//                 <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
//                   <nav className="mt-8 px-4 space-y-2">
//                     {filteredNavigation.map((item) => {
//                       const Icon = item.icon;
//                       const isActive = activeModule === item.id;

//                       return (
//                         <button
//                           key={item.id}
//                           onClick={() => {
//                             setActiveModule(item.id);
//                             setSidebarOpen(false);
//                           }}
//                           className={`w-full flex items-center px-4 py-3 text-sm font-medium rounded-lg transition ${isActive
//                             ? 'bg-blue-50 text-blue-700 border border-blue-200'
//                             : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
//                             }`}
//                         >
//                           <Icon className="w-5 h-5 mr-3" />
//                           {item.label}
//                         </button>
//                       );
//                     })}
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Main content */}
//         <main className="md:ml-64 flex-1">
//           <div className="py-6">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//               {children}
//             </div>
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// };

// ==================== COMPOSANT DE PROTECTION DES ROUTES ====================
const ProtectedRoute = ({ children, permissions = [] }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkAccess = () => {
      if (!AUTH_SERVICE.isAuthenticated()) {
        window.location.href = "/login";
        return;
      }

      // Vérifier les permissions si spécifiées
      if (permissions.length > 0) {
        const userHasAccess = AUTH_SERVICE.hasAnyPermission(permissions);
        setHasAccess(userHasAccess);

        if (!userHasAccess) {
          // Rediriger vers la page d'accès refusé
          window.location.href = "/access-denied";
          return;
        }
      } else {
        setHasAccess(true);
      }

      setIsChecking(false);
    };

    checkAccess();
  }, [permissions]);

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Loader className="w-12 h-12 text-blue-600 mx-auto mb-4 animate-spin" />
          <p className="text-gray-600">Vérification des accès...</p>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <AlertTriangle className="w-16 h-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Accès refusé
          </h2>
          <p className="text-gray-600">
            Vous n'avez pas les permissions nécessaires pour accéder à cette
            page.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

// ==================== SERVICES API MIS À JOUR AVEC AUTHENTIFICATION ====================
const administrationServiceWithAuth = {
  // Entités
  getEntities: async () => {
    const response = await AUTH_SERVICE.apiRequest("/travel-entities");
    if (!response.ok) throw new Error("Erreur récupération entités");
    return await response.json();
  },

  createEntity: async (data) => {
    const response = await AUTH_SERVICE.apiRequest("/travel-entities", {
      method: "POST",
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur création entité");
    }
    return await response.json();
  },

  updateEntity: async (id, data) => {
    const response = await AUTH_SERVICE.apiRequest(`/travel-entities/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur mise à jour entité");
    }
    return await response.json();
  },

  deleteEntity: async (id) => {
    const response = await AUTH_SERVICE.apiRequest(`/travel-entities/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur suppression entité");
    }
    return await response.json();
  },

  // ... autres méthodes similaires pour agents, profils, utilisateurs
};
// ==================== COMPOSANT ACHAT DIRECT DE VOL ====================

const SearchTab = ({
  totalPassengers,
  searchParams,
  setSearchParams,
  handleSearch,
  loading,
  error,
  searchResults,
  onSelectFlight,
  cart,
}) => {
  const [multiCitySegments, setMultiCitySegments] = useState([
    { origin: "", destination: "", date: "" },
  ]);
  const [airports, setAirports] = useState([]);

  // Charger la liste des aéroports au montage du composant
  useEffect(() => {
    fetchAirports();
  }, []);

  const fetchAirports = async () => {
    try {
      // Cette fonction devra être adaptée selon votre API d'aéroports
      const response = await fetch(`${API_BASE_URL2}/airports`);
      if (response.ok) {
        const data = await response.json();
        setAirports(data);
      }
    } catch (error) {
      console.error("Erreur lors du chargement des aéroports:", error);
    }
  };

  const getAirportOptionsJSX = () => {
    return airports.map((airport) => (
      <option key={airport.code} value={airport.code}>
        {airport.name} ({airport.code})
      </option>
    ));
  };

  // Gestion des segments multi-destinations
  const addSegment = () => {
    const lastSegment = multiCitySegments[multiCitySegments.length - 1];
    const newSegmentDate = lastSegment.date
      ? new Date(new Date(lastSegment.date).getTime() + 24 * 60 * 60 * 1000)
          .toISOString()
          .split("T")[0]
      : "";

    setMultiCitySegments([
      ...multiCitySegments,
      {
        origin: lastSegment.destination || "",
        destination: "",
        date: newSegmentDate,
      },
    ]);
  };

  const removeSegment = (index) => {
    if (multiCitySegments.length > 1) {
      setMultiCitySegments(multiCitySegments.filter((_, i) => i !== index));
    }
  };

  const updateSegment = (index, field, value) => {
    const updated = [...multiCitySegments];
    updated[index][field] = value;
    setMultiCitySegments(updated);
  };

  return (
    <div className="space-y-6">
      {/* Formulaire de recherche */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-xl font-bold mb-4">Rechercher des vols</h2>

        <form
          onSubmit={(e) =>
            handleSearch(
              e,
              searchParams.tripType === "multi-city" ? multiCitySegments : []
            )
          }
          className="space-y-6"
        >
          {/* Sélection du type de voyage */}
          <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
            <label className="block text-lg font-bold text-gray-800 mb-4">
              Type de voyage *
            </label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <button
                type="button"
                onClick={() => {
                  setSearchParams({
                    ...searchParams,
                    tripType: "one-way",
                    returnDate: "",
                  });
                  setMultiCitySegments([
                    { origin: "", destination: "", date: "" },
                  ]);
                }}
                className={`p-4 rounded-xl font-semibold transition-all duration-200 ${
                  searchParams.tripType === "one-way"
                    ? "bg-blue-600 text-white shadow-lg transform scale-105"
                    : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400 hover:shadow-md"
                }`}
              >
                <div className="flex flex-col items-center space-y-2">
                  <Plane className="w-6 h-6" />
                  <span>Aller simple</span>
                  <p className="text-xs opacity-80">Un seul trajet</p>
                </div>
              </button>

              <button
                type="button"
                onClick={() => {
                  setSearchParams({
                    ...searchParams,
                    tripType: "round-trip",
                  });
                  setMultiCitySegments([
                    { origin: "", destination: "", date: "" },
                  ]);
                }}
                className={`p-4 rounded-xl font-semibold transition-all duration-200 ${
                  searchParams.tripType === "round-trip"
                    ? "bg-blue-600 text-white shadow-lg transform scale-105"
                    : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400 hover:shadow-md"
                }`}
              >
                <div className="flex flex-col items-center space-y-2">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                    />
                  </svg>
                  <span>Aller-retour</span>
                  <p className="text-xs opacity-80">Aller + retour</p>
                </div>
              </button>

              <button
                type="button"
                onClick={() => {
                  setSearchParams({
                    ...searchParams,
                    tripType: "multi-city",
                    returnDate: "",
                  });
                  setMultiCitySegments([
                    { origin: "", destination: "", date: "" },
                    { origin: "", destination: "", date: "" },
                  ]);
                }}
                className={`p-4 rounded-xl font-semibold transition-all duration-200 ${
                  searchParams.tripType === "multi-city"
                    ? "bg-blue-600 text-white shadow-lg transform scale-105"
                    : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400 hover:shadow-md"
                }`}
              >
                <div className="flex flex-col items-center space-y-2">
                  <MapPin className="w-6 h-6" />
                  <span>Multi-destinations</span>
                  <p className="text-xs opacity-80">Plusieurs étapes</p>
                </div>
              </button>
            </div>
          </div>

          {/* Formulaire selon le type de voyage */}
          <div className="bg-white rounded-xl shadow-md p-6 border">
            {searchParams.tripType === "multi-city" ? (
              // ==================== FORMULAIRE MULTI-DESTINATIONS ====================
              <div className="space-y-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                  <MapPin className="w-5 h-5 mr-2 text-blue-600" />
                  Itinéraire Multi-Destinations
                </h3>

                <div className="space-y-4">
                  {multiCitySegments.map((segment, index) => (
                    <div
                      key={index}
                      className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 border-2 border-blue-200 relative"
                    >
                      <div className="absolute -top-3 -left-3 bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                        {index + 1}
                      </div>

                      <div className="flex justify-between items-center mb-4">
                        <h4 className="font-semibold text-gray-800 text-lg">
                          Étape {index + 1}
                        </h4>
                        {multiCitySegments.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeSegment(index)}
                            className="text-red-600 hover:text-red-800 bg-red-50 p-2 rounded-lg transition-colors"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        )}
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            <MapPin className="w-4 h-4 inline mr-1" />
                            Départ (Aéroport) *
                          </label>
                          <select
                            value={segment.origin}
                            onChange={(e) =>
                              updateSegment(index, "origin", e.target.value)
                            }
                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                            required
                          >
                            <option value="">Sélectionnez un aéroport</option>
                            {/* Afrique */}
                            <optgroup label="Afrique">
                              <option value="ABJ">
                                Abidjan, Côte d'Ivoire (ABJ)
                              </option>
                              <option value="ACC">Accra, Ghana (ACC)</option>
                              <option value="ADD">
                                Addis-Abeba, Éthiopie (ADD)
                              </option>
                              <option value="ALG">Alger, Algérie (ALG)</option>
                              <option value="CMN">
                                Casablanca, Maroc (CMN)
                              </option>
                              <option value="COO">Cotonou, Bénin (COO)</option>
                              <option value="DKR">Dakar, Sénégal (DKR)</option>
                              <option value="DAR">
                                Dar es Salaam, Tanzanie (DAR)
                              </option>
                              <option value="EBB">
                                Entebbe, Ouganda (EBB)
                              </option>
                              <option value="FIH">Kinshasa, RDC (FIH)</option>
                              <option value="JNB">
                                Johannesburg, Afrique du Sud (JNB)
                              </option>
                              <option value="KGL">Kigali, Rwanda (KGL)</option>
                              <option value="LAD">Luanda, Angola (LAD)</option>
                              <option value="LOS">Lagos, Nigeria (LOS)</option>
                              <option value="NBO">Nairobi, Kenya (NBO)</option>
                              <option value="RAI">Praia, Cap-Vert (RAI)</option>
                              <option value="TUN">Tunis, Tunisie (TUN)</option>
                            </optgroup>

                            {/* Europe */}
                            <optgroup label="Europe">
                              <option value="AMS">
                                Amsterdam, Pays-Bas (AMS)
                              </option>
                              <option value="BCN">
                                Barcelone, Espagne (BCN)
                              </option>
                              <option value="BER">
                                Berlin, Allemagne (BER)
                              </option>
                              <option value="BRU">
                                Bruxelles, Belgique (BRU)
                              </option>
                              <option value="CDG">
                                Paris Charles de Gaulle, France (CDG)
                              </option>
                              <option value="FCO">
                                Rome Fiumicino, Italie (FCO)
                              </option>
                              <option value="FRA">
                                Francfort, Allemagne (FRA)
                              </option>
                              <option value="GVA">Genève, Suisse (GVA)</option>
                              <option value="IST">
                                Istanbul, Turquie (IST)
                              </option>
                              <option value="LHR">
                                Londres Heathrow, Royaume-Uni (LHR)
                              </option>
                              <option value="LIS">
                                Lisbonne, Portugal (LIS)
                              </option>
                              <option value="MAD">Madrid, Espagne (MAD)</option>
                              <option value="MUC">
                                Munich, Allemagne (MUC)
                              </option>
                              <option value="ORY">
                                Paris Orly, France (ORY)
                              </option>
                              <option value="VIE">
                                Vienne, Autriche (VIE)
                              </option>
                              <option value="ZRH">Zurich, Suisse (ZRH)</option>
                            </optgroup>

                            {/* Amérique du Nord */}
                            <optgroup label="Amérique du Nord">
                              <option value="ATL">Atlanta, USA (ATL)</option>
                              <option value="DFW">Dallas, USA (DFW)</option>
                              <option value="DTW">Detroit, USA (DTW)</option>
                              <option value="JFK">
                                New York JFK, USA (JFK)
                              </option>
                              <option value="LAX">
                                Los Angeles, USA (LAX)
                              </option>
                              <option value="MIA">Miami, USA (MIA)</option>
                              <option value="ORD">Chicago, USA (ORD)</option>
                              <option value="SFO">
                                San Francisco, USA (SFO)
                              </option>
                              <option value="YYZ">Toronto, Canada (YYZ)</option>
                              <option value="YUL">
                                Montréal, Canada (YUL)
                              </option>
                            </optgroup>

                            {/* Amérique du Sud */}
                            <optgroup label="Amérique du Sud">
                              <option value="BOG">
                                Bogota, Colombie (BOG)
                              </option>
                              <option value="EZE">
                                Buenos Aires, Argentine (EZE)
                              </option>
                              <option value="GRU">
                                São Paulo, Brésil (GRU)
                              </option>
                              <option value="LIM">Lima, Pérou (LIM)</option>
                              <option value="SCL">Santiago, Chili (SCL)</option>
                            </optgroup>

                            {/* Asie */}
                            <optgroup label="Asie">
                              <option value="BKK">
                                Bangkok, Thaïlande (BKK)
                              </option>
                              <option value="CAN">
                                Guangzhou, Chine (CAN)
                              </option>
                              <option value="DEL">Delhi, Inde (DEL)</option>
                              <option value="DXB">
                                Dubaï, Émirats Arabes Unis (DXB)
                              </option>
                              <option value="HKG">Hong Kong (HKG)</option>
                              <option value="ICN">
                                Séoul, Corée du Sud (ICN)
                              </option>
                              <option value="KUL">
                                Kuala Lumpur, Malaisie (KUL)
                              </option>
                              <option value="NRT">
                                Tokyo Narita, Japon (NRT)
                              </option>
                              <option value="PEK">Pékin, Chine (PEK)</option>
                              <option value="PVG">
                                Shanghai Pudong, Chine (PVG)
                              </option>
                              <option value="SIN">Singapour (SIN)</option>
                            </optgroup>

                            {/* Océanie */}
                            <optgroup label="Océanie">
                              <option value="AKL">
                                Auckland, Nouvelle-Zélande (AKL)
                              </option>
                              <option value="BNE">
                                Brisbane, Australie (BNE)
                              </option>
                              <option value="MEL">
                                Melbourne, Australie (MEL)
                              </option>
                              <option value="SYD">
                                Sydney, Australie (SYD)
                              </option>
                            </optgroup>

                            {/* Moyen-Orient */}
                            <optgroup label="Moyen-Orient">
                              <option value="AUH">
                                Abu Dhabi, Émirats Arabes Unis (AUH)
                              </option>
                              <option value="BAH">Bahreïn (BAH)</option>
                              <option value="DOH">Doha, Qatar (DOH)</option>
                              <option value="JED">
                                Jeddah, Arabie Saoudite (JED)
                              </option>
                              <option value="RUH">
                                Riyad, Arabie Saoudite (RUH)
                              </option>
                              <option value="TLV">
                                Tel Aviv, Israël (TLV)
                              </option>
                            </optgroup>
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            <MapPin className="w-4 h-4 inline mr-1" />
                            Arrivée (Aéroport) *
                          </label>
                          <select
                            value={segment.destination}
                            onChange={(e) =>
                              updateSegment(
                                index,
                                "destination",
                                e.target.value
                              )
                            }
                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                            required
                          >
                            <option value="">Sélectionnez un aéroport</option>
                            {/* Afrique */}
                            <optgroup label="Afrique">
                              <option value="ABJ">
                                Abidjan, Côte d'Ivoire (ABJ)
                              </option>
                              <option value="ACC">Accra, Ghana (ACC)</option>
                              <option value="ADD">
                                Addis-Abeba, Éthiopie (ADD)
                              </option>
                              <option value="ALG">Alger, Algérie (ALG)</option>
                              <option value="CMN">
                                Casablanca, Maroc (CMN)
                              </option>
                              <option value="COO">Cotonou, Bénin (COO)</option>
                              <option value="DKR">Dakar, Sénégal (DKR)</option>
                              <option value="DAR">
                                Dar es Salaam, Tanzanie (DAR)
                              </option>
                              <option value="EBB">
                                Entebbe, Ouganda (EBB)
                              </option>
                              <option value="FIH">Kinshasa, RDC (FIH)</option>
                              <option value="JNB">
                                Johannesburg, Afrique du Sud (JNB)
                              </option>
                              <option value="KGL">Kigali, Rwanda (KGL)</option>
                              <option value="LAD">Luanda, Angola (LAD)</option>
                              <option value="LOS">Lagos, Nigeria (LOS)</option>
                              <option value="NBO">Nairobi, Kenya (NBO)</option>
                              <option value="RAI">Praia, Cap-Vert (RAI)</option>
                              <option value="TUN">Tunis, Tunisie (TUN)</option>
                            </optgroup>

                            {/* Europe */}
                            <optgroup label="Europe">
                              <option value="AMS">
                                Amsterdam, Pays-Bas (AMS)
                              </option>
                              <option value="BCN">
                                Barcelone, Espagne (BCN)
                              </option>
                              <option value="BER">
                                Berlin, Allemagne (BER)
                              </option>
                              <option value="BRU">
                                Bruxelles, Belgique (BRU)
                              </option>
                              <option value="CDG">
                                Paris Charles de Gaulle, France (CDG)
                              </option>
                              <option value="FCO">
                                Rome Fiumicino, Italie (FCO)
                              </option>
                              <option value="FRA">
                                Francfort, Allemagne (FRA)
                              </option>
                              <option value="GVA">Genève, Suisse (GVA)</option>
                              <option value="IST">
                                Istanbul, Turquie (IST)
                              </option>
                              <option value="LHR">
                                Londres Heathrow, Royaume-Uni (LHR)
                              </option>
                              <option value="LIS">
                                Lisbonne, Portugal (LIS)
                              </option>
                              <option value="MAD">Madrid, Espagne (MAD)</option>
                              <option value="MUC">
                                Munich, Allemagne (MUC)
                              </option>
                              <option value="ORY">
                                Paris Orly, France (ORY)
                              </option>
                              <option value="VIE">
                                Vienne, Autriche (VIE)
                              </option>
                              <option value="ZRH">Zurich, Suisse (ZRH)</option>
                            </optgroup>

                            {/* Amérique du Nord */}
                            <optgroup label="Amérique du Nord">
                              <option value="ATL">Atlanta, USA (ATL)</option>
                              <option value="DFW">Dallas, USA (DFW)</option>
                              <option value="DTW">Detroit, USA (DTW)</option>
                              <option value="JFK">
                                New York JFK, USA (JFK)
                              </option>
                              <option value="LAX">
                                Los Angeles, USA (LAX)
                              </option>
                              <option value="MIA">Miami, USA (MIA)</option>
                              <option value="ORD">Chicago, USA (ORD)</option>
                              <option value="SFO">
                                San Francisco, USA (SFO)
                              </option>
                              <option value="YYZ">Toronto, Canada (YYZ)</option>
                              <option value="YUL">
                                Montréal, Canada (YUL)
                              </option>
                            </optgroup>

                            {/* Amérique du Sud */}
                            <optgroup label="Amérique du Sud">
                              <option value="BOG">
                                Bogota, Colombie (BOG)
                              </option>
                              <option value="EZE">
                                Buenos Aires, Argentine (EZE)
                              </option>
                              <option value="GRU">
                                São Paulo, Brésil (GRU)
                              </option>
                              <option value="LIM">Lima, Pérou (LIM)</option>
                              <option value="SCL">Santiago, Chili (SCL)</option>
                            </optgroup>

                            {/* Asie */}
                            <optgroup label="Asie">
                              <option value="BKK">
                                Bangkok, Thaïlande (BKK)
                              </option>
                              <option value="CAN">
                                Guangzhou, Chine (CAN)
                              </option>
                              <option value="DEL">Delhi, Inde (DEL)</option>
                              <option value="DXB">
                                Dubaï, Émirats Arabes Unis (DXB)
                              </option>
                              <option value="HKG">Hong Kong (HKG)</option>
                              <option value="ICN">
                                Séoul, Corée du Sud (ICN)
                              </option>
                              <option value="KUL">
                                Kuala Lumpur, Malaisie (KUL)
                              </option>
                              <option value="NRT">
                                Tokyo Narita, Japon (NRT)
                              </option>
                              <option value="PEK">Pékin, Chine (PEK)</option>
                              <option value="PVG">
                                Shanghai Pudong, Chine (PVG)
                              </option>
                              <option value="SIN">Singapour (SIN)</option>
                            </optgroup>

                            {/* Océanie */}
                            <optgroup label="Océanie">
                              <option value="AKL">
                                Auckland, Nouvelle-Zélande (AKL)
                              </option>
                              <option value="BNE">
                                Brisbane, Australie (BNE)
                              </option>
                              <option value="MEL">
                                Melbourne, Australie (MEL)
                              </option>
                              <option value="SYD">
                                Sydney, Australie (SYD)
                              </option>
                            </optgroup>

                            {/* Moyen-Orient */}
                            <optgroup label="Moyen-Orient">
                              <option value="AUH">
                                Abu Dhabi, Émirats Arabes Unis (AUH)
                              </option>
                              <option value="BAH">Bahreïn (BAH)</option>
                              <option value="DOH">Doha, Qatar (DOH)</option>
                              <option value="JED">
                                Jeddah, Arabie Saoudite (JED)
                              </option>
                              <option value="RUH">
                                Riyad, Arabie Saoudite (RUH)
                              </option>
                              <option value="TLV">
                                Tel Aviv, Israël (TLV)
                              </option>
                            </optgroup>
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm font-semibold mb-2 flex items-center">
                            <Calendar className="w-4 h-4 mr-1 text-purple-600" />
                            Date de vol *
                          </label>
                          <input
                            type="date"
                            value={segment.date}
                            onChange={(e) =>
                              updateSegment(index, "date", e.target.value)
                            }
                            min={
                              index > 0
                                ? multiCitySegments[index - 1].date
                                : new Date().toISOString().split("T")[0]
                            }
                            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                            required
                          />
                        </div>
                      </div>

                      {index < multiCitySegments.length - 1 && (
                        <div className="flex justify-center mt-4">
                          <div className="bg-blue-200 text-blue-800 px-3 py-1 rounded-full text-xs font-semibold flex items-center">
                            <ChevronDown className="w-3 h-3 mr-1" />
                            Prochaine étape
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                <button
                  type="button"
                  onClick={addSegment}
                  disabled={multiCitySegments.length >= 5}
                  className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white py-3 rounded-lg font-semibold hover:from-green-600 hover:to-emerald-600 transition flex items-center justify-center disabled:opacity-50"
                >
                  <PlusCircle className="w-5 h-5 mr-2" />
                  Ajouter une étape (Maximum 5)
                </button>
              </div>
            ) : (
              // ==================== FORMULAIRE STANDARD ====================
              <div className="space-y-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                  {searchParams.tripType === "one-way" ? (
                    <>
                      <Plane className="w-5 h-5 mr-2 text-blue-600" />
                      Vol Aller Simple
                    </>
                  ) : (
                    <>
                      <svg
                        className="w-5 h-5 mr-2 text-blue-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                        />
                      </svg>
                      Vol Aller-Retour
                    </>
                  )}
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <MapPin className="w-4 h-4 inline mr-1" />
                      Départ (Aéroport) *
                    </label>
                    <select
                      value={searchParams.originLocationCode}
                      onChange={(e) =>
                        setSearchParams((prev) => ({
                          ...prev,
                          originLocationCode: e.target.value,
                        }))
                      }
                      className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      required
                    >
                      <option value="">
                        Sélectionnez un aéroport de départ
                      </option>
                      {/* Afrique */}
                      <optgroup label="Afrique">
                        <option value="ABJ">
                          Abidjan, Côte d'Ivoire (ABJ)
                        </option>
                        <option value="ACC">Accra, Ghana (ACC)</option>
                        <option value="ADD">Addis-Abeba, Éthiopie (ADD)</option>
                        <option value="ALG">Alger, Algérie (ALG)</option>
                        <option value="CMN">Casablanca, Maroc (CMN)</option>
                        <option value="COO">Cotonou, Bénin (COO)</option>
                        <option value="DKR">Dakar, Sénégal (DKR)</option>
                        <option value="DAR">
                          Dar es Salaam, Tanzanie (DAR)
                        </option>
                        <option value="EBB">Entebbe, Ouganda (EBB)</option>
                        <option value="FIH">Kinshasa, RDC (FIH)</option>
                        <option value="JNB">
                          Johannesburg, Afrique du Sud (JNB)
                        </option>
                        <option value="KGL">Kigali, Rwanda (KGL)</option>
                        <option value="LAD">Luanda, Angola (LAD)</option>
                        <option value="LOS">Lagos, Nigeria (LOS)</option>
                        <option value="NBO">Nairobi, Kenya (NBO)</option>
                        <option value="RAI">Praia, Cap-Vert (RAI)</option>
                        <option value="TUN">Tunis, Tunisie (TUN)</option>
                      </optgroup>

                      {/* Europe */}
                      <optgroup label="Europe">
                        <option value="AMS">Amsterdam, Pays-Bas (AMS)</option>
                        <option value="BCN">Barcelone, Espagne (BCN)</option>
                        <option value="BER">Berlin, Allemagne (BER)</option>
                        <option value="BRU">Bruxelles, Belgique (BRU)</option>
                        <option value="CDG">
                          Paris Charles de Gaulle, France (CDG)
                        </option>
                        <option value="FCO">
                          Rome Fiumicino, Italie (FCO)
                        </option>
                        <option value="FRA">Francfort, Allemagne (FRA)</option>
                        <option value="GVA">Genève, Suisse (GVA)</option>
                        <option value="IST">Istanbul, Turquie (IST)</option>
                        <option value="LHR">
                          Londres Heathrow, Royaume-Uni (LHR)
                        </option>
                        <option value="LIS">Lisbonne, Portugal (LIS)</option>
                        <option value="MAD">Madrid, Espagne (MAD)</option>
                        <option value="MUC">Munich, Allemagne (MUC)</option>
                        <option value="ORY">Paris Orly, France (ORY)</option>
                        <option value="VIE">Vienne, Autriche (VIE)</option>
                        <option value="ZRH">Zurich, Suisse (ZRH)</option>
                      </optgroup>

                      {/* Amérique du Nord */}
                      <optgroup label="Amérique du Nord">
                        <option value="ATL">Atlanta, USA (ATL)</option>
                        <option value="DFW">Dallas, USA (DFW)</option>
                        <option value="DTW">Detroit, USA (DTW)</option>
                        <option value="JFK">New York JFK, USA (JFK)</option>
                        <option value="LAX">Los Angeles, USA (LAX)</option>
                        <option value="MIA">Miami, USA (MIA)</option>
                        <option value="ORD">Chicago, USA (ORD)</option>
                        <option value="SFO">San Francisco, USA (SFO)</option>
                        <option value="YYZ">Toronto, Canada (YYZ)</option>
                        <option value="YUL">Montréal, Canada (YUL)</option>
                      </optgroup>

                      {/* Amérique du Sud */}
                      <optgroup label="Amérique du Sud">
                        <option value="BOG">Bogota, Colombie (BOG)</option>
                        <option value="EZE">
                          Buenos Aires, Argentine (EZE)
                        </option>
                        <option value="GRU">São Paulo, Brésil (GRU)</option>
                        <option value="LIM">Lima, Pérou (LIM)</option>
                        <option value="SCL">Santiago, Chili (SCL)</option>
                      </optgroup>

                      {/* Asie */}
                      <optgroup label="Asie">
                        <option value="BKK">Bangkok, Thaïlande (BKK)</option>
                        <option value="CAN">Guangzhou, Chine (CAN)</option>
                        <option value="DEL">Delhi, Inde (DEL)</option>
                        <option value="DXB">
                          Dubaï, Émirats Arabes Unis (DXB)
                        </option>
                        <option value="HKG">Hong Kong (HKG)</option>
                        <option value="ICN">Séoul, Corée du Sud (ICN)</option>
                        <option value="KUL">
                          Kuala Lumpur, Malaisie (KUL)
                        </option>
                        <option value="NRT">Tokyo Narita, Japon (NRT)</option>
                        <option value="PEK">Pékin, Chine (PEK)</option>
                        <option value="PVG">
                          Shanghai Pudong, Chine (PVG)
                        </option>
                        <option value="SIN">Singapour (SIN)</option>
                      </optgroup>

                      {/* Océanie */}
                      <optgroup label="Océanie">
                        <option value="AKL">
                          Auckland, Nouvelle-Zélande (AKL)
                        </option>
                        <option value="BNE">Brisbane, Australie (BNE)</option>
                        <option value="MEL">Melbourne, Australie (MEL)</option>
                        <option value="SYD">Sydney, Australie (SYD)</option>
                      </optgroup>

                      {/* Moyen-Orient */}
                      <optgroup label="Moyen-Orient">
                        <option value="AUH">
                          Abu Dhabi, Émirats Arabes Unis (AUH)
                        </option>
                        <option value="BAH">Bahreïn (BAH)</option>
                        <option value="DOH">Doha, Qatar (DOH)</option>
                        <option value="JED">
                          Jeddah, Arabie Saoudite (JED)
                        </option>
                        <option value="RUH">
                          Riyad, Arabie Saoudite (RUH)
                        </option>
                        <option value="TLV">Tel Aviv, Israël (TLV)</option>
                      </optgroup>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <MapPin className="w-4 h-4 inline mr-1" />
                      Arrivée (Aéroport) *
                    </label>
                    <select
                      value={searchParams.destinationLocationCode}
                      onChange={(e) =>
                        setSearchParams((prev) => ({
                          ...prev,
                          destinationLocationCode: e.target.value,
                        }))
                      }
                      className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      required
                    >
                      <option value="">
                        Sélectionnez un aéroport d'arrivée
                      </option>
                      {/* Afrique */}
                      <optgroup label="Afrique">
                        <option value="ABJ">
                          Abidjan, Côte d'Ivoire (ABJ)
                        </option>
                        <option value="ACC">Accra, Ghana (ACC)</option>
                        <option value="ADD">Addis-Abeba, Éthiopie (ADD)</option>
                        <option value="ALG">Alger, Algérie (ALG)</option>
                        <option value="CMN">Casablanca, Maroc (CMN)</option>
                        <option value="COO">Cotonou, Bénin (COO)</option>
                        <option value="DKR">Dakar, Sénégal (DKR)</option>
                        <option value="DAR">
                          Dar es Salaam, Tanzanie (DAR)
                        </option>
                        <option value="EBB">Entebbe, Ouganda (EBB)</option>
                        <option value="FIH">Kinshasa, RDC (FIH)</option>
                        <option value="JNB">
                          Johannesburg, Afrique du Sud (JNB)
                        </option>
                        <option value="KGL">Kigali, Rwanda (KGL)</option>
                        <option value="LAD">Luanda, Angola (LAD)</option>
                        <option value="LOS">Lagos, Nigeria (LOS)</option>
                        <option value="NBO">Nairobi, Kenya (NBO)</option>
                        <option value="RAI">Praia, Cap-Vert (RAI)</option>
                        <option value="TUN">Tunis, Tunisie (TUN)</option>
                      </optgroup>

                      {/* Europe */}
                      <optgroup label="Europe">
                        <option value="AMS">Amsterdam, Pays-Bas (AMS)</option>
                        <option value="BCN">Barcelone, Espagne (BCN)</option>
                        <option value="BER">Berlin, Allemagne (BER)</option>
                        <option value="BRU">Bruxelles, Belgique (BRU)</option>
                        <option value="CDG">
                          Paris Charles de Gaulle, France (CDG)
                        </option>
                        <option value="FCO">
                          Rome Fiumicino, Italie (FCO)
                        </option>
                        <option value="FRA">Francfort, Allemagne (FRA)</option>
                        <option value="GVA">Genève, Suisse (GVA)</option>
                        <option value="IST">Istanbul, Turquie (IST)</option>
                        <option value="LHR">
                          Londres Heathrow, Royaume-Uni (LHR)
                        </option>
                        <option value="LIS">Lisbonne, Portugal (LIS)</option>
                        <option value="MAD">Madrid, Espagne (MAD)</option>
                        <option value="MUC">Munich, Allemagne (MUC)</option>
                        <option value="ORY">Paris Orly, France (ORY)</option>
                        <option value="VIE">Vienne, Autriche (VIE)</option>
                        <option value="ZRH">Zurich, Suisse (ZRH)</option>
                      </optgroup>

                      {/* Amérique du Nord */}
                      <optgroup label="Amérique du Nord">
                        <option value="ATL">Atlanta, USA (ATL)</option>
                        <option value="DFW">Dallas, USA (DFW)</option>
                        <option value="DTW">Detroit, USA (DTW)</option>
                        <option value="JFK">New York JFK, USA (JFK)</option>
                        <option value="LAX">Los Angeles, USA (LAX)</option>
                        <option value="MIA">Miami, USA (MIA)</option>
                        <option value="ORD">Chicago, USA (ORD)</option>
                        <option value="SFO">San Francisco, USA (SFO)</option>
                        <option value="YYZ">Toronto, Canada (YYZ)</option>
                        <option value="YUL">Montréal, Canada (YUL)</option>
                      </optgroup>

                      {/* Amérique du Sud */}
                      <optgroup label="Amérique du Sud">
                        <option value="BOG">Bogota, Colombie (BOG)</option>
                        <option value="EZE">
                          Buenos Aires, Argentine (EZE)
                        </option>
                        <option value="GRU">São Paulo, Brésil (GRU)</option>
                        <option value="LIM">Lima, Pérou (LIM)</option>
                        <option value="SCL">Santiago, Chili (SCL)</option>
                      </optgroup>

                      {/* Asie */}
                      <optgroup label="Asie">
                        <option value="BKK">Bangkok, Thaïlande (BKK)</option>
                        <option value="CAN">Guangzhou, Chine (CAN)</option>
                        <option value="DEL">Delhi, Inde (DEL)</option>
                        <option value="DXB">
                          Dubaï, Émirats Arabes Unis (DXB)
                        </option>
                        <option value="HKG">Hong Kong (HKG)</option>
                        <option value="ICN">Séoul, Corée du Sud (ICN)</option>
                        <option value="KUL">
                          Kuala Lumpur, Malaisie (KUL)
                        </option>
                        <option value="NRT">Tokyo Narita, Japon (NRT)</option>
                        <option value="PEK">Pékin, Chine (PEK)</option>
                        <option value="PVG">
                          Shanghai Pudong, Chine (PVG)
                        </option>
                        <option value="SIN">Singapour (SIN)</option>
                      </optgroup>

                      {/* Océanie */}
                      <optgroup label="Océanie">
                        <option value="AKL">
                          Auckland, Nouvelle-Zélande (AKL)
                        </option>
                        <option value="BNE">Brisbane, Australie (BNE)</option>
                        <option value="MEL">Melbourne, Australie (MEL)</option>
                        <option value="SYD">Sydney, Australie (SYD)</option>
                      </optgroup>

                      {/* Moyen-Orient */}
                      <optgroup label="Moyen-Orient">
                        <option value="AUH">
                          Abu Dhabi, Émirats Arabes Unis (AUH)
                        </option>
                        <option value="BAH">Bahreïn (BAH)</option>
                        <option value="DOH">Doha, Qatar (DOH)</option>
                        <option value="JED">
                          Jeddah, Arabie Saoudite (JED)
                        </option>
                        <option value="RUH">
                          Riyad, Arabie Saoudite (RUH)
                        </option>
                        <option value="TLV">Tel Aviv, Israël (TLV)</option>
                      </optgroup>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <Calendar className="w-4 h-4 inline mr-1" />
                      Date de départ *
                    </label>
                    <input
                      type="date"
                      value={searchParams.departureDate}
                      onChange={(e) =>
                        setSearchParams((prev) => ({
                          ...prev,
                          departureDate: e.target.value,
                        }))
                      }
                      min={new Date().toISOString().split("T")[0]}
                      className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>

                  {searchParams.tripType === "round-trip" && (
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <Calendar className="w-4 h-4 inline mr-1" />
                        Date de retour *
                      </label>
                      <input
                        type="date"
                        value={searchParams.returnDate || ""}
                        onChange={(e) =>
                          setSearchParams((prev) => ({
                            ...prev,
                            returnDate: e.target.value,
                          }))
                        }
                        min={
                          searchParams.departureDate ||
                          new Date().toISOString().split("T")[0]
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                        required
                      />
                    </div>
                  )}

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <Users className="w-4 h-4 inline mr-1" />
                      Passagers adultes
                    </label>
                    <select
                      value={searchParams.adults}
                      onChange={(e) =>
                        setSearchParams((prev) => ({
                          ...prev,
                          adults: parseInt(e.target.value),
                        }))
                      }
                      className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                        <option key={n} value={n}>
                          {n} adulte{n > 1 ? "s" : ""}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <Users className="w-4 h-4 inline mr-1" />
                      Passagers enfants
                    </label>
                    <select
                      value={searchParams.children}
                      onChange={(e) =>
                        setSearchParams((prev) => ({
                          ...prev,
                          children: parseInt(e.target.value),
                        }))
                      }
                      className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    >
                      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                        <option key={n} value={n}>
                          {n} enfant{n > 1 ? "s" : ""}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <Star className="w-4 h-4 inline mr-1" />
                      Classe de voyage
                    </label>
                    <select
                      value={searchParams.travelClass}
                      onChange={(e) =>
                        setSearchParams((prev) => ({
                          ...prev,
                          travelClass: e.target.value,
                        }))
                      }
                      className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="ECONOMY">Économique</option>
                      <option value="PREMIUM_ECONOMY">
                        Économique Premium
                      </option>
                      <option value="BUSINESS">Affaires</option>
                      <option value="FIRST">Première Classe</option>
                    </select>
                  </div>
                </div>
              </div>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white py-4 rounded-xl font-bold text-lg shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          >
            {loading ? (
              <>
                <Loader className="w-6 h-6 mr-3 animate-spin" />
                Recherche en cours...
              </>
            ) : (
              <>
                <Search className="w-6 h-6 mr-3" />
                {searchParams.tripType === "multi-city"
                  ? `Rechercher ${multiCitySegments.length} vol${
                      multiCitySegments.length > 1 ? "s" : ""
                    } multi-destinations`
                  : searchParams.tripType === "round-trip"
                  ? "Rechercher des vols aller-retour"
                  : "Rechercher des vols aller simple"}
              </>
            )}
          </button>
        </form>
      </div>

      {/* Affichage des résultats */}
      {searchResults.length > 0 && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <h3 className="text-xl font-bold mb-4">
            {searchResults.length} vol{searchResults.length > 1 ? "s" : ""}{" "}
            trouvé{searchResults.length > 1 ? "s" : ""}
          </h3>
          <div className="space-y-4">
            {searchResults.map((flight, index) => (
              <div
                key={index}
                className="border rounded-lg p-4 hover:shadow-lg transition"
              >
                <div className="flex justify-between items-center">
                  <div className="flex-1">
                    <h4 className="font-bold text-lg">
                      {flight.departure} → {flight.arrival}
                    </h4>
                    <p className="text-gray-600">
                      {flight.departureTime} - {flight.arrivalTime} •{" "}
                      {flight.duration}
                    </p>
                    <p className="text-sm text-gray-500">{flight.airline}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-2xl font-bold text-blue-600">
                      {flight.price} {flight.currency}
                    </p>
                    <button
                      onClick={() => onSelectFlight(flight)}
                      className="mt-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                    >
                      Sélectionner
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const DirectFlightPurchase = ({
  user,
  onPurchaseCompleted,
  addToCart,
  cart,
  totalPassengers,
  onSelectFlight,
  config = {},
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [searchParams, setSearchParams] = useState({
    originLocationCode: "",
    destinationLocationCode: "",
    departureDate: "",
    returnDate: "",
    adults: 1,
    children: 0,
    infants: 0,
    travelClass: "ECONOMY",
    tripType: "one-way",
  });
  const [flights, setFlights] = useState([]);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [passengers, setPassengers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [error, setError] = useState(null);

  const steps = [
    { id: 1, label: "Recherche", icon: "🔍" },
    { id: 2, label: "Sélection", icon: "✈️" },
    { id: 3, label: "Passagers", icon: "👥" },
    { id: 4, label: "Paiement", icon: "💳" },
    { id: 5, label: "Confirmation", icon: "✅" },
  ];

  const handleSearch = async (e, segments = []) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Appel API pour rechercher des vols
      const searchPayload = {
        ...searchParams,
        segments: segments.length > 0 ? segments : undefined,
      };

      const response = await fetch(`${API_BASE_URL}/flight-search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(searchPayload),
      });

      if (!response.ok) {
        throw new Error("Erreur lors de la recherche de vols");
      }

      const results = await response.json();
      setSearchResults(results);
    } catch (error) {
      console.error("Erreur lors de la recherche:", error);
      setError("Erreur lors de la recherche de vols");

      // Fallback avec des données mockées en cas d'erreur
      const mockResults = [
        {
          id: "1",
          airline: "Air France",
          departure: searchParams.originLocationCode,
          arrival: searchParams.destinationLocationCode,
          departureTime: "08:00",
          arrivalTime: "12:00",
          duration: "4h 00min",
          price: "450",
          currency: "EUR",
          stops: 0,
          flightNumber: "AF123",
        },
        {
          id: "2",
          airline: "Air Côte d'Ivoire",
          departure: searchParams.originLocationCode,
          arrival: searchParams.destinationLocationCode,
          departureTime: "14:00",
          arrivalTime: "18:00",
          duration: "4h 00min",
          price: "380",
          currency: "EUR",
          stops: 0,
          flightNumber: "CI456",
        },
      ];
      setSearchResults(mockResults);
    } finally {
      setLoading(false);
    }
  };

  const handleFlightSelection = (flight) => {
    setSelectedFlight(flight);
    setCurrentStep(3);

    const totalPax =
      searchParams.adults + searchParams.children + searchParams.infants;
    const passengersList = [];

    for (let i = 0; i < searchParams.adults; i++) {
      passengersList.push({
        type: "ADULT",
        nom: "",
        prenom: "",
        date_naissance: "",
        email: user?.email || "",
        telephone: user?.phone || "",
        genre: "",
        nationalite: "",
        numero_passeport: "",
        date_expiration_passeport: "",
        numero_siege: "",
      });
    }

    for (let i = 0; i < searchParams.children; i++) {
      passengersList.push({
        type: "CHILD",
        nom: "",
        prenom: "",
        date_naissance: "",
        email: "",
        telephone: "",
        genre: "",
        nationalite: "",
        numero_passeport: "",
        date_expiration_passeport: "",
        numero_siege: "",
      });
    }

    for (let i = 0; i < searchParams.infants; i++) {
      passengersList.push({
        type: "INFANT",
        nom: "",
        prenom: "",
        date_naissance: "",
        email: "",
        telephone: "",
        genre: "",
        nationalite: "",
        numero_passeport: "",
        date_expiration_passeport: "",
        numero_siege: "",
      });
    }

    setPassengers(passengersList);
  };

  const updatePassenger = (index, field, value) => {
    const updated = [...passengers];
    updated[index][field] = value;
    setPassengers(updated);
  };

  const validatePassengers = () => {
    for (let passenger of passengers) {
      if (!passenger.nom || !passenger.prenom || !passenger.email) {
        setError(
          "Veuillez remplir toutes les informations obligatoires pour chaque passager"
        );
        return false;
      }
    }
    return true;
  };

  const proceedToPayment = () => {
    if (validatePassengers()) {
      setCurrentStep(4);
      setError(null);
    }
  };

  const processPayment = async () => {
    setLoading(true);
    setError(null);

    try {
      // 1. Créer l'achat de vol direct
      const purchaseData = {
        agentId: user?.agentId || "default-agent-id",
        createdById: user?.id,
        compagnieAerienne: selectedFlight.airline,
        numeroVol: selectedFlight.flightNumber,
        dateDepart: new Date(
          `${searchParams.departureDate}T${selectedFlight.departureTime}`
        ),
        dateArrivee: new Date(
          `${searchParams.departureDate}T${selectedFlight.arrivalTime}`
        ),
        villeDepart: selectedFlight.departure,
        villeArrivee: selectedFlight.arrival,
        montant: parseFloat(selectedFlight.price),
        devise: selectedFlight.currency,
        statut: "En attente",
        commentaire: "Réservation en attente de paiement",
      };

      const createResponse = await fetch(
        `${API_BASE_URL}/direct-flight-purchases`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(purchaseData),
        }
      );

      if (!createResponse.ok) {
        throw new Error("Erreur lors de la création de la réservation");
      }

      const createdPurchase = await createResponse.json();

      // 2. Mettre à jour les voyageurs
      const travelersData = {
        travelers: passengers.map((passenger, index) => ({
          passenger_index: index,
          nom: passenger.nom,
          prenom: passenger.prenom,
          date_naissance: passenger.date_naissance,
          genre: passenger.genre,
          nationalite: passenger.nationalite,
          numero_passeport: passenger.numero_passeport,
          date_expiration_passeport: passenger.date_expiration_passeport,
          numero_siege: passenger.numero_siege,
        })),
      };

      const travelersResponse = await fetch(
        `${API_BASE_URL2}/direct-flight-purchases/${createdPurchase.id}/travelers`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(travelersData),
        }
      );

      if (!travelersResponse.ok) {
        throw new Error("Erreur lors de l'enregistrement des voyageurs");
      }

      // 3. Émettre le billet
      const emitResponse = await fetch(
        `${API_BASE_URL2}/direct-flight-purchases/${createdPurchase.id}/emit-ticket`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            billetReference: `TKT${Date.now()}`,
          }),
        }
      );

      if (!emitResponse.ok) {
        throw new Error("Erreur lors de l'émission du billet");
      }

      const finalPurchase = await emitResponse.json();

      setLoading(false);
      setCurrentStep(5);

      if (onPurchaseCompleted) {
        onPurchaseCompleted({
          pnr: finalPurchase.billetReference,
          success: true,
          flight: selectedFlight,
          passengers: passengers,
          purchaseId: finalPurchase.id,
        });
      }
    } catch (error) {
      console.error("Erreur lors du processus de paiement:", error);
      setError(`Erreur lors de la réservation: ${error.message}`);
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto">
      {/* Barre de progression */}
      <div className="mb-8 bg-white rounded-lg shadow p-4">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <div
              key={step.id}
              className={`flex items-center ${
                index < steps.length - 1 ? "flex-1" : ""
              }`}
            >
              <div
                className={`flex items-center justify-center w-12 h-12 rounded-full text-lg border-2 
                  ${
                    currentStep >= step.id
                      ? "bg-blue-600 text-white border-blue-600"
                      : "bg-white text-gray-400 border-gray-300"
                  }`}
              >
                <span>{step.icon}</span>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-1 mx-4 ${
                    currentStep > step.id ? "bg-blue-600" : "bg-gray-200"
                  }`}
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Étape 1: Recherche avec SearchTab */}
      {currentStep === 1 && (
        <SearchTab
          totalPassengers={totalPassengers}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          handleSearch={handleSearch}
          loading={loading}
          error={error}
          searchResults={searchResults}
          onSelectFlight={handleFlightSelection}
          cart={cart}
        />
      )}

      {/* Étape 3: Informations passagers */}
      {currentStep === 3 && (
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold">Informations passagers</h2>
            <button
              onClick={() => setCurrentStep(1)}
              className="text-blue-600 hover:text-blue-800 flex items-center"
            >
              <ChevronLeft className="w-4 h-4 mr-1" />
              Retour à la recherche
            </button>
          </div>

          {selectedFlight && (
            <div className="bg-blue-50 rounded-lg p-4 mb-6">
              <h3 className="font-bold text-lg mb-2">Vol sélectionné</h3>
              <div className="flex justify-between items-center">
                <div>
                  <p className="font-semibold">
                    {selectedFlight.departure} → {selectedFlight.arrival}
                  </p>
                  <p className="text-gray-600">
                    {selectedFlight.departureTime} -{" "}
                    {selectedFlight.arrivalTime}
                  </p>
                  <p className="text-sm text-gray-500">
                    {selectedFlight.airline} • {selectedFlight.duration}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-xl font-bold text-blue-600">
                    {selectedFlight.price} {selectedFlight.currency}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="space-y-6">
            {passengers.map((passenger, index) => (
              <div key={index} className="border rounded-lg p-6">
                <h3 className="font-bold text-lg mb-4">
                  Passager {index + 1}
                  <span className="ml-2 text-sm font-normal text-gray-500">
                    (
                    {passenger.type === "ADULT"
                      ? "Adulte"
                      : passenger.type === "CHILD"
                      ? "Enfant"
                      : "Bébé"}
                    )
                  </span>
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Nom *
                    </label>
                    <input
                      type="text"
                      placeholder="Nom"
                      value={passenger.nom}
                      onChange={(e) =>
                        updatePassenger(index, "nom", e.target.value)
                      }
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Prénom *
                    </label>
                    <input
                      type="text"
                      placeholder="Prénom"
                      value={passenger.prenom}
                      onChange={(e) =>
                        updatePassenger(index, "prenom", e.target.value)
                      }
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Date de naissance
                    </label>
                    <input
                      type="date"
                      value={passenger.date_naissance}
                      onChange={(e) =>
                        updatePassenger(index, "date_naissance", e.target.value)
                      }
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Email {passenger.type === "ADULT" ? "*" : ""}
                    </label>
                    <input
                      type="email"
                      placeholder="email@exemple.com"
                      value={passenger.email}
                      onChange={(e) =>
                        updatePassenger(index, "email", e.target.value)
                      }
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      required={passenger.type === "ADULT"}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Genre
                    </label>
                    <select
                      value={passenger.genre}
                      onChange={(e) =>
                        updatePassenger(index, "genre", e.target.value)
                      }
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="">Sélectionnez</option>
                      <option value="M">Masculin</option>
                      <option value="F">Féminin</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Nationalité
                    </label>
                    <input
                      type="text"
                      placeholder="Nationalité"
                      value={passenger.nationalite}
                      onChange={(e) =>
                        updatePassenger(index, "nationalite", e.target.value)
                      }
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Numéro de passeport
                    </label>
                    <input
                      type="text"
                      placeholder="Numéro de passeport"
                      value={passenger.numero_passeport}
                      onChange={(e) =>
                        updatePassenger(
                          index,
                          "numero_passeport",
                          e.target.value
                        )
                      }
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Date d'expiration passeport
                    </label>
                    <input
                      type="date"
                      value={passenger.date_expiration_passeport}
                      onChange={(e) =>
                        updatePassenger(
                          index,
                          "date_expiration_passeport",
                          e.target.value
                        )
                      }
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Téléphone
                    </label>
                    <input
                      type="tel"
                      placeholder="+33 1 23 45 67 89"
                      value={passenger.telephone}
                      onChange={(e) =>
                        updatePassenger(index, "telephone", e.target.value)
                      }
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {error && (
            <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-red-600">{error}</p>
            </div>
          )}

          <button
            onClick={proceedToPayment}
            className="w-full mt-6 bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 font-semibold"
          >
            Continuer vers le paiement
          </button>
        </div>
      )}

      {/* Étape 4: Paiement */}
      {currentStep === 4 && (
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold">Paiement</h2>
            <button
              onClick={() => setCurrentStep(3)}
              className="text-blue-600 hover:text-blue-800 flex items-center"
            >
              <ChevronLeft className="w-4 h-4 mr-1" />
              Retour aux passagers
            </button>
          </div>

          {selectedFlight && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <h3 className="font-bold text-lg mb-3">
                Récapitulatif de votre commande
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span>
                    Vol {selectedFlight.departure} → {selectedFlight.arrival}
                  </span>
                  <span>
                    {selectedFlight.price} {selectedFlight.currency}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>
                    {passengers.length} passager
                    {passengers.length > 1 ? "s" : ""}
                  </span>
                  <span>Inclus</span>
                </div>
                <div className="border-t pt-2 mt-2">
                  <div className="flex justify-between font-bold">
                    <span>Total</span>
                    <span>
                      {selectedFlight.price} {selectedFlight.currency}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="space-y-4">
            <h3 className="font-bold text-lg">Informations de paiement</h3>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Numéro de carte *
              </label>
              <input
                type="text"
                placeholder="1234 5678 9012 3456"
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Date d'expiration *
                </label>
                <input
                  type="text"
                  placeholder="MM/AA"
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  CVV *
                </label>
                <input
                  type="text"
                  placeholder="123"
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Titulaire de la carte *
              </label>
              <input
                type="text"
                placeholder="Nom comme sur la carte"
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <button
            onClick={processPayment}
            disabled={loading}
            className="w-full mt-6 bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <Loader className="w-5 h-5 mr-2 animate-spin" />
                Traitement en cours...
              </div>
            ) : (
              `Payer ${selectedFlight?.price} ${selectedFlight?.currency}`
            )}
          </button>
        </div>
      )}

      {/* Étape 5: Confirmation */}
      {currentStep === 5 && (
        <div className="bg-white rounded-lg shadow p-6 text-center">
          <div className="w-24 h-24 text-green-500 mx-auto mb-4">✅</div>
          <h2 className="text-2xl font-bold mb-4">Réservation confirmée!</h2>

          {selectedFlight && (
            <div className="bg-green-50 rounded-lg p-6 mb-6 text-left">
              <h3 className="font-bold text-lg mb-3">
                Détails de votre réservation
              </h3>
              <div className="space-y-2">
                <p>
                  <strong>Référence:</strong> ABC123
                </p>
                <p>
                  <strong>Vol:</strong> {selectedFlight.departure} →{" "}
                  {selectedFlight.arrival}
                </p>
                <p>
                  <strong>Date:</strong> {selectedFlight.departureTime}
                </p>
                <p>
                  <strong>Compagnie:</strong> {selectedFlight.airline}
                </p>
                <p>
                  <strong>Passagers:</strong> {passengers.length}
                </p>
                <p>
                  <strong>Total payé:</strong> {selectedFlight.price}{" "}
                  {selectedFlight.currency}
                </p>
              </div>
            </div>
          )}

          <p className="text-gray-600 mb-6">
            Votre billet a été émis avec succès. Un email de confirmation a été
            envoyé à votre adresse email.
          </p>

          <button
            onClick={() => {
              setCurrentStep(1);
              setSelectedFlight(null);
              setPassengers([]);
              setSearchResults([]);
            }}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
          >
            Faire une nouvelle réservation
          </button>
        </div>
      )}
    </div>
  );
};

// ==================== COMPOSANT RÉSERVATION DIRECTE HÔTEL ====================
const DirectHotelBooking = ({ user, onBookingCompleted, config = {} }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [searchParams, setSearchParams] = useState({
    cityCode: "",
    checkInDate: "",
    checkOutDate: "",
    adults: 1,
    roomQuantity: 1,
  });
  const [hotels, setHotels] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [loading, setLoading] = useState(false);

  const steps = [
    { id: 1, label: "Recherche", icon: "🔍" },
    { id: 2, label: "Sélection", icon: "🏨" },
    { id: 3, label: "Clients", icon: "👥" },
    { id: 4, label: "Paiement", icon: "💳" },
    { id: 5, label: "Confirmation", icon: "✅" },
  ];

  const searchHotels = async () => {
    setLoading(true);
    try {
      // Simuler une recherche d'hôtels
      const mockHotels = [
        {
          id: "1",
          hotel: { name: "Radisson Blu Abidjan", rating: 5 },
          price: { total: "150", currency: "EUR" },
        },
      ];
      setHotels(mockHotels);
      setCurrentStep(2);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto">
      <div className="mb-8 bg-white rounded-lg shadow p-4">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <div
              key={step.id}
              className={`flex items-center ${
                index < steps.length - 1 ? "flex-1" : ""
              }`}
            >
              <div
                className={`flex items-center justify-center w-12 h-12 rounded-full text-lg border-2 
                  ${
                    currentStep >= step.id
                      ? "bg-green-600 text-white border-green-600"
                      : "bg-white text-gray-400 border-gray-300"
                  }`}
              >
                <span>{step.icon}</span>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-1 mx-4 ${
                    currentStep > step.id ? "bg-green-600" : "bg-gray-200"
                  }`}
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {currentStep === 1 && (
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-2xl font-bold mb-6">Rechercher un hôtel</h2>
          <div className="space-y-4">
            <input
              type="text"
              placeholder="Ville (ABJ, DSS, CKY...)"
              value={searchParams.cityCode}
              onChange={(e) =>
                setSearchParams({ ...searchParams, cityCode: e.target.value })
              }
              className="w-full px-4 py-2 border rounded-lg"
            />
            <div className="grid md:grid-cols-2 gap-4">
              <input
                type="date"
                value={searchParams.checkInDate}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    checkInDate: e.target.value,
                  })
                }
                className="px-4 py-2 border rounded-lg"
              />
              <input
                type="date"
                value={searchParams.checkOutDate}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    checkOutDate: e.target.value,
                  })
                }
                className="px-4 py-2 border rounded-lg"
              />
            </div>
          </div>
          <button
            onClick={searchHotels}
            disabled={loading}
            className="mt-6 w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 disabled:opacity-50"
          >
            {loading ? "Recherche..." : "Rechercher des hôtels"}
          </button>
        </div>
      )}

      {currentStep === 2 && hotels.length > 0 && (
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-2xl font-bold mb-6">Sélectionner un hôtel</h2>
          {hotels.map((hotel) => (
            <div
              key={hotel.id}
              className="border rounded-lg p-4 mb-4 hover:border-green-500 cursor-pointer"
              onClick={() => {
                setSelectedHotel(hotel);
                setCurrentStep(3);
              }}
            >
              <div className="flex justify-between items-center">
                <div>
                  <p className="font-bold">{hotel.hotel.name}</p>
                  <div className="flex items-center">
                    {[...Array(hotel.hotel.rating)].map((_, i) => (
                      <Star
                        key={i}
                        className="w-4 h-4 text-yellow-400 fill-current"
                      />
                    ))}
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-2xl font-bold text-green-600">
                    {hotel.price.total} {hotel.price.currency}
                  </p>
                  <button className="mt-2 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
                    Sélectionner
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {currentStep >= 3 && currentStep <= 5 && (
        <div className="bg-white rounded-lg shadow p-6 text-center">
          <h2 className="text-2xl font-bold mb-4">
            {currentStep === 3 && "Informations clients"}
            {currentStep === 4 && "Paiement"}
            {currentStep === 5 && "Réservation confirmée!"}
          </h2>
          {currentStep < 5 && (
            <button
              onClick={() => {
                setCurrentStep(currentStep + 1);
                if (currentStep === 4 && onBookingCompleted) {
                  onBookingCompleted({
                    confirmationNumber: "HTL123",
                    success: true,
                  });
                }
              }}
              className="mt-4 bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700"
            >
              Continuer
            </button>
          )}
          {currentStep === 5 && (
            <CheckCircle className="w-24 h-24 text-green-500 mx-auto mt-4" />
          )}
        </div>
      )}
    </div>
  );
};

// ==================== COMPOSANT DASHBOARD RÉSERVATION RAPIDE ====================
const QuickBookingDashboard = ({
  user,
  modules = ["flight", "hotel"],
  onFlightPurchase,
  onHotelBooking,
}) => {
  const [stats] = useState({
    totalFlights: 12,
    totalHotels: 8,
    totalSpent: 4589.5,
    savedTime: 36,
  });

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-blue-600 to-green-500 rounded-xl p-8 text-white shadow-lg">
        <h1 className="text-3xl font-bold mb-2">Réservation Rapide</h1>
        <p className="text-lg opacity-90">
          Achetez vos billets et réservez vos hôtels instantanément!
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {modules.includes("flight") && (
          <div
            onClick={onFlightPurchase}
            className="bg-white rounded-xl shadow-md p-6 cursor-pointer hover:shadow-xl transition-all"
          >
            <Plane className="w-8 h-8 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">Acheter un Billet</h3>
            <p className="text-gray-600">Réservation instantanée de vols</p>
          </div>
        )}

        {modules.includes("hotel") && (
          <div
            onClick={onHotelBooking}
            className="bg-white rounded-xl shadow-md p-6 cursor-pointer hover:shadow-xl transition-all"
          >
            <Hotel className="w-8 h-8 text-green-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">Réserver un Hôtel</h3>
            <p className="text-gray-600">Confirmation immédiate</p>
          </div>
        )}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-3xl font-bold text-blue-600">
            {stats.totalFlights}
          </div>
          <div className="text-sm text-gray-600">Billets</div>
        </div>
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-3xl font-bold text-green-600">
            {stats.totalHotels}
          </div>
          <div className="text-sm text-gray-600">Hôtels</div>
        </div>
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-3xl font-bold text-purple-600">
            {stats.totalSpent}€
          </div>
          <div className="text-sm text-gray-600">Dépensé</div>
        </div>
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-3xl font-bold text-orange-600">
            {stats.savedTime}h
          </div>
          <div className="text-sm text-gray-600">Économisé</div>
        </div>
      </div>
    </div>
  );
};

// ==================== COMPOSANT MES ACHATS DIRECTS ====================
const MyDirectPurchases = ({ user, type = "all" }) => {
  const [purchases] = useState([
    {
      id: 1,
      type: "flight",
      pnr: "ABC123",
      route: "ABJ → DSS",
      amount: 214.12,
      date: "2024-10-20",
    },
    {
      id: 2,
      type: "hotel",
      confirmationNumber: "HTL456",
      hotelName: "Radisson Blu",
      amount: 360,
      date: "2024-10-18",
    },
  ]);

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h1 className="text-2xl font-bold mb-4">Mes Achats Directs</h1>
        <div className="space-y-4">
          {purchases.map((purchase) => (
            <div key={purchase.id} className="border rounded-lg p-4">
              <div className="flex justify-between items-center">
                <div>
                  <p className="font-bold">
                    {purchase.type === "flight"
                      ? purchase.route
                      : purchase.hotelName}
                  </p>
                  <p className="text-sm text-gray-600">
                    {purchase.type === "flight"
                      ? `PNR: ${purchase.pnr}`
                      : `Conf: ${purchase.confirmationNumber}`}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-xl font-bold">{purchase.amount}€</p>
                  <p className="text-sm text-gray-500">{purchase.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// ==================== HANDLERS ====================
const handleDirectPurchaseCompleted = (purchaseData) => {
  console.log("Achat direct complété:", purchaseData);
};

const handleDirectHotelBookingCompleted = (bookingData) => {
  console.log("Réservation directe complétée:", bookingData);
};

const handleFlightRequestSubmitted = (data) => {
  console.log("Demande de vol soumise:", data);
};

const handleHotelRequestSubmitted = (data) => {
  console.log("Demande hôtel soumise:", data);
};

function Page() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentPage, setCurrentPage] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [loginForm, setLoginForm] = useState({ email: "", password: "" });
  const [flightRequests, setFlightRequests] = useState([]);
  const [hotelRequests, setHotelRequests] = useState([]);
  const [loadingFlights, setLoadingFlights] = useState(false);
  const [loadingHotels, setLoadingHotels] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [showPassword, setShowPassword] = useState(false);
  // Initialisation de l'authentification
  useEffect(() => {
    const initializeAuth = async () => {
      if (AUTH_SERVICE.isAuthenticated()) {
        const user = AUTH_SERVICE.getCurrentUser();
        setCurrentUser(user);
        setIsLoggedIn(true);

        // Charger les données après authentification
        await loadFlightRequests();
        await loadHotelRequests();
      }
      setIsLoading(false);
    };

    initializeAuth();
  }, []);

  const loadHotelRequests = async () => {
    if (!AUTH_SERVICE.hasPermission("demandes_read")) return;

    setLoadingHotels(true);
    try {
      const response = await AUTH_SERVICE.apiRequest("/hotel-requests");
      if (response.ok) {
        const data = await response.json();
        setHotelRequests(data);
      }
    } catch (error) {
      console.error("Erreur chargement demandes hôtels:", error);
    } finally {
      setLoadingHotels(false);
    }
  };

  const loadFlightRequests = async () => {
    if (!AUTH_SERVICE.hasPermission("demandes_read")) return;

    setLoadingFlights(true);
    try {
      const response = await AUTH_SERVICE.apiRequest("/flight-requests");
      if (response.ok) {
        const data = await response.json();
        setFlightRequests(data);
      }
    } catch (error) {
      console.error("Erreur chargement demandes:", error);
    } finally {
      setLoadingFlights(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const result = await AUTH_SERVICE.login(
        loginForm.email,
        loginForm.password
      );

      if (result.success) {
        setCurrentUser(result.user);
        setIsLoggedIn(true);
        setCurrentPage("dashboard");

        // Charger les données après connexion
        await loadFlightRequests();
        await loadHotelRequests();
      }
    } catch (error) {
      toast.error(error.message);
      // alert();
    }
  };

  const handleLogout = () => {
    AUTH_SERVICE.logout();
    setIsLoggedIn(false);
    setCurrentUser(null);
    setFlightRequests([]);
    setHotelRequests([]);
  };

  // Navigation sécurisée
  const navigateTo = (page, requiredPermissions = []) => {
    if (
      requiredPermissions.length > 0 &&
      !AUTH_SERVICE.hasAnyPermission(requiredPermissions)
    ) {
      toast.error(
        "Vous n'avez pas les permissions nécessaires pour accéder à cette section."
      );
      return;
    }
    setCurrentPage(page);
  };

  const handleFlightRequestSubmitted = async (request) => {
    try {
      if (request.type === "multi-flights" && request.flights) {
        const multiFlightRequest = {
          numeroRequete: `MULTI-${Date.now()}`,
          id: generateUUID(),
          type: "multi-flights",
          matricule: currentUser.agent?.matricule || currentUser.matricule,
          nom: currentUser.nom,
          agentId: currentUser.agent?.id || currentUser.id,
          prenom: currentUser.prenom,
          categorie: currentUser.agent?.categorie || currentUser.categorie,
          fonction: currentUser.agent?.fonction || currentUser.fonction,
          objetVoyage: request.objetVoyage,
          motifDeplacement: request.motifDeplacement,
          projet: request.projet || "",
          centreCoût: request.centreCoût || "",
          vol: request.flights.map((flight) => ({
            ...flight,
            searchParams: flight.searchParams || {
              originLocationCode:
                flight.itineraries?.[0]?.segments?.[0]?.departure?.iataCode ||
                "",
              destinationLocationCode:
                flight.itineraries?.[0]?.segments?.[
                  flight.itineraries[0].segments.length - 1
                ]?.arrival?.iataCode || "",
              departureDate:
                flight.searchParams?.departureDate ||
                new Date().toISOString().split("T")[0],
              adults: flight.searchParams?.adults || "1",
              tripType: "one-way",
              travelClass: flight.searchParams?.travelClass || "ECONOMY",
            },
          })),
          searchParams: {
            originLocationCode:
              request.flights[0]?.itineraries?.[0]?.segments?.[0]?.departure
                ?.iataCode || "",
            destinationLocationCode:
              request.flights[request.flights.length - 1]?.itineraries?.[0]
                ?.segments?.[0]?.arrival?.iataCode || "",
            departureDate:
              request.flights[0]?.searchParams?.departureDate ||
              new Date().toISOString().split("T")[0],
            adults: request.flights[0]?.searchParams?.adults || "1",
            tripType: "multi-city",
            travelClass:
              request.flights[0]?.searchParams?.travelClass || "ECONOMY",
            numberOfFlights: request.flights.length,
          },
          dateRequete: new Date().toISOString(),
          createdAt: new Date(),
          statut: "En attente",
          montant: request.montantTotal,
          devise: request.devise,
          agentId: currentUser.agent?.id || currentUser.id,
          createdById: currentUser.id,
        };

        const response = await AUTH_SERVICE.apiRequest("/flight-requests", {
          method: "POST",
          body: JSON.stringify(multiFlightRequest),
        });

        if (response.ok) {
          toast.success(
            `Demande multi-vols créée avec succès ! (${request.flights.length} vols inclus)`
          );
          await loadFlightRequests();
          setCurrentPage("flight-requests");
        }
      }
    } catch (error) {
      console.error("Erreur lors de la création de la demande:", error);
      toast.error(`Erreur lors de la création de la demande: ${error.message}`);
    }
  };

  const handleHotelRequestSubmitted = async (request) => {
    await loadHotelRequests();
    setCurrentPage("hotel-requests");
  };

  const handleApprove = async (id) => {
    if (!AUTH_SERVICE.hasPermission("demandes_approve")) {
      toast.error("Vous n'avez pas la permission d'approuver les demandes");
      return;
    }

    try {
      const response = await AUTH_SERVICE.apiRequest(
        `/flight-requests/${id}/approve`,
        {
          method: "PUT",
        }
      );

      if (response.ok) {
        setFlightRequests(
          flightRequests.map((r) =>
            r.numeroRequete === id ? { ...r, statut: "Approuvée" } : r
          )
        );
      }
    } catch (error) {
      console.error("Erreur approbation:", error);
    }
  };

  const handleReject = async (id) => {
    if (!AUTH_SERVICE.hasPermission("demandes_approve")) {
      toast.error("Vous n'avez pas la permission de rejeter les demandes");
      return;
    }

    try {
      const response = await AUTH_SERVICE.apiRequest(
        `/flight-requests/${id}/reject`,
        {
          method: "PUT",
        }
      );

      if (response.ok) {
        setFlightRequests(
          flightRequests.map((r) =>
            r.numeroRequete === id ? { ...r, statut: "Rejetée" } : r
          )
        );
      }
    } catch (error) {
      console.error("Erreur rejet:", error);
    }
  };

  const handleEmitTicket = async (id) => {
    if (!AUTH_SERVICE.hasPermission("billets_emit")) {
      toast.error("Vous n'avez pas la permission d'émettre des billets");
      return;
    }

    try {
      const response = await AUTH_SERVICE.apiRequest(
        `/flight-requests/${id}/emit-ticket`,
        {
          method: "PUT",
        }
      );

      if (response.ok) {
        setFlightRequests(
          flightRequests.map((r) =>
            r.numeroRequete === id ? { ...r, statut: "Billet émis" } : r
          )
        );
      }
    } catch (error) {
      console.error("Erreur émission billet:", error);
    }
  };

  const handleHotelApprove = async (id) => {
    if (!AUTH_SERVICE.hasPermission("demandes_approve")) {
      toast.error("Vous n'avez pas la permission d'approuver les demandes");
      return;
    }

    try {
      const response = await AUTH_SERVICE.apiRequest(
        `/hotel-requests/${id}/approve`,
        {
          method: "PUT",
        }
      );

      if (response.ok) {
        setHotelRequests(
          hotelRequests.map((r) =>
            r.numeroRequete === id ? { ...r, statut: "Approuvée" } : r
          )
        );
      }
    } catch (error) {
      console.error("Erreur approbation hôtel:", error);
    }
  };

  const handleHotelReject = async (id) => {
    if (!AUTH_SERVICE.hasPermission("demandes_approve")) {
      toast.error("Vous n'avez pas la permission de rejeter les demandes");
      return;
    }

    try {
      const response = await AUTH_SERVICE.apiRequest(
        `/hotel-requests/${id}/reject`,
        {
          method: "PUT",
        }
      );

      if (response.ok) {
        setHotelRequests(
          hotelRequests.map((r) =>
            r.numeroRequete === id ? { ...r, statut: "Rejetée" } : r
          )
        );
      }
    } catch (error) {
      console.error("Erreur rejet hôtel:", error);
    }
  };

  const handleHotelBook = async (id) => {
    if (!AUTH_SERVICE.hasPermission("billets_emit")) {
      toast.error("Vous n'avez pas la permission de réserver des hôtels");
      return;
    }

    try {
      const response = await AUTH_SERVICE.apiRequest(
        `/hotel-requests/${id}/book`,
        {
          method: "PUT",
        }
      );

      if (response.ok) {
        setHotelRequests(
          hotelRequests.map((r) =>
            r.numeroRequete === id ? { ...r, statut: "Réservée" } : r
          )
        );
      }
    } catch (error) {
      console.error("Erreur réservation hôtel:", error);
    }
  };

  // Menu items avec vérification des permissions
  const menuItems = [
    {
      id: "dashboard",
      icon: BarChart3,
      label: "Tableau de bord",
      permission: "demandes_read",
    },
    {
      id: "quick-booking",
      icon: Zap,
      label: "Réservation Rapide",
      badge: "NEW",
      permission: "direct_purchase",
    },
    {
      id: "direct-flight-purchase",
      icon: Plane,
      label: "Achat Direct Vol",
      permission: "direct_purchase",
    },
    {
      id: "direct-hotel-booking",
      icon: Hotel,
      label: "Réservation Hôtel",
      permission: "direct_purchase",
    },
    {
      id: "my-direct-purchases",
      icon: ShoppingCart,
      label: "Mes Achats",
      permission: "direct_purchase",
    },
    {
      id: "new-flight-request",
      icon: Plane,
      label: "Demande Billet",
      permission: "demandes_create",
    },
    {
      id: "new-hotel-request",
      icon: Hotel,
      label: "Demande Hebergement",
      permission: "demandes_create",
    },
    {
      id: "flight-requests",
      icon: Clock,
      label: "liste Billets",
      permission: "demandes_read",
    },
    {
      id: "hotel-requests",
      icon: Hotel,
      label: "Liste Hebergement",
      permission: "demandes_read",
    },
    {
      id: "billing",
      icon: CreditCard,
      label: "Facturation",
      permission: "reports_view",
    },
    {
      id: "statistics",
      icon: BarChart3,
      label: "Statistiques",
      permission: "reports_view",
    },
    {
      id: "travelers",
      icon: Users,
      label: "Voyageurs",
      permission: "demandes_read",
    },
    {
      id: "administration",
      icon: Settings,
      label: "Administration",
      permission: [
        "admin_entities",
        "admin_agents",
        "admin_users",
        "admin_profiles",
      ],
    },
  ].filter((item) => {
    if (!item.permission) return true;
    if (Array.isArray(item.permission)) {
      return AUTH_SERVICE.hasAnyPermission(item.permission);
    }
    return AUTH_SERVICE.hasPermission(item.permission);
  });

  useEffect(() => {
    if (!isLoggedIn) {
      document.title = "Connexion | ABM Travel";
    } else {
      document.title = "Tableau de bord | ABM Travel";
    }
  }, [isLoggedIn]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader className="w-12 h-12 text-blue-600 mx-auto mb-4 animate-spin" />
          <p className="text-gray-600">Chargement de l'application...</p>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <>
        <div
          className="min-h-screen flex items-center justify-center p-4"
          style={{
            backgroundImage:
              'url("https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>

          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative z-10">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-8 text-white rounded-t-2xl">
              <div className="flex justify-center mb-4">
                <img
                  src="/BanniereABM.png"
                  alt="ABM Travel Logo"
                  className="w-16 h-16 object-contain"
                />
              </div>
              <h1 className="text-3xl font-bold text-center">ABM Travel</h1>
              <p className="text-center text-green-100 mt-2 font-bold">
                Trip Manager Pro (TMP)
              </p>
              <p className="text-center text-blue-50 mt-4 text-sm px-4">
                Simplifiez vos déplacements professionnels en quelques clics.
                Recherchez, réservez et gérez vos vols et hôtels.
              </p>
            </div>

            <form onSubmit={handleLogin} className="p-8">
              <div className="mb-6">
                <label className="block text-gray-700 font-semibold mb-2">
                  Email
                </label>
                <input
                  type="email"
                  value={loginForm.email}
                  onChange={(e) =>
                    setLoginForm({ ...loginForm, email: e.target.value })
                  }
                  className="w-full px-4 py-3 border rounded-lg"
                  placeholder="email@entreprise.com"
                  required
                />
              </div>
              <div className="mb-6">
                <label className="block text-gray-700 font-semibold mb-2">
                  Mot de passe
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={loginForm.password}
                    onChange={(e) =>
                      setLoginForm({ ...loginForm, password: e.target.value })
                    }
                    className="w-full px-4 py-3 border rounded-lg pr-12"
                    placeholder="••••••••"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                  >
                    {showPassword ? (
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                        />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700"
              >
                Se connecter
              </button>
            </form>
          </div>
        </div>
        <ToastContainer />
      </>
    );
  }

  const DashboardContent = () => (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Bienvenue, {currentUser.prenom} {currentUser.nom} !
        </h1>
        <p className="text-gray-600">
          Vous êtes connecté en tant que{" "}
          <span className="font-semibold">
            {currentUser.profil?.nom || "Utilisateur"}
          </span>
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {AUTH_SERVICE.hasPermission("demandes_read") && (
          <>
            <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-blue-500">
              <p className="text-gray-500 text-sm">Demandes vols en attente</p>
              <p className="text-3xl font-bold mt-1">
                {flightRequests.filter((r) => r.statut === "En attente").length}
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-green-500">
              <p className="text-gray-500 text-sm">
                Demandes hôtels en attente
              </p>
              <p className="text-3xl font-bold mt-1">
                {hotelRequests.filter((r) => r.statut === "En attente").length}
              </p>
            </div>
          </>
        )}

        {AUTH_SERVICE.hasPermission("billets_emit") && (
          <>
            <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-purple-500">
              <p className="text-gray-500 text-sm">Billets émis</p>
              <p className="text-3xl font-bold mt-1">
                {
                  flightRequests.filter((r) => r.statut === "Billet émis")
                    .length
                }
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-orange-500">
              <p className="text-gray-500 text-sm">Hôtels réservés</p>
              <p className="text-3xl font-bold mt-1">
                {hotelRequests.filter((r) => r.statut === "Réservée").length}
              </p>
            </div>
          </>
        )}
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {AUTH_SERVICE.hasPermission("demandes_create") && (
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl shadow-md p-8 text-white">
            <Plane className="w-12 h-12 mb-4" />
            <h3 className="text-2xl font-bold mb-2">Réserver un vol</h3>
            <p className="mb-6 text-blue-100">
              Recherchez et réservez vos billets d'avion via Amadeus
            </p>
            <button
              onClick={() =>
                navigateTo("new-flight-request", ["demandes_create"])
              }
              className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50"
            >
              Créer une demande de vol
            </button>
          </div>
        )}

        {AUTH_SERVICE.hasPermission("demandes_create") && (
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl shadow-md p-8 text-white">
            <Hotel className="w-12 h-12 mb-4" />
            <h3 className="text-2xl font-bold mb-2">Réserver un hôtel</h3>
            <p className="mb-6 text-purple-100">
              Recherchez et réservez vos hôtels via Amadeus
            </p>
            <button
              onClick={() =>
                navigateTo("new-hotel-request", ["demandes_create"])
              }
              className="bg-white text-purple-600 px-6 py-3 rounded-lg font-semibold hover:bg-purple-50"
            >
              Créer une demande d'hôtel
            </button>
          </div>
        )}
      </div>

      {AUTH_SERVICE.hasPermission("demandes_read") && (
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl shadow-md p-6">
            <h3 className="text-lg font-bold mb-4 flex items-center">
              <Plane className="w-5 h-5 mr-2 text-blue-600" />
              Statistiques vols
            </h3>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Demandes créées</span>
                <span className="font-bold text-blue-600">
                  {flightRequests.length}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Taux d'approbation</span>
                <span className="font-bold text-green-600">
                  {flightRequests.length > 0
                    ? Math.round(
                        (flightRequests.filter(
                          (r) =>
                            r.statut === "Approuvée" ||
                            r.statut === "Billet émis"
                        ).length /
                          flightRequests.length) *
                          100
                      )
                    : 0}
                  %
                </span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6">
            <h3 className="text-lg font-bold mb-4 flex items-center">
              <Hotel className="w-5 h-5 mr-2 text-purple-600" />
              Statistiques hôtels
            </h3>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Demandes créées</span>
                <span className="font-bold text-purple-600">
                  {hotelRequests.length}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Taux d'approbation</span>
                <span className="font-bold text-green-600">
                  {hotelRequests.length > 0
                    ? Math.round(
                        (hotelRequests.filter(
                          (r) =>
                            r.statut === "Approuvée" || r.statut === "Réservée"
                        ).length /
                          hotelRequests.length) *
                          100
                      )
                    : 0}
                  %
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-lg font-bold mb-4">Accès rapide</h3>
        <div className="grid md:grid-cols-3 gap-3">
          {AUTH_SERVICE.hasPermission("demandes_create") && (
            <button
              onClick={() =>
                navigateTo("new-flight-request", ["demandes_create"])
              }
              className="text-left px-4 py-3 hover:bg-gray-50 rounded-lg flex items-center space-x-3 border"
            >
              <Plane className="w-5 h-5 text-blue-600" />
              <span>Nouvelle demande vol</span>
            </button>
          )}
          {AUTH_SERVICE.hasPermission("demandes_create") && (
            <button
              onClick={() =>
                navigateTo("new-hotel-request", ["demandes_create"])
              }
              className="text-left px-4 py-3 hover:bg-gray-50 rounded-lg flex items-center space-x-3 border"
            >
              <Hotel className="w-5 h-5 text-purple-600" />
              <span>Nouvelle demande hôtel</span>
            </button>
          )}
          {AUTH_SERVICE.hasAnyPermission([
            "admin_entities",
            "admin_agents",
            "admin_users",
            "admin_profiles",
          ]) && (
            <button
              onClick={() => navigateTo("administration", ["admin_entities"])}
              className="text-left px-4 py-3 hover:bg-gray-50 rounded-lg flex items-center space-x-3 border"
            >
              <Settings className="w-5 h-5 text-gray-600" />
              <span>Administration</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    if (!currentUser) return null;

    switch (currentPage) {
      case "dashboard":
        return <DashboardContent />;
      case "direct-flight-purchase":
        return (
          <ProtectedRoute permissions={["direct_purchase"]}>
            <DirectFlightPurchase
              user={currentUser}
              onPurchaseCompleted={handleDirectPurchaseCompleted}
              config={{ skipApproval: true, autoIssueTicket: true }}
            />
          </ProtectedRoute>
        );

      case "direct-hotel-booking":
        return (
          <ProtectedRoute permissions={["direct_purchase"]}>
            <DirectHotelBooking
              user={currentUser}
              onBookingCompleted={handleDirectHotelBookingCompleted}
              config={{ skipApproval: true, instantConfirmation: true }}
            />
          </ProtectedRoute>
        );

      case "quick-booking":
        return (
          <ProtectedRoute permissions={["direct_purchase"]}>
            <QuickBookingDashboard
              user={currentUser}
              modules={["flight", "hotel"]}
              onFlightPurchase={() => setCurrentPage("direct-flight-purchase")}
              onHotelBooking={() => setCurrentPage("direct-hotel-booking")}
            />
          </ProtectedRoute>
        );

      case "my-direct-purchases":
        return (
          <ProtectedRoute permissions={["direct_purchase"]}>
            <MyDirectPurchases user={currentUser} type="all" />
          </ProtectedRoute>
        );
      case "new-flight-request":
        return (
          <ProtectedRoute permissions={["demandes_create"]}>
            <MultiFlightCartWorkflow
              user={currentUser}
              onRequestSubmitted={handleFlightRequestSubmitted}
            />
          </ProtectedRoute>
        );

      case "new-hotel-request":
        return (
          <ProtectedRoute permissions={["demandes_create"]}>
            <HotelBookingWorkflow
              user={currentUser}
              onRequestSubmitted={handleHotelRequestSubmitted}
            />
          </ProtectedRoute>
        );

      case "flight-requests":
        return (
          <ProtectedRoute permissions={["demandes_read"]}>
            <FlightRequestsList
              onRefresh={loadFlightRequests}
              onApprove={handleApprove}
              onReject={handleReject}
              onEmitTicket={handleEmitTicket}
              user={currentUser}
            />
          </ProtectedRoute>
        );

      case "travelers":
        return (
          <ProtectedRoute permissions={["demandes_read"]}>
            <TravelersModule user={currentUser} />
          </ProtectedRoute>
        );

      case "hotel-requests":
        return (
          <ProtectedRoute permissions={["demandes_read"]}>
            <HotelRequestsList
              onRefresh={loadHotelRequests}
              onApprove={handleHotelApprove}
              onReject={handleHotelReject}
              onBook={handleHotelBook}
              user={currentUser}
            />
          </ProtectedRoute>
        );

      case "billing":
        return (
          <ProtectedRoute permissions={["reports_view"]}>
            <BillingModule user={currentUser} />
          </ProtectedRoute>
        );

      case "statistics":
        return (
          <ProtectedRoute permissions={["reports_view"]}>
            <StatisticsModule user={currentUser} />
          </ProtectedRoute>
        );

      case "administration":
        return (
          <ProtectedRoute
            permissions={[
              "admin_entities",
              "admin_agents",
              "admin_users",
              "admin_profiles",
            ]}
          >
            <AdministrationModule />
          </ProtectedRoute>
        );

      default:
        return (
          <div className="bg-white rounded-xl shadow-md p-6">
            <p className="text-gray-600">Section en développement...</p>
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-md">
        <div className="flex items-center justify-between px-6 py-4">
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="lg:hidden"
            >
              {sidebarOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
            <div className="flex items-center space-x-3">
              <img
                src="/BanniereABM.png"
                alt="ABM Travel Logo"
                className="w-12 h-12 object-contain"
              />
              <div>
                <h1 className="text-xl font-bold">Trip Manager Pro (TMP)</h1>
                <p className="text-sm text-gray-500">
                  Connecté en tant que:{" "}
                  {currentUser?.profil?.nom || "Utilisateur"}
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <div className="text-right hidden md:block">
              <p className="font-semibold">
                {currentUser?.prenom} {currentUser?.nom}
              </p>
              <p className="text-sm text-gray-500">
                {currentUser?.agent?.fonction ||
                  currentUser?.fonction ||
                  "Collaborateur"}
              </p>
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center space-x-2 px-4 py-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200"
            >
              <LogOut className="w-5 h-5" />
              <span className="hidden md:inline">Déconnexion</span>
            </button>
          </div>
        </div>
      </header>

      <div className="flex">
        <aside
          className={`${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          } lg:translate-x-0 fixed lg:static w-64 bg-white h-screen shadow-lg transition-transform z-10`}
        >
          <nav className="p-6 space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  onClick={() =>
                    navigateTo(
                      item.id,
                      Array.isArray(item.permission)
                        ? item.permission
                        : [item.permission]
                    )
                  }
                  className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition ${
                    currentPage === item.id
                      ? "bg-blue-600 text-white"
                      : "text-gray-600 hover:bg-gray-100"
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span className="font-medium">{item.label}</span>
                </button>
              );
            })}
          </nav>
        </aside>

        <main className="flex-1 p-6 lg:p-8">{renderContent()}</main>
      </div>
    </div>
  );
}

function App() {
  return (
    <>
      <Page />

      <ToastContainer />
    </>
  );
  // return (
  //   // <SnackbarProvider maxSnack={3}>
  //     <Page />
  //     // <Ali/>
  //   // </SnackbarProvider>
  // );
}

export default App;

export const confirmToast = (message, onConfirm, onCancel) => {
  toast(
    ({ closeToast }) => (
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <span style={{ textAlign: "center" }}>{message}</span>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginTop: "8px",
          }}
        >
          <button
            style={{
              padding: "6px 14px",
              background: "#2563eb",
              color: "white",
              borderRadius: "4px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => {
              onConfirm();
              closeToast();
            }}
          >
            Confirmer
          </button>

          <button
            style={{
              padding: "6px 14px",
              background: "#f50424ff",
              color: "white",
              borderRadius: "4px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => {
              onCancel && onCancel();
              closeToast();
            }}
          >
            Annuler
          </button>
        </div>
      </div>
    ),
    {
      autoClose: false,
      closeOnClick: false,
      position: "top-center",
    }
  );
};
